(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 6136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ datadogRum; }
});

// UNUSED EXPORTS: DefaultPrivacyLevel

;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.js
/* eslint-disable no-console, local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
var ConsoleApiName = {
    log: 'log',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error',
};
var display = function (api) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (!Object.prototype.hasOwnProperty.call(ConsoleApiName, api)) {
        api = ConsoleApiName.log;
    }
    display[api].apply(display, args);
};
display.debug = console.debug.bind(console);
display.log = console.log.bind(console);
display.info = console.info.bind(console);
display.warn = console.warn.bind(console);
display.error = console.error.bind(console);
//# sourceMappingURL=display.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/catchUserErrors.js

function catchUserErrors(fn, errorMsg) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            return fn.apply(void 0, args);
        }
        catch (err) {
            display.error(errorMsg, err);
        }
    };
}
//# sourceMappingURL=catchUserErrors.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.js
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var onMonitorErrorCollected;
var debugMode = false;
function startMonitorErrorCollection(newOnMonitorErrorCollected) {
    onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function setDebugMode(newDebugMode) {
    debugMode = newDebugMode;
}
function resetMonitor() {
    onMonitorErrorCollected = undefined;
    debugMode = false;
}
function monitored(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var decorated = onMonitorErrorCollected ? monitor(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
function monitor(fn) {
    return function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return callMonitored(fn, this, arguments);
    }; // consider output type has input type
}
function callMonitored(fn, context, args) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fn.apply(context, args);
    }
    catch (e) {
        displayIfDebugEnabled(ConsoleApiName.error, e);
        if (onMonitorErrorCollected) {
            try {
                onMonitorErrorCollected(e);
            }
            catch (e) {
                displayIfDebugEnabled(ConsoleApiName.error, e);
            }
        }
    }
}
function displayIfDebugEnabled(api) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (debugMode) {
        display.apply(void 0, __spreadArray([api, '[MONITOR]'], args, false));
    }
}
//# sourceMappingURL=monitor.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils.js

var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;
var ONE_YEAR = 365 * ONE_DAY;
var ONE_KILO_BYTE = 1024;
// use lodash API
function throttle(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var pendingExecutionWithParameters;
    var pendingTimeoutId;
    return {
        throttled: function () {
            var parameters = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                parameters[_i] = arguments[_i];
            }
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) {
                fn.apply(void 0, parameters);
            }
            else {
                pendingExecutionWithParameters = parameters;
            }
            inWaitPeriod = true;
            pendingTimeoutId = setTimeout(function () {
                if (needTrailingExecution && pendingExecutionWithParameters) {
                    fn.apply(void 0, pendingExecutionWithParameters);
                }
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: function () {
            clearTimeout(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        },
    };
}
function utils_assign(target) {
    var toAssign = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        toAssign[_i - 1] = arguments[_i];
    }
    toAssign.forEach(function (source) {
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    });
    return target;
}
function shallowClone(object) {
    return utils_assign({}, object);
}
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
    return placeholder
        ? // eslint-disable-next-line  no-bitwise
            (parseInt(placeholder, 10) ^ ((Math.random() * 16) >> (parseInt(placeholder, 10) / 4))).toString(16)
        : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function round(num, decimals) {
    return +num.toFixed(decimals);
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() { }
/**
 * Custom implementation of JSON.stringify that ignores value.toJSON.
 * We need to do that because some sites badly override toJSON on certain objects.
 * Note this still supposes that JSON.stringify is correct...
 */
function jsonStringify(value, replacer, space) {
    if (value === null || value === undefined) {
        return JSON.stringify(value);
    }
    var originalToJSON = [false, undefined];
    if (hasToJSON(value)) {
        // We need to add a flag and not rely on the truthiness of value.toJSON
        // because it can be set but undefined and that's actually significant.
        originalToJSON = [true, value.toJSON];
        delete value.toJSON;
    }
    var originalProtoToJSON = [false, undefined];
    var prototype;
    if (typeof value === 'object') {
        prototype = Object.getPrototypeOf(value);
        if (hasToJSON(prototype)) {
            originalProtoToJSON = [true, prototype.toJSON];
            delete prototype.toJSON;
        }
    }
    var result;
    try {
        result = JSON.stringify(value, replacer, space);
    }
    catch (_a) {
        result = '<error: unable to serialize object>';
    }
    finally {
        if (originalToJSON[0]) {
            ;
            value.toJSON = originalToJSON[1];
        }
        if (originalProtoToJSON[0]) {
            ;
            prototype.toJSON = originalProtoToJSON[1];
        }
    }
    return result;
}
function hasToJSON(value) {
    return typeof value === 'object' && value !== null && Object.prototype.hasOwnProperty.call(value, 'toJSON');
}
function includes(candidate, search) {
    return candidate.indexOf(search) !== -1;
}
function find(array, predicate) {
    for (var i = 0; i < array.length; i += 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
function findLast(array, predicate) {
    for (var i = array.length - 1; i >= 0; i -= 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
function isPercentage(value) {
    return isNumber(value) && value >= 0 && value <= 100;
}
function isNumber(value) {
    return typeof value === 'number';
}
function objectValues(object) {
    return Object.keys(object).map(function (key) { return object[key]; });
}
function objectHasValue(object, value) {
    return Object.keys(object).some(function (key) { return object[key] === value; });
}
function objectEntries(object) {
    return Object.keys(object).map(function (key) { return [key, object[key]]; });
}
function isEmptyObject(object) {
    return Object.keys(object).length === 0;
}
function mapValues(object, fn) {
    var newObject = {};
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var key = _a[_i];
        newObject[key] = fn(object[key]);
    }
    return newObject;
}
function startsWith(candidate, search) {
    return candidate.slice(0, search.length) === search;
}
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject() {
    if (typeof globalThis === 'object') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get: function () {
            return this;
        },
        configurable: true,
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    var globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') {
            globalObject = self;
        }
        else if (typeof window === 'object') {
            globalObject = window;
        }
        else {
            globalObject = {};
        }
    }
    return globalObject;
}
function getLocationOrigin() {
    return getLinkElementOrigin(window.location);
}
/**
 * IE fallback
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/origin
 */
function getLinkElementOrigin(element) {
    if (element.origin) {
        return element.origin;
    }
    var sanitizedHost = element.host.replace(/(:80|:443)$/, '');
    return "".concat(element.protocol, "//").concat(sanitizedHost);
}
function findCommaSeparatedValue(rawString, name) {
    var regex = new RegExp("(?:^|;)\\s*".concat(name, "\\s*=\\s*([^;]+)"));
    var matches = regex.exec(rawString);
    return matches ? matches[1] : undefined;
}
function safeTruncate(candidate, length, suffix) {
    if (suffix === void 0) { suffix = ''; }
    var lastChar = candidate.charCodeAt(length - 1);
    var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength)
        return candidate;
    return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}
/**
 * Add an event listener to an event emitter object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(emitter, event, listener, options) {
    return addEventListeners(emitter, [event], listener, options);
}
/**
 * Add event listeners to an event emitter object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListeners(emitter, events, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var wrappedListener = monitor(once
        ? function (event) {
            stop();
            listener(event);
        }
        : listener);
    var options = passive ? { capture: capture, passive: passive } : capture;
    events.forEach(function (event) { return emitter.addEventListener(event, wrappedListener, options); });
    var stop = function () { return events.forEach(function (event) { return emitter.removeEventListener(event, wrappedListener, options); }); };
    return {
        stop: stop,
    };
}
function runOnReadyState(expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
    }
    else {
        var eventName = expectedReadyState === 'complete' ? "load" /* LOAD */ : "DOMContentLoaded" /* DOM_CONTENT_LOADED */;
        addEventListener(window, eventName, callback, { once: true });
    }
}
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function getType(value) {
    if (value === null) {
        return 'null';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    return typeof value;
}
function createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function (value) {
                var has = set_1.has(value);
                if (!has) {
                    set_1.add(value);
                }
                return has;
            },
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function (value) {
            var has = array.indexOf(value) >= 0;
            if (!has) {
                array.push(value);
            }
            return has;
        },
    };
}
/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto(destination, source, circularReferenceChecker) {
    if (circularReferenceChecker === void 0) { circularReferenceChecker = createCircularReferenceChecker(); }
    // ignore the source if it is undefined
    if (source === undefined) {
        return destination;
    }
    if (typeof source !== 'object' || source === null) {
        // primitive values - just return source
        return source;
    }
    else if (source instanceof Date) {
        return new Date(source.getTime());
    }
    else if (source instanceof RegExp) {
        var flags = source.flags ||
            // old browsers compatibility
            [
                source.global ? 'g' : '',
                source.ignoreCase ? 'i' : '',
                source.multiline ? 'm' : '',
                source.sticky ? 'y' : '',
                source.unicode ? 'u' : '',
            ].join('');
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
        // remove circular references
        return undefined;
    }
    else if (Array.isArray(source)) {
        var merged_1 = Array.isArray(destination) ? destination : [];
        for (var i = 0; i < source.length; ++i) {
            merged_1[i] = mergeInto(merged_1[i], source[i], circularReferenceChecker);
        }
        return merged_1;
    }
    var merged = getType(destination) === 'object' ? destination : {};
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
        }
    }
    return merged;
}
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function deepClone(value) {
    return mergeInto(undefined, value);
}
function combine() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var destination;
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) {
            continue;
        }
        destination = mergeInto(destination, source);
    }
    return destination;
}
function requestIdleCallback(callback, opts) {
    // Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
    // browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
    // fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
    // browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes
    // efficiently.
    if (window.requestIdleCallback) {
        var id_1 = window.requestIdleCallback(monitor(callback), opts);
        return function () { return window.cancelIdleCallback(id_1); };
    }
    var id = window.requestAnimationFrame(monitor(callback));
    return function () { return window.cancelAnimationFrame(id); };
}
function setToArray(set) {
    var array = [];
    set.forEach(function (item) { return array.push(item); });
    return array;
}
function removeDuplicates(array) {
    var set = new Set();
    array.forEach(function (item) { return set.add(item); });
    return setToArray(set);
}
function matchList(list, value) {
    return list.some(function (item) { return item === value || (item instanceof RegExp && item.test(value)); });
}
//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/boot/init.js



function makePublicApi(stub) {
    var publicApi = utils_assign({
        version: "4.11.2",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady: function (callback) {
            callback();
        },
    }, stub);
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, '_setDebug', {
        get: function () {
            return setDebugMode;
        },
        enumerable: false,
    });
    return publicApi;
}
function defineGlobal(global, name, api) {
    var existingGlobalVariable = global[name];
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) {
        existingGlobalVariable.q.forEach(function (fn) { return catchUserErrors(fn, 'onReady callback threw an error:')(); });
    }
}
//# sourceMappingURL=init.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/contextManager.js
function createContextManager() {
    var context = {};
    return {
        get: function () { return context; },
        add: function (key, value) {
            context[key] = value;
        },
        remove: function (key) {
            delete context[key];
        },
        set: function (newContext) {
            context = newContext;
        },
    };
}
//# sourceMappingURL=contextManager.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/boundedBuffer.js
var BUFFER_LIMIT = 500;
var BoundedBuffer = /** @class */ (function () {
    function BoundedBuffer() {
        this.buffer = [];
    }
    BoundedBuffer.prototype.add = function (callback) {
        var length = this.buffer.push(callback);
        if (length > BUFFER_LIMIT) {
            this.buffer.splice(0, 1);
        }
    };
    BoundedBuffer.prototype.drain = function () {
        this.buffer.forEach(function (callback) { return callback(); });
        this.buffer.length = 0;
    };
    return BoundedBuffer;
}());

//# sourceMappingURL=boundedBuffer.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/timeUtils.js

function relativeToClocks(relative) {
    return { relative: relative, timeStamp: getCorrectedTimeStamp(relative) };
}
function getCorrectedTimeStamp(relativeTime) {
    var correctedOrigin = Date.now() - performance.now();
    // apply correction only for positive drift
    if (correctedOrigin > getNavigationStart()) {
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        return Math.round(correctedOrigin + relativeTime);
    }
    return getTimeStamp(relativeTime);
}
function currentDrift() {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    return Math.round(Date.now() - (getNavigationStart() + performance.now()));
}
function toServerDuration(duration) {
    if (!isNumber(duration)) {
        return duration;
    }
    return round(duration * 1e6, 0);
}
function timeStampNow() {
    return Date.now();
}
function relativeNow() {
    return performance.now();
}
function clocksNow() {
    return { relative: relativeNow(), timeStamp: timeStampNow() };
}
function clocksOrigin() {
    return { relative: 0, timeStamp: getNavigationStart() };
}
function elapsed(start, end) {
    return (end - start);
}
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function getRelativeTime(timestamp) {
    return (timestamp - getNavigationStart());
}
function getTimeStamp(relativeTime) {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    return Math.round(getNavigationStart() + relativeTime);
}
function looksLikeRelativeTime(time) {
    return time < ONE_YEAR;
}
/**
 * Navigation start slightly change on some rare cases
 */
var navigationStart;
function getNavigationStart() {
    if (navigationStart === undefined) {
        navigationStart = performance.timing.navigationStart;
    }
    return navigationStart;
}
function resetNavigationStart() {
    navigationStart = undefined;
}
//# sourceMappingURL=timeUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/eventBridge.js

function getEventBridge() {
    var eventBridgeGlobal = getEventBridgeGlobal();
    if (!eventBridgeGlobal) {
        return;
    }
    return {
        getAllowedWebViewHosts: function () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function (eventType, event) {
            eventBridgeGlobal.send(JSON.stringify({ eventType: eventType, event: event }));
        },
    };
}
function canUseEventBridge(hostname) {
    var _a;
    if (hostname === void 0) { hostname = (_a = getGlobalObject().location) === null || _a === void 0 ? void 0 : _a.hostname; }
    var bridge = getEventBridge();
    return (!!bridge &&
        bridge.getAllowedWebViewHosts().some(function (host) {
            var escapedHost = host.replace(/\./g, '\\.');
            var isDomainOrSubDomain = new RegExp("^(.+\\.)*".concat(escapedHost, "$"));
            return isDomainOrSubDomain.test(hostname);
        }));
}
function getEventBridgeGlobal() {
    return getGlobalObject().DatadogEventBridge;
}
//# sourceMappingURL=eventBridge.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/tracekit/computeStackTrace.js
var UNKNOWN_FUNCTION = '?';
/**
 * Computes a stack trace for an exception.
 */
function computeStackTrace(ex) {
    var stack = [];
    var stackProperty = tryToGetString(ex, 'stack');
    if (stackProperty) {
        stackProperty.split('\n').forEach(function (line) {
            var stackFrame = parseChromeLine(line) || parseWinLine(line) || parseGeckoLine(line);
            if (stackFrame) {
                if (!stackFrame.func && stackFrame.line) {
                    stackFrame.func = UNKNOWN_FUNCTION;
                }
                stack.push(stackFrame);
            }
        });
    }
    return {
        message: tryToGetString(ex, 'message'),
        name: tryToGetString(ex, 'name'),
        stack: stack,
    };
}
var CHROME_LINE_RE = 
// eslint-disable-next-line max-len
/^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var CHROME_EVAL_RE = /\((\S*)(?::(\d+))(?::(\d+))\)/;
function parseChromeLine(line) {
    var parts = CHROME_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
    var submatch = CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [parts[2]] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined,
    };
}
var WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
    var parts = WINJS_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2],
    };
}
var GECKO_LINE_RE = 
// eslint-disable-next-line max-len
/^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
    var parts = GECKO_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    var submatch = GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(',') : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3],
    };
}
function tryToGetString(candidate, property) {
    if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
        return undefined;
    }
    var value = candidate[property];
    return typeof value === 'string' ? value : undefined;
}
//# sourceMappingURL=computeStackTrace.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/error.js



var ErrorSource = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report',
};
function formatUnknownError(stackTrace, errorObject, nonErrorPrefix, handlingStack) {
    if (!stackTrace || (stackTrace.message === undefined && !(errorObject instanceof Error))) {
        return {
            message: "".concat(nonErrorPrefix, " ").concat(jsonStringify(errorObject)),
            stack: 'No stack, consider using an instance of Error',
            handlingStack: handlingStack,
            type: stackTrace && stackTrace.name,
        };
    }
    return {
        message: stackTrace.message || 'Empty message',
        stack: toStackTraceString(stackTrace),
        handlingStack: handlingStack,
        type: stackTrace.name,
    };
}
function toStackTraceString(stack) {
    var result = formatErrorMessage(stack);
    stack.stack.forEach(function (frame) {
        var func = frame.func === '?' ? '<anonymous>' : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
        var line = frame.line ? ":".concat(frame.line) : '';
        var column = frame.line && frame.column ? ":".concat(frame.column) : '';
        result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
    });
    return result;
}
function getFileFromStackTraceString(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
function formatErrorMessage(stack) {
    return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}
/**
 Creates a stacktrace without SDK internal frames.
 
 Constraints:
 - Has to be called at the utmost position of the call stack.
 - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
 */
function createHandlingStack() {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */
    var internalFramesToSkip = 2;
    var error = new Error();
    var formattedStack;
    // IE needs to throw the error to fill in the stack trace
    if (!error.stack) {
        try {
            throw error;
        }
        catch (e) {
            noop();
        }
    }
    callMonitored(function () {
        var stackTrace = computeStackTrace(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = toStackTraceString(stackTrace);
    });
    return formattedStack;
}
//# sourceMappingURL=error.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/browser/cookie.js


var COOKIE_ACCESS_DELAY = ONE_SECOND;
function setCookie(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=".concat(date.toUTCString());
    var sameSite = options && options.crossSite ? 'none' : 'strict';
    var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
    var secure = options && options.secure ? ';secure' : '';
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure);
}
function getCookie(name) {
    return findCommaSeparatedValue(document.cookie, name);
}
function deleteCookie(name, options) {
    setCookie(name, '', 0, options);
}
function areCookiesAuthorized(options) {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_".concat(generateUUID());
        var testCookieValue = 'test';
        setCookie(testCookieName, testCookieValue, ONE_SECOND, options);
        var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
        deleteCookie(testCookieName, options);
        return isCookieCorrectlySet;
    }
    catch (error) {
        display.error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var getCurrentSiteCache;
function getCurrentSite() {
    if (getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_".concat(generateUUID());
        var testCookieValue = 'test';
        var domainLevels = window.location.hostname.split('.');
        var candidateDomain = domainLevels.pop();
        while (domainLevels.length && !getCookie(testCookieName)) {
            candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
            setCookie(testCookieName, testCookieValue, ONE_SECOND, { domain: candidateDomain });
        }
        deleteCookie(testCookieName, { domain: candidateDomain });
        getCurrentSiteCache = candidateDomain;
    }
    return getCurrentSiteCache;
}
//# sourceMappingURL=cookie.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/experimentalFeatures.js
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 */
var enabledExperimentalFeatures;
function updateExperimentalFeatures(enabledFeatures) {
    // Safely handle external data
    if (!Array.isArray(enabledFeatures)) {
        return;
    }
    if (!enabledExperimentalFeatures) {
        enabledExperimentalFeatures = new Set(enabledFeatures);
    }
    enabledFeatures
        .filter(function (flag) { return typeof flag === 'string'; })
        .forEach(function (flag) {
        enabledExperimentalFeatures.add(flag);
    });
}
function isExperimentalFeatureEnabled(featureName) {
    return !!enabledExperimentalFeatures && enabledExperimentalFeatures.has(featureName);
}
function resetExperimentalFeatures() {
    enabledExperimentalFeatures = new Set();
}
//# sourceMappingURL=experimentalFeatures.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/urlPolyfill.js

function normalizeUrl(url) {
    return buildUrl(url, getLocationOrigin()).href;
}
function isValidUrl(url) {
    try {
        return !!buildUrl(url);
    }
    catch (_a) {
        return false;
    }
}
function haveSameOrigin(url1, url2) {
    return getOrigin(url1) === getOrigin(url2);
}
function getOrigin(url) {
    return getLinkElementOrigin(buildUrl(url));
}
function getPathName(url) {
    var pathname = buildUrl(url).pathname;
    return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
function getSearch(url) {
    return buildUrl(url).search;
}
function getHash(url) {
    return buildUrl(url).hash;
}
function buildUrl(url, base) {
    if (checkURLSupported()) {
        return base !== undefined ? new URL(url, base) : new URL(url);
    }
    if (base === undefined && !/:/.test(url)) {
        throw new Error("Invalid URL: '".concat(url, "'"));
    }
    var doc = document;
    var anchorElement = doc.createElement('a');
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument('');
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
var isURLSupported;
function checkURLSupported() {
    if (isURLSupported !== undefined) {
        return isURLSupported;
    }
    try {
        var url = new URL('http://test/path');
        isURLSupported = url.href === 'http://test/path';
        return isURLSupported;
    }
    catch (_a) {
        isURLSupported = false;
    }
    return isURLSupported;
}
//# sourceMappingURL=urlPolyfill.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/intakeSites.js
var INTAKE_SITE_STAGING = 'datad0g.com';
var INTAKE_SITE_US1 = 'datadoghq.com';
var INTAKE_SITE_US1_FED = 'ddog-gov.com';
//# sourceMappingURL=intakeSites.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/endpointBuilder.js




var ENDPOINTS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'session-replay',
};
var INTAKE_TRACKS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'replay',
};
function createEndpointBuilder(initConfiguration, endpointType, tags) {
    var _a = initConfiguration.site, site = _a === void 0 ? INTAKE_SITE_US1 : _a, clientToken = initConfiguration.clientToken;
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    var host = "".concat(ENDPOINTS[endpointType], ".browser-intake-").concat(domainParts.join('-'), ".").concat(extension);
    var baseUrl = "https://".concat(host, "/api/v2/").concat(INTAKE_TRACKS[endpointType]);
    var proxyUrl = initConfiguration.proxyUrl && normalizeUrl(initConfiguration.proxyUrl);
    return {
        build: function () {
            var parameters = 'ddsource=browser' +
                "&ddtags=".concat(encodeURIComponent(["sdk_version:".concat("4.11.2")].concat(tags).join(','))) +
                "&dd-api-key=".concat(clientToken) +
                "&dd-evp-origin-version=".concat(encodeURIComponent("4.11.2")) +
                '&dd-evp-origin=browser' +
                "&dd-request-id=".concat(generateUUID());
            if (endpointType === 'rum') {
                parameters += "&batch_time=".concat(timeStampNow());
            }
            var endpointUrl = "".concat(baseUrl, "?").concat(parameters);
            return proxyUrl ? "".concat(proxyUrl, "?ddforward=").concat(encodeURIComponent(endpointUrl)) : endpointUrl;
        },
        buildIntakeUrl: function () {
            return proxyUrl ? "".concat(proxyUrl, "?ddforward") : baseUrl;
        },
        endpointType: endpointType,
    };
}
//# sourceMappingURL=endpointBuilder.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/tags.js

var TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version, datacenter = configuration.datacenter;
    var tags = [];
    if (env) {
        tags.push(buildTag('env', env));
    }
    if (service) {
        tags.push(buildTag('service', service));
    }
    if (version) {
        tags.push(buildTag('version', version));
    }
    if (datacenter) {
        tags.push(buildTag('datacenter', datacenter));
    }
    return tags;
}
var FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function buildTag(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    var valueSizeLimit = TAG_SIZE_LIMIT - key.length - 1;
    if (rawValue.length > valueSizeLimit || FORBIDDEN_CHARACTERS.test(rawValue)) {
        display.warn("".concat(key, " value doesn't meet tag requirements and will be sanitized"));
    }
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    var sanitizedValue = rawValue.replace(/,/g, '_');
    return "".concat(key, ":").concat(sanitizedValue);
}
//# sourceMappingURL=tags.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/transportConfiguration.js




function computeTransportConfiguration(initConfiguration) {
    var tags = buildTags(initConfiguration);
    var endpointBuilders = computeEndpointBuilders(initConfiguration, tags);
    var intakeEndpoints = objectValues(endpointBuilders).map(function (builder) { return builder.buildIntakeUrl(); });
    var replicaConfiguration = computeReplicaConfiguration(initConfiguration, intakeEndpoints, tags);
    return utils_assign({
        isIntakeUrl: function (url) { return intakeEndpoints.some(function (intakeEndpoint) { return url.indexOf(intakeEndpoint) === 0; }); },
        replica: replicaConfiguration,
        site: initConfiguration.site || INTAKE_SITE_US1,
    }, endpointBuilders);
}
function computeEndpointBuilders(initConfiguration, tags) {
    return {
        logsEndpointBuilder: createEndpointBuilder(initConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(initConfiguration, 'rum', tags),
        sessionReplayEndpointBuilder: createEndpointBuilder(initConfiguration, 'sessionReplay', tags),
    };
}
function computeReplicaConfiguration(initConfiguration, intakeEndpoints, tags) {
    if (!initConfiguration.replica) {
        return;
    }
    var replicaConfiguration = utils_assign({}, initConfiguration, {
        site: INTAKE_SITE_US1,
        clientToken: initConfiguration.replica.clientToken,
    });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'rum', tags),
    };
    intakeEndpoints.push.apply(intakeEndpoints, objectValues(replicaEndpointBuilders).map(function (builder) { return builder.buildIntakeUrl(); }));
    return utils_assign({ applicationId: initConfiguration.replica.applicationId }, replicaEndpointBuilders);
}
//# sourceMappingURL=transportConfiguration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js






var DefaultPrivacyLevel = {
    ALLOW: 'allow',
    MASK: 'mask',
    MASK_USER_INPUT: 'mask-user-input',
};
function validateAndBuildConfiguration(initConfiguration) {
    var _a, _b;
    if (!initConfiguration || !initConfiguration.clientToken) {
        display.error('Client Token is not configured, we will not send any data.');
        return;
    }
    if (initConfiguration.sampleRate !== undefined && !isPercentage(initConfiguration.sampleRate)) {
        display.error('Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetrySampleRate !== undefined && !isPercentage(initConfiguration.telemetrySampleRate)) {
        display.error('Telemetry Sample Rate should be a number between 0 and 100');
        return;
    }
    // Set the experimental feature flags as early as possible, so we can use them in most places
    updateExperimentalFeatures(initConfiguration.enableExperimentalFeatures);
    return utils_assign({
        beforeSend: initConfiguration.beforeSend && catchUserErrors(initConfiguration.beforeSend, 'beforeSend threw an error:'),
        cookieOptions: buildCookieOptions(initConfiguration),
        sampleRate: (_a = initConfiguration.sampleRate) !== null && _a !== void 0 ? _a : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        service: initConfiguration.service,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        /**
         * beacon payload max queue size implementation is 64kb
         * ensure that we leave room for logs, rum and potential other users
         */
        batchBytesLimit: isExperimentalFeatureEnabled('lower-batch-size') ? 10 * ONE_KILO_BYTE : 16 * ONE_KILO_BYTE,
        eventRateLimiterThreshold: 3000,
        maxTelemetryEventsPerPage: 15,
        /**
         * flush automatically, aim to be lower than ALB connection timeout
         * to maximize connection reuse.
         */
        flushTimeout: 30 * ONE_SECOND,
        /**
         * Logs intake limit
         */
        batchMessagesLimit: 50,
        messageBytesLimit: 256 * ONE_KILO_BYTE,
    }, computeTransportConfiguration(initConfiguration));
}
function buildCookieOptions(initConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure = mustUseSecureCookie(initConfiguration);
    cookieOptions.crossSite = !!initConfiguration.useCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) {
        cookieOptions.domain = getCurrentSite();
    }
    return cookieOptions;
}
function mustUseSecureCookie(initConfiguration) {
    return !!initConfiguration.useSecureSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
}
//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/syntheticsContext.js

var SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
var SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
var SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function getSyntheticsContext() {
    var testId = window._DATADOG_SYNTHETICS_PUBLIC_ID || getCookie(SYNTHETICS_TEST_ID_COOKIE_NAME);
    var resultId = window._DATADOG_SYNTHETICS_RESULT_ID || getCookie(SYNTHETICS_RESULT_ID_COOKIE_NAME);
    if (typeof testId === 'string' && typeof resultId === 'string') {
        return {
            test_id: testId,
            result_id: resultId,
            injected: willSyntheticsInjectRum(),
        };
    }
}
function willSyntheticsInjectRum() {
    return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || getCookie(SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
//# sourceMappingURL=syntheticsContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/configuration.js

function validateAndBuildRumConfiguration(initConfiguration) {
    var _a, _b, _c, _d;
    if (!initConfiguration.applicationId) {
        display.error('Application ID is not configured, no RUM data will be collected.');
        return;
    }
    // TODO remove fallback in next major
    var premiumSampleRate = (_a = initConfiguration.premiumSampleRate) !== null && _a !== void 0 ? _a : initConfiguration.replaySampleRate;
    if (premiumSampleRate !== undefined && !isPercentage(premiumSampleRate)) {
        display.error('Premium Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.tracingSampleRate !== undefined && !isPercentage(initConfiguration.tracingSampleRate)) {
        display.error('Tracing Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.allowedTracingOrigins !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingOrigins)) {
            display.error('Allowed Tracing Origins should be an array');
            return;
        }
        if (initConfiguration.allowedTracingOrigins.length !== 0 && initConfiguration.service === undefined) {
            display.error('Service need to be configured when tracing is enabled');
            return;
        }
    }
    if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
        display.error('Excluded Activity Urls should be an array');
        return;
    }
    var baseConfiguration = validateAndBuildConfiguration(initConfiguration);
    if (!baseConfiguration) {
        return;
    }
    var trackFrustrations = isExperimentalFeatureEnabled('frustration-signals') && !!initConfiguration.trackFrustrations;
    return utils_assign({
        applicationId: initConfiguration.applicationId,
        version: initConfiguration.version,
        actionNameAttribute: initConfiguration.actionNameAttribute,
        premiumSampleRate: premiumSampleRate !== null && premiumSampleRate !== void 0 ? premiumSampleRate : 100,
        allowedTracingOrigins: (_b = initConfiguration.allowedTracingOrigins) !== null && _b !== void 0 ? _b : [],
        tracingSampleRate: (_c = initConfiguration.tracingSampleRate) !== null && _c !== void 0 ? _c : 100,
        excludedActivityUrls: (_d = initConfiguration.excludedActivityUrls) !== null && _d !== void 0 ? _d : [],
        trackInteractions: !!initConfiguration.trackInteractions || trackFrustrations,
        trackFrustrations: trackFrustrations,
        trackViewsManually: !!initConfiguration.trackViewsManually,
        defaultPrivacyLevel: objectHasValue(DefaultPrivacyLevel, initConfiguration.defaultPrivacyLevel)
            ? initConfiguration.defaultPrivacyLevel
            : DefaultPrivacyLevel.MASK_USER_INPUT,
    }, baseConfiguration);
}
//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/boot/rumPublicApi.js



function makeRumPublicApi(startRumImpl, recorderApi, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.ignoreInitIfSyntheticsWillInjectRum, ignoreInitIfSyntheticsWillInjectRum = _c === void 0 ? true : _c;
    var isAlreadyInitialized = false;
    var globalContextManager = createContextManager();
    var user = {};
    var getInternalContextStrategy = function () { return undefined; };
    var getInitConfigurationStrategy = function () { return undefined; };
    var bufferApiCalls = new BoundedBuffer();
    var addTimingStrategy = function (name, time) {
        if (time === void 0) { time = timeStampNow(); }
        bufferApiCalls.add(function () { return addTimingStrategy(name, time); });
    };
    var startViewStrategy = function (options, startClocks) {
        if (startClocks === void 0) { startClocks = clocksNow(); }
        bufferApiCalls.add(function () { return startViewStrategy(options, startClocks); });
    };
    var addActionStrategy = function (action, commonContext) {
        if (commonContext === void 0) { commonContext = clonedCommonContext(); }
        bufferApiCalls.add(function () { return addActionStrategy(action, commonContext); });
    };
    var addErrorStrategy = function (providedError, commonContext) {
        if (commonContext === void 0) { commonContext = clonedCommonContext(); }
        bufferApiCalls.add(function () { return addErrorStrategy(providedError, commonContext); });
    };
    function clonedCommonContext() {
        return deepClone({
            context: globalContextManager.get(),
            user: user,
        });
    }
    function initRum(initConfiguration) {
        // If we are in a Synthetics test configured to automatically inject a RUM instance, we want to
        // completely discard the customer application RUM instance by ignoring their init() call.  But,
        // we should not ignore the init() call from the Synthetics-injected RUM instance, so the
        // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
        if (ignoreInitIfSyntheticsWillInjectRum && willSyntheticsInjectRum()) {
            return;
        }
        if (canUseEventBridge()) {
            initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
        }
        else if (!canHandleSession(initConfiguration)) {
            return;
        }
        if (!canInitRum(initConfiguration)) {
            return;
        }
        var configuration = validateAndBuildRumConfiguration(initConfiguration);
        if (!configuration) {
            return;
        }
        if (!configuration.trackViewsManually) {
            doStartRum(configuration);
        }
        else {
            // drain beforeInitCalls by buffering them until we start RUM
            // if we get a startView, drain re-buffered calls before continuing to drain beforeInitCalls
            // in order to ensure that calls are processed in order
            var beforeInitCalls = bufferApiCalls;
            bufferApiCalls = new BoundedBuffer();
            startViewStrategy = function (options) {
                doStartRum(configuration, options);
            };
            beforeInitCalls.drain();
        }
        getInitConfigurationStrategy = function () { return deepClone(initConfiguration); };
        isAlreadyInitialized = true;
    }
    function doStartRum(configuration, initialViewOptions) {
        var startRumResults = startRumImpl(configuration, function () { return ({
            user: user,
            context: globalContextManager.get(),
            hasReplay: recorderApi.isRecording() ? true : undefined,
        }); }, recorderApi, initialViewOptions);
        (startViewStrategy = startRumResults.startView, addActionStrategy = startRumResults.addAction, addErrorStrategy = startRumResults.addError, addTimingStrategy = startRumResults.addTiming, getInternalContextStrategy = startRumResults.getInternalContext);
        bufferApiCalls.drain();
        recorderApi.onRumStart(startRumResults.lifeCycle, configuration, startRumResults.session, startRumResults.viewContexts);
    }
    var startView = monitor(function (options) {
        var sanitizedOptions = typeof options === 'object' ? options : { name: options };
        startViewStrategy(sanitizedOptions);
    });
    var rumPublicApi = makePublicApi({
        init: monitor(initRum),
        addRumGlobalContext: monitor(globalContextManager.add),
        removeRumGlobalContext: monitor(globalContextManager.remove),
        getRumGlobalContext: monitor(globalContextManager.get),
        setRumGlobalContext: monitor(globalContextManager.set),
        getInternalContext: monitor(function (startTime) { return getInternalContextStrategy(startTime); }),
        getInitConfiguration: monitor(function () { return getInitConfigurationStrategy(); }),
        addAction: monitor(function (name, context) {
            addActionStrategy({
                name: name,
                context: deepClone(context),
                startClocks: clocksNow(),
                type: "custom" /* CUSTOM */,
            });
        }),
        addError: function (error, context) {
            var handlingStack = createHandlingStack();
            callMonitored(function () {
                addErrorStrategy({
                    error: error,
                    handlingStack: handlingStack,
                    context: deepClone(context),
                    startClocks: clocksNow(),
                });
            });
        },
        addTiming: monitor(function (name, time) {
            addTimingStrategy(name, time);
        }),
        setUser: monitor(function (newUser) {
            var sanitizedUser = sanitizeUser(newUser);
            if (sanitizedUser) {
                user = sanitizedUser;
            }
            else {
                display.error('Unsupported user:', newUser);
            }
        }),
        removeUser: monitor(function () {
            user = {};
        }),
        startView: startView,
        startSessionReplayRecording: monitor(recorderApi.start),
        stopSessionReplayRecording: monitor(recorderApi.stop),
    });
    return rumPublicApi;
    function sanitizeUser(newUser) {
        if (typeof newUser !== 'object' || !newUser) {
            return;
        }
        var result = deepClone(newUser);
        if ('id' in result) {
            result.id = String(result.id);
        }
        if ('name' in result) {
            result.name = String(result.name);
        }
        if ('email' in result) {
            result.email = String(result.email);
        }
        return result;
    }
    function canHandleSession(initConfiguration) {
        if (!areCookiesAuthorized(buildCookieOptions(initConfiguration))) {
            display.warn('Cookies are not authorized, we will not send any data.');
            return false;
        }
        if (isLocalFile()) {
            display.error('Execution is not allowed in the current context.');
            return false;
        }
        return true;
    }
    function canInitRum(initConfiguration) {
        if (isAlreadyInitialized) {
            if (!initConfiguration.silentMultipleInit) {
                display.error('DD_RUM is already initialized.');
            }
            return false;
        }
        return true;
    }
    function overrideInitConfigurationForBridge(initConfiguration) {
        return utils_assign({}, initConfiguration, {
            applicationId: '00000000-aaaa-0000-aaaa-000000000000',
            clientToken: 'empty',
            sampleRate: 100,
        });
    }
    function isLocalFile() {
        return window.location.protocol === 'file:';
    }
}
//# sourceMappingURL=rumPublicApi.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.js
var Observable = /** @class */ (function () {
    function Observable(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    Observable.prototype.subscribe = function (f) {
        var _this = this;
        if (!this.observers.length && this.onFirstSubscribe) {
            this.onLastUnsubscribe = this.onFirstSubscribe() || undefined;
        }
        this.observers.push(f);
        return {
            unsubscribe: function () {
                _this.observers = _this.observers.filter(function (other) { return f !== other; });
                if (!_this.observers.length && _this.onLastUnsubscribe) {
                    _this.onLastUnsubscribe();
                }
            },
        };
    };
    Observable.prototype.notify = function (data) {
        this.observers.forEach(function (observer) { return observer(data); });
    };
    return Observable;
}());

function mergeObservables() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var globalObservable = new Observable(function () {
        var subscriptions = observables.map(function (observable) {
            return observable.subscribe(function (data) { return globalObservable.notify(data); });
        });
        return function () { return subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); }); };
    });
    return globalObservable;
}
//# sourceMappingURL=observable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js








var ALLOWED_FRAME_URLS = [
    'https://www.datadoghq-browser-agent.com',
    'https://www.datad0g-browser-agent.com',
    'http://localhost',
    '<anonymous>',
];
var TELEMETRY_EXCLUDED_SITES = [INTAKE_SITE_US1_FED];
var telemetryConfiguration = { maxEventsPerPage: 0, sentEventCount: 0, telemetryEnabled: false };
var onRawTelemetryEventCollected;
function startTelemetry(configuration) {
    var contextProvider;
    var observable = new Observable();
    telemetryConfiguration.telemetryEnabled = performDraw(configuration.telemetrySampleRate);
    onRawTelemetryEventCollected = function (event) {
        if (!includes(TELEMETRY_EXCLUDED_SITES, configuration.site) && telemetryConfiguration.telemetryEnabled) {
            observable.notify(toTelemetryEvent(event));
        }
    };
    startMonitorErrorCollection(addTelemetryError);
    utils_assign(telemetryConfiguration, {
        maxEventsPerPage: configuration.maxTelemetryEventsPerPage,
        sentEventCount: 0,
    });
    function toTelemetryEvent(event) {
        return combine({
            type: 'telemetry',
            date: timeStampNow(),
            service: 'browser-sdk',
            version: "4.11.2",
            source: 'browser',
            _dd: {
                format_version: 2,
            },
            telemetry: event, // https://github.com/microsoft/TypeScript/issues/48457
        }, contextProvider !== undefined ? contextProvider() : {});
    }
    return {
        setContextProvider: function (provider) {
            contextProvider = provider;
        },
        observable: observable,
    };
}
function startFakeTelemetry() {
    var events = [];
    assign(telemetryConfiguration, {
        maxEventsPerPage: Infinity,
        sentEventCount: 0,
    });
    onRawTelemetryEventCollected = function (event) {
        events.push(event);
    };
    return events;
}
function resetTelemetry() {
    onRawTelemetryEventCollected = undefined;
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */
function isTelemetryReplicationAllowed(configuration) {
    return configuration.site === INTAKE_SITE_STAGING;
}
function addTelemetryDebug(message, context) {
    displayIfDebugEnabled(ConsoleApiName.debug, message, context);
    addTelemetry(utils_assign({
        message: message,
        status: "debug" /* debug */,
    }, context));
}
function addTelemetryError(e) {
    addTelemetry(utils_assign({
        status: "error" /* error */,
    }, formatError(e)));
}
function addTelemetry(event) {
    if (onRawTelemetryEventCollected && telemetryConfiguration.sentEventCount < telemetryConfiguration.maxEventsPerPage) {
        telemetryConfiguration.sentEventCount += 1;
        onRawTelemetryEventCollected(event);
    }
}
function formatError(e) {
    if (e instanceof Error) {
        var stackTrace = computeStackTrace(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: toStackTraceString(scrubCustomerFrames(stackTrace)),
            },
            message: stackTrace.message,
        };
    }
    return {
        error: {
            stack: 'Not an instance of error',
        },
        message: "Uncaught ".concat(jsonStringify(e)),
    };
}
function scrubCustomerFrames(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter(function (frame) { return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) { return startsWith(frame.url, allowedFrameUrl); }); });
    return stackTrace;
}
//# sourceMappingURL=telemetry.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/failedSendBeacon.js




var LOCAL_STORAGE_KEY = 'datadog-browser-sdk-failed-send-beacon';
function startFlushFailedSendBeacons() {
    if (!isExperimentalFeatureEnabled('lower-batch-size'))
        return;
    // delay the computation to prevent the SDK from blocking the main thread on init
    setTimeout(monitor(flushFailedSendBeacon));
}
function addFailedSendBeacon(endpointType, size, reason) {
    if (!isExperimentalFeatureEnabled('lower-batch-size'))
        return;
    var failSendBeaconLog = {
        reason: reason,
        endpointType: endpointType,
        version: "4.11.2",
        connection: navigator.connection ? navigator.connection.effectiveType : undefined,
        onLine: navigator.onLine,
        size: size,
    };
    if (reason === 'before_unload' || reason === 'visibility_hidden') {
        window.localStorage.setItem("".concat(LOCAL_STORAGE_KEY, "-").concat(generateUUID()), JSON.stringify(failSendBeaconLog));
    }
    else {
        addTelemetryDebug('failed sendBeacon', failSendBeaconLog);
    }
}
function flushFailedSendBeacon() {
    var keys = Object.keys(localStorage);
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        if (startsWith(key, LOCAL_STORAGE_KEY)) {
            var value = localStorage.getItem(key);
            if (value) {
                addTelemetryDebug('failed sendBeacon', JSON.parse(value));
                window.localStorage.removeItem(key);
            }
        }
    }
}
//# sourceMappingURL=failedSendBeacon.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/domMutationObservable.js

function createDOMMutationObservable() {
    var MutationObserver = getMutationObserverConstructor();
    var observable = new Observable(function () {
        if (!MutationObserver) {
            return;
        }
        var observer = new MutationObserver(monitor(function () { return observable.notify(); }));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
        });
        return function () { return observer.disconnect(); };
    });
    return observable;
}
function getMutationObserverConstructor() {
    var constructor;
    var browserWindow = window;
    // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we try to get the original MutationObserver constructor stored by
    // Zone.js.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        var zoneSymbol = browserWindow.Zone.__symbol__;
        // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
        //
        // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
        constructor = browserWindow[zoneSymbol('MutationObserver')];
        if (!constructor && browserWindow.MutationObserver) {
            // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
            // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
            // instance in its properties[4]. Let's get the original MutationObserver constructor from
            // there.
            //
            // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
            var patchedInstance = new browserWindow.MutationObserver(noop);
            var originalInstance = patchedInstance[zoneSymbol('originalInstance')];
            constructor = originalInstance && originalInstance.constructor;
        }
    }
    if (!constructor) {
        constructor = browserWindow.MutationObserver;
    }
    return constructor;
}
//# sourceMappingURL=domMutationObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/resource/resourceUtils.js

var FAKE_INITIAL_DOCUMENT = 'initial_document';
var RESOURCE_TYPES = [
    ["document" /* DOCUMENT */, function (initiatorType) { return FAKE_INITIAL_DOCUMENT === initiatorType; }],
    ["xhr" /* XHR */, function (initiatorType) { return 'xmlhttprequest' === initiatorType; }],
    ["fetch" /* FETCH */, function (initiatorType) { return 'fetch' === initiatorType; }],
    ["beacon" /* BEACON */, function (initiatorType) { return 'beacon' === initiatorType; }],
    ["css" /* CSS */, function (_, path) { return /\.css$/i.test(path); }],
    ["js" /* JS */, function (_, path) { return /\.js$/i.test(path); }],
    [
        "image" /* IMAGE */,
        function (initiatorType, path) {
            return includes(['image', 'img', 'icon'], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
        },
    ],
    ["font" /* FONT */, function (_, path) { return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null; }],
    [
        "media" /* MEDIA */,
        function (initiatorType, path) {
            return includes(['audio', 'video'], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
        },
    ],
];
function computeResourceKind(timing) {
    var url = timing.name;
    if (!isValidUrl(url)) {
        addTelemetryDebug("Failed to construct URL for \"".concat(timing.name, "\""));
        return "other" /* OTHER */;
    }
    var path = getPathName(url);
    for (var _i = 0, RESOURCE_TYPES_1 = RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++) {
        var _a = RESOURCE_TYPES_1[_i], type = _a[0], isType = _a[1];
        if (isType(timing.initiatorType, path)) {
            return type;
        }
    }
    return "other" /* OTHER */;
}
function areInOrder() {
    var numbers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        numbers[_i] = arguments[_i];
    }
    for (var i = 1; i < numbers.length; i += 1) {
        if (numbers[i - 1] > numbers[i]) {
            return false;
        }
    }
    return true;
}
function isRequestKind(timing) {
    return timing.initiatorType === 'xmlhttprequest' || timing.initiatorType === 'fetch';
}
function computePerformanceResourceDuration(entry) {
    var duration = entry.duration, startTime = entry.startTime, responseEnd = entry.responseEnd;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) {
        return toServerDuration(elapsed(startTime, responseEnd));
    }
    return toServerDuration(duration);
}
function computePerformanceResourceDetails(entry) {
    var validEntry = toValidEntry(entry);
    if (!validEntry) {
        return undefined;
    }
    var startTime = validEntry.startTime, fetchStart = validEntry.fetchStart, redirectStart = validEntry.redirectStart, redirectEnd = validEntry.redirectEnd, domainLookupStart = validEntry.domainLookupStart, domainLookupEnd = validEntry.domainLookupEnd, connectStart = validEntry.connectStart, secureConnectionStart = validEntry.secureConnectionStart, connectEnd = validEntry.connectEnd, requestStart = validEntry.requestStart, responseStart = validEntry.responseStart, responseEnd = validEntry.responseEnd;
    var details = {
        download: formatTiming(startTime, responseStart, responseEnd),
        first_byte: formatTiming(startTime, requestStart, responseStart),
    };
    // Make sure a connection occurred
    if (connectEnd !== fetchStart) {
        details.connect = formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if (areInOrder(connectStart, secureConnectionStart, connectEnd)) {
            details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
        }
    }
    // Make sure a domain lookup occurred
    if (domainLookupEnd !== fetchStart) {
        details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
    }
    if (hasRedirection(entry)) {
        details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
    }
    return details;
}
function toValidEntry(entry) {
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    if (!areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd)) {
        return undefined;
    }
    if (!hasRedirection(entry)) {
        return entry;
    }
    var redirectStart = entry.redirectStart, redirectEnd = entry.redirectEnd;
    // Firefox doesn't provide redirect timings on cross origin requests.
    // Provide a default for those.
    if (redirectStart < entry.startTime) {
        redirectStart = entry.startTime;
    }
    if (redirectEnd < entry.startTime) {
        redirectEnd = entry.fetchStart;
    }
    // Make sure redirect timings are in order
    if (!areInOrder(entry.startTime, redirectStart, redirectEnd, entry.fetchStart)) {
        return undefined;
    }
    return utils_assign({}, entry, {
        redirectEnd: redirectEnd,
        redirectStart: redirectStart,
    });
}
function hasRedirection(entry) {
    // The only time fetchStart is different than startTime is if a redirection occurred.
    return entry.fetchStart !== entry.startTime;
}
function formatTiming(origin, start, end) {
    return {
        duration: toServerDuration(elapsed(start, end)),
        start: toServerDuration(elapsed(origin, start)),
    };
}
function computeSize(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) {
        return entry.decodedBodySize;
    }
    return undefined;
}
function isAllowedRequestUrl(configuration, url) {
    return url && !configuration.isIntakeUrl(url);
}
//# sourceMappingURL=resourceUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/tracing/getDocumentTraceId.js

var INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * ONE_MINUTE;
function getDocumentTraceId(document) {
    var data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);
    if (!data || data.traceTime <= Date.now() - INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) {
        return undefined;
    }
    return data.traceId;
}
function getDocumentTraceDataFromMeta(document) {
    var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
    var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
    return createDocumentTraceData(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function getDocumentTraceDataFromComment(document) {
    var comment = findTraceComment(document);
    if (!comment) {
        return undefined;
    }
    return createDocumentTraceData(findCommaSeparatedValue(comment, 'trace-id'), findCommaSeparatedValue(comment, 'trace-time'));
}
function createDocumentTraceData(traceId, rawTraceTime) {
    var traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) {
        return undefined;
    }
    return {
        traceId: traceId,
        traceTime: traceTime,
    };
}
function findTraceComment(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < document.childNodes.length; i += 1) {
        var comment = getTraceCommentFromNode(document.childNodes[i]);
        if (comment) {
            return comment;
        }
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stopping if we come across a non-text node.
    if (document.body) {
        for (var i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
            var node = document.body.childNodes[i];
            var comment = getTraceCommentFromNode(node);
            if (comment) {
                return comment;
            }
            if (!isTextNode(node)) {
                break;
            }
        }
    }
}
function getTraceCommentFromNode(node) {
    if (node && isCommentNode(node)) {
        var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) {
            return match[1];
        }
    }
}
function isCommentNode(node) {
    return node.nodeName === '#comment';
}
function isTextNode(node) {
    return node.nodeName === '#text';
}
//# sourceMappingURL=getDocumentTraceId.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/performanceCollection.js



function supportPerformanceObject() {
    return window.performance !== undefined && 'getEntries' in performance;
}
function supportPerformanceTimingEvent(entryType) {
    return (window.PerformanceObserver &&
        PerformanceObserver.supportedEntryTypes !== undefined &&
        PerformanceObserver.supportedEntryTypes.includes(entryType));
}
function supportPerformanceEntry() {
    // Safari 10 doesn't support PerformanceEntry
    return typeof PerformanceEntry === 'function';
}
function startPerformanceCollection(lifeCycle, configuration) {
    retrieveInitialDocumentResourceTiming(function (timing) {
        handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
    });
    if (supportPerformanceObject()) {
        var performanceEntries_1 = performance.getEntries();
        // Because the performance entry list can be quite large
        // delay the computation to prevent the SDK from blocking the main thread on init
        setTimeout(monitor(function () { return handleRumPerformanceEntries(lifeCycle, configuration, performanceEntries_1); }));
    }
    if (window.PerformanceObserver) {
        var handlePerformanceEntryList_1 = monitor(function (entries) {
            return handleRumPerformanceEntries(lifeCycle, configuration, entries.getEntries());
        });
        var mainEntries = ['resource', 'navigation', 'longtask', 'paint'];
        var experimentalEntries = ['largest-contentful-paint', 'first-input', 'layout-shift'];
        try {
            // Experimental entries are not retrieved by performance.getEntries()
            // use a single PerformanceObserver with buffered flag by type
            // to get values that could happen before SDK init
            experimentalEntries.forEach(function (type) {
                var observer = new PerformanceObserver(handlePerformanceEntryList_1);
                observer.observe({ type: type, buffered: true });
            });
        }
        catch (e) {
            // Some old browser versions (ex: chrome 67) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to PerformanceObserver with entryTypes
            mainEntries.push.apply(mainEntries, experimentalEntries);
        }
        var mainObserver = new PerformanceObserver(handlePerformanceEntryList_1);
        mainObserver.observe({ entryTypes: mainEntries });
        if (supportPerformanceObject() && 'addEventListener' in performance) {
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
            performance.addEventListener('resourcetimingbufferfull', function () {
                performance.clearResourceTimings();
            });
        }
    }
    if (!supportPerformanceTimingEvent('navigation')) {
        retrieveNavigationTiming(function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
    if (!supportPerformanceTimingEvent('first-input')) {
        retrieveFirstInputTiming(function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
}
function retrieveInitialDocumentResourceTiming(callback) {
    runOnReadyState('interactive', function () {
        var timing;
        var forcedAttributes = {
            entryType: 'resource',
            initiatorType: FAKE_INITIAL_DOCUMENT,
            traceId: getDocumentTraceId(document),
        };
        if (supportPerformanceTimingEvent('navigation') && performance.getEntriesByType('navigation').length > 0) {
            var navigationEntry = performance.getEntriesByType('navigation')[0];
            timing = utils_assign(navigationEntry.toJSON(), forcedAttributes);
        }
        else {
            var relativePerformanceTiming = computeRelativePerformanceTiming();
            timing = utils_assign(relativePerformanceTiming, {
                decodedBodySize: 0,
                duration: relativePerformanceTiming.responseEnd,
                name: window.location.href,
                startTime: 0,
            }, forcedAttributes);
        }
        callback(timing);
    });
}
function retrieveNavigationTiming(callback) {
    function sendFakeTiming() {
        callback(utils_assign(computeRelativePerformanceTiming(), {
            entryType: 'navigation',
        }));
    }
    runOnReadyState('complete', function () {
        // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
        setTimeout(monitor(sendFakeTiming));
    });
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */
function retrieveFirstInputTiming(callback) {
    var startTimeStamp = Date.now();
    var timingSent = false;
    var removeEventListeners = addEventListeners(window, ["click" /* CLICK */, "mousedown" /* MOUSE_DOWN */, "keydown" /* KEY_DOWN */, "touchstart" /* TOUCH_START */, "pointerdown" /* POINTER_DOWN */], function (evt) {
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) {
            return;
        }
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        var timing = {
            entryType: 'first-input',
            processingStart: relativeNow(),
            startTime: evt.timeStamp,
        };
        if (evt.type === "pointerdown" /* POINTER_DOWN */) {
            sendTimingIfPointerIsNotCancelled(timing);
        }
        else {
            sendTiming(timing);
        }
    }, { passive: true, capture: true }).stop;
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differentiate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */
    function sendTimingIfPointerIsNotCancelled(timing) {
        addEventListeners(window, ["pointerup" /* POINTER_UP */, "pointercancel" /* POINTER_CANCEL */], function (event) {
            if (event.type === "pointerup" /* POINTER_UP */) {
                sendTiming(timing);
            }
        }, { once: true });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            var delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < Date.now() - startTimeStamp) {
                callback(timing);
            }
        }
    }
}
function computeRelativePerformanceTiming() {
    var result = {};
    var timing = performance.timing;
    for (var key in timing) {
        if (isNumber(timing[key])) {
            var numberKey = key;
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
            var timingElement = timing[numberKey];
            result[numberKey] = timingElement === 0 ? 0 : getRelativeTime(timingElement);
        }
    }
    return result;
}
function handleRumPerformanceEntries(lifeCycle, configuration, entries) {
    var rumPerformanceEntries = entries.filter(function (entry) {
        return entry.entryType === 'resource' ||
            entry.entryType === 'navigation' ||
            entry.entryType === 'paint' ||
            entry.entryType === 'longtask' ||
            entry.entryType === 'largest-contentful-paint' ||
            entry.entryType === 'first-input' ||
            entry.entryType === 'layout-shift';
    });
    var rumAllowedPerformanceEntries = rumPerformanceEntries.filter(function (entry) { return !isIncompleteNavigation(entry) && !isForbiddenResource(configuration, entry); });
    if (rumAllowedPerformanceEntries.length) {
        lifeCycle.notify(0 /* PERFORMANCE_ENTRIES_COLLECTED */, rumAllowedPerformanceEntries);
    }
}
function isIncompleteNavigation(entry) {
    return entry.entryType === 'navigation' && entry.loadEventEnd <= 0;
}
function isForbiddenResource(configuration, entry) {
    return entry.entryType === 'resource' && !isAllowedRequestUrl(configuration, entry.name);
}
//# sourceMappingURL=performanceCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/createEventRateLimiter.js



function createEventRateLimiter(eventType, limit, onLimitReached) {
    var eventCount = 0;
    var allowNextEvent = false;
    return {
        isLimitReached: function () {
            if (eventCount === 0) {
                setTimeout(function () {
                    eventCount = 0;
                }, ONE_MINUTE);
            }
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
                        source: ErrorSource.AGENT,
                        startClocks: clocksNow(),
                    });
                }
                finally {
                    allowNextEvent = false;
                }
            }
            return true;
        },
    };
}
//# sourceMappingURL=createEventRateLimiter.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/limitModification.js

/**
 * Current limitation:
 * - field path do not support array, 'a.b.c' only
 */
function limitModification(object, modifiableFieldPaths, modifier) {
    var clone = deepClone(object);
    var result = modifier(clone);
    modifiableFieldPaths.forEach(function (path) {
        var originalValue = get(object, path);
        var newValue = get(clone, path);
        var originalType = getType(originalValue);
        var newType = getType(newValue);
        if (newType === originalType) {
            set(object, path, newValue);
        }
        else if (originalType === 'object' && (newType === 'undefined' || newType === 'null')) {
            set(object, path, {});
        }
    });
    return result;
}
function get(object, path) {
    var current = object;
    for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
        var field = _a[_i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        current = current[field];
    }
    return current;
}
function set(object, path, value) {
    var current = object;
    var fields = path.split('.');
    for (var i = 0; i < fields.length; i += 1) {
        var field = fields[i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        if (i !== fields.length - 1) {
            current = current[field];
        }
        else {
            current[field] = value;
        }
    }
}
function isValidObjectContaining(object, field) {
    return typeof object === 'object' && object !== null && field in object;
}
//# sourceMappingURL=limitModification.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/ciTestContext.js
function getCiTestContext() {
    var _a;
    var testExecutionId = (_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId');
    if (typeof testExecutionId === 'string') {
        return {
            test_execution_id: testExecutionId,
        };
    }
}
//# sourceMappingURL=ciTestContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/assembly.js



var VIEW_EVENTS_MODIFIABLE_FIELD_PATHS = [
    // Fields with sensitive data
    'view.url',
    'view.referrer',
    'action.target.name',
    'error.message',
    'error.stack',
    'error.resource.url',
    'resource.url',
];
var OTHER_EVENTS_MODIFIABLE_FIELD_PATHS = VIEW_EVENTS_MODIFIABLE_FIELD_PATHS.concat([
    // User-customizable field
    'context',
]);
function startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, getCommonContext) {
    var _a;
    var reportError = function (error) {
        lifeCycle.notify(12 /* RAW_ERROR_COLLECTED */, { error: error });
    };
    var eventRateLimiters = (_a = {},
        _a["error" /* ERROR */] = createEventRateLimiter("error" /* ERROR */, configuration.eventRateLimiterThreshold, reportError),
        _a["action" /* ACTION */] = createEventRateLimiter("action" /* ACTION */, configuration.eventRateLimiterThreshold, reportError),
        _a);
    var syntheticsContext = getSyntheticsContext();
    var ciTestContext = getCiTestContext();
    lifeCycle.subscribe(10 /* RAW_RUM_EVENT_COLLECTED */, function (_a) {
        var startTime = _a.startTime, rawRumEvent = _a.rawRumEvent, domainContext = _a.domainContext, savedCommonContext = _a.savedCommonContext, customerContext = _a.customerContext;
        var viewContext = viewContexts.findView(startTime);
        var urlContext = urlContexts.findUrl(startTime);
        // allow to send events if the session was tracked when they start
        // except for views which are continuously updated
        // TODO: stop sending view updates when session is expired
        var session = sessionManager.findTrackedSession(rawRumEvent.type !== "view" /* VIEW */ ? startTime : undefined);
        if (session && viewContext && urlContext) {
            var commonContext = savedCommonContext || getCommonContext();
            var rumContext = {
                _dd: {
                    format_version: 2,
                    drift: currentDrift(),
                    session: {
                        plan: session.hasPremiumPlan ? 2 /* PREMIUM */ : 1 /* LITE */,
                    },
                    browser_sdk_version: canUseEventBridge() ? "4.11.2" : undefined,
                },
                application: {
                    id: configuration.applicationId,
                },
                date: timeStampNow(),
                service: configuration.service,
                source: 'browser',
                session: {
                    id: session.id,
                    type: syntheticsContext ? "synthetics" /* SYNTHETICS */ : ciTestContext ? "ci_test" /* CI_TEST */ : "user" /* USER */,
                },
                synthetics: syntheticsContext,
                ci_test: ciTestContext,
            };
            var actionId = actionContexts.findActionId(startTime);
            if (!isExperimentalFeatureEnabled('sub-apps')) {
                delete viewContext.service;
                delete viewContext.version;
            }
            else {
                rumContext.version = configuration.version;
            }
            var serverRumEvent = (needToAssembleWithAction(rawRumEvent) && actionId
                ? combine(rumContext, urlContext, viewContext, { action: { id: actionId } }, rawRumEvent)
                : combine(rumContext, urlContext, viewContext, rawRumEvent));
            serverRumEvent.context = combine(commonContext.context, customerContext);
            if (!('has_replay' in serverRumEvent.session)) {
                ;
                serverRumEvent.session.has_replay = commonContext.hasReplay;
            }
            if (!isEmptyObject(commonContext.user)) {
                ;
                serverRumEvent.usr = commonContext.user;
            }
            if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
                if (isEmptyObject(serverRumEvent.context)) {
                    delete serverRumEvent.context;
                }
                lifeCycle.notify(11 /* RUM_EVENT_COLLECTED */, serverRumEvent);
            }
        }
    });
}
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    var _a;
    if (beforeSend) {
        var result = limitModification(event, event.type === "view" /* VIEW */ ? VIEW_EVENTS_MODIFIABLE_FIELD_PATHS : OTHER_EVENTS_MODIFIABLE_FIELD_PATHS, function (event) { return beforeSend(event, domainContext); });
        if (result === false && event.type !== "view" /* VIEW */) {
            return false;
        }
        if (result === false) {
            display.warn("Can't dismiss view events using beforeSend!");
        }
    }
    var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
    return !rateLimitReached;
}
function needToAssembleWithAction(event) {
    return ["error" /* ERROR */, "resource" /* RESOURCE */, "long_task" /* LONG_TASK */].indexOf(event.type) !== -1;
}
//# sourceMappingURL=assembly.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/foregroundContexts.js

// Arbitrary value to cap number of element mostly for backend & to save bandwidth
var MAX_NUMBER_OF_SELECTABLE_FOREGROUND_PERIODS = 500;
// Arbitrary value to cap number of element mostly for memory consumption in the browser
var MAX_NUMBER_OF_STORED_FOREGROUND_PERIODS = 2500;
var foregroundPeriods = [];
function startForegroundContexts() {
    if (document.hasFocus()) {
        addNewForegroundPeriod();
    }
    var stopForegroundTracking = trackFocus(addNewForegroundPeriod).stop;
    var stopBlurTracking = trackBlur(closeForegroundPeriod).stop;
    return {
        isInForegroundAt: isInForegroundAt,
        selectInForegroundPeriodsFor: selectInForegroundPeriodsFor,
        stop: function () {
            foregroundPeriods = [];
            stopForegroundTracking();
            stopBlurTracking();
        },
    };
}
function addNewForegroundPeriod() {
    if (foregroundPeriods.length > MAX_NUMBER_OF_STORED_FOREGROUND_PERIODS) {
        return;
    }
    var currentForegroundPeriod = foregroundPeriods[foregroundPeriods.length - 1];
    var now = relativeNow();
    if (currentForegroundPeriod !== undefined && currentForegroundPeriod.end === undefined) {
        return;
    }
    foregroundPeriods.push({
        start: now,
    });
}
function closeForegroundPeriod() {
    if (foregroundPeriods.length === 0) {
        return;
    }
    var currentForegroundPeriod = foregroundPeriods[foregroundPeriods.length - 1];
    var now = relativeNow();
    if (currentForegroundPeriod.end !== undefined) {
        return;
    }
    currentForegroundPeriod.end = now;
}
function trackFocus(onFocusChange) {
    return addEventListener(window, "focus" /* FOCUS */, function (event) {
        if (!event.isTrusted) {
            return;
        }
        onFocusChange();
    });
}
function trackBlur(onBlurChange) {
    return addEventListener(window, "blur" /* BLUR */, function (event) {
        if (!event.isTrusted) {
            return;
        }
        onBlurChange();
    });
}
function isInForegroundAt(startTime) {
    for (var i = foregroundPeriods.length - 1; i >= 0; i--) {
        var foregroundPeriod = foregroundPeriods[i];
        if (foregroundPeriod.end !== undefined && startTime > foregroundPeriod.end) {
            break;
        }
        if (startTime > foregroundPeriod.start &&
            (foregroundPeriod.end === undefined || startTime < foregroundPeriod.end)) {
            return true;
        }
    }
    return false;
}
function selectInForegroundPeriodsFor(eventStartTime, duration) {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    var eventEndTime = (eventStartTime + duration);
    var filteredForegroundPeriods = [];
    var earliestIndex = Math.max(0, foregroundPeriods.length - MAX_NUMBER_OF_SELECTABLE_FOREGROUND_PERIODS);
    for (var i = foregroundPeriods.length - 1; i >= earliestIndex; i--) {
        var foregroundPeriod = foregroundPeriods[i];
        if (foregroundPeriod.end !== undefined && eventStartTime > foregroundPeriod.end) {
            // event starts after the end of the current focus period
            // since the array is sorted, we can stop looking for foreground periods
            break;
        }
        if (eventEndTime < foregroundPeriod.start) {
            // event ends before the start of the current focus period
            // continue to previous one
            continue;
        }
        var startTime = eventStartTime > foregroundPeriod.start ? eventStartTime : foregroundPeriod.start;
        var startDuration = elapsed(eventStartTime, startTime);
        var endTime = foregroundPeriod.end === undefined || eventEndTime < foregroundPeriod.end ? eventEndTime : foregroundPeriod.end;
        var endDuration = elapsed(startTime, endTime);
        filteredForegroundPeriods.unshift({
            start: toServerDuration(startDuration),
            duration: toServerDuration(endDuration),
        });
    }
    return filteredForegroundPeriods;
}
//# sourceMappingURL=foregroundContexts.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/internalContext.js

/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
function startInternalContext(applicationId, sessionManager, viewContexts, actionContexts, urlContexts) {
    return {
        get: function (startTime) {
            var viewContext = viewContexts.findView(startTime);
            var urlContext = urlContexts.findUrl(startTime);
            var session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                var actionId = actionContexts.findActionId(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionId ? { id: actionId } : undefined,
                    view: utils_assign({}, viewContext.view, urlContext.view),
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/lifeCycle.js
var LifeCycle = /** @class */ (function () {
    function LifeCycle() {
        this.callbacks = {};
    }
    LifeCycle.prototype.notify = function (eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) {
            eventCallbacks.forEach(function (callback) { return callback(data); });
        }
    };
    LifeCycle.prototype.subscribe = function (eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) {
            this.callbacks[eventType] = [];
        }
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function () {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) { return callback !== other; });
            },
        };
    };
    return LifeCycle;
}());

//# sourceMappingURL=lifeCycle.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.js

var SESSION_TIME_OUT_DELAY = 4 * ONE_HOUR;
var SESSION_EXPIRATION_DELAY = 15 * ONE_MINUTE;
//# sourceMappingURL=sessionConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/contextHistory.js


var END_OF_TIMES = Infinity;
var CLEAR_OLD_CONTEXTS_INTERVAL = ONE_MINUTE;
/**
 * Store and keep track of contexts spans. This whole class assumes that contexts are added in
 * chronological order (i.e. all entries have an increasing start time).
 */
var ContextHistory = /** @class */ (function () {
    function ContextHistory(expireDelay) {
        var _this = this;
        this.expireDelay = expireDelay;
        this.entries = [];
        this.clearOldContextsInterval = setInterval(function () { return _this.clearOldContexts(); }, CLEAR_OLD_CONTEXTS_INTERVAL);
    }
    /**
     * Add a context to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */
    ContextHistory.prototype.add = function (context, startTime) {
        var _this = this;
        var entry = {
            context: context,
            startTime: startTime,
            endTime: END_OF_TIMES,
            remove: function () {
                var index = _this.entries.indexOf(entry);
                if (index >= 0) {
                    _this.entries.splice(index, 1);
                }
            },
            close: function (endTime) {
                entry.endTime = endTime;
            },
        };
        this.entries.unshift(entry);
        return entry;
    };
    /**
     * Return the latest context that was active during `startTime`, or the currently active context
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     */
    ContextHistory.prototype.find = function (startTime) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
            var entry = _a[_i];
            if (entry.startTime <= startTime) {
                if (startTime <= entry.endTime) {
                    return entry.context;
                }
                break;
            }
        }
    };
    /**
     * Helper function to close the currently active context, if any. This method assumes that entries
     * are not overlapping.
     */
    ContextHistory.prototype.closeActive = function (endTime) {
        var latestEntry = this.entries[0];
        if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
            latestEntry.close(endTime);
        }
    };
    /**
     * Return all contexts that were active during `startTime`, or all currently active contexts if no
     * `startTime` is provided.
     */
    ContextHistory.prototype.findAll = function (startTime) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        return this.entries
            .filter(function (entry) { return entry.startTime <= startTime && startTime <= entry.endTime; })
            .map(function (entry) { return entry.context; });
    };
    /**
     * Remove all entries from this collection.
     */
    ContextHistory.prototype.reset = function () {
        this.entries = [];
    };
    /**
     * Stop internal garbage collection of past entries.
     */
    ContextHistory.prototype.stop = function () {
        clearInterval(this.clearOldContextsInterval);
    };
    ContextHistory.prototype.clearOldContexts = function () {
        var oldTimeThreshold = relativeNow() - this.expireDelay;
        while (this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < oldTimeThreshold) {
            this.entries.pop();
        }
    };
    return ContextHistory;
}());

//# sourceMappingURL=contextHistory.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/viewContexts.js

var VIEW_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
function startViewContexts(lifeCycle) {
    var viewContextHistory = new ContextHistory(VIEW_CONTEXT_TIME_OUT_DELAY);
    lifeCycle.subscribe(2 /* VIEW_CREATED */, function (view) {
        viewContextHistory.add(buildViewContext(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(4 /* VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        viewContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(8 /* SESSION_RENEWED */, function () {
        viewContextHistory.reset();
    });
    function buildViewContext(view) {
        return {
            service: view.service,
            version: view.version,
            view: {
                id: view.id,
                name: view.name,
            },
        };
    }
    return {
        findView: function (startTime) { return viewContextHistory.find(startTime); },
        stop: function () {
            viewContextHistory.stop();
        },
    };
}
//# sourceMappingURL=viewContexts.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/instrumentMethod.js


function instrumentMethod(object, method, instrumentationFactory) {
    var original = object[method];
    var instrumentation = instrumentationFactory(original);
    var instrumentationWrapper = function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return instrumentation.apply(this, arguments);
    };
    object[method] = instrumentationWrapper;
    return {
        stop: function () {
            if (object[method] === instrumentationWrapper) {
                object[method] = original;
            }
            else {
                instrumentation = original;
            }
        },
    };
}
function instrumentMethodAndCallOriginal(object, method, _a) {
    var before = _a.before, after = _a.after;
    return instrumentMethod(object, method, function (original) {
        return function () {
            var args = arguments;
            var result;
            if (before) {
                callMonitored(before, this, args);
            }
            if (typeof original === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                result = original.apply(this, args);
            }
            if (after) {
                callMonitored(after, this, args);
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return result;
        };
    });
}
function instrumentSetter(object, property, after) {
    var originalDescriptor = Object.getOwnPropertyDescriptor(object, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
        return { stop: noop };
    }
    var instrumentation = function (thisObject, value) {
        // put hooked setter into event loop to avoid of set latency
        setTimeout(monitor(function () {
            after(thisObject, value);
        }), 0);
    };
    var instrumentationWrapper = function (value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(object, property, {
        set: instrumentationWrapper,
    });
    return {
        stop: function () {
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(object, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
                Object.defineProperty(object, property, originalDescriptor);
            }
            else {
                instrumentation = noop;
            }
        },
    };
}
//# sourceMappingURL=instrumentMethod.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/browser/xhrObservable.js






var xhrObservable;
var xhrContexts = new WeakMap();
function initXhrObservable() {
    if (!xhrObservable) {
        xhrObservable = createXhrObservable();
    }
    return xhrObservable;
}
function createXhrObservable() {
    var observable = new Observable(function () {
        var stopInstrumentingStart = instrumentMethodAndCallOriginal(XMLHttpRequest.prototype, 'open', {
            before: openXhr,
        }).stop;
        var stopInstrumentingSend = instrumentMethodAndCallOriginal(XMLHttpRequest.prototype, 'send', {
            before: function () {
                sendXhr.call(this, observable);
            },
        }).stop;
        var stopInstrumentingAbort = instrumentMethodAndCallOriginal(XMLHttpRequest.prototype, 'abort', {
            before: abortXhr,
        }).stop;
        return function () {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
    return observable;
}
function openXhr(method, url) {
    xhrContexts.set(this, {
        state: 'open',
        method: method,
        url: normalizeUrl(url.toString()),
    });
}
function sendXhr(observable) {
    var _this = this;
    var context = xhrContexts.get(this);
    if (!context) {
        return;
    }
    var startContext = context;
    startContext.state = 'start';
    startContext.startTime = relativeNow();
    startContext.startClocks = clocksNow();
    startContext.isAborted = false;
    startContext.xhr = this;
    var hasBeenReported = false;
    var stopInstrumentingOnReadyStateChange = instrumentMethodAndCallOriginal(this, 'onreadystatechange', {
        before: function () {
            if (this.readyState === XMLHttpRequest.DONE) {
                // Try to report the XHR as soon as possible, because the XHR may be mutated by the
                // application during a future event. For example, Angular is calling .abort() on
                // completed requests during a onreadystatechange event, so the status becomes '0'
                // before the request is collected.
                onEnd();
            }
        },
    }).stop;
    var onEnd = monitor(function () {
        _this.removeEventListener('loadend', onEnd);
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) {
            return;
        }
        hasBeenReported = true;
        var completeContext = context;
        completeContext.state = 'complete';
        completeContext.duration = elapsed(startContext.startClocks.timeStamp, timeStampNow());
        completeContext.status = _this.status;
        observable.notify(shallowClone(completeContext));
    });
    this.addEventListener('loadend', onEnd);
    observable.notify(startContext);
}
function abortXhr() {
    var context = xhrContexts.get(this);
    if (context) {
        context.isAborted = true;
    }
}
//# sourceMappingURL=xhrObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/browser/fetchObservable.js





var fetchObservable;
function initFetchObservable() {
    if (!fetchObservable) {
        fetchObservable = createFetchObservable();
    }
    return fetchObservable;
}
function createFetchObservable() {
    var observable = new Observable(function () {
        if (!window.fetch) {
            return;
        }
        var stop = instrumentMethod(window, 'fetch', function (originalFetch) {
            return function (input, init) {
                var responsePromise;
                var context = callMonitored(beforeSend, null, [observable, input, init]);
                if (context) {
                    responsePromise = originalFetch.call(this, context.input, context.init);
                    callMonitored(afterSend, null, [observable, responsePromise, context]);
                }
                else {
                    responsePromise = originalFetch.call(this, input, init);
                }
                return responsePromise;
            };
        }).stop;
        return stop;
    });
    return observable;
}
function beforeSend(observable, input, init) {
    var method = (init && init.method) || (typeof input === 'object' && input.method) || 'GET';
    var url = normalizeUrl((typeof input === 'object' && input.url) || input);
    var startClocks = clocksNow();
    var context = {
        state: 'start',
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
    };
    observable.notify(context);
    return context;
}
function afterSend(observable, responsePromise, startContext) {
    var reportFetch = function (response) {
        var context = startContext;
        context.state = 'complete';
        context.duration = elapsed(context.startClocks.timeStamp, timeStampNow());
        if ('stack' in response || response instanceof Error) {
            context.status = 0;
            context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
            context.error = response;
            observable.notify(context);
        }
        else if ('status' in response) {
            context.response = response;
            context.responseType = response.type;
            context.status = response.status;
            context.isAborted = false;
            observable.notify(context);
        }
    };
    responsePromise.then(monitor(reportFetch), monitor(reportFetch));
}
//# sourceMappingURL=fetchObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/tracing/tracer.js

/**
 * Clear tracing information to avoid incomplete traces. Ideally, we should do it when the
 * request did not reach the server, but the browser does not expose this. So, we clear tracing
 * information if the request ended with status 0 without being aborted by the application.
 *
 * Reasoning:
 *
 * * Applications are usually aborting requests after a bit of time, for example when the user is
 * typing (autocompletion) or navigating away (in a SPA). With a performant device and good
 * network conditions, the request is likely to reach the server before being canceled.
 *
 * * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
 * are likely to finish quickly and without reaching the server.
 *
 * Of course, it might not be the case every time, but it should limit having incomplete traces a
 * bit.
 * */
function clearTracingIfNeeded(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = undefined;
        context.spanId = undefined;
        context.traceSampled = undefined;
    }
}
function startTracer(configuration, sessionManager) {
    return {
        clearTracingIfNeeded: clearTracingIfNeeded,
        traceFetch: function (context) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                var _a;
                if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
                    context.input = new Request(context.input);
                    Object.keys(tracingHeaders).forEach(function (key) {
                        ;
                        context.input.headers.append(key, tracingHeaders[key]);
                    });
                }
                else {
                    context.init = shallowClone(context.init);
                    var headers_1 = [];
                    if (context.init.headers instanceof Headers) {
                        context.init.headers.forEach(function (value, key) {
                            headers_1.push([key, value]);
                        });
                    }
                    else if (Array.isArray(context.init.headers)) {
                        context.init.headers.forEach(function (header) {
                            headers_1.push(header);
                        });
                    }
                    else if (context.init.headers) {
                        Object.keys(context.init.headers).forEach(function (key) {
                            headers_1.push([key, context.init.headers[key]]);
                        });
                    }
                    context.init.headers = headers_1.concat(objectEntries(tracingHeaders));
                }
            });
        },
        traceXhr: function (context, xhr) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                Object.keys(tracingHeaders).forEach(function (name) {
                    xhr.setRequestHeader(name, tracingHeaders[name]);
                });
            });
        },
    };
}
function injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
    if (!isTracingSupported() || !isAllowedUrl(configuration, context.url) || !sessionManager.findTrackedSession()) {
        return;
    }
    context.traceId = new TraceIdentifier();
    context.spanId = new TraceIdentifier();
    context.traceSampled = performDraw(configuration.tracingSampleRate);
    inject(makeTracingHeaders(context.traceId, context.spanId, context.traceSampled));
}
function isAllowedUrl(configuration, requestUrl) {
    return matchList(configuration.allowedTracingOrigins, getOrigin(requestUrl));
}
function isTracingSupported() {
    return getCrypto() !== undefined;
}
function getCrypto() {
    return window.crypto || window.msCrypto;
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */
function makeTracingHeaders(traceId, spanId, traceSampled) {
    return {
        'x-datadog-origin': 'rum',
        'x-datadog-parent-id': spanId.toDecimalString(),
        'x-datadog-sampling-priority': traceSampled ? '1' : '0',
        'x-datadog-trace-id': traceId.toDecimalString(),
    };
}
/* eslint-disable no-bitwise */
var TraceIdentifier = /** @class */ (function () {
    function TraceIdentifier() {
        this.buffer = new Uint8Array(8);
        getCrypto().getRandomValues(this.buffer);
        this.buffer[0] = this.buffer[0] & 0x7f; // force 63-bit
    }
    TraceIdentifier.prototype.toString = function (radix) {
        var high = this.readInt32(0);
        var low = this.readInt32(4);
        var str = '';
        do {
            var mod = (high % radix) * 4294967296 + low;
            high = Math.floor(high / radix);
            low = Math.floor(mod / radix);
            str = (mod % radix).toString(radix) + str;
        } while (high || low);
        return str;
    };
    /**
     * Format used everywhere except the trace intake
     */
    TraceIdentifier.prototype.toDecimalString = function () {
        return this.toString(10);
    };
    TraceIdentifier.prototype.readInt32 = function (offset) {
        return (this.buffer[offset] * 16777216 +
            (this.buffer[offset + 1] << 16) +
            (this.buffer[offset + 2] << 8) +
            this.buffer[offset + 3]);
    };
    return TraceIdentifier;
}());

/* eslint-enable no-bitwise */
//# sourceMappingURL=tracer.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/requestCollection.js



var nextRequestIndex = 1;
function startRequestCollection(lifeCycle, configuration, sessionManager) {
    var tracer = startTracer(configuration, sessionManager);
    trackXhr(lifeCycle, configuration, tracer);
    trackFetch(lifeCycle, configuration, tracer);
}
function trackXhr(lifeCycle, configuration, tracer) {
    var subscription = initXhrObservable().subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceXhr(context, context.xhr);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(6 /* REQUEST_COMPLETED */, {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    traceSampled: context.traceSampled,
                    type: "xhr" /* XHR */,
                    url: context.url,
                    xhr: context.xhr,
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function trackFetch(lifeCycle, configuration, tracer) {
    var subscription = initFetchObservable().subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceFetch(context);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(6 /* REQUEST_COMPLETED */, {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    responseType: context.responseType,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    traceSampled: context.traceSampled,
                    type: "fetch" /* FETCH */,
                    url: context.url,
                    response: context.response,
                    init: context.init,
                    input: context.input,
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function getNextRequestIndex() {
    var result = nextRequestIndex;
    nextRequestIndex += 1;
    return result;
}
//# sourceMappingURL=requestCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/trackEventCounts.js

function trackEventCounts(lifeCycle, callback) {
    if (callback === void 0) { callback = noop; }
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        actionCount: 0,
        frustrationCount: 0,
    };
    var subscription = lifeCycle.subscribe(11 /* RUM_EVENT_COLLECTED */, function (event) {
        switch (event.type) {
            case "error" /* ERROR */:
                eventCounts.errorCount += 1;
                callback(eventCounts);
                break;
            case "action" /* ACTION */:
                eventCounts.actionCount += 1;
                if (event.action.frustration) {
                    eventCounts.frustrationCount += event.action.frustration.type.length;
                }
                callback(eventCounts);
                break;
            case "long_task" /* LONG_TASK */:
                eventCounts.longTaskCount += 1;
                callback(eventCounts);
                break;
            case "resource" /* RESOURCE */:
                eventCounts.resourceCount += 1;
                callback(eventCounts);
                break;
        }
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackEventCounts.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/waitPageActivityEnd.js

// Delay to wait for a page activity to validate the tracking process
var PAGE_ACTIVITY_VALIDATION_DELAY = 100;
// Delay to wait after a page activity to end the tracking process
var PAGE_ACTIVITY_END_DELAY = 100;
/**
 * Wait for the page activity end
 *
 * Detection lifecycle:
 * ```
 *                        Wait page activity end
 *              .-------------------'--------------------.
 *              v                                        v
 *     [Wait for a page activity ]          [Wait for a maximum duration]
 *     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
 *          /                  \                           |
 *         v                    v                          |
 *  [No page activity]   [Page activity]                   |
 *         |                   |,----------------------.   |
 *         v                   v                       |   |
 *     (Discard)     [Wait for a page activity]        |   |
 *                   [   timeout: END_DELAY   ]        |   |
 *                       /                \            |   |
 *                      v                  v           |   |
 *             [No page activity]    [Page activity]   |   |
 *                      |                 |            |   |
 *                      |                 '------------'   |
 *                      '-----------. ,--------------------'
 *                                   v
 *                                 (End)
 * ```
 *
 * Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
 * process is still alive after maxDuration, it has been validated.
 */
function waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, pageActivityEndCallback, maxDuration) {
    var pageActivityObservable = createPageActivityObservable(lifeCycle, domMutationObservable, configuration);
    return doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration);
}
function doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration) {
    var pageActivityEndTimeoutId;
    var hasCompleted = false;
    var validationTimeoutId = setTimeout(monitor(function () { return complete({ hadActivity: false }); }), PAGE_ACTIVITY_VALIDATION_DELAY);
    var maxDurationTimeoutId = maxDuration &&
        setTimeout(monitor(function () { return complete({ hadActivity: true, end: timeStampNow() }); }), maxDuration);
    var pageActivitySubscription = pageActivityObservable.subscribe(function (_a) {
        var isBusy = _a.isBusy;
        clearTimeout(validationTimeoutId);
        clearTimeout(pageActivityEndTimeoutId);
        var lastChangeTime = timeStampNow();
        if (!isBusy) {
            pageActivityEndTimeoutId = setTimeout(monitor(function () { return complete({ hadActivity: true, end: lastChangeTime }); }), PAGE_ACTIVITY_END_DELAY);
        }
    });
    var stop = function () {
        hasCompleted = true;
        clearTimeout(validationTimeoutId);
        clearTimeout(pageActivityEndTimeoutId);
        clearTimeout(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) {
            return;
        }
        stop();
        pageActivityEndCallback(event);
    }
    return { stop: stop };
}
function createPageActivityObservable(lifeCycle, domMutationObservable, configuration) {
    var observable = new Observable(function () {
        var subscriptions = [];
        var firstRequestIndex;
        var pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe(function () { return notifyPageActivity(pendingRequestsCount); }), lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
            if (entries.some(function (entry) { return entry.entryType === 'resource' && !isExcludedUrl(configuration, entry.name); })) {
                notifyPageActivity(pendingRequestsCount);
            }
        }), lifeCycle.subscribe(5 /* REQUEST_STARTED */, function (startEvent) {
            if (isExcludedUrl(configuration, startEvent.url)) {
                return;
            }
            if (firstRequestIndex === undefined) {
                firstRequestIndex = startEvent.requestIndex;
            }
            notifyPageActivity(++pendingRequestsCount);
        }), lifeCycle.subscribe(6 /* REQUEST_COMPLETED */, function (request) {
            if (isExcludedUrl(configuration, request.url) ||
                firstRequestIndex === undefined ||
                // If the request started before the tracking start, ignore it
                request.requestIndex < firstRequestIndex) {
                return;
            }
            notifyPageActivity(--pendingRequestsCount);
        }));
        return function () { return subscriptions.forEach(function (s) { return s.unsubscribe(); }); };
    });
    function notifyPageActivity(pendingRequestsCount) {
        observable.notify({ isBusy: pendingRequestsCount > 0 });
    }
    return observable;
}
function isExcludedUrl(configuration, requestUrl) {
    return matchList(configuration.excludedActivityUrls, requestUrl);
}
//# sourceMappingURL=waitPageActivityEnd.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/rageClickChain.js

var MAX_DURATION_BETWEEN_CLICKS = ONE_SECOND;
var MAX_DISTANCE_BETWEEN_CLICKS = 100;
function createRageClickChain(firstClick) {
    var bufferedClicks = [];
    var status = 0 /* WaitingForMoreClicks */;
    var maxDurationBetweenClicksTimeout;
    var rageClick = firstClick.clone();
    appendClick(firstClick);
    function appendClick(click) {
        click.stopObservable.subscribe(tryFinalize);
        bufferedClicks.push(click);
        clearTimeout(maxDurationBetweenClicksTimeout);
        maxDurationBetweenClicksTimeout = setTimeout(monitor(dontAcceptMoreClick), MAX_DURATION_BETWEEN_CLICKS);
    }
    function tryFinalize() {
        if (status === 1 /* WaitingForClicksToStop */ && bufferedClicks.every(function (click) { return click.isStopped(); })) {
            status = 2 /* Finalized */;
            finalizeClicks(bufferedClicks, rageClick);
        }
    }
    function dontAcceptMoreClick() {
        clearTimeout(maxDurationBetweenClicksTimeout);
        if (status === 0 /* WaitingForMoreClicks */) {
            status = 1 /* WaitingForClicksToStop */;
            tryFinalize();
        }
    }
    return {
        tryAppend: function (click) {
            if (status !== 0 /* WaitingForMoreClicks */) {
                return false;
            }
            if (bufferedClicks.length > 0 &&
                !areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
                dontAcceptMoreClick();
                return false;
            }
            appendClick(click);
            return true;
        },
        stop: function () {
            dontAcceptMoreClick();
        },
    };
}
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */
function areEventsSimilar(first, second) {
    return (first.target === second.target &&
        mouseEventDistance(first, second) <= MAX_DISTANCE_BETWEEN_CLICKS &&
        first.timeStamp - second.timeStamp <= MAX_DURATION_BETWEEN_CLICKS);
}
function mouseEventDistance(origin, other) {
    return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}
function finalizeClicks(clicks, rageClick) {
    if (isRage(clicks)) {
        clicks.forEach(function (click) {
            click.discard();
            click.getFrustrations().forEach(function (frustration) {
                rageClick.addFrustration(frustration);
            });
        });
        rageClick.addFrustration("rage_click" /* RAGE_CLICK */);
        rageClick.validate(timeStampNow());
    }
    else {
        rageClick.discard();
        clicks.forEach(function (click) { return click.validate(); });
    }
}
var MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function isRage(clicks) {
    // TODO: this condition should be improved to avoid reporting 3-click selection as rage click
    for (var i = 0; i < clicks.length - (MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1) {
        if (clicks[i + MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <=
            ONE_SECOND) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=rageClickChain.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/browserDetection.js
function isIE() {
    return Boolean(document.documentMode);
}
function isChromium() {
    return !!window.chrome || /HeadlessChrome/.test(window.navigator.userAgent);
}
//# sourceMappingURL=browserDetection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/getActionNameFromElement.js

/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */
var DEFAULT_PROGRAMMATIC_ATTRIBUTE = 'data-dd-action-name';
function getActionNameFromElement(element, userProgrammaticAttribute) {
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, use strategies that are known to return good results. Those strategies will be used on
    //   the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    return (getActionNameFromElementProgrammatically(element, DEFAULT_PROGRAMMATIC_ATTRIBUTE) ||
        (userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute)) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, priorityStrategies) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, fallbackStrategies) ||
        '');
}
function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    var elementWithAttribute;
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    // If available, use element.closest() to match get the attribute from the element or any of its
    // parent.  Else fallback to a more traditional implementation.
    if (supportsElementClosest()) {
        elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
    }
    else {
        var element = targetElement;
        while (element) {
            if (element.hasAttribute(programmaticAttribute)) {
                elementWithAttribute = element;
                break;
            }
            element = element.parentElement;
        }
    }
    if (!elementWithAttribute) {
        return;
    }
    var name = elementWithAttribute.getAttribute(programmaticAttribute);
    return truncate(normalizeWhitespace(name.trim()));
}
var priorityStrategies = [
    // associated LABEL text
    function (element, userProgrammaticAttribute) {
        // IE does not support element.labels, so we fallback to a CSS selector based on the element id
        // instead
        if (supportsLabelProperty()) {
            if ('labels' in element && element.labels && element.labels.length > 0) {
                return getTextualContent(element.labels[0], userProgrammaticAttribute);
            }
        }
        else if (element.id) {
            var label = element.ownerDocument && element.ownerDocument.querySelector("label[for=\"".concat(element.id.replace('"', '\\"'), "\"]"));
            return label && getTextualContent(label, userProgrammaticAttribute);
        }
    },
    // INPUT button (and associated) value
    function (element) {
        if (element.nodeName === 'INPUT') {
            var input = element;
            var type = input.getAttribute('type');
            if (type === 'button' || type === 'submit' || type === 'reset') {
                return input.value;
            }
        }
    },
    // BUTTON, LABEL or button-like element text
    function (element, userProgrammaticAttribute) {
        if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') {
            return getTextualContent(element, userProgrammaticAttribute);
        }
    },
    function (element) { return element.getAttribute('aria-label'); },
    // associated element text designated by the aria-labelledby attribute
    function (element, userProgrammaticAttribute) {
        var labelledByAttribute = element.getAttribute('aria-labelledby');
        if (labelledByAttribute) {
            return labelledByAttribute
                .split(/\s+/)
                .map(function (id) { return getElementById(element, id); })
                .filter(function (label) { return Boolean(label); })
                .map(function (element) { return getTextualContent(element, userProgrammaticAttribute); })
                .join(' ');
        }
    },
    function (element) { return element.getAttribute('alt'); },
    function (element) { return element.getAttribute('name'); },
    function (element) { return element.getAttribute('title'); },
    function (element) { return element.getAttribute('placeholder'); },
    // SELECT first OPTION text
    function (element, userProgrammaticAttribute) {
        if ('options' in element && element.options.length > 0) {
            return getTextualContent(element.options[0], userProgrammaticAttribute);
        }
    },
];
var fallbackStrategies = [
    function (element, userProgrammaticAttribute) { return getTextualContent(element, userProgrammaticAttribute); },
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */
var MAX_PARENTS_TO_CONSIDER = 10;
function getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies) {
    var element = targetElement;
    var recursionCounter = 0;
    while (recursionCounter <= MAX_PARENTS_TO_CONSIDER &&
        element &&
        element.nodeName !== 'BODY' &&
        element.nodeName !== 'HTML' &&
        element.nodeName !== 'HEAD') {
        for (var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++) {
            var strategy = strategies_1[_i];
            var name_1 = strategy(element, userProgrammaticAttribute);
            if (typeof name_1 === 'string') {
                var trimmedName = name_1.trim();
                if (trimmedName) {
                    return truncate(normalizeWhitespace(trimmedName));
                }
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === 'FORM') {
            break;
        }
        element = element.parentElement;
        recursionCounter += 1;
    }
}
function normalizeWhitespace(s) {
    return s.replace(/\s+/g, ' ');
}
function truncate(s) {
    return s.length > 100 ? "".concat(safeTruncate(s, 100), " [...]") : s;
}
function getElementById(refElement, id) {
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function getTextualContent(element, userProgrammaticAttribute) {
    if (element.isContentEditable) {
        return;
    }
    if ('innerText' in element) {
        var text_1 = element.innerText;
        var removeTextFromElements = function (query) {
            var list = element.querySelectorAll(query);
            for (var index = 0; index < list.length; index += 1) {
                var element_1 = list[index];
                if ('innerText' in element_1) {
                    var textToReplace = element_1.innerText;
                    if (textToReplace && textToReplace.trim().length > 0) {
                        text_1 = text_1.replace(textToReplace, '');
                    }
                }
            }
        };
        if (!supportsInnerTextScriptAndStyleRemoval()) {
            // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
            // be relatively fast and work in most cases.
            removeTextFromElements('script, style');
        }
        // remove the text of elements with programmatic attribute value
        removeTextFromElements("[".concat(DEFAULT_PROGRAMMATIC_ATTRIBUTE, "]"));
        if (userProgrammaticAttribute) {
            removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
        }
        return text_1;
    }
    return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */
function supportsInnerTextScriptAndStyleRemoval() {
    return !isIE();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsLabelPropertyResult;
function supportsLabelProperty() {
    if (supportsLabelPropertyResult === undefined) {
        supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
    }
    return supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsElementClosestResult;
function supportsElementClosest() {
    if (supportsElementClosestResult === undefined) {
        supportsElementClosestResult = 'closest' in HTMLElement.prototype;
    }
    return supportsElementClosestResult;
}
//# sourceMappingURL=getActionNameFromElement.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/trackClickActions.js





// Maximum duration for click actions
var CLICK_ACTION_MAX_DURATION = 10 * ONE_SECOND;
var ACTION_CONTEXT_TIME_OUT_DELAY = 5 * ONE_MINUTE; // arbitrary
function trackClickActions(lifeCycle, domMutationObservable, configuration) {
    var history = new ContextHistory(ACTION_CONTEXT_TIME_OUT_DELAY);
    var stopObservable = new Observable();
    var trackFrustrations = configuration.trackFrustrations;
    var currentRageClickChain;
    lifeCycle.subscribe(8 /* SESSION_RENEWED */, function () {
        history.reset();
    });
    lifeCycle.subscribe(9 /* BEFORE_UNLOAD */, stopRageClickChain);
    lifeCycle.subscribe(4 /* VIEW_ENDED */, stopRageClickChain);
    var stopListener = listenClickEvents(processClick).stop;
    var actionContexts = {
        findActionId: function (startTime) {
            return trackFrustrations ? history.findAll(startTime) : history.find(startTime);
        },
    };
    return {
        stop: function () {
            stopRageClickChain();
            stopObservable.notify();
            stopListener();
        },
        actionContexts: actionContexts,
    };
    function stopRageClickChain() {
        if (currentRageClickChain) {
            currentRageClickChain.stop();
        }
    }
    function processClick(event) {
        if (!trackFrustrations && history.find()) {
            // TODO: remove this in a future major version. To keep retrocompatibility, ignore any new
            // action if another one is already occurring.
            return;
        }
        var name = getActionNameFromElement(event.target, configuration.actionNameAttribute);
        if (!trackFrustrations && !name) {
            // TODO: remove this in a future major version. To keep retrocompatibility, ignore any action
            // with a blank name
            return;
        }
        var startClocks = clocksNow();
        var click = newClick(lifeCycle, history, trackFrustrations, {
            name: name,
            event: event,
            startClocks: startClocks,
        });
        if (trackFrustrations && (!currentRageClickChain || !currentRageClickChain.tryAppend(click))) {
            currentRageClickChain = createRageClickChain(click);
        }
        var stopWaitPageActivityEnd = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
            if (!pageActivityEndEvent.hadActivity) {
                // If it has no activity, consider it as a dead click.
                // TODO: this will yield a lot of false positive. We'll need to refine it in the future.
                if (trackFrustrations) {
                    click.addFrustration("dead_click" /* DEAD_CLICK */);
                    click.stop();
                }
                else {
                    click.discard();
                }
            }
            else if (pageActivityEndEvent.end < startClocks.timeStamp) {
                // If the clock is looking weird, just discard the click
                click.discard();
            }
            else if (trackFrustrations) {
                // If we track frustrations, let's stop the click, but validate it later
                click.stop(pageActivityEndEvent.end);
            }
            else {
                // Else just validate it now
                click.validate(pageActivityEndEvent.end);
            }
        }, CLICK_ACTION_MAX_DURATION).stop;
        var viewEndedSubscription = lifeCycle.subscribe(4 /* VIEW_ENDED */, function (_a) {
            var endClocks = _a.endClocks;
            click.stop(endClocks.timeStamp);
        });
        var stopSubscription = stopObservable.subscribe(function () {
            click.stop();
        });
        click.stopObservable.subscribe(function () {
            viewEndedSubscription.unsubscribe();
            stopWaitPageActivityEnd();
            stopSubscription.unsubscribe();
        });
    }
}
function listenClickEvents(callback) {
    return addEventListener(window, "click" /* CLICK */, function (clickEvent) {
        if (clickEvent.target instanceof Element) {
            callback(clickEvent);
        }
    }, { capture: true });
}
function newClick(lifeCycle, history, trackFrustrations, base) {
    var id = generateUUID();
    var historyEntry = history.add(id, base.startClocks.relative);
    var eventCountsSubscription = trackEventCounts(lifeCycle);
    var state = { status: 0 /* ONGOING */ };
    var frustrations = new Set();
    var stopObservable = new Observable();
    function stop(endTime) {
        if (state.status !== 0 /* ONGOING */) {
            return;
        }
        state = { status: 1 /* STOPPED */, endTime: endTime };
        if (endTime) {
            historyEntry.close(getRelativeTime(endTime));
        }
        else {
            historyEntry.remove();
        }
        eventCountsSubscription.stop();
        stopObservable.notify();
    }
    function addFrustration(frustration) {
        if (trackFrustrations) {
            frustrations.add(frustration);
        }
    }
    return {
        event: base.event,
        addFrustration: addFrustration,
        stop: stop,
        stopObservable: stopObservable,
        getFrustrations: function () { return frustrations; },
        isStopped: function () { return state.status === 1 /* STOPPED */ || state.status === 2 /* FINALIZED */; },
        clone: function () { return newClick(lifeCycle, history, trackFrustrations, base); },
        validate: function (endTime) {
            stop(endTime);
            if (state.status !== 1 /* STOPPED */) {
                return;
            }
            if (eventCountsSubscription.eventCounts.errorCount > 0) {
                addFrustration("error_click" /* ERROR_CLICK */);
            }
            var _a = eventCountsSubscription.eventCounts, resourceCount = _a.resourceCount, errorCount = _a.errorCount, longTaskCount = _a.longTaskCount;
            var clickAction = utils_assign({
                type: "click" /* CLICK */,
                duration: state.endTime && elapsed(base.startClocks.timeStamp, state.endTime),
                id: id,
                frustrationTypes: setToArray(frustrations),
                counts: {
                    resourceCount: resourceCount,
                    errorCount: errorCount,
                    longTaskCount: longTaskCount,
                },
            }, base);
            lifeCycle.notify(1 /* AUTO_ACTION_COMPLETED */, clickAction);
            state = { status: 2 /* FINALIZED */ };
        },
        discard: function () {
            stop();
            state = { status: 2 /* FINALIZED */ };
        },
    };
}
//# sourceMappingURL=trackClickActions.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/actionCollection.js


function startActionCollection(lifeCycle, domMutationObservable, configuration, foregroundContexts) {
    lifeCycle.subscribe(1 /* AUTO_ACTION_COMPLETED */, function (action) {
        return lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, processAction(action, foregroundContexts));
    });
    var actionContexts = { findActionId: noop };
    if (configuration.trackInteractions) {
        actionContexts = trackClickActions(lifeCycle, domMutationObservable, configuration).actionContexts;
    }
    return {
        addAction: function (action, savedCommonContext) {
            lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, utils_assign({
                savedCommonContext: savedCommonContext,
            }, processAction(action, foregroundContexts)));
        },
        actionContexts: actionContexts,
    };
}
function processAction(action, foregroundContexts) {
    var autoActionProperties = isAutoAction(action)
        ? {
            action: {
                id: action.id,
                loading_time: toServerDuration(action.duration),
                frustration: {
                    type: action.frustrationTypes,
                },
                error: {
                    count: action.counts.errorCount,
                },
                long_task: {
                    count: action.counts.longTaskCount,
                },
                resource: {
                    count: action.counts.resourceCount,
                },
            },
        }
        : undefined;
    var customerContext = !isAutoAction(action) ? action.context : undefined;
    var actionEvent = combine({
        action: {
            id: generateUUID(),
            target: {
                name: action.name,
            },
            type: action.type,
        },
        date: action.startClocks.timeStamp,
        type: "action" /* ACTION */,
    }, autoActionProperties);
    var inForeground = foregroundContexts.isInForegroundAt(action.startClocks.relative);
    if (inForeground !== undefined) {
        actionEvent.view = { in_foreground: inForeground };
    }
    return {
        customerContext: customerContext,
        rawRumEvent: actionEvent,
        startTime: action.startClocks.relative,
        domainContext: isAutoAction(action) ? { event: action.event } : {},
    };
}
function isAutoAction(action) {
    return action.type !== "custom" /* CUSTOM */;
}
//# sourceMappingURL=actionCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/tracekit/tracekit.js


// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
/**
 * Cross-browser collection of unhandled errors
 *
 * Supports:
 * - Firefox: full stack trace with line numbers, plus column number
 * on top frame; column number is not guaranteed
 * - Opera: full stack trace with line and column numbers
 * - Chrome: full stack trace with line and column numbers
 * - Safari: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 * - IE: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 * - IE5.5+ (only 8.0 tested)
 * - Firefox 0.9+ (only 3.5+ tested)
 * - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 * Exceptions Have Stacktrace to be enabled in opera:config)
 * - Safari 3+ (only 4+ tested)
 * - Chrome 1+ (only 5+ tested)
 * - Konqueror 3.5+ (untested)
 *
 * Tries to catch all unhandled errors and report them to the
 * callback.
 *
 * Callbacks receive a StackTrace object as described in the
 * computeStackTrace docs.
 *
 * @memberof TraceKit
 * @namespace
 */
function startUnhandledErrorCollection(callback) {
    var stopInstrumentingOnError = instrumentOnError(callback).stop;
    var stopInstrumentingOnUnhandledRejection = instrumentUnhandledRejection(callback).stop;
    return {
        stop: function () {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        },
    };
}
/**
 * Install a global onerror handler
 */
function instrumentOnError(callback) {
    return instrumentMethodAndCallOriginal(window, 'onerror', {
        before: function (message, url, lineNo, columnNo, errorObj) {
            var stack;
            if (errorObj) {
                stack = computeStackTrace(errorObj);
                callback(stack, errorObj);
            }
            else {
                var location_1 = {
                    url: url,
                    column: columnNo,
                    line: lineNo,
                };
                var name_1;
                var msg = message;
                if ({}.toString.call(message) === '[object String]') {
                    var groups = ERROR_TYPES_RE.exec(msg);
                    if (groups) {
                        name_1 = groups[1];
                        msg = groups[2];
                    }
                }
                stack = {
                    name: name_1,
                    message: typeof msg === 'string' ? msg : undefined,
                    stack: [location_1],
                };
                callback(stack, message);
            }
        },
    });
}
/**
 * Install a global onunhandledrejection handler
 */
function instrumentUnhandledRejection(callback) {
    return instrumentMethodAndCallOriginal(window, 'onunhandledrejection', {
        before: function (e) {
            var reason = e.reason || 'Empty reason';
            var stack = computeStackTrace(reason);
            callback(stack, reason);
        },
    });
}
//# sourceMappingURL=tracekit.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js



function trackRuntimeError(errorObservable) {
    return startUnhandledErrorCollection(function (stackTrace, errorObject) {
        var _a = formatUnknownError(stackTrace, errorObject, 'Uncaught'), stack = _a.stack, message = _a.message, type = _a.type;
        errorObservable.notify({
            message: message,
            stack: stack,
            type: type,
            source: ErrorSource.SOURCE,
            startClocks: clocksNow(),
            originalError: errorObject,
            handling: "unhandled" /* UNHANDLED */,
        });
    });
}
//# sourceMappingURL=trackRuntimeError.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/console/consoleObservable.js






var consoleObservablesByApi = {};
function initConsoleObservable(apis) {
    var consoleObservables = apis.map(function (api) {
        if (!consoleObservablesByApi[api]) {
            consoleObservablesByApi[api] = createConsoleObservable(api);
        }
        return consoleObservablesByApi[api];
    });
    return mergeObservables.apply(void 0, consoleObservables);
}
/* eslint-disable no-console */
function createConsoleObservable(api) {
    var observable = new Observable(function () {
        var originalConsoleApi = console[api];
        console[api] = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            originalConsoleApi.apply(console, params);
            var handlingStack = createHandlingStack();
            callMonitored(function () {
                observable.notify(buildConsoleLog(params, api, handlingStack));
            });
        };
        return function () {
            console[api] = originalConsoleApi;
        };
    });
    return observable;
}
function buildConsoleLog(params, api, handlingStack) {
    // Todo: remove console error prefix in the next major version
    var message = params.map(function (param) { return formatConsoleParameters(param); }).join(' ');
    var stack;
    if (api === ConsoleApiName.error) {
        var firstErrorParam = find(params, function (param) { return param instanceof Error; });
        stack = firstErrorParam ? toStackTraceString(computeStackTrace(firstErrorParam)) : undefined;
        message = "console error: ".concat(message);
    }
    return {
        api: api,
        message: message,
        stack: stack,
        handlingStack: handlingStack,
    };
}
function formatConsoleParameters(param) {
    if (typeof param === 'string') {
        return param;
    }
    if (param instanceof Error) {
        return formatErrorMessage(computeStackTrace(param));
    }
    return jsonStringify(param, undefined, 2);
}
//# sourceMappingURL=consoleObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/error/trackConsoleError.js

function trackConsoleError(errorObservable) {
    var subscription = initConsoleObservable([ConsoleApiName.error]).subscribe(function (consoleError) {
        return errorObservable.notify({
            startClocks: clocksNow(),
            message: consoleError.message,
            stack: consoleError.stack,
            source: ErrorSource.CONSOLE,
            handling: "handled" /* HANDLED */,
            handlingStack: consoleError.handlingStack,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackConsoleError.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/report/reportObservable.js




var RawReportType = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation',
};
function initReportObservable(apis) {
    var observables = [];
    if (includes(apis, RawReportType.cspViolation)) {
        observables.push(createCspViolationReportObservable());
    }
    var reportTypes = apis.filter(function (api) { return api !== RawReportType.cspViolation; });
    if (reportTypes.length) {
        observables.push(createReportObservable(reportTypes));
    }
    return mergeObservables.apply(void 0, observables);
}
function createReportObservable(reportTypes) {
    var observable = new Observable(function () {
        if (!window.ReportingObserver) {
            return;
        }
        var handleReports = monitor(function (reports) {
            return reports.forEach(function (report) {
                observable.notify(buildRawReportFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true,
        });
        observer.observe();
        return function () {
            observer.disconnect();
        };
    });
    return observable;
}
function createCspViolationReportObservable() {
    var observable = new Observable(function () {
        var handleCspViolation = monitor(function (event) {
            observable.notify(buildRawReportFromCspViolation(event));
        });
        var stop = addEventListener(document, "securitypolicyviolation" /* SECURITY_POLICY_VIOLATION */, handleCspViolation).stop;
        return stop;
    });
    return observable;
}
function buildRawReportFromReport(_a) {
    var type = _a.type, body = _a.body;
    return {
        type: type,
        subtype: body.id,
        message: "".concat(type, ": ").concat(body.message),
        stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber),
    };
}
function buildRawReportFromCspViolation(event) {
    var type = RawReportType.cspViolation;
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return {
        type: RawReportType.cspViolation,
        subtype: event.effectiveDirective,
        message: "".concat(type, ": ").concat(message),
        stack: buildStack(event.effectiveDirective, "".concat(message, " of the policy \"").concat(safeTruncate(event.originalPolicy, 100, '...'), "\""), event.sourceFile, event.lineNumber, event.columnNumber),
    };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return (sourceFile &&
        toStackTraceString({
            name: name,
            message: message,
            stack: [
                {
                    func: '?',
                    url: sourceFile,
                    line: lineNumber,
                    column: columnNumber,
                },
            ],
        }));
}
//# sourceMappingURL=reportObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/error/trackReportError.js

function trackReportError(errorObservable) {
    var subscription = initReportObservable([RawReportType.cspViolation, RawReportType.intervention]).subscribe(function (reportError) {
        return errorObservable.notify({
            startClocks: clocksNow(),
            message: reportError.message,
            stack: reportError.stack,
            type: reportError.subtype,
            source: ErrorSource.REPORT,
            handling: "unhandled" /* UNHANDLED */,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackReportError.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/error/errorCollection.js



function startErrorCollection(lifeCycle, foregroundContexts) {
    var errorObservable = new Observable();
    trackConsoleError(errorObservable);
    trackRuntimeError(errorObservable);
    trackReportError(errorObservable);
    errorObservable.subscribe(function (error) { return lifeCycle.notify(12 /* RAW_ERROR_COLLECTED */, { error: error }); });
    return doStartErrorCollection(lifeCycle, foregroundContexts);
}
function doStartErrorCollection(lifeCycle, foregroundContexts) {
    lifeCycle.subscribe(12 /* RAW_ERROR_COLLECTED */, function (_a) {
        var error = _a.error, customerContext = _a.customerContext, savedCommonContext = _a.savedCommonContext;
        lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, utils_assign({
            customerContext: customerContext,
            savedCommonContext: savedCommonContext,
        }, processError(error, foregroundContexts)));
    });
    return {
        addError: function (_a, savedCommonContext) {
            var error = _a.error, handlingStack = _a.handlingStack, startClocks = _a.startClocks, customerContext = _a.context;
            var rawError = computeRawError(error, handlingStack, startClocks);
            lifeCycle.notify(12 /* RAW_ERROR_COLLECTED */, {
                customerContext: customerContext,
                savedCommonContext: savedCommonContext,
                error: rawError,
            });
        },
    };
}
function computeRawError(error, handlingStack, startClocks) {
    var stackTrace = error instanceof Error ? computeStackTrace(error) : undefined;
    return utils_assign({
        startClocks: startClocks,
        source: ErrorSource.CUSTOM,
        originalError: error,
        handling: "handled" /* HANDLED */,
    }, formatUnknownError(stackTrace, error, 'Provided', handlingStack));
}
function processError(error, foregroundContexts) {
    var rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: generateUUID(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            type: error.type,
            handling: error.handling,
            source_type: 'browser',
        },
        type: "error" /* ERROR */,
    };
    var inForeground = foregroundContexts.isInForegroundAt(error.startClocks.relative);
    if (inForeground !== undefined) {
        rawRumEvent.view = { in_foreground: inForeground };
    }
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startClocks.relative,
        domainContext: {
            error: error.originalError,
        },
    };
}
//# sourceMappingURL=errorCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/longTask/longTaskCollection.js

function startLongTaskCollection(lifeCycle, sessionManager) {
    lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType !== 'longtask') {
                break;
            }
            var session = sessionManager.findTrackedSession(entry.startTime);
            if (!session || session.hasLitePlan) {
                break;
            }
            var startClocks = relativeToClocks(entry.startTime);
            var rawRumEvent = {
                date: startClocks.timeStamp,
                long_task: {
                    id: generateUUID(),
                    duration: toServerDuration(entry.duration),
                },
                type: "long_task" /* LONG_TASK */,
            };
            lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, {
                rawRumEvent: rawRumEvent,
                startTime: startClocks.relative,
                domainContext: { performanceEntry: entry.toJSON() },
            });
        }
    });
}
//# sourceMappingURL=longTaskCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/resource/matchRequestTiming.js

/**
 * Look for corresponding timing in resource timing buffer
 *
 * Observations:
 * - Timing (start, end) are nested inside the request (start, end)
 * - Some timing can be not exactly nested, being off by < 1 ms
 * - Browsers generate a timing entry for OPTIONS request
 *
 * Strategy:
 * - from valid nested entries (with 1 ms error margin)
 * - if a single timing match, return the timing
 * - if two following timings match (OPTIONS request), return the timing for the actual request
 * - otherwise we can't decide, return undefined
 */
function matchRequestTiming(request) {
    if (!performance || !('getEntriesByName' in performance)) {
        return;
    }
    var sameNameEntries = performance.getEntriesByName(request.url, 'resource');
    if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) {
        return;
    }
    var candidates = sameNameEntries
        .map(function (entry) { return entry.toJSON(); })
        .filter(toValidEntry)
        .filter(function (entry) {
        return isBetween(entry, request.startClocks.relative, endTime({ startTime: request.startClocks.relative, duration: request.duration }));
    });
    if (candidates.length === 1) {
        return candidates[0];
    }
    if (candidates.length === 2 && firstCanBeOptionRequest(candidates)) {
        return candidates[1];
    }
    return;
}
function firstCanBeOptionRequest(correspondingEntries) {
    return endTime(correspondingEntries[0]) <= correspondingEntries[1].startTime;
}
function endTime(timing) {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    return (timing.startTime + timing.duration);
}
function isBetween(timing, start, end) {
    var errorMargin = 1;
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    return timing.startTime >= start - errorMargin && endTime(timing) <= end + errorMargin;
}
//# sourceMappingURL=matchRequestTiming.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/resource/resourceCollection.js




function startResourceCollection(lifeCycle) {
    lifeCycle.subscribe(6 /* REQUEST_COMPLETED */, function (request) {
        lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, processRequest(request));
    });
    lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'resource' && !isRequestKind(entry)) {
                lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, processResourceEntry(entry));
            }
        }
    });
}
function processRequest(request) {
    var type = request.type === "xhr" /* XHR */ ? "xhr" /* XHR */ : "fetch" /* FETCH */;
    var matchingTiming = matchRequestTiming(request);
    var startClocks = matchingTiming ? relativeToClocks(matchingTiming.startTime) : request.startClocks;
    var correspondingTimingOverrides = matchingTiming ? computePerformanceEntryMetrics(matchingTiming) : undefined;
    var tracingInfo = computeRequestTracingInfo(request);
    var resourceEvent = combine({
        date: startClocks.timeStamp,
        resource: {
            id: generateUUID(),
            type: type,
            duration: toServerDuration(request.duration),
            method: request.method,
            status_code: request.status,
            url: request.url,
        },
        type: "resource" /* RESOURCE */,
    }, tracingInfo, correspondingTimingOverrides);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: matchingTiming && toPerformanceEntryRepresentation(matchingTiming),
            xhr: request.xhr,
            response: request.response,
            requestInput: request.input,
            requestInit: request.init,
            error: request.error,
        },
    };
}
function processResourceEntry(entry) {
    var type = computeResourceKind(entry);
    var entryMetrics = computePerformanceEntryMetrics(entry);
    var tracingInfo = computeEntryTracingInfo(entry);
    var startClocks = relativeToClocks(entry.startTime);
    var resourceEvent = combine({
        date: startClocks.timeStamp,
        resource: {
            id: generateUUID(),
            type: type,
            url: entry.name,
        },
        type: "resource" /* RESOURCE */,
    }, tracingInfo, entryMetrics);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: toPerformanceEntryRepresentation(entry),
        },
    };
}
function computePerformanceEntryMetrics(timing) {
    return {
        resource: utils_assign({
            duration: computePerformanceResourceDuration(timing),
            size: computeSize(timing),
        }, computePerformanceResourceDetails(timing)),
    };
}
function computeRequestTracingInfo(request) {
    var hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            span_id: request.spanId.toDecimalString(),
            trace_id: request.traceId.toDecimalString(),
        },
    };
}
function computeEntryTracingInfo(entry) {
    return entry.traceId ? { _dd: { trace_id: entry.traceId } } : undefined;
}
function toPerformanceEntryRepresentation(entry) {
    if (supportPerformanceEntry() && entry instanceof PerformanceEntry) {
        entry.toJSON();
    }
    return entry;
}
//# sourceMappingURL=resourceCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackFirstHidden.js

var trackFirstHiddenSingleton;
var stopListeners;
function trackFirstHidden(emitter) {
    if (emitter === void 0) { emitter = window; }
    if (!trackFirstHiddenSingleton) {
        if (document.visibilityState === 'hidden') {
            trackFirstHiddenSingleton = {
                timeStamp: 0,
            };
        }
        else {
            trackFirstHiddenSingleton = {
                timeStamp: Infinity,
            };
            (stopListeners = addEventListeners(emitter, ["pagehide" /* PAGE_HIDE */, "visibilitychange" /* VISIBILITY_CHANGE */], function (event) {
                if (event.type === 'pagehide' || document.visibilityState === 'hidden') {
                    trackFirstHiddenSingleton.timeStamp = event.timeStamp;
                    stopListeners();
                }
            }, { capture: true }).stop);
        }
    }
    return trackFirstHiddenSingleton;
}
function resetFirstHidden() {
    if (stopListeners) {
        stopListeners();
    }
    trackFirstHiddenSingleton = undefined;
}
//# sourceMappingURL=trackFirstHidden.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackInitialViewTimings.js


// Discard LCP and FCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var TIMING_MAXIMUM_DELAY = 10 * ONE_MINUTE;
function trackInitialViewTimings(lifeCycle, callback) {
    var timings = {};
    function setTimings(newTimings) {
        utils_assign(timings, newTimings);
        callback(timings);
    }
    var stopNavigationTracking = trackNavigationTimings(lifeCycle, setTimings).stop;
    var stopFCPTracking = trackFirstContentfulPaintTiming(lifeCycle, function (firstContentfulPaint) {
        return setTimings({ firstContentfulPaint: firstContentfulPaint });
    }).stop;
    var stopLCPTracking = trackLargestContentfulPaintTiming(lifeCycle, window, function (largestContentfulPaint) {
        setTimings({
            largestContentfulPaint: largestContentfulPaint,
        });
    }).stop;
    var stopFIDTracking = trackFirstInputTimings(lifeCycle, function (_a) {
        var firstInputDelay = _a.firstInputDelay, firstInputTime = _a.firstInputTime;
        setTimings({
            firstInputDelay: firstInputDelay,
            firstInputTime: firstInputTime,
        });
    }).stop;
    return {
        stop: function () {
            stopNavigationTracking();
            stopFCPTracking();
            stopLCPTracking();
            stopFIDTracking();
        },
    };
}
function trackNavigationTimings(lifeCycle, callback) {
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'navigation') {
                callback({
                    domComplete: entry.domComplete,
                    domContentLoaded: entry.domContentLoadedEventEnd,
                    domInteractive: entry.domInteractive,
                    loadEvent: entry.loadEventEnd,
                });
            }
        }
    }).unsubscribe;
    return { stop: stop };
}
function trackFirstContentfulPaintTiming(lifeCycle, callback) {
    var firstHidden = trackFirstHidden();
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var fcpEntry = find(entries, function (entry) {
            return entry.entryType === 'paint' &&
                entry.name === 'first-contentful-paint' &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < TIMING_MAXIMUM_DELAY;
        });
        if (fcpEntry) {
            callback(fcpEntry.startTime);
        }
    }).unsubscribe;
    return { stop: stop };
}
/**
 * Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
 * multiple values, only the most recent one should be used.
 * Documentation: https://web.dev/lcp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getLCP.ts
 */
function trackLargestContentfulPaintTiming(lifeCycle, emitter, callback) {
    var firstHidden = trackFirstHidden();
    // Ignore entries that come after the first user interaction.  According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    var firstInteractionTimestamp = Infinity;
    var stopEventListener = addEventListeners(emitter, ["pointerdown" /* POINTER_DOWN */, "keydown" /* KEY_DOWN */], function (event) {
        firstInteractionTimestamp = event.timeStamp;
    }, { capture: true, once: true }).stop;
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var lcpEntry = findLast(entries, function (entry) {
            return entry.entryType === 'largest-contentful-paint' &&
                entry.startTime < firstInteractionTimestamp &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < TIMING_MAXIMUM_DELAY;
        });
        if (lcpEntry) {
            callback(lcpEntry.startTime);
        }
    }).unsubscribe;
    return {
        stop: function () {
            stopEventListener();
            unsubscribeLifeCycle();
        },
    };
}
/**
 * Track the first input occurring during the initial View to return:
 * - First Input Delay
 * - First Input Time
 * Callback is called at most one time.
 * Documentation: https://web.dev/fid/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getFID.ts
 */
function trackFirstInputTimings(lifeCycle, callback) {
    var firstHidden = trackFirstHidden();
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var firstInputEntry = find(entries, function (entry) {
            return entry.entryType === 'first-input' && entry.startTime < firstHidden.timeStamp;
        });
        if (firstInputEntry) {
            var firstInputDelay = elapsed(firstInputEntry.startTime, firstInputEntry.processingStart);
            callback({
                // Ensure firstInputDelay to be positive, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
                firstInputDelay: firstInputDelay >= 0 ? firstInputDelay : 0,
                firstInputTime: firstInputEntry.startTime,
            });
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
//# sourceMappingURL=trackInitialViewTimings.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackViewMetrics.js




function trackViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
    var viewMetrics = {
        eventCounts: {
            errorCount: 0,
            longTaskCount: 0,
            resourceCount: 0,
            actionCount: 0,
            frustrationCount: 0,
        },
    };
    var stopEventCountsTracking = trackEventCounts(lifeCycle, function (newEventCounts) {
        viewMetrics.eventCounts = newEventCounts;
        scheduleViewUpdate();
    }).stop;
    var _a = trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadingType, viewStart, function (newLoadingTime) {
        viewMetrics.loadingTime = newLoadingTime;
        scheduleViewUpdate();
    }), stopLoadingTimeTracking = _a.stop, setLoadEvent = _a.setLoadEvent;
    var stopCLSTracking;
    if (isLayoutShiftSupported()) {
        viewMetrics.cumulativeLayoutShift = 0;
        (stopCLSTracking = trackCumulativeLayoutShift(lifeCycle, function (cumulativeLayoutShift) {
            viewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
            scheduleViewUpdate();
        }).stop);
    }
    else {
        stopCLSTracking = noop;
    }
    return {
        stop: function () {
            stopEventCountsTracking();
            stopLoadingTimeTracking();
            stopCLSTracking();
        },
        setLoadEvent: setLoadEvent,
        viewMetrics: viewMetrics,
    };
}
function trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadType, viewStart, callback) {
    var isWaitingForLoadEvent = loadType === "initial_load" /* INITIAL_LOAD */;
    var isWaitingForActivityLoadingTime = true;
    var loadingTimeCandidates = [];
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
            callback(Math.max.apply(Math, loadingTimeCandidates));
        }
    }
    var stop = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (event) {
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) {
                loadingTimeCandidates.push(elapsed(viewStart.timeStamp, event.end));
            }
            invokeCallbackIfAllCandidatesAreReceived();
        }
    }).stop;
    return {
        stop: stop,
        setLoadEvent: function (loadEvent) {
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        },
    };
}
/**
 * Track the cumulative layout shifts (CLS).
 * Layout shifts are grouped into session windows.
 * The minimum gap between session windows is 1 second.
 * The maximum duration of a session window is 5 second.
 * The session window layout shift value is the sum of layout shifts inside it.
 * The CLS value is the max of session windows values.
 *
 * This yields a new value whenever the CLS value is updated (a higher session window value is computed).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation:
 * https://web.dev/cls/
 * https://web.dev/evolving-cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */
function trackCumulativeLayoutShift(lifeCycle, callback) {
    var maxClsValue = 0;
    var window = slidingSessionWindow();
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'layout-shift' && !entry.hadRecentInput) {
                window.update(entry);
                if (window.value() > maxClsValue) {
                    maxClsValue = window.value();
                    callback(round(maxClsValue, 4));
                }
            }
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
function slidingSessionWindow() {
    var value = 0;
    var startTime;
    var endTime;
    return {
        update: function (entry) {
            var shouldCreateNewWindow = startTime === undefined ||
                entry.startTime - endTime >= ONE_SECOND ||
                entry.startTime - startTime >= 5 * ONE_SECOND;
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                value = entry.value;
            }
            else {
                value += entry.value;
                endTime = entry.startTime;
            }
        },
        value: function () { return value; },
    };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */
function isLayoutShiftSupported() {
    return supportPerformanceTimingEvent('layout-shift');
}
//# sourceMappingURL=trackViewMetrics.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackViews.js



var THROTTLE_VIEW_UPDATE_PERIOD = 3000;
var SESSION_KEEP_ALIVE_INTERVAL = 5 * ONE_MINUTE;
function trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
    var _a = trackInitialView(initialViewOptions), stopInitialViewTracking = _a.stop, initialView = _a.initialView;
    var currentView = initialView;
    var stopViewLifeCycle = startViewLifeCycle().stop;
    var locationChangeSubscription;
    if (areViewsTrackedAutomatically) {
        locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
    }
    function trackInitialView(options) {
        var initialView = newView(lifeCycle, domMutationObservable, configuration, location, "initial_load" /* INITIAL_LOAD */, clocksOrigin(), options);
        var stop = trackInitialViewTimings(lifeCycle, function (timings) {
            initialView.updateTimings(timings);
            initialView.scheduleUpdate();
        }).stop;
        return { initialView: initialView, stop: stop };
    }
    function trackViewChange(startClocks, viewOptions) {
        return newView(lifeCycle, domMutationObservable, configuration, location, "route_change" /* ROUTE_CHANGE */, startClocks, viewOptions);
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(8 /* SESSION_RENEWED */, function () {
            // do not trigger view update to avoid wrong data
            currentView.end();
            // Renew view on session renewal
            currentView = trackViewChange(undefined, {
                name: currentView.name,
                service: currentView.service,
                version: currentView.version,
            });
        });
        // End the current view on page unload
        lifeCycle.subscribe(9 /* BEFORE_UNLOAD */, function () {
            currentView.end();
            currentView.triggerUpdate();
        });
        // Session keep alive
        var keepAliveInterval = window.setInterval(monitor(function () {
            currentView.triggerUpdate();
        }), SESSION_KEEP_ALIVE_INTERVAL);
        return {
            stop: function () {
                clearInterval(keepAliveInterval);
            },
        };
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(function (_a) {
            var oldLocation = _a.oldLocation, newLocation = _a.newLocation;
            if (areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView.triggerUpdate();
                currentView = trackViewChange();
                return;
            }
        });
    }
    return {
        addTiming: function (name, time) {
            if (time === void 0) { time = timeStampNow(); }
            currentView.addTiming(name, time);
            currentView.scheduleUpdate();
        },
        startView: function (options, startClocks) {
            currentView.end(startClocks);
            currentView.triggerUpdate();
            currentView = trackViewChange(startClocks, options);
        },
        stop: function () {
            locationChangeSubscription === null || locationChangeSubscription === void 0 ? void 0 : locationChangeSubscription.unsubscribe();
            stopInitialViewTracking();
            stopViewLifeCycle();
            currentView.end();
        },
    };
}
function newView(lifeCycle, domMutationObservable, configuration, initialLocation, loadingType, startClocks, viewOptions) {
    if (startClocks === void 0) { startClocks = clocksNow(); }
    // Setup initial values
    var id = generateUUID();
    var timings = {};
    var customTimings = {};
    var documentVersion = 0;
    var endClocks;
    var location = shallowClone(initialLocation);
    var name;
    var service;
    var version;
    if (viewOptions) {
        name = viewOptions.name;
        service = viewOptions.service;
        version = viewOptions.version;
    }
    lifeCycle.notify(2 /* VIEW_CREATED */, { id: id, name: name, startClocks: startClocks, service: service, version: version });
    // Update the view every time the measures are changing
    var _a = throttle(monitor(triggerViewUpdate), THROTTLE_VIEW_UPDATE_PERIOD, {
        leading: false,
    }), scheduleViewUpdate = _a.throttled, cancelScheduleViewUpdate = _a.cancel;
    var _b = trackViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, startClocks), setLoadEvent = _b.setLoadEvent, stopViewMetricsTracking = _b.stop, viewMetrics = _b.viewMetrics;
    // Initial view update
    triggerViewUpdate();
    function triggerViewUpdate() {
        documentVersion += 1;
        var currentEnd = endClocks === undefined ? timeStampNow() : endClocks.timeStamp;
        lifeCycle.notify(3 /* VIEW_UPDATED */, utils_assign({
            customTimings: customTimings,
            documentVersion: documentVersion,
            id: id,
            name: name,
            service: service,
            version: version,
            loadingType: loadingType,
            location: location,
            startClocks: startClocks,
            timings: timings,
            duration: elapsed(startClocks.timeStamp, currentEnd),
            isActive: endClocks === undefined,
        }, viewMetrics));
    }
    return {
        name: name,
        service: service,
        version: version,
        scheduleUpdate: scheduleViewUpdate,
        end: function (clocks) {
            if (clocks === void 0) { clocks = clocksNow(); }
            endClocks = clocks;
            lifeCycle.notify(4 /* VIEW_ENDED */, { endClocks: endClocks });
            stopViewMetricsTracking();
        },
        triggerUpdate: function () {
            // cancel any pending view updates execution
            cancelScheduleViewUpdate();
            triggerViewUpdate();
        },
        updateTimings: function (newTimings) {
            timings = newTimings;
            if (newTimings.loadEvent !== undefined) {
                setLoadEvent(newTimings.loadEvent);
            }
        },
        addTiming: function (name, time) {
            var relativeTime = looksLikeRelativeTime(time) ? time : elapsed(startClocks.timeStamp, time);
            customTimings[sanitizeTiming(name)] = relativeTime;
        },
    };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */
function sanitizeTiming(name) {
    var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
    if (sanitized !== name) {
        display.warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
    }
    return sanitized;
}
function areDifferentLocation(currentLocation, otherLocation) {
    return (currentLocation.pathname !== otherLocation.pathname ||
        (!isHashAnAnchor(otherLocation.hash) &&
            getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash)));
}
function isHashAnAnchor(hash) {
    var correspondingId = hash.substr(1);
    return !!document.getElementById(correspondingId);
}
function getPathFromHash(hash) {
    var index = hash.indexOf('?');
    return index < 0 ? hash : hash.slice(0, index);
}
//# sourceMappingURL=trackViews.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/viewCollection.js


function startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, foregroundContexts, recorderApi, initialViewOptions) {
    lifeCycle.subscribe(3 /* VIEW_UPDATED */, function (view) {
        return lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, processViewUpdate(view, foregroundContexts, recorderApi));
    });
    return trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
function processViewUpdate(view, foregroundContexts, recorderApi) {
    var replayStats = recorderApi.getReplayStats(view.id);
    var viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
        },
        date: view.startClocks.timeStamp,
        type: "view" /* VIEW */,
        view: {
            action: {
                count: view.eventCounts.actionCount,
            },
            frustration: {
                count: view.eventCounts.frustrationCount,
            },
            cumulative_layout_shift: view.cumulativeLayoutShift,
            dom_complete: toServerDuration(view.timings.domComplete),
            dom_content_loaded: toServerDuration(view.timings.domContentLoaded),
            dom_interactive: toServerDuration(view.timings.domInteractive),
            error: {
                count: view.eventCounts.errorCount,
            },
            first_contentful_paint: toServerDuration(view.timings.firstContentfulPaint),
            first_input_delay: toServerDuration(view.timings.firstInputDelay),
            first_input_time: toServerDuration(view.timings.firstInputTime),
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: toServerDuration(view.timings.largestContentfulPaint),
            load_event: toServerDuration(view.timings.loadEvent),
            loading_time: discardNegativeDuration(toServerDuration(view.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount,
            },
            resource: {
                count: view.eventCounts.resourceCount,
            },
            time_spent: toServerDuration(view.duration),
            in_foreground_periods: foregroundContexts.selectInForegroundPeriodsFor(view.startClocks.relative, view.duration),
        },
        session: {
            has_replay: replayStats ? true : undefined,
        },
    };
    if (!isEmptyObject(view.customTimings)) {
        viewEvent.view.custom_timings = mapValues(view.customTimings, toServerDuration);
    }
    return {
        rawRumEvent: viewEvent,
        startTime: view.startClocks.relative,
        domainContext: {
            location: view.location,
        },
    };
}
function discardNegativeDuration(duration) {
    return isNumber(duration) && duration < 0 ? undefined : duration;
}
//# sourceMappingURL=viewCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionCookieStore.js





var SESSION_ENTRY_REGEXP = /^([a-z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
var SESSION_COOKIE_NAME = '_dd_s';
// arbitrary values
var LOCK_RETRY_DELAY = 10;
var MAX_NUMBER_OF_LOCK_RETRIES = 100;
var bufferedOperations = [];
var ongoingOperations;
function withCookieLockAccess(operations, numberOfRetries) {
    var _a;
    if (numberOfRetries === void 0) { numberOfRetries = 0; }
    if (!ongoingOperations) {
        ongoingOperations = operations;
    }
    if (operations !== ongoingOperations) {
        bufferedOperations.push(operations);
        return;
    }
    if (numberOfRetries >= MAX_NUMBER_OF_LOCK_RETRIES) {
        next();
        return;
    }
    var currentLock;
    var currentSession = retrieveSession();
    if (isCookieLockEnabled()) {
        // if someone has lock, retry later
        if (currentSession.lock) {
            retryLater(operations, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = generateUUID();
        currentSession.lock = currentLock;
        setSession(currentSession, operations.options);
        // if lock is not acquired, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, numberOfRetries);
            return;
        }
    }
    var processedSession = operations.process(currentSession);
    if (isCookieLockEnabled()) {
        // if lock corrupted after process, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        persistSession(processedSession, operations.options);
    }
    if (isCookieLockEnabled()) {
        // correctly handle lock around expiration would require to handle this case properly at several levels
        // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
        if (!(processedSession && isExpiredState(processedSession))) {
            // if lock corrupted after persist, retry later
            currentSession = retrieveSession();
            if (currentSession.lock !== currentLock) {
                retryLater(operations, numberOfRetries);
                return;
            }
            delete currentSession.lock;
            setSession(currentSession, operations.options);
            processedSession = currentSession;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date cookie value, the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentSession);
    next();
}
/**
 * Cookie lock strategy allows mitigating issues due to concurrent access to cookie.
 * This issue concerns only chromium browsers and enabling this on firefox increase cookie write failures.
 */
function isCookieLockEnabled() {
    return isChromium();
}
function retryLater(operations, currentNumberOfRetries) {
    setTimeout(monitor(function () {
        withCookieLockAccess(operations, currentNumberOfRetries + 1);
    }), LOCK_RETRY_DELAY);
}
function next() {
    ongoingOperations = undefined;
    var nextOperations = bufferedOperations.shift();
    if (nextOperations) {
        withCookieLockAccess(nextOperations);
    }
}
function persistSession(session, options) {
    if (isExpiredState(session)) {
        clearSession(options);
        return;
    }
    session.expire = String(Date.now() + SESSION_EXPIRATION_DELAY);
    setSession(session, options);
}
function setSession(session, options) {
    setCookie(SESSION_COOKIE_NAME, toSessionString(session), SESSION_EXPIRATION_DELAY, options);
}
function toSessionString(session) {
    return objectEntries(session)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    })
        .join(SESSION_ENTRY_SEPARATOR);
}
function retrieveSession() {
    var sessionString = getCookie(SESSION_COOKIE_NAME);
    var session = {};
    if (isValidSessionString(sessionString)) {
        sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
            var matches = SESSION_ENTRY_REGEXP.exec(entry);
            if (matches !== null) {
                var key = matches[1], value = matches[2];
                session[key] = value;
            }
        });
    }
    return session;
}
function isValidSessionString(sessionString) {
    return (sessionString !== undefined &&
        (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString)));
}
function isExpiredState(session) {
    return isEmptyObject(session);
}
function clearSession(options) {
    setCookie(SESSION_COOKIE_NAME, '', 0, options);
}
//# sourceMappingURL=sessionCookieStore.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/oldCookiesMigration.js


var OLD_SESSION_COOKIE_NAME = '_dd';
var OLD_RUM_COOKIE_NAME = '_dd_r';
var OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
var RUM_SESSION_KEY = 'rum';
var LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(options) {
    var sessionString = getCookie(SESSION_COOKIE_NAME);
    var oldSessionId = getCookie(OLD_SESSION_COOKIE_NAME);
    var oldRumType = getCookie(OLD_RUM_COOKIE_NAME);
    var oldLogsType = getCookie(OLD_LOGS_COOKIE_NAME);
    if (!sessionString) {
        var session = {};
        if (oldSessionId) {
            session.id = oldSessionId;
        }
        if (oldLogsType && /^[01]$/.test(oldLogsType)) {
            session[LOGS_SESSION_KEY] = oldLogsType;
        }
        if (oldRumType && /^[012]$/.test(oldRumType)) {
            session[RUM_SESSION_KEY] = oldRumType;
        }
        persistSession(session, options);
    }
}
//# sourceMappingURL=oldCookiesMigration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionStore.js






/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function startSessionStore(options, productKey, computeSessionState) {
    var renewObservable = new Observable();
    var expireObservable = new Observable();
    var watchSessionTimeoutId = setInterval(monitor(watchSession), COOKIE_ACCESS_DELAY);
    var sessionCache = retrieveActiveSession();
    function expandOrRenewSession() {
        var isTracked;
        withCookieLockAccess({
            options: options,
            process: function (cookieSession) {
                var synchronizedSession = synchronizeSession(cookieSession);
                isTracked = expandOrRenewCookie(synchronizedSession);
                return synchronizedSession;
            },
            after: function (cookieSession) {
                if (isTracked && !hasSessionInCache()) {
                    renewSession(cookieSession);
                }
                sessionCache = cookieSession;
            },
        });
    }
    function expandSession() {
        withCookieLockAccess({
            options: options,
            process: function (cookieSession) { return (hasSessionInCache() ? synchronizeSession(cookieSession) : undefined); },
        });
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session cookie
     * - if the session is not active, clear the session cookie and expire the session cache
     */
    function watchSession() {
        withCookieLockAccess({
            options: options,
            process: function (cookieSession) { return (!isActiveSession(cookieSession) ? {} : undefined); },
            after: synchronizeSession,
        });
    }
    function synchronizeSession(cookieSession) {
        if (!isActiveSession(cookieSession)) {
            cookieSession = {};
        }
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(cookieSession)) {
                expireSession();
            }
            else {
                sessionCache = cookieSession;
            }
        }
        return cookieSession;
    }
    function expandOrRenewCookie(cookieSession) {
        var _a = computeSessionState(cookieSession[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        cookieSession[productKey] = trackingType;
        if (isTracked && !cookieSession.id) {
            cookieSession.id = generateUUID();
            cookieSession.created = String(Date.now());
        }
        return isTracked;
    }
    function hasSessionInCache() {
        return sessionCache[productKey] !== undefined;
    }
    function isSessionInCacheOutdated(cookieSession) {
        return sessionCache.id !== cookieSession.id || sessionCache[productKey] !== cookieSession[productKey];
    }
    function expireSession() {
        sessionCache = {};
        expireObservable.notify();
    }
    function renewSession(cookieSession) {
        sessionCache = cookieSession;
        renewObservable.notify();
    }
    function retrieveActiveSession() {
        var session = retrieveSession();
        if (isActiveSession(session)) {
            return session;
        }
        return {};
    }
    function isActiveSession(session) {
        // created and expire can be undefined for versions which was not storing them
        // these checks could be removed when older versions will not be available/live anymore
        return ((session.created === undefined || Date.now() - Number(session.created) < SESSION_TIME_OUT_DELAY) &&
            (session.expire === undefined || Date.now() < Number(session.expire)));
    }
    return {
        expandOrRenewSession: throttle(monitor(expandOrRenewSession), COOKIE_ACCESS_DELAY).throttled,
        expandSession: expandSession,
        getSession: function () { return sessionCache; },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        stop: function () {
            clearInterval(watchSessionTimeoutId);
        },
    };
}
//# sourceMappingURL=sessionStore.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionManager.js







var VISIBILITY_CHECK_DELAY = ONE_MINUTE;
var SESSION_CONTEXT_TIMEOUT_DELAY = SESSION_TIME_OUT_DELAY;
var stopCallbacks = [];
function startSessionManager(options, productKey, computeSessionState) {
    tryOldCookiesMigration(options);
    var sessionStore = startSessionStore(options, productKey, computeSessionState);
    stopCallbacks.push(function () { return sessionStore.stop(); });
    var sessionContextHistory = new ContextHistory(SESSION_CONTEXT_TIMEOUT_DELAY);
    stopCallbacks.push(function () { return sessionContextHistory.stop(); });
    sessionStore.renewObservable.subscribe(function () {
        sessionContextHistory.add(buildSessionContext(), relativeNow());
    });
    sessionStore.expireObservable.subscribe(function () {
        sessionContextHistory.closeActive(relativeNow());
    });
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), clocksOrigin().relative);
    trackActivity(function () { return sessionStore.expandOrRenewSession(); });
    trackVisibility(function () { return sessionStore.expandSession(); });
    function buildSessionContext() {
        return {
            id: sessionStore.getSession().id,
            trackingType: sessionStore.getSession()[productKey],
        };
    }
    return {
        findActiveSession: function (startTime) { return sessionContextHistory.find(startTime); },
        renewObservable: sessionStore.renewObservable,
        expireObservable: sessionStore.expireObservable,
    };
}
function stopSessionManager() {
    stopCallbacks.forEach(function (e) { return e(); });
    stopCallbacks = [];
}
function trackActivity(expandOrRenewSession) {
    var stop = addEventListeners(window, ["click" /* CLICK */, "touchstart" /* TOUCH_START */, "keydown" /* KEY_DOWN */, "scroll" /* SCROLL */], expandOrRenewSession, { capture: true, passive: true }).stop;
    stopCallbacks.push(stop);
}
function trackVisibility(expandSession) {
    var expandSessionWhenVisible = monitor(function () {
        if (document.visibilityState === 'visible') {
            expandSession();
        }
    });
    var stop = addEventListener(document, "visibilitychange" /* VISIBILITY_CHANGE */, expandSessionWhenVisible).stop;
    stopCallbacks.push(stop);
    var visibilityCheckInterval = setInterval(expandSessionWhenVisible, VISIBILITY_CHECK_DELAY);
    stopCallbacks.push(function () {
        clearInterval(visibilityCheckInterval);
    });
}
//# sourceMappingURL=sessionManager.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumSessionManager.js

var rumSessionManager_RUM_SESSION_KEY = 'rum';
function startRumSessionManager(configuration, lifeCycle) {
    var sessionManager = startSessionManager(configuration.cookieOptions, rumSessionManager_RUM_SESSION_KEY, function (rawTrackingType) {
        return computeSessionState(configuration, rawTrackingType);
    });
    sessionManager.expireObservable.subscribe(function () {
        lifeCycle.notify(7 /* SESSION_EXPIRED */);
    });
    sessionManager.renewObservable.subscribe(function () {
        lifeCycle.notify(8 /* SESSION_RENEWED */);
    });
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findActiveSession(startTime);
            if (!session || !isTypeTracked(session.trackingType)) {
                return;
            }
            return {
                id: session.id,
                hasPremiumPlan: session.trackingType === "1" /* TRACKED_PREMIUM */,
                hasLitePlan: session.trackingType === "2" /* TRACKED_LITE */,
            };
        },
    };
}
/**
 * Start a tracked replay session stub
 * It needs to be a premium plan in order to get long tasks
 */
function startRumSessionManagerStub() {
    var session = {
        id: '00000000-aaaa-0000-aaaa-000000000000',
        hasPremiumPlan: true,
        hasLitePlan: false,
    };
    return {
        findTrackedSession: function () { return session; },
    };
}
function computeSessionState(configuration, rawTrackingType) {
    var trackingType;
    if (hasValidRumSession(rawTrackingType)) {
        trackingType = rawTrackingType;
    }
    else if (!performDraw(configuration.sampleRate)) {
        trackingType = "0" /* NOT_TRACKED */;
    }
    else if (!performDraw(configuration.premiumSampleRate)) {
        trackingType = "2" /* TRACKED_LITE */;
    }
    else {
        trackingType = "1" /* TRACKED_PREMIUM */;
    }
    return {
        trackingType: trackingType,
        isTracked: isTypeTracked(trackingType),
    };
}
function hasValidRumSession(trackingType) {
    return (trackingType === "0" /* NOT_TRACKED */ ||
        trackingType === "1" /* TRACKED_PREMIUM */ ||
        trackingType === "2" /* TRACKED_LITE */);
}
function isTypeTracked(rumSessionType) {
    return rumSessionType === "2" /* TRACKED_LITE */ || rumSessionType === "1" /* TRACKED_PREMIUM */;
}
//# sourceMappingURL=rumSessionManager.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/batch.js



// https://en.wikipedia.org/wiki/UTF-8
// eslint-disable-next-line no-control-regex
var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
var Batch = /** @class */ (function () {
    function Batch(request, batchMessagesLimit, batchBytesLimit, messageBytesLimit, flushTimeout, beforeUnloadCallback) {
        if (beforeUnloadCallback === void 0) { beforeUnloadCallback = noop; }
        this.request = request;
        this.batchMessagesLimit = batchMessagesLimit;
        this.batchBytesLimit = batchBytesLimit;
        this.messageBytesLimit = messageBytesLimit;
        this.flushTimeout = flushTimeout;
        this.beforeUnloadCallback = beforeUnloadCallback;
        this.pushOnlyBuffer = [];
        this.upsertBuffer = {};
        this.bufferBytesCount = 0;
        this.bufferMessagesCount = 0;
        this.flushOnVisibilityHidden();
        this.flushPeriodically();
    }
    Batch.prototype.add = function (message) {
        this.addOrUpdate(message);
    };
    Batch.prototype.upsert = function (message, key) {
        this.addOrUpdate(message, key);
    };
    Batch.prototype.flush = function (reason) {
        if (this.bufferMessagesCount !== 0) {
            var messages = this.pushOnlyBuffer.concat(objectValues(this.upsertBuffer));
            this.request.send(messages.join('\n'), this.bufferBytesCount, reason);
            this.pushOnlyBuffer = [];
            this.upsertBuffer = {};
            this.bufferBytesCount = 0;
            this.bufferMessagesCount = 0;
        }
    };
    Batch.prototype.computeBytesCount = function (candidate) {
        // Accurate bytes count computations can degrade performances when there is a lot of events to process
        if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
            return candidate.length;
        }
        if (window.TextEncoder !== undefined) {
            return new TextEncoder().encode(candidate).length;
        }
        return new Blob([candidate]).size;
    };
    Batch.prototype.addOrUpdate = function (message, key) {
        var _a = this.process(message), processedMessage = _a.processedMessage, messageBytesCount = _a.messageBytesCount;
        if (messageBytesCount >= this.messageBytesLimit) {
            display.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB."));
            return;
        }
        if (this.hasMessageFor(key)) {
            this.remove(key);
        }
        if (this.willReachedBytesLimitWith(messageBytesCount)) {
            this.flush('batch_bytes_limit');
        }
        this.push(processedMessage, messageBytesCount, key);
        if (this.isFull()) {
            this.flush('batch_messages_limit');
        }
    };
    Batch.prototype.process = function (message) {
        var processedMessage = jsonStringify(message);
        var messageBytesCount = this.computeBytesCount(processedMessage);
        return { processedMessage: processedMessage, messageBytesCount: messageBytesCount };
    };
    Batch.prototype.push = function (processedMessage, messageBytesCount, key) {
        if (this.bufferMessagesCount > 0) {
            // \n separator at serialization
            this.bufferBytesCount += 1;
        }
        if (key !== undefined) {
            this.upsertBuffer[key] = processedMessage;
        }
        else {
            this.pushOnlyBuffer.push(processedMessage);
        }
        this.bufferBytesCount += messageBytesCount;
        this.bufferMessagesCount += 1;
    };
    Batch.prototype.remove = function (key) {
        var removedMessage = this.upsertBuffer[key];
        delete this.upsertBuffer[key];
        var messageBytesCount = this.computeBytesCount(removedMessage);
        this.bufferBytesCount -= messageBytesCount;
        this.bufferMessagesCount -= 1;
        if (this.bufferMessagesCount > 0) {
            this.bufferBytesCount -= 1;
        }
    };
    Batch.prototype.hasMessageFor = function (key) {
        return key !== undefined && this.upsertBuffer[key] !== undefined;
    };
    Batch.prototype.willReachedBytesLimitWith = function (messageBytesCount) {
        // byte of the separator at the end of the message
        return this.bufferBytesCount + messageBytesCount + 1 >= this.batchBytesLimit;
    };
    Batch.prototype.isFull = function () {
        return this.bufferMessagesCount === this.batchMessagesLimit || this.bufferBytesCount >= this.batchBytesLimit;
    };
    Batch.prototype.flushPeriodically = function () {
        var _this = this;
        setTimeout(monitor(function () {
            _this.flush('batch_flush_timeout');
            _this.flushPeriodically();
        }), this.flushTimeout);
    };
    Batch.prototype.flushOnVisibilityHidden = function () {
        var _this = this;
        /**
         * With sendBeacon, requests are guaranteed to be successfully sent during document unload
         */
        // @ts-ignore this function is not always defined
        if (navigator.sendBeacon) {
            /**
             * beforeunload is called before visibilitychange
             * register first to be sure to be called before flush on beforeunload
             * caveat: unload can still be canceled by another listener
             */
            addEventListener(window, "beforeunload" /* BEFORE_UNLOAD */, this.beforeUnloadCallback);
            /**
             * Only event that guarantee to fire on mobile devices when the page transitions to background state
             * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
             */
            addEventListener(document, "visibilitychange" /* VISIBILITY_CHANGE */, function () {
                if (document.visibilityState === 'hidden') {
                    _this.flush('visibility_hidden');
                }
            });
            /**
             * Safari does not support yet to send a request during:
             * - a visibility change during doc unload (cf: https://bugs.webkit.org/show_bug.cgi?id=194897)
             * - a page hide transition (cf: https://bugs.webkit.org/show_bug.cgi?id=188329)
             */
            addEventListener(window, "beforeunload" /* BEFORE_UNLOAD */, function () { return _this.flush('before_unload'); });
        }
    };
    return Batch;
}());

//# sourceMappingURL=batch.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/httpRequest.js


/**
 * Use POST request without content type to:
 * - avoid CORS preflight requests
 * - allow usage of sendBeacon
 *
 * multiple elements are sent separated by \n in order
 * to be parsed correctly without content type header
 */
var HttpRequest = /** @class */ (function () {
    function HttpRequest(endpointBuilder, bytesLimit) {
        this.endpointBuilder = endpointBuilder;
        this.bytesLimit = bytesLimit;
    }
    HttpRequest.prototype.send = function (data, bytesCount, reason) {
        var url = this.endpointBuilder.build();
        var canUseBeacon = !!navigator.sendBeacon && bytesCount < this.bytesLimit;
        if (canUseBeacon) {
            try {
                var isQueued = navigator.sendBeacon(url, data);
                if (isQueued) {
                    return;
                }
                addFailedSendBeacon(this.endpointBuilder.endpointType, bytesCount, reason);
            }
            catch (e) {
                reportBeaconError(e);
            }
        }
        var request = new XMLHttpRequest();
        request.open('POST', url, true);
        request.send(data);
    };
    return HttpRequest;
}());

var hasReportedBeaconError = false;
function reportBeaconError(e) {
    if (!hasReportedBeaconError) {
        hasReportedBeaconError = true;
        addTelemetryError(e);
    }
}
//# sourceMappingURL=httpRequest.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/transport/startRumBatch.js

function startRumBatch(configuration, lifeCycle, telemetryEventObservable) {
    var batch = makeRumBatch(configuration, lifeCycle);
    lifeCycle.subscribe(11 /* RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        if (serverRumEvent.type === "view" /* VIEW */) {
            batch.upsert(serverRumEvent, serverRumEvent.view.id);
        }
        else {
            batch.add(serverRumEvent);
        }
    });
    telemetryEventObservable.subscribe(function (event) { return batch.add(event, isTelemetryReplicationAllowed(configuration)); });
}
function makeRumBatch(configuration, lifeCycle) {
    var primaryBatch = createRumBatch(configuration.rumEndpointBuilder, function () {
        return lifeCycle.notify(9 /* BEFORE_UNLOAD */);
    });
    var replicaBatch;
    var replica = configuration.replica;
    if (replica !== undefined) {
        replicaBatch = createRumBatch(replica.rumEndpointBuilder);
    }
    function createRumBatch(endpointBuilder, unloadCallback) {
        return new Batch(new HttpRequest(endpointBuilder, configuration.batchBytesLimit), configuration.batchMessagesLimit, configuration.batchBytesLimit, configuration.messageBytesLimit, configuration.flushTimeout, unloadCallback);
    }
    function withReplicaApplicationId(message) {
        return combine(message, { application: { id: replica.applicationId } });
    }
    return {
        add: function (message, replicated) {
            if (replicated === void 0) { replicated = true; }
            primaryBatch.add(message);
            if (replicaBatch && replicated) {
                replicaBatch.add(withReplicaApplicationId(message));
            }
        },
        upsert: function (message, key) {
            primaryBatch.upsert(message, key);
            if (replicaBatch) {
                replicaBatch.upsert(withReplicaApplicationId(message), key);
            }
        },
    };
}
//# sourceMappingURL=startRumBatch.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/transport/startRumEventBridge.js

function startRumEventBridge(lifeCycle) {
    var bridge = getEventBridge();
    lifeCycle.subscribe(11 /* RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        bridge.send('rum', serverRumEvent);
    });
}
//# sourceMappingURL=startRumEventBridge.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/urlContexts.js

/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */
var URL_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
function startUrlContexts(lifeCycle, locationChangeObservable, location) {
    var urlContextHistory = new ContextHistory(URL_CONTEXT_TIME_OUT_DELAY);
    var previousViewUrl;
    lifeCycle.subscribe(4 /* VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        urlContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(2 /* VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        var viewUrl = location.href;
        urlContextHistory.add(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl,
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    var locationChangeSubscription = locationChangeObservable.subscribe(function (_a) {
        var newLocation = _a.newLocation;
        var current = urlContextHistory.find();
        if (current) {
            var changeTime = relativeNow();
            urlContextHistory.closeActive(changeTime);
            urlContextHistory.add(buildUrlContext({
                url: newLocation.href,
                referrer: current.view.referrer,
            }), changeTime);
        }
    });
    function buildUrlContext(_a) {
        var url = _a.url, referrer = _a.referrer;
        return {
            view: {
                url: url,
                referrer: referrer,
            },
        };
    }
    return {
        findUrl: function (startTime) { return urlContextHistory.find(startTime); },
        stop: function () {
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        },
    };
}
//# sourceMappingURL=urlContexts.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/locationChangeObservable.js

function createLocationChangeObservable(location) {
    var currentLocation = shallowClone(location);
    var observable = new Observable(function () {
        var stopHistoryTracking = trackHistory(onLocationChange).stop;
        var stopHashTracking = trackHash(onLocationChange).stop;
        return function () {
            stopHistoryTracking();
            stopHashTracking();
        };
    });
    function onLocationChange() {
        if (currentLocation.href === location.href) {
            return;
        }
        var newLocation = shallowClone(location);
        observable.notify({
            newLocation: newLocation,
            oldLocation: currentLocation,
        });
        currentLocation = newLocation;
    }
    return observable;
}
function trackHistory(onHistoryChange) {
    var stopInstrumentingPushState = instrumentMethodAndCallOriginal(history, 'pushState', {
        after: onHistoryChange,
    }).stop;
    var stopInstrumentingReplaceState = instrumentMethodAndCallOriginal(history, 'replaceState', {
        after: onHistoryChange,
    }).stop;
    var removeListener = addEventListener(window, "popstate" /* POP_STATE */, onHistoryChange).stop;
    return {
        stop: function () {
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        },
    };
}
function trackHash(onHashChange) {
    return addEventListener(window, "hashchange" /* HASH_CHANGE */, onHashChange);
}
//# sourceMappingURL=locationChangeObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/boot/startRum.js



















function startRum(configuration, getCommonContext, recorderApi, initialViewOptions) {
    var lifeCycle = new LifeCycle();
    var telemetry = startRumTelemetry(configuration);
    telemetry.setContextProvider(function () {
        var _a, _b;
        return ({
            application: {
                id: configuration.applicationId,
            },
            session: {
                id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id,
            },
            view: {
                id: (_b = viewContexts.findView()) === null || _b === void 0 ? void 0 : _b.view.id,
            },
            action: {
                id: actionContexts.findActionId(),
            },
        });
    });
    if (!canUseEventBridge()) {
        startRumBatch(configuration, lifeCycle, telemetry.observable);
    }
    else {
        startRumEventBridge(lifeCycle);
    }
    var session = !canUseEventBridge() ? startRumSessionManager(configuration, lifeCycle) : startRumSessionManagerStub();
    var domMutationObservable = createDOMMutationObservable();
    var locationChangeObservable = createLocationChangeObservable(location);
    var _a = startRumEventCollection(lifeCycle, configuration, location, session, locationChangeObservable, domMutationObservable, getCommonContext), viewContexts = _a.viewContexts, foregroundContexts = _a.foregroundContexts, urlContexts = _a.urlContexts, actionContexts = _a.actionContexts, addAction = _a.addAction;
    startLongTaskCollection(lifeCycle, session);
    startResourceCollection(lifeCycle);
    var _b = startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, foregroundContexts, recorderApi, initialViewOptions), addTiming = _b.addTiming, startView = _b.startView;
    var addError = startErrorCollection(lifeCycle, foregroundContexts).addError;
    startRequestCollection(lifeCycle, configuration, session);
    startPerformanceCollection(lifeCycle, configuration);
    startFlushFailedSendBeacons();
    var internalContext = startInternalContext(configuration.applicationId, session, viewContexts, actionContexts, urlContexts);
    return {
        addAction: addAction,
        addError: addError,
        addTiming: addTiming,
        startView: startView,
        lifeCycle: lifeCycle,
        viewContexts: viewContexts,
        session: session,
        getInternalContext: internalContext.get,
    };
}
function startRumTelemetry(configuration) {
    var telemetry = startTelemetry(configuration);
    if (canUseEventBridge()) {
        var bridge_1 = getEventBridge();
        telemetry.observable.subscribe(function (event) { return bridge_1.send('internal_telemetry', event); });
    }
    return telemetry;
}
function startRumEventCollection(lifeCycle, configuration, location, sessionManager, locationChangeObservable, domMutationObservable, getCommonContext) {
    var viewContexts = startViewContexts(lifeCycle);
    var urlContexts = startUrlContexts(lifeCycle, locationChangeObservable, location);
    var foregroundContexts = startForegroundContexts();
    var _a = startActionCollection(lifeCycle, domMutationObservable, configuration, foregroundContexts), addAction = _a.addAction, actionContexts = _a.actionContexts;
    startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, getCommonContext);
    return {
        viewContexts: viewContexts,
        foregroundContexts: foregroundContexts,
        urlContexts: urlContexts,
        addAction: addAction,
        actionContexts: actionContexts,
        stop: function () {
            viewContexts.stop();
            foregroundContexts.stop();
        },
    };
}
//# sourceMappingURL=startRum.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/types.js

var RecordType = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
};
//# sourceMappingURL=types.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/constants.js

var NodePrivacyLevel = {
    IGNORE: 'ignore',
    HIDDEN: 'hidden',
    ALLOW: DefaultPrivacyLevel.ALLOW,
    MASK: DefaultPrivacyLevel.MASK,
    MASK_USER_INPUT: DefaultPrivacyLevel.MASK_USER_INPUT,
};
var PRIVACY_ATTR_NAME = 'data-dd-privacy';
// Privacy Attrs
var PRIVACY_ATTR_VALUE_ALLOW = 'allow';
var PRIVACY_ATTR_VALUE_MASK = 'mask';
var PRIVACY_ATTR_VALUE_MASK_USER_INPUT = 'mask-user-input';
var PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
var PRIVACY_CLASS_ALLOW = 'dd-privacy-allow';
var PRIVACY_CLASS_MASK = 'dd-privacy-mask';
var PRIVACY_CLASS_MASK_USER_INPUT = 'dd-privacy-mask-user-input';
var PRIVACY_CLASS_HIDDEN = 'dd-privacy-hidden';
// Private Replacement Templates
var CENSORED_STRING_MARK = '***';
var CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
var FORM_PRIVATE_TAG_NAMES = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true,
};
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/privacy.js

var MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = 100000;
var TEXT_MASKING_CHAR = 'x';
/**
 * Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
 * know, it is best to use something like:
 *
 * derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
 */
function getNodePrivacyLevel(node, defaultPrivacyLevel) {
    var parentNodePrivacyLevel = node.parentNode
        ? getNodePrivacyLevel(node.parentNode, defaultPrivacyLevel)
        : defaultPrivacyLevel;
    var selfNodePrivacyLevel = getNodeSelfPrivacyLevel(node);
    return reducePrivacyLevel(selfNodePrivacyLevel, parentNodePrivacyLevel);
}
/**
 * Reduces the next privacy level based on self + parent privacy levels
 */
function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
    switch (parentNodePrivacyLevel) {
        // These values cannot be overridden
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return parentNodePrivacyLevel;
    }
    switch (childPrivacyLevel) {
        case NodePrivacyLevel.ALLOW:
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.MASK_USER_INPUT:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
/**
 * Determines the node's own privacy level without checking for ancestors.
 */
function getNodeSelfPrivacyLevel(node) {
    // Only Element types can have a privacy level set
    if (!isElement(node)) {
        return;
    }
    var privAttr = node.getAttribute(PRIVACY_ATTR_NAME);
    // Overrules for replay purpose
    if (node.tagName === 'BASE') {
        return NodePrivacyLevel.ALLOW;
    }
    // Overrules to enforce end-user protection
    if (node.tagName === 'INPUT') {
        var inputElement = node;
        if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') {
            return NodePrivacyLevel.MASK;
        }
        if (inputElement.type === 'hidden') {
            return NodePrivacyLevel.MASK;
        }
        var autocomplete = inputElement.getAttribute('autocomplete');
        // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year]
        if (autocomplete && autocomplete.indexOf('cc-') === 0) {
            return NodePrivacyLevel.MASK;
        }
    }
    // Check HTML privacy attributes and classes
    if (privAttr === PRIVACY_ATTR_VALUE_HIDDEN || node.classList.contains(PRIVACY_CLASS_HIDDEN)) {
        return NodePrivacyLevel.HIDDEN;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_MASK || node.classList.contains(PRIVACY_CLASS_MASK)) {
        return NodePrivacyLevel.MASK;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_MASK_USER_INPUT || node.classList.contains(PRIVACY_CLASS_MASK_USER_INPUT)) {
        return NodePrivacyLevel.MASK_USER_INPUT;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_ALLOW || node.classList.contains(PRIVACY_CLASS_ALLOW)) {
        return NodePrivacyLevel.ALLOW;
    }
    if (shouldIgnoreElement(node)) {
        return NodePrivacyLevel.IGNORE;
    }
}
/**
 * Helper aiming to unify `mask` and `mask-user-input` privacy levels:
 *
 * In the `mask` case, it is trivial: we should mask the element.
 *
 * In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
 * direct parent is a form element for text nodes).
 *
 * Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
 * node if it is ignored or hidden? it doesn't matter since it won't be serialized).
 */
function shouldMaskNode(node, privacyLevel) {
    switch (privacyLevel) {
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return true;
        case NodePrivacyLevel.MASK_USER_INPUT:
            return privacy_isTextNode(node) ? isFormElement(node.parentNode) : isFormElement(node);
        default:
            return false;
    }
}
function isElement(node) {
    return node.nodeType === node.ELEMENT_NODE;
}
function privacy_isTextNode(node) {
    return node.nodeType === node.TEXT_NODE;
}
function isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) {
        return false;
    }
    var element = node;
    if (element.tagName === 'INPUT') {
        switch (element.type) {
            case 'button':
            case 'color':
            case 'reset':
            case 'submit':
                return false;
        }
    }
    return !!FORM_PRIVATE_TAG_NAMES[element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */
var censorText = function (text) { return text.replace(/\S/g, TEXT_MASKING_CHAR); };
function getTextContent(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = textNode.textContent || '';
    if (ignoreWhiteSpace && !textContent.trim()) {
        return;
    }
    var nodePrivacyLevel = parentNodePrivacyLevel;
    var isStyle = parentTagName === 'STYLE' ? true : undefined;
    var isScript = parentTagName === 'SCRIPT';
    if (isScript) {
        // For perf reasons, we don't record script (heuristic)
        textContent = CENSORED_STRING_MARK;
    }
    else if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // Should never occur, but just in case, we set to CENSORED_MARK.
        textContent = CENSORED_STRING_MARK;
    }
    else if (shouldMaskNode(textNode, nodePrivacyLevel) &&
        // Style tags are `overruled` (Use `hide` to enforce privacy)
        !isStyle) {
        if (
        // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        parentTagName === 'DATALIST' ||
            parentTagName === 'SELECT' ||
            parentTagName === 'OPTGROUP') {
            if (!textContent.trim()) {
                return;
            }
        }
        else if (parentTagName === 'OPTION') {
            // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
            textContent = CENSORED_STRING_MARK;
        }
        else {
            textContent = censorText(textContent);
        }
    }
    return textContent;
}
/**
 * TODO: Preserve CSS element order, and record the presence of the tag, just don't render
 * We don't need this logic on the recorder side.
 * For security related meta's, customer can mask themmanually given they
 * are easy to identify in the HEAD tag.
 */
function shouldIgnoreElement(element) {
    if (element.nodeName === 'SCRIPT') {
        return true;
    }
    if (element.nodeName === 'LINK') {
        var relAttribute = getLowerCaseAttribute('rel');
        return (
        // Scripts
        (relAttribute === 'preload' && getLowerCaseAttribute('as') === 'script') ||
            // Favicons
            relAttribute === 'shortcut icon' ||
            relAttribute === 'icon');
    }
    if (element.nodeName === 'META') {
        var nameAttribute = getLowerCaseAttribute('name');
        var relAttribute = getLowerCaseAttribute('rel');
        var propertyAttribute = getLowerCaseAttribute('property');
        return (
        // Favicons
        /^msapplication-tile(image|color)$/.test(nameAttribute) ||
            nameAttribute === 'application-name' ||
            relAttribute === 'icon' ||
            relAttribute === 'apple-touch-icon' ||
            relAttribute === 'shortcut icon' ||
            // Description
            nameAttribute === 'keywords' ||
            nameAttribute === 'description' ||
            // Social
            /^(og|twitter|fb):/.test(propertyAttribute) ||
            /^(og|twitter):/.test(nameAttribute) ||
            nameAttribute === 'pinterest' ||
            // Robots
            nameAttribute === 'robots' ||
            nameAttribute === 'googlebot' ||
            nameAttribute === 'bingbot' ||
            // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
            // X-Translated-By
            element.hasAttribute('http-equiv') ||
            // Authorship
            nameAttribute === 'author' ||
            nameAttribute === 'generator' ||
            nameAttribute === 'framework' ||
            nameAttribute === 'publisher' ||
            nameAttribute === 'progid' ||
            /^article:/.test(propertyAttribute) ||
            /^product:/.test(propertyAttribute) ||
            // Verification
            nameAttribute === 'google-site-verification' ||
            nameAttribute === 'yandex-verification' ||
            nameAttribute === 'csrf-token' ||
            nameAttribute === 'p:domain_verify' ||
            nameAttribute === 'verify-v1' ||
            nameAttribute === 'verification' ||
            nameAttribute === 'shopify-checkout-api-token');
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || '').toLowerCase();
    }
    return false;
}
//# sourceMappingURL=privacy.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serializationUtils.js


var serializedNodeIds = new WeakMap();
function hasSerializedNode(node) {
    return serializedNodeIds.has(node);
}
function nodeAndAncestorsHaveSerializedNode(node) {
    var current = node;
    while (current) {
        if (!hasSerializedNode(current)) {
            return false;
        }
        current = current.parentNode;
    }
    return true;
}
function getSerializedNodeId(node) {
    return serializedNodeIds.get(node);
}
function setSerializedNodeId(node, serializeNodeId) {
    serializedNodeIds.set(node, serializeNodeId);
}
/**
 * Get the element "value" to be serialized as an attribute or an input update record. It respects
 * the input privacy mode of the element.
 * PERFROMANCE OPTIMIZATION: Assumes that privacy level `HIDDEN` is never encountered because of earlier checks.
 */
function getElementInputValue(element, nodePrivacyLevel) {
    /*
     BROWSER SPEC NOTE: <input>, <select>
     For some <input> elements, the `value` is an exceptional property/attribute that has the
     value synced between el.value and el.getAttribute()
     input[type=button,checkbox,hidden,image,radio,reset,submit]
     */
    var tagName = element.tagName;
    var value = element.value;
    if (shouldMaskNode(element, nodePrivacyLevel)) {
        var type = element.type;
        if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) {
            // Overrule `MASK` privacy level for button-like element values, as they are used during replay
            // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
            return value;
        }
        else if (!value || tagName === 'OPTION') {
            // <Option> value provides no benefit
            return;
        }
        return CENSORED_STRING_MARK;
    }
    if (tagName === 'OPTION' || tagName === 'SELECT') {
        return element.value;
    }
    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
        return;
    }
    return value;
}
//# sourceMappingURL=serializationUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/utils.js
function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function forEach(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialize.js





function serializeDocument(document, defaultPrivacyLevel) {
    // We are sure that Documents are never ignored, so this function never returns null
    return serializeNodeWithId(document, {
        document: document,
        parentNodePrivacyLevel: defaultPrivacyLevel,
    });
}
function serializeNodeWithId(node, options) {
    var serializedNode = serializeNode(node, options);
    if (!serializedNode) {
        return null;
    }
    // Try to reuse the previous id
    var id = getSerializedNodeId(node) || generateNextId();
    var serializedNodeWithId = serializedNode;
    serializedNodeWithId.id = id;
    setSerializedNodeId(node, id);
    if (options.serializedNodeIds) {
        options.serializedNodeIds.add(id);
    }
    return serializedNodeWithId;
}
function serializeNode(node, options) {
    switch (node.nodeType) {
        case node.DOCUMENT_NODE:
            return serializeDocumentNode(node, options);
        case node.DOCUMENT_TYPE_NODE:
            return serializeDocumentTypeNode(node);
        case node.ELEMENT_NODE:
            return serializeElementNode(node, options);
        case node.TEXT_NODE:
            return serializeTextNode(node, options);
        case node.CDATA_SECTION_NODE:
            return serializeCDataNode();
    }
}
function serializeDocumentNode(document, options) {
    return {
        type: 0 /* Document */,
        childNodes: serializeChildNodes(document, options),
    };
}
function serializeDocumentTypeNode(documentType) {
    return {
        type: 1 /* DocumentType */,
        name: documentType.name,
        publicId: documentType.publicId,
        systemId: documentType.systemId,
    };
}
/**
 * Serialzing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, otpion selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */
function serializeElementNode(element, options) {
    var _a;
    var tagName = getValidTagName(element.tagName);
    var isSVG = isSVGElement(element) || undefined;
    // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
    // parentNodePrivacyLevel option to avoid iterating over all parents
    var nodePrivacyLevel = reducePrivacyLevel(getNodeSelfPrivacyLevel(element), options.parentNodePrivacyLevel);
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        var _b = element.getBoundingClientRect(), width = _b.width, height = _b.height;
        return {
            type: 2 /* Element */,
            tagName: tagName,
            attributes: (_a = {
                    rr_width: "".concat(width, "px"),
                    rr_height: "".concat(height, "px")
                },
                _a[PRIVACY_ATTR_NAME] = PRIVACY_ATTR_VALUE_HIDDEN,
                _a),
            childNodes: [],
            isSVG: isSVG,
        };
    }
    // Ignore Elements like Script and some Link, Metas
    if (nodePrivacyLevel === NodePrivacyLevel.IGNORE) {
        return;
    }
    var attributes = getAttributesForPrivacyLevel(element, nodePrivacyLevel);
    var childNodes = [];
    if (element.childNodes.length) {
        // OBJECT POOLING OPTIMIZATION:
        // We should not create a new object systematically as it could impact performances. Try to reuse
        // the same object as much as possible, and clone it only if we need to.
        var childNodesSerializationOptions = void 0;
        if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) {
            childNodesSerializationOptions = options;
        }
        else {
            childNodesSerializationOptions = utils_assign({}, options, {
                parentNodePrivacyLevel: nodePrivacyLevel,
                ignoreWhiteSpace: tagName === 'head',
            });
        }
        childNodes = serializeChildNodes(element, childNodesSerializationOptions);
    }
    return {
        type: 2 /* Element */,
        tagName: tagName,
        attributes: attributes,
        childNodes: childNodes,
        isSVG: isSVG,
    };
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */
function serializeTextNode(textNode, options) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = getTextContent(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
    if (!textContent) {
        return;
    }
    return {
        type: 3 /* Text */,
        textContent: textContent,
        isStyle: parentTagName === 'STYLE' ? true : undefined,
    };
}
function serializeCDataNode() {
    return {
        type: 4 /* CDATA */,
        textContent: '',
    };
}
function serializeChildNodes(node, options) {
    var result = [];
    forEach(node.childNodes, function (childNode) {
        var serializedChildNode = serializeNodeWithId(childNode, options);
        if (serializedChildNode) {
            result.push(serializedChildNode);
        }
    });
    return result;
}
function serializeAttribute(element, nodePrivacyLevel, attributeName) {
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // dup condition for direct access case
        return null;
    }
    var attributeValue = element.getAttribute(attributeName);
    if (nodePrivacyLevel === NodePrivacyLevel.MASK) {
        var tagName = element.tagName;
        switch (attributeName) {
            // Mask Attribute text content
            case 'title':
            case 'alt':
                return CENSORED_STRING_MARK;
        }
        // mask image URLs
        if (tagName === 'IMG' || tagName === 'SOURCE') {
            if (attributeName === 'src' || attributeName === 'srcset') {
                return CENSORED_IMG_MARK;
            }
        }
        // mask <a> URLs
        if (tagName === 'A' && attributeName === 'href') {
            return CENSORED_STRING_MARK;
        }
        // mask data-* attributes
        if (attributeValue && attributeName.indexOf('data-') === 0 && attributeName !== PRIVACY_ATTR_NAME) {
            // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
            return CENSORED_STRING_MARK;
        }
    }
    if (!attributeValue || typeof attributeValue !== 'string') {
        return attributeValue;
    }
    // Minimum Fix for customer.
    if (attributeValue.length > MAX_ATTRIBUTE_VALUE_CHAR_LENGTH && attributeValue.slice(0, 5) === 'data:') {
        return 'data:truncated';
    }
    return attributeValue;
}
var _nextId = 1;
function generateNextId() {
    return _nextId++;
}
var TAG_NAME_REGEX = /[^a-z1-6-_]/;
function getValidTagName(tagName) {
    var processedTagName = tagName.toLowerCase().trim();
    if (TAG_NAME_REGEX.test(processedTagName)) {
        // if the tag name is odd and we cannot extract
        // anything from the string, then we return a
        // generic div
        return 'div';
    }
    return processedTagName;
}
function getCssRulesString(s) {
    try {
        var rules = s.rules || s.cssRules;
        return rules ? Array.from(rules).map(getCssRuleString).join('') : null;
    }
    catch (error) {
        return null;
    }
}
function getCssRuleString(rule) {
    return isCSSImportRule(rule) ? getCssRulesString(rule.styleSheet) || '' : rule.cssText;
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function isSVGElement(el) {
    return el.tagName === 'svg' || el instanceof SVGElement;
}
function getAttributesForPrivacyLevel(element, nodePrivacyLevel) {
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        return {};
    }
    var safeAttrs = {};
    var tagName = getValidTagName(element.tagName);
    var doc = element.ownerDocument;
    for (var i = 0; i < element.attributes.length; i += 1) {
        var attribute = element.attributes.item(i);
        var attributeName = attribute.name;
        var attributeValue = serializeAttribute(element, nodePrivacyLevel, attributeName);
        if (attributeValue !== null) {
            safeAttrs[attributeName] = attributeValue;
        }
    }
    if (element.value &&
        (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
        var formValue = getElementInputValue(element, nodePrivacyLevel);
        if (formValue !== undefined) {
            safeAttrs.value = formValue;
        }
    }
    /**
     * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
     */
    if (tagName === 'option' && nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
        // For privacy=`MASK`, all the values would be the same, so skip.
        var optionElement = element;
        if (optionElement.selected) {
            safeAttrs.selected = optionElement.selected;
        }
    }
    // remote css
    if (tagName === 'link') {
        var stylesheet = Array.from(doc.styleSheets).find(function (s) { return s.href === element.href; });
        var cssText = getCssRulesString(stylesheet);
        if (cssText && stylesheet) {
            delete safeAttrs.rel;
            delete safeAttrs.href;
            safeAttrs._cssText = cssText;
        }
    }
    // dynamic stylesheet
    if (tagName === 'style' &&
        element.sheet &&
        // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
        !(element.innerText || element.textContent || '').trim().length) {
        var cssText = getCssRulesString(element.sheet);
        if (cssText) {
            safeAttrs._cssText = cssText;
        }
    }
    /**
     * Forms: input[type=checkbox,radio]
     * The `checked` property for <input> is a little bit special:
     * 1. el.checked is a setter that returns if truthy.
     * 2. getAttribute returns the string value
     * getAttribute('checked') does not sync with `Element.checked`, so use JS property
     * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
     */
    var inputElement = element;
    if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
        if (nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
            safeAttrs.checked = !!inputElement.checked;
        }
        else if (shouldMaskNode(inputElement, nodePrivacyLevel)) {
            safeAttrs.checked = CENSORED_STRING_MARK;
        }
    }
    /**
     * Serialize the media playback state
     */
    if (tagName === 'audio' || tagName === 'video') {
        var mediaElement = element;
        safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
    }
    /**
     * Serialize the scroll state for each element
     */
    if (element.scrollLeft) {
        safeAttrs.rr_scrollLeft = Math.round(element.scrollLeft);
    }
    if (element.scrollTop) {
        safeAttrs.rr_scrollTop = Math.round(element.scrollTop);
    }
    return safeAttrs;
}
//# sourceMappingURL=serialize.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/types.js
var IncrementalSource = {
    Mutation: 0,
    MouseMove: 1,
    MouseInteraction: 2,
    Scroll: 3,
    ViewportResize: 4,
    Input: 5,
    TouchMove: 6,
    MediaInteraction: 7,
    StyleSheetRule: 8,
    // CanvasMutation : 9,
    // Font : 10,
};
var MouseInteractions = {
    MouseUp: 0,
    MouseDown: 1,
    Click: 2,
    ContextMenu: 3,
    DblClick: 4,
    Focus: 5,
    Blur: 6,
    TouchStart: 7,
    TouchEnd: 9,
};
var MediaInteractions = {
    Play: 0,
    Pause: 1,
};
//# sourceMappingURL=types.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/mutationBatch.js

/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */
var MUTATION_PROCESS_MAX_DELAY = 100;
function createMutationBatch(processMutationBatch) {
    var cancelScheduledFlush = noop;
    var pendingMutations = [];
    function flush() {
        cancelScheduledFlush();
        processMutationBatch(pendingMutations);
        pendingMutations = [];
    }
    return {
        addMutations: function (mutations) {
            if (pendingMutations.length === 0) {
                cancelScheduledFlush = requestIdleCallback(flush, { timeout: MUTATION_PROCESS_MAX_DELAY });
            }
            pendingMutations.push.apply(pendingMutations, mutations);
        },
        flush: flush,
        stop: function () {
            cancelScheduledFlush();
        },
    };
}
//# sourceMappingURL=mutationBatch.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/mutationObserver.js








/**
 * Buffers and aggregate mutations generated by a MutationObserver into MutationPayload
 */
function startMutationObserver(controller, mutationCallback, defaultPrivacyLevel) {
    var MutationObserver = getMutationObserverConstructor();
    if (!MutationObserver) {
        return { stop: noop };
    }
    var mutationBatch = createMutationBatch(function (mutations) {
        processMutations(mutations.concat(observer.takeRecords()), mutationCallback, defaultPrivacyLevel);
    });
    var observer = new MutationObserver(monitor(mutationBatch.addMutations));
    observer.observe(document, {
        attributeOldValue: true,
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true,
    });
    controller.onFlush(mutationBatch.flush);
    return {
        stop: function () {
            observer.disconnect();
            mutationBatch.stop();
        },
    };
}
/**
 * Controls how mutations are processed, allowing to flush pending mutations.
 */
var MutationController = /** @class */ (function () {
    function MutationController() {
    }
    MutationController.prototype.flush = function () {
        var _a;
        (_a = this.flushListener) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    MutationController.prototype.onFlush = function (listener) {
        this.flushListener = listener;
    };
    return MutationController;
}());

function processMutations(mutations, mutationCallback, defaultPrivacyLevel) {
    // Discard any mutation with a 'target' node that:
    // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
    // part of a mutation occurring in a parent Node
    // * should be hidden or ignored
    var filteredMutations = mutations.filter(function (mutation) {
        return document.contains(mutation.target) &&
            nodeAndAncestorsHaveSerializedNode(mutation.target) &&
            getNodePrivacyLevel(mutation.target, defaultPrivacyLevel) !== NodePrivacyLevel.HIDDEN;
    });
    var _a = processChildListMutations(filteredMutations.filter(function (mutation) { return mutation.type === 'childList'; }), defaultPrivacyLevel), adds = _a.adds, removes = _a.removes, hasBeenSerialized = _a.hasBeenSerialized;
    var texts = processCharacterDataMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'characterData' && !hasBeenSerialized(mutation.target);
    }), defaultPrivacyLevel);
    var attributes = processAttributesMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'attributes' && !hasBeenSerialized(mutation.target);
    }), defaultPrivacyLevel);
    if (!texts.length && !attributes.length && !removes.length && !adds.length) {
        return;
    }
    mutationCallback({
        adds: adds,
        removes: removes,
        texts: texts,
        attributes: attributes,
    });
}
function processChildListMutations(mutations, defaultPrivacyLevel) {
    // First, we iterate over mutations to collect:
    //
    // * nodes that have been added in the document and not removed by a subsequent mutation
    // * nodes that have been removed from the document but were not added in a previous mutation
    //
    // For this second category, we also collect their previous parent (mutation.target) because we'll
    // need it to emit a 'remove' mutation.
    //
    // Those two categories may overlap: if a node moved from a position to another, it is reported as
    // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
    // the node will be in both sets.
    var addedAndMovedNodes = new Set();
    var removedNodes = new Map();
    var _loop_1 = function (mutation) {
        forEach(mutation.addedNodes, function (node) {
            addedAndMovedNodes.add(node);
        });
        forEach(mutation.removedNodes, function (node) {
            if (!addedAndMovedNodes.has(node)) {
                removedNodes.set(node, mutation.target);
            }
            addedAndMovedNodes.delete(node);
        });
    };
    for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
        var mutation = mutations_1[_i];
        _loop_1(mutation);
    }
    // Then, we sort nodes that are still in the document by topological order, for two reasons:
    //
    // * We will serialize each added nodes with their descendants. We don't want to serialize a node
    // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
    // a precedent node.
    //
    // * To emit "add" mutations, we need references to the parent and potential next sibling of each
    // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
    // siblings, we want to iterate from last to first. This will ensure that any "next" node is
    // already serialized and have an id.
    var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
    sortAddedAndMovedNodes(sortedAddedAndMovedNodes);
    // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
    // node ids in a set to be able to skip subsequent related mutations.
    var serializedNodeIds = new Set();
    var addedNodeMutations = [];
    for (var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++) {
        var node = sortedAddedAndMovedNodes_1[_a];
        if (hasBeenSerialized(node)) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(node.parentNode, defaultPrivacyLevel);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        var serializedNode = serializeNodeWithId(node, {
            document: document,
            serializedNodeIds: serializedNodeIds,
            parentNodePrivacyLevel: parentNodePrivacyLevel,
        });
        if (!serializedNode) {
            continue;
        }
        addedNodeMutations.push({
            nextId: getNextSibling(node),
            parentId: getSerializedNodeId(node.parentNode),
            node: serializedNode,
        });
    }
    // Finally, we emit remove mutations.
    var removedNodeMutations = [];
    removedNodes.forEach(function (parent, node) {
        if (hasSerializedNode(node)) {
            removedNodeMutations.push({
                parentId: getSerializedNodeId(parent),
                id: getSerializedNodeId(node),
            });
        }
    });
    return { adds: addedNodeMutations, removes: removedNodeMutations, hasBeenSerialized: hasBeenSerialized };
    function hasBeenSerialized(node) {
        return hasSerializedNode(node) && serializedNodeIds.has(getSerializedNodeId(node));
    }
    function getNextSibling(node) {
        var nextSibling = node.nextSibling;
        while (nextSibling) {
            if (hasSerializedNode(nextSibling)) {
                return getSerializedNodeId(nextSibling);
            }
            nextSibling = nextSibling.nextSibling;
        }
        return null;
    }
}
function processCharacterDataMutations(mutations, defaultPrivacyLevel) {
    var _a;
    var textMutations = [];
    // Deduplicate mutations based on their target node
    var handledNodes = new Set();
    var filteredMutations = mutations.filter(function (mutation) {
        if (handledNodes.has(mutation.target)) {
            return false;
        }
        handledNodes.add(mutation.target);
        return true;
    });
    // Emit mutations
    for (var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++) {
        var mutation = filteredMutations_1[_i];
        var value = mutation.target.textContent;
        if (value === mutation.oldValue) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(mutation.target.parentNode, defaultPrivacyLevel);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        textMutations.push({
            id: getSerializedNodeId(mutation.target),
            // TODO: pass a valid "ignoreWhiteSpace" argument
            value: (_a = getTextContent(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null,
        });
    }
    return textMutations;
}
function processAttributesMutations(mutations, defaultPrivacyLevel) {
    var attributeMutations = [];
    // Deduplicate mutations based on their target node and changed attribute
    var handledElements = new Map();
    var filteredMutations = mutations.filter(function (mutation) {
        var handledAttributes = handledElements.get(mutation.target);
        if (handledAttributes === null || handledAttributes === void 0 ? void 0 : handledAttributes.has(mutation.attributeName)) {
            return false;
        }
        if (!handledAttributes) {
            handledElements.set(mutation.target, new Set([mutation.attributeName]));
        }
        else {
            handledAttributes.add(mutation.attributeName);
        }
        return true;
    });
    // Emit mutations
    var emittedMutations = new Map();
    for (var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++) {
        var mutation = filteredMutations_2[_i];
        var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
        if (uncensoredValue === mutation.oldValue) {
            continue;
        }
        var privacyLevel = getNodePrivacyLevel(mutation.target, defaultPrivacyLevel);
        var attributeValue = serializeAttribute(mutation.target, privacyLevel, mutation.attributeName);
        var transformedValue = void 0;
        if (mutation.attributeName === 'value') {
            var inputValue = getElementInputValue(mutation.target, privacyLevel);
            if (inputValue === undefined) {
                continue;
            }
            transformedValue = inputValue;
        }
        else if (typeof attributeValue === 'string') {
            transformedValue = attributeValue;
        }
        else {
            transformedValue = null;
        }
        var emittedMutation = emittedMutations.get(mutation.target);
        if (!emittedMutation) {
            emittedMutation = {
                id: getSerializedNodeId(mutation.target),
                attributes: {},
            };
            attributeMutations.push(emittedMutation);
            emittedMutations.set(mutation.target, emittedMutation);
        }
        emittedMutation.attributes[mutation.attributeName] = transformedValue;
    }
    return attributeMutations;
}
function sortAddedAndMovedNodes(nodes) {
    nodes.sort(function (a, b) {
        var position = a.compareDocumentPosition(b);
        /* eslint-disable no-bitwise */
        if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return -1;
        }
        else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
            return -1;
        }
        /* eslint-enable no-bitwise */
        return 0;
    });
}
//# sourceMappingURL=mutationObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/viewports.js
/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */
// Scrollbar widths vary across properties on different devices and browsers
var TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */
function isVisualViewportFactoredIn() {
    var visual = window.visualViewport;
    return (Math.abs(visual.pageTop - visual.offsetTop - window.scrollY) > TOLERANCE ||
        Math.abs(visual.pageLeft - visual.offsetLeft - window.scrollX) > TOLERANCE);
}
var convertMouseEventToLayoutCoordinates = function (clientX, clientY) {
    var visual = window.visualViewport;
    var normalised = {
        layoutViewportX: clientX,
        layoutViewportY: clientY,
        visualViewportX: clientX,
        visualViewportY: clientY,
    };
    if (!visual) {
        // On old browsers, we cannot normalise, so fallback to clientX/Y
        return normalised;
    }
    else if (isVisualViewportFactoredIn()) {
        // Typically Mobile Devices
        normalised.layoutViewportX = Math.round(clientX + visual.offsetLeft);
        normalised.layoutViewportY = Math.round(clientY + visual.offsetTop);
    }
    else {
        // Typically Desktop Devices
        normalised.visualViewportX = Math.round(clientX - visual.offsetLeft);
        normalised.visualViewportY = Math.round(clientY - visual.offsetTop);
    }
    return normalised;
};
var getVisualViewport = function () {
    var visual = window.visualViewport;
    return {
        scale: visual.scale,
        offsetLeft: visual.offsetLeft,
        offsetTop: visual.offsetTop,
        pageLeft: visual.pageLeft,
        pageTop: visual.pageTop,
        height: visual.height,
        width: visual.width,
    };
};
// excludes the width of any rendered classic scrollbar that is fixed to the visual viewport
function getWindowWidth() {
    var visual = window.visualViewport;
    if (visual) {
        return visual.width * visual.scale;
    }
    return window.innerWidth || 0;
}
// excludes the height of any rendered classic scrollbar that is fixed to the visual viewport
function getWindowHeight() {
    var visual = window.visualViewport;
    if (visual) {
        return visual.height * visual.scale;
    }
    return window.innerHeight || 0;
}
function getScrollX() {
    var visual = window.visualViewport;
    if (visual) {
        return visual.pageLeft - visual.offsetLeft;
    }
    if (window.scrollX !== undefined) {
        return window.scrollX;
    }
    return window.pageXOffset || 0;
}
function getScrollY() {
    var visual = window.visualViewport;
    if (visual) {
        return visual.pageTop - visual.offsetTop;
    }
    if (window.scrollY !== undefined) {
        return window.scrollY;
    }
    return window.pageYOffset || 0;
}
//# sourceMappingURL=viewports.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observer.js
var _a;








var MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
var SCROLL_OBSERVER_THRESHOLD = 100;
var VISUAL_VIEWPORT_OBSERVER_THRESHOLD = 200;
function initObservers(o) {
    var mutationHandler = initMutationObserver(o.mutationController, o.mutationCb, o.defaultPrivacyLevel);
    var mousemoveHandler = initMoveObserver(o.mousemoveCb);
    var mouseInteractionHandler = initMouseInteractionObserver(o.mouseInteractionCb, o.defaultPrivacyLevel);
    var scrollHandler = initScrollObserver(o.scrollCb, o.defaultPrivacyLevel);
    var viewportResizeHandler = initViewportResizeObserver(o.viewportResizeCb);
    var inputHandler = initInputObserver(o.inputCb, o.defaultPrivacyLevel);
    var mediaInteractionHandler = initMediaInteractionObserver(o.mediaInteractionCb, o.defaultPrivacyLevel);
    var styleSheetObserver = initStyleSheetObserver(o.styleSheetRuleCb);
    var focusHandler = initFocusObserver(o.focusCb);
    var visualViewportResizeHandler = initVisualViewportResizeObserver(o.visualViewportResizeCb);
    return function () {
        mutationHandler();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        focusHandler();
        visualViewportResizeHandler();
    };
}
function initMutationObserver(mutationController, cb, defaultPrivacyLevel) {
    return startMutationObserver(mutationController, cb, defaultPrivacyLevel).stop;
}
function initMoveObserver(cb) {
    var updatePosition = throttle(monitor(function (event) {
        var target = event.target;
        if (hasSerializedNode(target)) {
            var _a = isTouchEvent(event) ? event.changedTouches[0] : event, clientX = _a.clientX, clientY = _a.clientY;
            var position = {
                id: getSerializedNodeId(target),
                timeOffset: 0,
                x: clientX,
                y: clientY,
            };
            if (window.visualViewport) {
                var _b = convertMouseEventToLayoutCoordinates(clientX, clientY), visualViewportX = _b.visualViewportX, visualViewportY = _b.visualViewportY;
                position.x = visualViewportX;
                position.y = visualViewportY;
            }
            cb([position], isTouchEvent(event) ? IncrementalSource.TouchMove : IncrementalSource.MouseMove);
        }
    }), MOUSE_MOVE_OBSERVER_THRESHOLD, {
        trailing: false,
    }).throttled;
    return addEventListeners(document, ["mousemove" /* MOUSE_MOVE */, "touchmove" /* TOUCH_MOVE */], updatePosition, {
        capture: true,
        passive: true,
    }).stop;
}
var eventTypeToMouseInteraction = (_a = {},
    _a["mouseup" /* MOUSE_UP */] = MouseInteractions.MouseUp,
    _a["mousedown" /* MOUSE_DOWN */] = MouseInteractions.MouseDown,
    _a["click" /* CLICK */] = MouseInteractions.Click,
    _a["contextmenu" /* CONTEXT_MENU */] = MouseInteractions.ContextMenu,
    _a["dblclick" /* DBL_CLICK */] = MouseInteractions.DblClick,
    _a["focus" /* FOCUS */] = MouseInteractions.Focus,
    _a["blur" /* BLUR */] = MouseInteractions.Blur,
    _a["touchstart" /* TOUCH_START */] = MouseInteractions.TouchStart,
    _a["touchend" /* TOUCH_END */] = MouseInteractions.TouchEnd,
    _a);
function initMouseInteractionObserver(cb, defaultPrivacyLevel) {
    var handler = function (event) {
        var target = event.target;
        if (getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN || !hasSerializedNode(target)) {
            return;
        }
        var _a = isTouchEvent(event) ? event.changedTouches[0] : event, clientX = _a.clientX, clientY = _a.clientY;
        var position = {
            id: getSerializedNodeId(target),
            type: eventTypeToMouseInteraction[event.type],
            x: clientX,
            y: clientY,
        };
        if (window.visualViewport) {
            var _b = convertMouseEventToLayoutCoordinates(clientX, clientY), visualViewportX = _b.visualViewportX, visualViewportY = _b.visualViewportY;
            position.x = visualViewportX;
            position.y = visualViewportY;
        }
        cb(position);
    };
    return addEventListeners(document, Object.keys(eventTypeToMouseInteraction), handler, {
        capture: true,
        passive: true,
    }).stop;
}
function initScrollObserver(cb, defaultPrivacyLevel) {
    var updatePosition = throttle(monitor(function (event) {
        var target = event.target;
        if (!target ||
            getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        var id = getSerializedNodeId(target);
        if (target === document) {
            cb({
                id: id,
                x: getScrollX(),
                y: getScrollY(),
            });
        }
        else {
            cb({
                id: id,
                x: target.scrollLeft,
                y: target.scrollTop,
            });
        }
    }), SCROLL_OBSERVER_THRESHOLD).throttled;
    return addEventListener(document, "scroll" /* SCROLL */, updatePosition, { capture: true, passive: true }).stop;
}
function initViewportResizeObserver(cb) {
    var updateDimension = throttle(monitor(function () {
        var height = getWindowHeight();
        var width = getWindowWidth();
        cb({
            height: Number(height),
            width: Number(width),
        });
    }), 200).throttled;
    return addEventListener(window, "resize" /* RESIZE */, updateDimension, { capture: true, passive: true }).stop;
}
function initInputObserver(cb, defaultPrivacyLevel) {
    var lastInputStateMap = new WeakMap();
    function onElementChange(target) {
        var nodePrivacyLevel = getNodePrivacyLevel(target, defaultPrivacyLevel);
        if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
            return;
        }
        var type = target.type;
        var inputState;
        if (type === 'radio' || type === 'checkbox') {
            if (shouldMaskNode(target, nodePrivacyLevel)) {
                return;
            }
            inputState = { isChecked: target.checked };
        }
        else {
            var value = getElementInputValue(target, nodePrivacyLevel);
            if (value === undefined) {
                return;
            }
            inputState = { text: value };
        }
        // Can be multiple changes on the same node within the same batched mutation observation.
        cbWithDedup(target, inputState);
        // If a radio was checked, other radios with the same name attribute will be unchecked.
        var name = target.name;
        if (type === 'radio' && name && target.checked) {
            forEach(document.querySelectorAll("input[type=\"radio\"][name=\"".concat(name, "\"]")), function (el) {
                if (el !== target) {
                    // TODO: Consider the privacy implications for various differing input privacy levels
                    cbWithDedup(el, { isChecked: false });
                }
            });
        }
    }
    /**
     * There can be multiple changes on the same node within the same batched mutation observation.
     */
    function cbWithDedup(target, inputState) {
        if (!hasSerializedNode(target)) {
            return;
        }
        var lastInputState = lastInputStateMap.get(target);
        if (!lastInputState ||
            lastInputState.text !== inputState.text ||
            lastInputState.isChecked !== inputState.isChecked) {
            lastInputStateMap.set(target, inputState);
            cb(utils_assign({
                id: getSerializedNodeId(target),
            }, inputState));
        }
    }
    var stopEventListeners = addEventListeners(document, ["input" /* INPUT */, "change" /* CHANGE */], function (event) {
        if (event.target instanceof HTMLInputElement ||
            event.target instanceof HTMLTextAreaElement ||
            event.target instanceof HTMLSelectElement) {
            onElementChange(event.target);
        }
    }, {
        capture: true,
        passive: true,
    }).stop;
    var instrumentationStoppers = [
        instrumentSetter(HTMLInputElement.prototype, 'value', onElementChange),
        instrumentSetter(HTMLInputElement.prototype, 'checked', onElementChange),
        instrumentSetter(HTMLSelectElement.prototype, 'value', onElementChange),
        instrumentSetter(HTMLTextAreaElement.prototype, 'value', onElementChange),
        instrumentSetter(HTMLSelectElement.prototype, 'selectedIndex', onElementChange),
    ];
    return function () {
        instrumentationStoppers.forEach(function (stopper) { return stopper.stop(); });
        stopEventListeners();
    };
}
function initStyleSheetObserver(cb) {
    var restoreInsertRule = instrumentMethodAndCallOriginal(CSSStyleSheet.prototype, 'insertRule', {
        before: function (rule, index) {
            if (hasSerializedNode(this.ownerNode)) {
                cb({
                    id: getSerializedNodeId(this.ownerNode),
                    adds: [{ rule: rule, index: index }],
                });
            }
        },
    }).stop;
    var restoreDeleteRule = instrumentMethodAndCallOriginal(CSSStyleSheet.prototype, 'deleteRule', {
        before: function (index) {
            if (hasSerializedNode(this.ownerNode)) {
                cb({
                    id: getSerializedNodeId(this.ownerNode),
                    removes: [{ index: index }],
                });
            }
        },
    }).stop;
    return function () {
        restoreInsertRule();
        restoreDeleteRule();
    };
}
function initMediaInteractionObserver(mediaInteractionCb, defaultPrivacyLevel) {
    var handler = function (event) {
        var target = event.target;
        if (!target ||
            getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        mediaInteractionCb({
            id: getSerializedNodeId(target),
            type: event.type === "play" /* PLAY */ ? MediaInteractions.Play : MediaInteractions.Pause,
        });
    };
    return addEventListeners(document, ["play" /* PLAY */, "pause" /* PAUSE */], handler, { capture: true, passive: true }).stop;
}
function initFocusObserver(focusCb) {
    return addEventListeners(window, ["focus" /* FOCUS */, "blur" /* BLUR */], function () {
        focusCb({ has_focus: document.hasFocus() });
    }).stop;
}
function initVisualViewportResizeObserver(cb) {
    if (!window.visualViewport) {
        return noop;
    }
    var _a = throttle(monitor(function () {
        cb(getVisualViewport());
    }), VISUAL_VIEWPORT_OBSERVER_THRESHOLD, {
        trailing: false,
    }), updateDimension = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = addEventListeners(window.visualViewport, ["resize" /* RESIZE */, "scroll" /* SCROLL */], updateDimension, {
        capture: true,
        passive: true,
    }).stop;
    return function stop() {
        removeListener();
        cancelThrottle();
    };
}
//# sourceMappingURL=observer.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/record.js







function record(options) {
    var emit = options.emit;
    // runtime checks for user options
    if (!emit) {
        throw new Error('emit function is required');
    }
    var mutationController = new MutationController();
    var takeFullSnapshot = function (timestamp) {
        if (timestamp === void 0) { timestamp = timeStampNow(); }
        mutationController.flush(); // process any pending mutation before taking a full snapshot
        emit({
            data: {
                height: getWindowHeight(),
                href: window.location.href,
                width: getWindowWidth(),
            },
            type: RecordType.Meta,
            timestamp: timestamp,
        });
        emit({
            data: {
                has_focus: document.hasFocus(),
            },
            type: RecordType.Focus,
            timestamp: timestamp,
        });
        emit({
            data: {
                node: serializeDocument(document, options.defaultPrivacyLevel),
                initialOffset: {
                    left: getScrollX(),
                    top: getScrollY(),
                },
            },
            type: RecordType.FullSnapshot,
            timestamp: timestamp,
        });
        if (window.visualViewport) {
            emit({
                data: getVisualViewport(),
                type: RecordType.VisualViewport,
                timestamp: timestamp,
            });
        }
    };
    takeFullSnapshot();
    var stopObservers = initObservers({
        mutationController: mutationController,
        defaultPrivacyLevel: options.defaultPrivacyLevel,
        inputCb: function (v) { return emit(assembleIncrementalSnapshot(IncrementalSource.Input, v)); },
        mediaInteractionCb: function (p) {
            return emit(assembleIncrementalSnapshot(IncrementalSource.MediaInteraction, p));
        },
        mouseInteractionCb: function (d) {
            return emit(assembleIncrementalSnapshot(IncrementalSource.MouseInteraction, d));
        },
        mousemoveCb: function (positions, source) { return emit(assembleIncrementalSnapshot(source, { positions: positions })); },
        mutationCb: function (m) { return emit(assembleIncrementalSnapshot(IncrementalSource.Mutation, m)); },
        scrollCb: function (p) { return emit(assembleIncrementalSnapshot(IncrementalSource.Scroll, p)); },
        styleSheetRuleCb: function (r) { return emit(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, r)); },
        viewportResizeCb: function (d) { return emit(assembleIncrementalSnapshot(IncrementalSource.ViewportResize, d)); },
        focusCb: function (data) {
            return emit({
                data: data,
                type: RecordType.Focus,
                timestamp: timeStampNow(),
            });
        },
        visualViewportResizeCb: function (data) {
            emit({
                data: data,
                type: RecordType.VisualViewport,
                timestamp: timeStampNow(),
            });
        },
    });
    return {
        stop: stopObservers,
        takeFullSnapshot: takeFullSnapshot,
        flushMutations: function () { return mutationController.flush(); },
    };
}
function assembleIncrementalSnapshot(source, data) {
    return {
        data: utils_assign({
            source: source,
        }, data),
        type: RecordType.IncrementalSnapshot,
        timestamp: timeStampNow(),
    };
}
//# sourceMappingURL=record.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/replayStats.js
var MAX_STATS_HISTORY = 10;
var statsPerView;
function getSegmentsCount(viewId) {
    return getOrCreateReplayStats(viewId).segments_count;
}
function addSegment(viewId) {
    getOrCreateReplayStats(viewId).segments_count += 1;
}
function addRecord(viewId) {
    getOrCreateReplayStats(viewId).records_count += 1;
}
function addWroteData(viewId, additionalBytesCount) {
    getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function getReplayStats(viewId) {
    return statsPerView === null || statsPerView === void 0 ? void 0 : statsPerView.get(viewId);
}
function resetReplayStats() {
    statsPerView = undefined;
}
function getOrCreateReplayStats(viewId) {
    if (!statsPerView) {
        statsPerView = new Map();
    }
    var replayStats;
    if (statsPerView.has(viewId)) {
        replayStats = statsPerView.get(viewId);
    }
    else {
        replayStats = {
            records_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0,
        };
        statsPerView.set(viewId, replayStats);
        if (statsPerView.size > MAX_STATS_HISTORY) {
            deleteOldestStats();
        }
    }
    return replayStats;
}
function deleteOldestStats() {
    if (!statsPerView) {
        return;
    }
    if (statsPerView.keys) {
        statsPerView.delete(statsPerView.keys().next().value);
    }
    else {
        // IE11 doesn't support map.keys
        var isFirst_1 = true;
        statsPerView.forEach(function (_value, key) {
            if (isFirst_1) {
                statsPerView.delete(key);
                isFirst_1 = false;
            }
        });
    }
}
//# sourceMappingURL=replayStats.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segment.js



var nextId = 0;
var Segment = /** @class */ (function () {
    function Segment(worker, context, creationReason, initialRecord, onWrote, onFlushed) {
        var _this = this;
        this.worker = worker;
        this.isFlushed = false;
        this.id = nextId++;
        var viewId = context.view.id;
        this.metadata = utils_assign({
            start: initialRecord.timestamp,
            end: initialRecord.timestamp,
            creation_reason: creationReason,
            records_count: 1,
            has_full_snapshot: initialRecord.type === RecordType.FullSnapshot,
            index_in_view: getSegmentsCount(viewId),
        }, context);
        addSegment(viewId);
        addRecord(viewId);
        var listener = monitor(function (_a) {
            var data = _a.data;
            if (data.type === 'errored' || data.type === 'initialized') {
                return;
            }
            if (data.id === _this.id) {
                addWroteData(viewId, data.additionalBytesCount);
                if (data.type === 'flushed') {
                    onFlushed(data.result, data.rawBytesCount, data.reason);
                    worker.removeEventListener('message', listener);
                }
                else {
                    onWrote(data.compressedBytesCount);
                }
            }
            else if (data.id > _this.id) {
                // Messages should be received in the same order as they are sent, so if we receive a
                // message with an id superior to this Segment instance id, we know that another, more
                // recent Segment instance is being used.
                //
                // In theory, a "flush" response should have been received at this point, so the listener
                // should already have been removed. But if something goes wrong and we didn't receive a
                // "flush" response, remove the listener to avoid any leak, and send a monitor message to
                // help investigate the issue.
                worker.removeEventListener('message', listener);
                addTelemetryDebug("Segment did not receive a 'flush' response before being replaced.");
            }
        });
        worker.addEventListener('message', listener);
        this.worker.postMessage({ data: "{\"records\":[".concat(JSON.stringify(initialRecord)), id: this.id, action: 'write' });
    }
    Segment.prototype.addRecord = function (record) {
        var _a;
        this.metadata.end = record.timestamp;
        this.metadata.records_count += 1;
        addRecord(this.metadata.view.id);
        (_a = this.metadata).has_full_snapshot || (_a.has_full_snapshot = record.type === RecordType.FullSnapshot);
        this.worker.postMessage({ data: ",".concat(JSON.stringify(record)), id: this.id, action: 'write' });
    };
    Segment.prototype.flush = function (reason) {
        this.worker.postMessage({
            data: "],".concat(JSON.stringify(this.metadata).slice(1), "\n"),
            id: this.id,
            action: 'flush',
            reason: reason,
        });
        this.isFlushed = true;
    };
    return Segment;
}());

//# sourceMappingURL=segment.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segmentCollection.js


var SEGMENT_DURATION_LIMIT = 30 * ONE_SECOND;
/**
 * beacon payload max queue size implementation is 64kb
 * ensure that we leave room for logs, rum and potential other users
 */
var SEGMENT_BYTES_LIMIT = 60000;
// Segments are the main data structure for session replays. They contain context information used
// for indexing or UI needs, and a list of records (RRWeb 'events', renamed to avoid confusing
// namings). They are stored without any processing from the intake, and fetched one after the
// other while a session is being replayed. Their encoding (deflate) are carefully crafted to allow
// concatenating multiple segments together. Segments have a size overhead (metadata), so our goal is to
// build segments containing as many records as possible while complying with the various flush
// strategies to guarantee a good replay quality.
//
// When the recording starts, a segment is initially created.  The segment is flushed (finalized and
// sent) based on various events (non-exhaustive list):
//
// * the page visibility change or becomes to unload
// * the segment duration reaches a limit
// * the encoded segment bytes count reaches a limit
// * ...
//
// A segment cannot be created without its context.  If the RUM session ends and no session id is
// available when creating a new segment, records will be ignored, until the session is renewed and
// a new session id is available.
//
// Empty segments (segments with no record) aren't useful and should be ignored.
//
// To help investigate session replays issues, each segment is created with a "creation reason",
// indicating why the session has been created.
function startSegmentCollection(lifeCycle, applicationId, sessionManager, viewContexts, send, worker) {
    return doStartSegmentCollection(lifeCycle, function () { return computeSegmentContext(applicationId, sessionManager, viewContexts); }, send, worker);
}
function doStartSegmentCollection(lifeCycle, getSegmentContext, send, worker, emitter) {
    if (emitter === void 0) { emitter = window; }
    var state = {
        status: 0 /* WaitingForInitialRecord */,
        nextSegmentCreationReason: 'init',
    };
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* VIEW_CREATED */, function () {
        flushSegment('view_change');
    }).unsubscribe;
    var unsubscribeBeforeUnload = lifeCycle.subscribe(9 /* BEFORE_UNLOAD */, function () {
        flushSegment('before_unload');
    }).unsubscribe;
    var unsubscribeVisibilityChange = addEventListener(emitter, "visibilitychange" /* VISIBILITY_CHANGE */, function () {
        if (document.visibilityState === 'hidden') {
            flushSegment('visibility_hidden');
        }
    }, { capture: true }).stop;
    function flushSegment(nextSegmentCreationReason) {
        if (state.status === 1 /* SegmentPending */) {
            state.segment.flush(nextSegmentCreationReason);
            clearTimeout(state.expirationTimeoutId);
        }
        if (nextSegmentCreationReason) {
            state = {
                status: 0 /* WaitingForInitialRecord */,
                nextSegmentCreationReason: nextSegmentCreationReason,
            };
        }
        else {
            state = {
                status: 2 /* Stopped */,
            };
        }
    }
    function createNewSegment(creationReason, initialRecord) {
        var context = getSegmentContext();
        if (!context) {
            return;
        }
        var segment = new Segment(worker, context, creationReason, initialRecord, function (compressedSegmentBytesCount) {
            if (!segment.isFlushed && compressedSegmentBytesCount > SEGMENT_BYTES_LIMIT) {
                flushSegment('segment_bytes_limit');
            }
        }, function (data, rawSegmentBytesCount, reason) {
            send(data, segment.metadata, rawSegmentBytesCount, reason);
        });
        state = {
            status: 1 /* SegmentPending */,
            segment: segment,
            expirationTimeoutId: setTimeout(monitor(function () {
                flushSegment('segment_duration_limit');
            }), SEGMENT_DURATION_LIMIT),
        };
    }
    return {
        addRecord: function (record) {
            switch (state.status) {
                case 0 /* WaitingForInitialRecord */:
                    createNewSegment(state.nextSegmentCreationReason, record);
                    break;
                case 1 /* SegmentPending */:
                    state.segment.addRecord(record);
                    break;
            }
        },
        stop: function () {
            flushSegment();
            unsubscribeViewCreated();
            unsubscribeBeforeUnload();
            unsubscribeVisibilityChange();
        },
    };
}
function computeSegmentContext(applicationId, sessionManager, viewContexts) {
    var session = sessionManager.findTrackedSession();
    var viewContext = viewContexts.findView();
    if (!session || !viewContext) {
        return undefined;
    }
    return {
        application: {
            id: applicationId,
        },
        session: {
            id: session.id,
        },
        view: {
            id: viewContext.view.id,
        },
    };
}
function setSegmentBytesLimit(newSegmentBytesLimit) {
    if (newSegmentBytesLimit === void 0) { newSegmentBytesLimit = 60000; }
    SEGMENT_BYTES_LIMIT = newSegmentBytesLimit;
}
//# sourceMappingURL=segmentCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/deflateWorker.js
var workerURL;
function createDeflateWorker() {
    // Lazily compute the worker URL to allow importing the SDK in NodeJS
    if (!workerURL) {
        workerURL = URL.createObjectURL(new Blob(["(".concat(workerCodeFn, ")(self)")]));
    }
    return new Worker(workerURL);
}
function workerCodeFn() {
    monitor(function () {
        var _a = makePakoDeflate(), Deflate = _a.Deflate, constants = _a.constants, string2buf = _a.string2buf;
        var deflate = new Deflate();
        var rawBytesCount = 0;
        self.addEventListener('message', monitor(function (event) {
            var data = event.data;
            switch (data.action) {
                case 'init':
                    self.postMessage({
                        type: 'initialized',
                    });
                    break;
                case 'write': {
                    var additionalBytesCount = pushData(data.data);
                    self.postMessage({
                        type: 'wrote',
                        id: data.id,
                        compressedBytesCount: deflate.chunks.reduce(function (total, chunk) { return total + chunk.length; }, 0),
                        additionalBytesCount: additionalBytesCount,
                    });
                    break;
                }
                case 'flush': {
                    var additionalBytesCount = data.data ? pushData(data.data) : 0;
                    deflate.push('', constants.Z_FINISH);
                    self.postMessage({
                        type: 'flushed',
                        id: data.id,
                        result: deflate.result,
                        additionalBytesCount: additionalBytesCount,
                        rawBytesCount: rawBytesCount,
                    });
                    deflate = new Deflate();
                    rawBytesCount = 0;
                    break;
                }
            }
        }));
        function pushData(data) {
            // TextEncoder is not supported on old browser version like Edge 18, therefore we use string2buf
            var binaryData = string2buf(data);
            deflate.push(binaryData, constants.Z_SYNC_FLUSH);
            rawBytesCount += binaryData.length;
            return binaryData.length;
        }
    })();
    function monitor(fn) {
        return function () {
            try {
                return fn.apply(this, arguments);
            }
            catch (e) {
                try {
                    self.postMessage({
                        type: 'errored',
                        error: e,
                    });
                }
                catch (_) {
                    // DATA_CLONE_ERR, cf https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm
                    self.postMessage({
                        type: 'errored',
                        error: "".concat(e),
                    });
                }
            }
        };
    }
    // https://github.com/nodeca/pako/blob/034669ba0f1a4c0590e45f7c2820128200f972b3/dist/pako_deflate.es5.js
    function makePakoDeflate() {
        /* eslint-disable camelcase, no-bitwise */
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        /* Public constants ========================================================== */
        /* =========================================================================== */
        // const Z_FILTERED          = 1;
        // const Z_HUFFMAN_ONLY      = 2;
        // const Z_RLE               = 3;
        var Z_FIXED = 4; // const Z_DEFAULT_STRATEGY  = 0;
        /* Possible values of the data_type field (though see inflate()) */
        var Z_BINARY = 0;
        var Z_TEXT = 1; // const Z_ASCII             = 1; // = Z_TEXT
        var Z_UNKNOWN = 2;
        /* ============================================================================ */
        function zero(buf) {
            var len = buf.length;
            while (--len >= 0) {
                buf[len] = 0;
            }
        } // From zutil.h
        var STORED_BLOCK = 0;
        var STATIC_TREES = 1;
        var DYN_TREES = 2;
        /* The three kinds of block type */
        var MIN_MATCH = 3;
        var MAX_MATCH = 258;
        /* The minimum and maximum match lengths */
        // From deflate.h
        /* ===========================================================================
         * Internal compression state.
         */
        var LENGTH_CODES = 29;
        /* number of length codes, not counting the special END_BLOCK code */
        var LITERALS = 256;
        /* number of literal bytes 0..255 */
        var L_CODES = LITERALS + 1 + LENGTH_CODES;
        /* number of Literal or Length codes, including the END_BLOCK code */
        var D_CODES = 30;
        /* number of distance codes */
        var BL_CODES = 19;
        /* number of codes used to transfer the bit lengths */
        var HEAP_SIZE = 2 * L_CODES + 1;
        /* maximum heap size */
        var MAX_BITS = 15;
        /* All codes must not exceed MAX_BITS bits */
        var Buf_size = 16;
        /* size of bit buffer in bi_buf */
        /* ===========================================================================
         * Constants
         */
        var MAX_BL_BITS = 7;
        /* Bit length codes must not exceed MAX_BL_BITS bits */
        var END_BLOCK = 256;
        /* end of block literal code */
        var REP_3_6 = 16;
        /* repeat previous bit length 3-6 times (2 bits of repeat count) */
        var REPZ_3_10 = 17;
        /* repeat a zero length 3-10 times  (3 bits of repeat count) */
        var REPZ_11_138 = 18;
        /* repeat a zero length 11-138 times  (7 bits of repeat count) */
        var extra_lbits = 
        /* extra bits for each length code */
        new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]);
        var extra_dbits = 
        /* extra bits for each distance code */
        new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]);
        var extra_blbits = 
        /* extra bits for each bit length code */
        new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]);
        var bl_order = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
        /* eslint-enable comma-spacing,array-bracket-spacing */
        /* The lengths of the bit length codes are sent in order of decreasing
         * probability, to avoid transmitting the lengths for unused bit length codes.
         */
        /* ===========================================================================
         * Local data. These are initialized only once.
         */
        // We pre-fill arrays with 0 to avoid uninitialized gaps
        var DIST_CODE_LEN = 512;
        /* see definition of array dist_code below */
        // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
        var static_ltree = new Array((L_CODES + 2) * 2);
        zero(static_ltree);
        /* The static literal tree. Since the bit lengths are imposed, there is no
         * need for the L_CODES extra codes used during heap construction. However
         * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
         * below).
         */
        var static_dtree = new Array(D_CODES * 2);
        zero(static_dtree);
        /* The static distance tree. (Actually a trivial tree since all codes use
         * 5 bits.)
         */
        var _dist_code = new Array(DIST_CODE_LEN);
        zero(_dist_code);
        /* Distance codes. The first 256 values correspond to the distances
         * 3 .. 258, the last 256 values correspond to the top 8 bits of
         * the 15 bit distances.
         */
        var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
        zero(_length_code);
        /* length code for each normalized match length (0 == MIN_MATCH) */
        var base_length = new Array(LENGTH_CODES);
        zero(base_length);
        /* First normalized length for each code (0 = MIN_MATCH) */
        var base_dist = new Array(D_CODES);
        zero(base_dist);
        /* First normalized distance for each code (0 = distance of 1) */
        function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
            this.static_tree = static_tree;
            /* static tree or NULL */
            this.extra_bits = extra_bits;
            /* extra bits for each code or NULL */
            this.extra_base = extra_base;
            /* base index for extra_bits */
            this.elems = elems;
            /* max number of elements in the tree */
            this.max_length = max_length;
            /* max bit length for the codes */
            // show if `static_tree` has data or dummy - needed for monomorphic objects
            this.has_stree = static_tree && static_tree.length;
        }
        var static_l_desc;
        var static_d_desc;
        var static_bl_desc;
        function TreeDesc(dyn_tree, stat_desc) {
            this.dyn_tree = dyn_tree;
            /* the dynamic tree */
            this.max_code = 0;
            /* largest code with non zero frequency */
            this.stat_desc = stat_desc;
            /* the corresponding static tree */
        }
        var d_code = function d_code(dist) {
            return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
        };
        /* ===========================================================================
         * Output a short LSB first on the stream.
         * IN assertion: there is enough room in pendingBuf.
         */
        var put_short = function put_short(s, w) {
            //    put_byte(s, (uch)((w) & 0xff));
            //    put_byte(s, (uch)((ush)(w) >> 8));
            s.pending_buf[s.pending++] = w & 0xff;
            s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
        };
        /* ===========================================================================
         * Send a value on a given number of bits.
         * IN assertion: length <= 16 and value fits in length bits.
         */
        var send_bits = function send_bits(s, value, length) {
            if (s.bi_valid > Buf_size - length) {
                s.bi_buf |= (value << s.bi_valid) & 0xffff;
                put_short(s, s.bi_buf);
                s.bi_buf = value >> (Buf_size - s.bi_valid);
                s.bi_valid += length - Buf_size;
            }
            else {
                s.bi_buf |= (value << s.bi_valid) & 0xffff;
                s.bi_valid += length;
            }
        };
        var send_code = function send_code(s, c, tree) {
            send_bits(s, tree[c * 2], 
            /* .Code */
            tree[c * 2 + 1]
            /* .Len */
            );
        };
        /* ===========================================================================
         * Reverse the first len bits of a code, using straightforward code (a faster
         * method would use a table)
         * IN assertion: 1 <= len <= 15
         */
        var bi_reverse = function bi_reverse(code, len) {
            var res = 0;
            do {
                res |= code & 1;
                code >>>= 1;
                res <<= 1;
            } while (--len > 0);
            return res >>> 1;
        };
        /* ===========================================================================
         * Flush the bit buffer, keeping at most 7 bits in it.
         */
        var bi_flush = function bi_flush(s) {
            if (s.bi_valid === 16) {
                put_short(s, s.bi_buf);
                s.bi_buf = 0;
                s.bi_valid = 0;
            }
            else if (s.bi_valid >= 8) {
                s.pending_buf[s.pending++] = s.bi_buf & 0xff;
                s.bi_buf >>= 8;
                s.bi_valid -= 8;
            }
        };
        /* ===========================================================================
         * Compute the optimal bit lengths for a tree and update the total bit length
         * for the current block.
         * IN assertion: the fields freq and dad are set, heap[heap_max] and
         *    above are the tree nodes sorted by increasing frequency.
         * OUT assertions: the field len is set to the optimal bit length, the
         *     array bl_count contains the frequencies for each bit length.
         *     The length opt_len is updated; static_len is also updated if stree is
         *     not null.
         */
        var gen_bitlen = function gen_bitlen(s, desc //    deflate_state *s; //    tree_desc *desc;    /* the tree descriptor */
        ) {
            var tree = desc.dyn_tree;
            var max_code = desc.max_code;
            var stree = desc.stat_desc.static_tree;
            var has_stree = desc.stat_desc.has_stree;
            var extra = desc.stat_desc.extra_bits;
            var base = desc.stat_desc.extra_base;
            var max_length = desc.stat_desc.max_length;
            var h;
            /* heap index */
            var n;
            var m;
            /* iterate over the tree elements */
            var bits;
            /* bit length */
            var xbits;
            /* extra bits */
            var f;
            /* frequency */
            var overflow = 0;
            /* number of elements with bit length too large */
            for (bits = 0; bits <= MAX_BITS; bits++) {
                s.bl_count[bits] = 0;
            }
            /* In a first pass, compute the optimal bit lengths (which may
             * overflow in the case of the bit length tree).
             */
            tree[s.heap[s.heap_max] * 2 + 1] =
                /* .Len */
                0;
            /* root of the heap */
            for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
                n = s.heap[h];
                bits =
                    tree[tree[n * 2 + 1] *
                        /* .Dad */
                        2 +
                        1] +
                        /* .Len */
                        1;
                if (bits > max_length) {
                    bits = max_length;
                    overflow++;
                }
                tree[n * 2 + 1] =
                    /* .Len */
                    bits;
                /* We overwrite tree[n].Dad which is no longer needed */
                if (n > max_code) {
                    continue;
                }
                /* not a leaf node */
                s.bl_count[bits]++;
                xbits = 0;
                if (n >= base) {
                    xbits = extra[n - base];
                }
                f = tree[n * 2];
                /* .Freq */
                s.opt_len += f * (bits + xbits);
                if (has_stree) {
                    s.static_len +=
                        f *
                            (stree[n * 2 + 1] +
                                /* .Len */
                                xbits);
                }
            }
            if (overflow === 0) {
                return;
            } // Trace((stderr,"\nbit length overflow\n"));
            /* This happens for example on obj2 and pic of the Calgary corpus */
            /* Find the first bit length which could increase: */
            do {
                bits = max_length - 1;
                while (s.bl_count[bits] === 0) {
                    bits--;
                }
                s.bl_count[bits]--;
                /* move one leaf down the tree */
                s.bl_count[bits + 1] += 2;
                /* move one overflow item as its brother */
                s.bl_count[max_length]--;
                /* The brother of the overflow item also moves one step up,
                 * but this does not affect bl_count[max_length]
                 */
                overflow -= 2;
            } while (overflow > 0);
            /* Now recompute all bit lengths, scanning in increasing frequency.
             * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
             * lengths instead of fixing only the wrong ones. This idea is taken
             * from 'ar' written by Haruhiko Okumura.)
             */
            for (bits = max_length; bits !== 0; bits--) {
                n = s.bl_count[bits];
                while (n !== 0) {
                    m = s.heap[--h];
                    if (m > max_code) {
                        continue;
                    }
                    if (tree[m * 2 + 1] !==
                        /* .Len */
                        bits) {
                        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                        s.opt_len +=
                            (bits - tree[m * 2 + 1]) *
                                /* .Len */
                                tree[m * 2];
                        /* .Freq */
                        tree[m * 2 + 1] =
                            /* .Len */
                            bits;
                    }
                    n--;
                }
            }
        };
        /* ===========================================================================
         * Generate the codes for a given tree and bit counts (which need not be
         * optimal).
         * IN assertion: the array bl_count contains the bit length statistics for
         * the given tree and the field len is set for all tree elements.
         * OUT assertion: the field code is set for all tree elements of non
         *     zero code length.
         */
        var gen_codes = function gen_codes(tree, max_code, bl_count
        //    ct_data *tree;             /* the tree to decorate */
        //    int max_code;              /* largest code with non zero frequency */
        //    ushf *bl_count;            /* number of codes at each bit length */
        ) {
            var next_code = new Array(MAX_BITS + 1);
            /* next code value for each bit length */
            var code = 0;
            /* running code value */
            var bits;
            /* bit index */
            var n;
            /* code index */
            /* The distribution counts are first used to generate the code values
             * without bit reversal.
             */
            for (bits = 1; bits <= MAX_BITS; bits++) {
                next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
            }
            /* Check that the bit counts in bl_count are consistent. The last code
             * must be all ones.
             */
            // Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
            //        "inconsistent bit counts");
            // Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
            for (n = 0; n <= max_code; n++) {
                var len = tree[n * 2 + 1];
                /* .Len */
                if (len === 0) {
                    continue;
                }
                /* Now reverse the bits */
                tree[n * 2] =
                    /* .Code */
                    bi_reverse(next_code[len]++, len); // Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
                //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
            }
        };
        /* ===========================================================================
         * Initialize the various 'constant' tables.
         */
        var tr_static_init = function tr_static_init() {
            var n;
            /* iterates over tree elements */
            var bits;
            /* bit counter */
            var length;
            /* length value */
            var code;
            /* code value */
            var dist;
            /* distance index */
            var bl_count = new Array(MAX_BITS + 1);
            /* number of codes at each bit length for an optimal tree */
            // do check in _tr_init()
            // if (static_init_done) return;
            /* For some embedded targets, global variables are not initialized: */
            /* #ifdef NO_INIT_GLOBAL_POINTERS
            static_l_desc.static_tree = static_ltree;
            static_l_desc.extra_bits = extra_lbits;
            static_d_desc.static_tree = static_dtree;
            static_d_desc.extra_bits = extra_dbits;
            static_bl_desc.extra_bits = extra_blbits;
          #endif */
            /* Initialize the mapping length (0..255) -> length code (0..28) */
            length = 0;
            for (code = 0; code < LENGTH_CODES - 1; code++) {
                base_length[code] = length;
                for (n = 0; n < 1 << extra_lbits[code]; n++) {
                    _length_code[length++] = code;
                }
            } // Assert (length == 256, "tr_static_init: length != 256");
            /* Note that the length 255 (match length 258) can be represented
             * in two different ways: code 284 + 5 bits or code 285, so we
             * overwrite length_code[255] to use the best encoding:
             */
            _length_code[length - 1] = code;
            /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
            dist = 0;
            for (code = 0; code < 16; code++) {
                base_dist[code] = dist;
                for (n = 0; n < 1 << extra_dbits[code]; n++) {
                    _dist_code[dist++] = code;
                }
            } // Assert (dist == 256, "tr_static_init: dist != 256");
            dist >>= 7;
            /* from now on, all distances are divided by 128 */
            for (; code < D_CODES; code++) {
                base_dist[code] = dist << 7;
                for (n = 0; n < 1 << (extra_dbits[code] - 7); n++) {
                    _dist_code[256 + dist++] = code;
                }
            } // Assert (dist == 256, "tr_static_init: 256+dist != 512");
            /* Construct the codes of the static literal tree */
            for (bits = 0; bits <= MAX_BITS; bits++) {
                bl_count[bits] = 0;
            }
            n = 0;
            while (n <= 143) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    8;
                n++;
                bl_count[8]++;
            }
            while (n <= 255) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    9;
                n++;
                bl_count[9]++;
            }
            while (n <= 279) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    7;
                n++;
                bl_count[7]++;
            }
            while (n <= 287) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    8;
                n++;
                bl_count[8]++;
            }
            /* Codes 286 and 287 do not exist, but we must include them in the
             * tree construction to get a canonical Huffman tree (longest code
             * all ones)
             */
            gen_codes(static_ltree, L_CODES + 1, bl_count);
            /* The static distance tree is trivial: */
            for (n = 0; n < D_CODES; n++) {
                static_dtree[n * 2 + 1] =
                    /* .Len */
                    5;
                static_dtree[n * 2] =
                    /* .Code */
                    bi_reverse(n, 5);
            } // Now data ready and we can init static trees
            static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
            static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
            static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
            // static_init_done = true;
        };
        /* ===========================================================================
         * Initialize a new block.
         */
        var init_block = function init_block(s) {
            var n;
            /* iterates over tree elements */
            /* Initialize the trees. */
            for (n = 0; n < L_CODES; n++) {
                s.dyn_ltree[n * 2] =
                    /* .Freq */
                    0;
            }
            for (n = 0; n < D_CODES; n++) {
                s.dyn_dtree[n * 2] =
                    /* .Freq */
                    0;
            }
            for (n = 0; n < BL_CODES; n++) {
                s.bl_tree[n * 2] =
                    /* .Freq */
                    0;
            }
            s.dyn_ltree[END_BLOCK * 2] =
                /* .Freq */
                1;
            s.opt_len = s.static_len = 0;
            s.last_lit = s.matches = 0;
        };
        /* ===========================================================================
         * Flush the bit buffer and align the output on a byte boundary
         */
        var bi_windup = function bi_windup(s) {
            if (s.bi_valid > 8) {
                put_short(s, s.bi_buf);
            }
            else if (s.bi_valid > 0) {
                // put_byte(s, (Byte)s->bi_buf);
                s.pending_buf[s.pending++] = s.bi_buf;
            }
            s.bi_buf = 0;
            s.bi_valid = 0;
        };
        /* ===========================================================================
         * Copy a stored block, storing first the length and its
         * one's complement if requested.
         */
        var copy_block = function copy_block(s, buf, len, header
        // DeflateState *s;
        // charf    *buf;    /* the input data */
        // unsigned len;     /* its length */
        // int      header;  /* true if block header must be written */
        ) {
            bi_windup(s);
            /* align on byte boundary */
            if (header) {
                put_short(s, len);
                put_short(s, ~len);
            }
            //  while (len--) {
            //    put_byte(s, *buf++);
            //  }
            s.pending_buf.set(s.window.subarray(buf, buf + len), s.pending);
            s.pending += len;
        };
        /* ===========================================================================
         * Compares to subtrees, using the tree depth as tie breaker when
         * the subtrees have equal frequency. This minimizes the worst case length.
         */
        var smaller = function smaller(tree, n, m, depth) {
            var _n2 = n * 2;
            var _m2 = m * 2;
            return (tree[_n2] <
                /* .Freq */
                tree[_m2] ||
                /* .Freq */
                (tree[_n2] ===
                    /* .Freq */
                    tree[_m2] &&
                    /* .Freq */
                    depth[n] <= depth[m]));
        };
        /* ===========================================================================
         * Restore the heap property by moving down the tree starting at node k,
         * exchanging a node with the smallest of its two sons if necessary, stopping
         * when the heap property is re-established (each father smaller than its
         * two sons).
         */
        var pqdownheap = function pqdownheap(s, tree, k
        //    deflate_state *s;
        //    ct_data *tree;  /* the tree to restore */
        //    int k;               /* node to move down */
        ) {
            var v = s.heap[k];
            var j = k << 1;
            /* left son of k */
            while (j <= s.heap_len) {
                /* Set j to the smallest of the two sons: */
                if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
                    j++;
                }
                /* Exit if v is smaller than both sons */
                if (smaller(tree, v, s.heap[j], s.depth)) {
                    break;
                }
                /* Exchange v with the smallest son */
                s.heap[k] = s.heap[j];
                k = j;
                /* And continue down the tree, setting j to the left son of k */
                j <<= 1;
            }
            s.heap[k] = v;
        }; // inlined manually
        // const SMALLEST = 1;
        /* ===========================================================================
         * Send the block data compressed using the given Huffman trees
         */
        var compress_block = function compress_block(s, ltree, dtree
        //    deflate_state *s;
        //    const ct_data *ltree; /* literal tree */
        //    const ct_data *dtree; /* distance tree */
        ) {
            var dist;
            /* distance of matched string */
            var lc;
            /* match length or unmatched char (if dist == 0) */
            var lx = 0;
            /* running index in l_buf */
            var code;
            /* the code to send */
            var extra;
            /* number of extra bits to send */
            if (s.last_lit !== 0) {
                do {
                    dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | s.pending_buf[s.d_buf + lx * 2 + 1];
                    lc = s.pending_buf[s.l_buf + lx];
                    lx++;
                    if (dist === 0) {
                        send_code(s, lc, ltree);
                        /* send a literal byte */
                        // Tracecv(isgraph(lc), (stderr," '%c' ", lc));
                    }
                    else {
                        /* Here, lc is the match length - MIN_MATCH */
                        code = _length_code[lc];
                        send_code(s, code + LITERALS + 1, ltree);
                        /* send the length code */
                        extra = extra_lbits[code];
                        if (extra !== 0) {
                            lc -= base_length[code];
                            send_bits(s, lc, extra);
                            /* send the extra length bits */
                        }
                        dist--;
                        /* dist is now the match distance - 1 */
                        code = d_code(dist); // Assert (code < D_CODES, "bad d_code");
                        send_code(s, code, dtree);
                        /* send the distance code */
                        extra = extra_dbits[code];
                        if (extra !== 0) {
                            dist -= base_dist[code];
                            send_bits(s, dist, extra);
                            /* send the extra distance bits */
                        }
                    }
                    /* literal or match pair ? */
                    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
                    // Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
                    //       "pendingBuf overflow");
                } while (lx < s.last_lit);
            }
            send_code(s, END_BLOCK, ltree);
        };
        /* ===========================================================================
         * Construct one Huffman tree and assigns the code bit strings and lengths.
         * Update the total bit length for the current block.
         * IN assertion: the field freq is set for all tree elements.
         * OUT assertions: the fields len and code are set to the optimal bit length
         *     and corresponding code. The length opt_len is updated; static_len is
         *     also updated if stree is not null. The field max_code is set.
         */
        var build_tree = function build_tree(s, desc //    deflate_state *s; //    tree_desc *desc; /* the tree descriptor */
        ) {
            var tree = desc.dyn_tree;
            var stree = desc.stat_desc.static_tree;
            var has_stree = desc.stat_desc.has_stree;
            var elems = desc.stat_desc.elems;
            var n;
            var m;
            /* iterate over heap elements */
            var max_code = -1;
            /* largest code with non zero frequency */
            var node;
            /* new node being created */
            /* Construct the initial heap, with least frequent element in
             * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
             * heap[0] is not used.
             */
            s.heap_len = 0;
            s.heap_max = HEAP_SIZE;
            for (n = 0; n < elems; n++) {
                if (tree[n * 2] !==
                    /* .Freq */
                    0) {
                    s.heap[++s.heap_len] = max_code = n;
                    s.depth[n] = 0;
                }
                else {
                    tree[n * 2 + 1] =
                        /* .Len */
                        0;
                }
            }
            /* The pkzip format requires that at least one distance code exists,
             * and that at least one bit should be sent even if there is only one
             * possible code. So to avoid special checks later on we force at least
             * two codes of non zero frequency.
             */
            while (s.heap_len < 2) {
                node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
                tree[node * 2] =
                    /* .Freq */
                    1;
                s.depth[node] = 0;
                s.opt_len--;
                if (has_stree) {
                    s.static_len -= stree[node * 2 + 1];
                    /* .Len */
                }
                /* node is 0 or 1 so it does not have extra bits */
            }
            desc.max_code = max_code;
            /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
             * establish sub-heaps of increasing lengths:
             */
            for (n = s.heap_len >> 1; 
            /* int /2 */
            n >= 1; n--) {
                pqdownheap(s, tree, n);
            }
            /* Construct the Huffman tree by repeatedly combining the least two
             * frequent nodes.
             */
            node = elems;
            /* next internal node of the tree */
            do {
                // pqremove(s, tree, n);  /* n = node of least frequency */
                /** * pqremove ** */
                n = s.heap[1];
                /* SMALLEST */
                s.heap[1] = s.heap[s.heap_len--];
                /* SMALLEST */
                pqdownheap(s, tree, 1
                /* SMALLEST */
                );
                /***/
                m = s.heap[1];
                /* SMALLEST */
                /* m = node of next least frequency */
                s.heap[--s.heap_max] = n;
                /* keep the nodes sorted by frequency */
                s.heap[--s.heap_max] = m;
                /* Create a new node father of n and m */
                tree[node * 2] =
                    /* .Freq */
                    tree[n * 2] +
                        /* .Freq */
                        tree[m * 2];
                /* .Freq */
                s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
                tree[n * 2 + 1] =
                    /* .Dad */
                    tree[m * 2 + 1] =
                        /* .Dad */
                        node;
                /* and insert the new node in the heap */
                s.heap[1] = node++;
                /* SMALLEST */
                pqdownheap(s, tree, 1
                /* SMALLEST */
                );
            } while (s.heap_len >= 2);
            s.heap[--s.heap_max] = s.heap[1];
            /* SMALLEST */
            /* At this point, the fields freq and dad are set. We can now
             * generate the bit lengths.
             */
            gen_bitlen(s, desc);
            /* The field len is now set, we can generate the bit codes */
            gen_codes(tree, max_code, s.bl_count);
        };
        /* ===========================================================================
         * Scan a literal or distance tree to determine the frequencies of the codes
         * in the bit length tree.
         */
        var scan_tree = function scan_tree(s, tree, max_code
        //    deflate_state *s;
        //    ct_data *tree;   /* the tree to be scanned */
        //    int max_code;    /* and its largest code of non zero frequency */
        ) {
            var n;
            /* iterates over all tree elements */
            var prevlen = -1;
            /* last emitted length */
            var curlen;
            /* length of current code */
            var nextlen = tree[0 * 2 + 1];
            /* .Len */
            /* length of next code */
            var count = 0;
            /* repeat count of the current code */
            var max_count = 7;
            /* max repeat count */
            var min_count = 4;
            /* min repeat count */
            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            }
            tree[(max_code + 1) * 2 + 1] =
                /* .Len */
                0xffff;
            /* guard */
            for (n = 0; n <= max_code; n++) {
                curlen = nextlen;
                nextlen = tree[(n + 1) * 2 + 1];
                /* .Len */
                if (++count < max_count && curlen === nextlen) {
                    continue;
                }
                else if (count < min_count) {
                    s.bl_tree[curlen * 2] +=
                        /* .Freq */
                        count;
                }
                else if (curlen !== 0) {
                    if (curlen !== prevlen) {
                        s.bl_tree[curlen * 2] /* .Freq */++;
                    }
                    s.bl_tree[REP_3_6 * 2] /* .Freq */++;
                }
                else if (count <= 10) {
                    s.bl_tree[REPZ_3_10 * 2] /* .Freq */++;
                }
                else {
                    s.bl_tree[REPZ_11_138 * 2] /* .Freq */++;
                }
                count = 0;
                prevlen = curlen;
                if (nextlen === 0) {
                    max_count = 138;
                    min_count = 3;
                }
                else if (curlen === nextlen) {
                    max_count = 6;
                    min_count = 3;
                }
                else {
                    max_count = 7;
                    min_count = 4;
                }
            }
        };
        /* ===========================================================================
         * Send a literal or distance tree in compressed form, using the codes in
         * bl_tree.
         */
        var send_tree = function send_tree(s, tree, max_code
        //    deflate_state *s;
        //    ct_data *tree; /* the tree to be scanned */
        //    int max_code;       /* and its largest code of non zero frequency */
        ) {
            var n;
            /* iterates over all tree elements */
            var prevlen = -1;
            /* last emitted length */
            var curlen;
            /* length of current code */
            var nextlen = tree[0 * 2 + 1];
            /* .Len */
            /* length of next code */
            var count = 0;
            /* repeat count of the current code */
            var max_count = 7;
            /* max repeat count */
            var min_count = 4;
            /* min repeat count */
            /* tree[max_code+1].Len = -1; */
            /* guard already set */
            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            }
            for (n = 0; n <= max_code; n++) {
                curlen = nextlen;
                nextlen = tree[(n + 1) * 2 + 1];
                /* .Len */
                if (++count < max_count && curlen === nextlen) {
                    continue;
                }
                else if (count < min_count) {
                    do {
                        send_code(s, curlen, s.bl_tree);
                    } while (--count !== 0);
                }
                else if (curlen !== 0) {
                    if (curlen !== prevlen) {
                        send_code(s, curlen, s.bl_tree);
                        count--;
                    } // Assert(count >= 3 && count <= 6, " 3_6?");
                    send_code(s, REP_3_6, s.bl_tree);
                    send_bits(s, count - 3, 2);
                }
                else if (count <= 10) {
                    send_code(s, REPZ_3_10, s.bl_tree);
                    send_bits(s, count - 3, 3);
                }
                else {
                    send_code(s, REPZ_11_138, s.bl_tree);
                    send_bits(s, count - 11, 7);
                }
                count = 0;
                prevlen = curlen;
                if (nextlen === 0) {
                    max_count = 138;
                    min_count = 3;
                }
                else if (curlen === nextlen) {
                    max_count = 6;
                    min_count = 3;
                }
                else {
                    max_count = 7;
                    min_count = 4;
                }
            }
        };
        /* ===========================================================================
         * Construct the Huffman tree for the bit lengths and return the index in
         * bl_order of the last bit length code to send.
         */
        var build_bl_tree = function build_bl_tree(s) {
            var max_blindex;
            /* index of last bit length code of non zero freq */
            /* Determine the bit length frequencies for literal and distance trees */
            scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
            scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
            /* Build the bit length tree: */
            build_tree(s, s.bl_desc);
            /* opt_len now includes the length of the tree representations, except
             * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
             */
            /* Determine the number of bit length codes to send. The pkzip format
             * requires that at least 4 bit length codes be sent. (appnote.txt says
             * 3 but the actual value used is 4.)
             */
            for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
                if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !==
                    /* .Len */
                    0) {
                    break;
                }
            }
            /* Update opt_len to include the bit length tree and counts */
            s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4; // Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
            //        s->opt_len, s->static_len));
            return max_blindex;
        };
        /* ===========================================================================
         * Send the header for a block using dynamic Huffman trees: the counts, the
         * lengths of the bit length codes, the literal tree and the distance tree.
         * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
         */
        var send_all_trees = function send_all_trees(s, lcodes, dcodes, blcodes //    deflate_state *s; //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
        ) {
            var rank;
            /* index in bl_order */
            // Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
            // Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
            //        "too many codes");
            // Tracev((stderr, "\nbl counts: "));
            send_bits(s, lcodes - 257, 5);
            /* not +255 as stated in appnote.txt */
            send_bits(s, dcodes - 1, 5);
            send_bits(s, blcodes - 4, 4);
            /* not -3 as stated in appnote.txt */
            for (rank = 0; rank < blcodes; rank++) {
                // Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
                send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 
                /* .Len */
                3);
            } // Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
            send_tree(s, s.dyn_ltree, lcodes - 1);
            /* literal tree */
            // Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
            send_tree(s, s.dyn_dtree, dcodes - 1);
            /* distance tree */
            // Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
        };
        /* ===========================================================================
         * Check if the data type is TEXT or BINARY, using the following algorithm:
         * - TEXT if the two conditions below are satisfied:
         *    a) There are no non-portable control characters belonging to the
         *       "black list" (0..6, 14..25, 28..31).
         *    b) There is at least one printable character belonging to the
         *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
         * - BINARY otherwise.
         * - The following partially-portable control characters form a
         *   "gray list" that is ignored in this detection algorithm:
         *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
         * IN assertion: the fields Freq of dyn_ltree are set.
         */
        var detect_data_type = function detect_data_type(s) {
            /* black_mask is the bit mask of black-listed bytes
             * set bits 0..6, 14..25, and 28..31
             * 0xf3ffc07f = binary 11110011111111111100000001111111
             */
            var black_mask = 0xf3ffc07f;
            var n;
            /* Check for non-textual ("black-listed") bytes. */
            for (n = 0; n <= 31; n++, black_mask >>>= 1) {
                if (black_mask & 1 &&
                    s.dyn_ltree[n * 2] !==
                        /* .Freq */
                        0) {
                    return Z_BINARY;
                }
            }
            /* Check for textual ("white-listed") bytes. */
            if (s.dyn_ltree[9 * 2] !==
                /* .Freq */
                0 ||
                s.dyn_ltree[10 * 2] !==
                    /* .Freq */
                    0 ||
                s.dyn_ltree[13 * 2] !==
                    /* .Freq */
                    0) {
                return Z_TEXT;
            }
            for (n = 32; n < LITERALS; n++) {
                if (s.dyn_ltree[n * 2] !==
                    /* .Freq */
                    0) {
                    return Z_TEXT;
                }
            }
            /* There are no "black-listed" or "white-listed" bytes:
             * this stream either is empty or has tolerated ("gray-listed") bytes only.
             */
            return Z_BINARY;
        };
        var static_init_done = false;
        /* ===========================================================================
         * Initialize the tree data structures for a new zlib stream.
         */
        var _tr_init = function _tr_init(s) {
            if (!static_init_done) {
                tr_static_init();
                static_init_done = true;
            }
            s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
            s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
            s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
            s.bi_buf = 0;
            s.bi_valid = 0;
            /* Initialize the first block of the first file: */
            init_block(s);
        };
        /* ===========================================================================
         * Send a stored block
         */
        var _tr_stored_block = function _tr_stored_block(s, buf, stored_len, last
        // DeflateState *s;
        // charf *buf;       /* input block */
        // ulg stored_len;   /* length of input block */
        // int last;         /* one if this is the last block for a file */
        ) {
            send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);
            /* send block type */
            copy_block(s, buf, stored_len, true);
            /* with header */
        };
        /* ===========================================================================
         * Send one empty static block to give enough lookahead for inflate.
         * This takes 10 bits, of which 7 may remain in the bit buffer.
         */
        var _tr_align = function _tr_align(s) {
            send_bits(s, STATIC_TREES << 1, 3);
            send_code(s, END_BLOCK, static_ltree);
            bi_flush(s);
        };
        /* ===========================================================================
         * Determine the best encoding for the current block: dynamic trees, static
         * trees or store, and output the encoded block to the zip file.
         */
        var _tr_flush_block = function _tr_flush_block(s, buf, stored_len, last
        // DeflateState *s;
        // charf *buf;       /* input block, or NULL if too old */
        // ulg stored_len;   /* length of input block */
        // int last;         /* one if this is the last block for a file */
        ) {
            var opt_lenb;
            var static_lenb;
            /* opt_len and static_len in bytes */
            var max_blindex = 0;
            /* index of last bit length code of non zero freq */
            /* Build the Huffman trees unless a stored block is forced */
            if (s.level > 0) {
                /* Check if the file is binary or text */
                if (s.strm.data_type === Z_UNKNOWN) {
                    s.strm.data_type = detect_data_type(s);
                }
                /* Construct the literal and distance trees */
                build_tree(s, s.l_desc); // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
                //        s->static_len));
                build_tree(s, s.d_desc); // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
                //        s->static_len));
                /* At this point, opt_len and static_len are the total bit lengths of
                 * the compressed block data, excluding the tree representations.
                 */
                /* Build the bit length tree for the above two trees, and get the index
                 * in bl_order of the last bit length code to send.
                 */
                max_blindex = build_bl_tree(s);
                /* Determine the best encoding. Compute the block lengths in bytes. */
                opt_lenb = (s.opt_len + 3 + 7) >>> 3;
                static_lenb = (s.static_len + 3 + 7) >>> 3; // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
                //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
                //        s->last_lit));
                if (static_lenb <= opt_lenb) {
                    opt_lenb = static_lenb;
                }
            }
            else {
                // Assert(buf != (char*)0, "lost buf");
                opt_lenb = static_lenb = stored_len + 5;
                /* force a stored block */
            }
            if (stored_len + 4 <= opt_lenb && buf !== -1) {
                /* 4: two words for the lengths */
                /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
                 * Otherwise we can't have processed more than WSIZE input bytes since
                 * the last block flush, because compression would have been
                 * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
                 * transform a block into a stored block.
                 */
                _tr_stored_block(s, buf, stored_len, last);
            }
            else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
                send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
                compress_block(s, static_ltree, static_dtree);
            }
            else {
                send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
                send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
                compress_block(s, s.dyn_ltree, s.dyn_dtree);
            } // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
            /* The above check is made mod 2^32, for files larger than 512 MB
             * and uLong implemented on 32 bits.
             */
            init_block(s);
            if (last) {
                bi_windup(s);
            } // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
            //       s->compressed_len-7*last));
        };
        /* ===========================================================================
         * Save the match info and tally the frequency counts. Return true if
         * the current block must be flushed.
         */
        var _tr_tally = function _tr_tally(s, dist, lc
        //    deflate_state *s;
        //    unsigned dist;  /* distance of matched string */
        //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
        ) {
            // let out_length, in_length, dcode;
            s.pending_buf[s.d_buf + s.last_lit * 2] = (dist >>> 8) & 0xff;
            s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
            s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
            s.last_lit++;
            if (dist === 0) {
                /* lc is the unmatched char */
                s.dyn_ltree[lc * 2] /* .Freq */++;
            }
            else {
                s.matches++;
                /* Here, lc is the match length - MIN_MATCH */
                dist--;
                /* dist = match distance - 1 */
                // Assert((ush)dist < (ush)MAX_DIST(s) &&
                //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
                //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
                s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2] /* .Freq */++;
                s.dyn_dtree[d_code(dist) * 2] /* .Freq */++;
            } // (!) This block is disabled in zlib defaults,
            // don't enable it for binary compatibility
            // #ifdef TRUNCATE_BLOCK
            //  /* Try to guess if it is profitable to stop the current block here */
            //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
            //    /* Compute an upper bound for the compressed length */
            //    out_length = s.last_lit*8;
            //    in_length = s.strstart - s.block_start;
            //
            //    for (dcode = 0; dcode < D_CODES; dcode++) {
            //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
            //    }
            //    out_length >>>= 3;
            //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
            //    //       s->last_lit, in_length, out_length,
            //    //       100L - out_length*100L/in_length));
            //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
            //      return true;
            //    }
            //  }
            // #endif
            return s.last_lit === s.lit_bufsize - 1;
            /* We avoid equality with lit_bufsize because of wraparound at 64K
             * on 16 bit machines and because stored blocks are restricted to
             * 64K-1 bytes.
             */
        };
        var _tr_init_1 = _tr_init;
        var _tr_stored_block_1 = _tr_stored_block;
        var _tr_flush_block_1 = _tr_flush_block;
        var _tr_tally_1 = _tr_tally;
        var _tr_align_1 = _tr_align;
        var trees = {
            _tr_init: _tr_init_1,
            _tr_stored_block: _tr_stored_block_1,
            _tr_flush_block: _tr_flush_block_1,
            _tr_tally: _tr_tally_1,
            _tr_align: _tr_align_1,
        };
        // It isn't worth it to make additional optimizations as in original.
        // Small size is preferable.
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var adler32 = function adler32(adler, buf, len, pos) {
            var s1 = (adler & 0xffff) | 0;
            var s2 = ((adler >>> 16) & 0xffff) | 0;
            var n = 0;
            while (len !== 0) {
                // Set limit ~ twice less than 5552, to keep
                // s2 in 31-bits, because we force signed ints.
                // in other case %= will fail.
                n = len > 2000 ? 2000 : len;
                len -= n;
                do {
                    s1 = (s1 + buf[pos++]) | 0;
                    s2 = (s2 + s1) | 0;
                } while (--n);
                s1 %= 65521;
                s2 %= 65521;
            }
            return s1 | (s2 << 16) | 0;
        };
        var adler32_1 = adler32;
        // So write code to minimize size - no pregenerated tables
        // and array tools dependencies.
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        // Use ordinary array, since untyped makes no boost here
        var makeTable = function makeTable() {
            var c;
            var table = [];
            for (var n = 0; n < 256; n++) {
                c = n;
                for (var k = 0; k < 8; k++) {
                    c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
                }
                table[n] = c;
            }
            return table;
        }; // Create table on load. Just 255 signed longs. Not a problem.
        var crcTable = new Uint32Array(makeTable());
        var crc32 = function crc32(crc, buf, len, pos) {
            var t = crcTable;
            var end = pos + len;
            crc ^= -1;
            for (var i = pos; i < end; i++) {
                crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xff];
            }
            return crc ^ -1; // >>> 0;
        };
        var crc32_1 = crc32;
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var messages = {
            2: 'need dictionary',
            /* Z_NEED_DICT       2  */
            1: 'stream end',
            /* Z_STREAM_END      1  */
            0: '',
            /* Z_OK              0  */
            '-1': 'file error',
            /* Z_ERRNO         (-1) */
            '-2': 'stream error',
            /* Z_STREAM_ERROR  (-2) */
            '-3': 'data error',
            /* Z_DATA_ERROR    (-3) */
            '-4': 'insufficient memory',
            /* Z_MEM_ERROR     (-4) */
            '-5': 'buffer error',
            /* Z_BUF_ERROR     (-5) */
            '-6': 'incompatible version',
            /* Z_VERSION_ERROR (-6) */
        };
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var constants = {
            /* Allowed flush values; see deflate() and inflate() below for details */
            Z_NO_FLUSH: 0,
            Z_PARTIAL_FLUSH: 1,
            Z_SYNC_FLUSH: 2,
            Z_FULL_FLUSH: 3,
            Z_FINISH: 4,
            Z_BLOCK: 5,
            Z_TREES: 6,
            /* Return codes for the compression/decompression functions. Negative values
             * are errors, positive values are used for special but normal events.
             */
            Z_OK: 0,
            Z_STREAM_END: 1,
            Z_NEED_DICT: 2,
            Z_ERRNO: -1,
            Z_STREAM_ERROR: -2,
            Z_DATA_ERROR: -3,
            Z_MEM_ERROR: -4,
            Z_BUF_ERROR: -5,
            // Z_VERSION_ERROR: -6,
            /* compression levels */
            Z_NO_COMPRESSION: 0,
            Z_BEST_SPEED: 1,
            Z_BEST_COMPRESSION: 9,
            Z_DEFAULT_COMPRESSION: -1,
            Z_FILTERED: 1,
            Z_HUFFMAN_ONLY: 2,
            Z_RLE: 3,
            Z_FIXED: 4,
            Z_DEFAULT_STRATEGY: 0,
            /* Possible values of the data_type field (though see inflate()) */
            Z_BINARY: 0,
            Z_TEXT: 1,
            // Z_ASCII:                1, // = Z_TEXT (deprecated)
            Z_UNKNOWN: 2,
            /* The deflate compression method */
            Z_DEFLATED: 8, // Z_NULL:                 null // Use -1 or null inline, depending on var type
        };
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var _tr_init$1 = trees._tr_init;
        var _tr_stored_block$1 = trees._tr_stored_block;
        var _tr_flush_block$1 = trees._tr_flush_block;
        var _tr_tally$1 = trees._tr_tally;
        var _tr_align$1 = trees._tr_align;
        /* Public constants ========================================================== */
        /* =========================================================================== */
        var Z_NO_FLUSH = constants.Z_NO_FLUSH;
        var Z_PARTIAL_FLUSH = constants.Z_PARTIAL_FLUSH;
        var Z_FULL_FLUSH = constants.Z_FULL_FLUSH;
        var Z_FINISH = constants.Z_FINISH;
        var Z_BLOCK = constants.Z_BLOCK;
        var Z_OK = constants.Z_OK;
        var Z_STREAM_END = constants.Z_STREAM_END;
        var Z_STREAM_ERROR = constants.Z_STREAM_ERROR;
        var Z_DATA_ERROR = constants.Z_DATA_ERROR;
        var Z_BUF_ERROR = constants.Z_BUF_ERROR;
        var Z_DEFAULT_COMPRESSION = constants.Z_DEFAULT_COMPRESSION;
        var Z_FILTERED = constants.Z_FILTERED;
        var Z_HUFFMAN_ONLY = constants.Z_HUFFMAN_ONLY;
        var Z_RLE = constants.Z_RLE;
        var Z_FIXED$1 = constants.Z_FIXED;
        var Z_DEFAULT_STRATEGY = constants.Z_DEFAULT_STRATEGY;
        var Z_UNKNOWN$1 = constants.Z_UNKNOWN;
        var Z_DEFLATED = constants.Z_DEFLATED;
        /* ============================================================================ */
        var MAX_MEM_LEVEL = 9;
        /* Maximum value for memLevel in deflateInit2 */
        var MAX_WBITS = 15;
        /* 32K LZ77 window */
        var DEF_MEM_LEVEL = 8;
        var LENGTH_CODES$1 = 29;
        /* number of length codes, not counting the special END_BLOCK code */
        var LITERALS$1 = 256;
        /* number of literal bytes 0..255 */
        var L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1;
        /* number of Literal or Length codes, including the END_BLOCK code */
        var D_CODES$1 = 30;
        /* number of distance codes */
        var BL_CODES$1 = 19;
        /* number of codes used to transfer the bit lengths */
        var HEAP_SIZE$1 = 2 * L_CODES$1 + 1;
        /* maximum heap size */
        var MAX_BITS$1 = 15;
        /* All codes must not exceed MAX_BITS bits */
        var MIN_MATCH$1 = 3;
        var MAX_MATCH$1 = 258;
        var MIN_LOOKAHEAD = MAX_MATCH$1 + MIN_MATCH$1 + 1;
        var PRESET_DICT = 0x20;
        var INIT_STATE = 42;
        var EXTRA_STATE = 69;
        var NAME_STATE = 73;
        var COMMENT_STATE = 91;
        var HCRC_STATE = 103;
        var BUSY_STATE = 113;
        var FINISH_STATE = 666;
        var BS_NEED_MORE = 1;
        /* block not completed, need more input or more output */
        var BS_BLOCK_DONE = 2;
        /* block flush performed */
        var BS_FINISH_STARTED = 3;
        /* finish started, need only more output at next deflate */
        var BS_FINISH_DONE = 4;
        /* finish done, accept no more input or output */
        var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
        var err = function err(strm, errorCode) {
            strm.msg = messages[errorCode];
            return errorCode;
        };
        var rank = function rank(f) {
            return (f << 1) - (f > 4 ? 9 : 0);
        };
        var zero$1 = function zero(buf) {
            var len = buf.length;
            while (--len >= 0) {
                buf[len] = 0;
            }
        };
        var HASH_ZLIB = function HASH_ZLIB(s, prev, data) {
            return ((prev << s.hash_shift) ^ data) & s.hash_mask;
        }; // This hash causes less collisions, https://github.com/nodeca/pako/issues/135
        // But breaks binary compatibility
        // let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
        var HASH = HASH_ZLIB;
        /* =========================================================================
         * Flush as much pending output as possible. All deflate() output goes
         * through this function so some applications may wish to modify it
         * to avoid allocating a large strm->output buffer and copying into it.
         * (See also read_buf()).
         */
        var flush_pending = function flush_pending(strm) {
            var s = strm.state; // _tr_flush_bits(s);
            var len = s.pending;
            if (len > strm.avail_out) {
                len = strm.avail_out;
            }
            if (len === 0) {
                return;
            }
            strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
            strm.next_out += len;
            s.pending_out += len;
            strm.total_out += len;
            strm.avail_out -= len;
            s.pending -= len;
            if (s.pending === 0) {
                s.pending_out = 0;
            }
        };
        var flush_block_only = function flush_block_only(s, last) {
            _tr_flush_block$1(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
            s.block_start = s.strstart;
            flush_pending(s.strm);
        };
        var put_byte = function put_byte(s, b) {
            s.pending_buf[s.pending++] = b;
        };
        /* =========================================================================
         * Put a short in the pending buffer. The 16-bit value is put in MSB order.
         * IN assertion: the stream state is correct and there is enough room in
         * pending_buf.
         */
        var putShortMSB = function putShortMSB(s, b) {
            //  put_byte(s, (Byte)(b >> 8));
            //  put_byte(s, (Byte)(b & 0xff));
            s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
            s.pending_buf[s.pending++] = b & 0xff;
        };
        /* ===========================================================================
         * Read a new buffer from the current input stream, update the adler32
         * and total number of bytes read.  All deflate() input goes through
         * this function so some applications may wish to modify it to avoid
         * allocating a large strm->input buffer and copying from it.
         * (See also flush_pending()).
         */
        var read_buf = function read_buf(strm, buf, start, size) {
            var len = strm.avail_in;
            if (len > size) {
                len = size;
            }
            if (len === 0) {
                return 0;
            }
            strm.avail_in -= len; // zmemcpy(buf, strm->next_in, len);
            buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
            if (strm.state.wrap === 1) {
                strm.adler = adler32_1(strm.adler, buf, len, start);
            }
            else if (strm.state.wrap === 2) {
                strm.adler = crc32_1(strm.adler, buf, len, start);
            }
            strm.next_in += len;
            strm.total_in += len;
            return len;
        };
        /* ===========================================================================
         * Set match_start to the longest match starting at the given string and
         * return its length. Matches shorter or equal to prev_length are discarded,
         * in which case the result is equal to prev_length and match_start is
         * garbage.
         * IN assertions: cur_match is the head of the hash chain for the current
         *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
         * OUT assertion: the match length is not greater than s->lookahead.
         */
        var longest_match = function longest_match(s, cur_match) {
            var chain_length = s.max_chain_length;
            /* max hash chain length */
            var scan = s.strstart;
            /* current string */
            var match;
            /* matched string */
            var len;
            /* length of current match */
            var best_len = s.prev_length;
            /* best match length so far */
            var nice_match = s.nice_match;
            /* stop if match long enough */
            var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0;
            /* NIL */
            var _win = s.window; // shortcut
            var wmask = s.w_mask;
            var prev = s.prev;
            /* Stop when cur_match becomes <= limit. To simplify the code,
             * we prevent matches with the string of window index 0.
             */
            var strend = s.strstart + MAX_MATCH$1;
            var scan_end1 = _win[scan + best_len - 1];
            var scan_end = _win[scan + best_len];
            /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
             * It is easy to get rid of this optimization if necessary.
             */
            // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
            /* Do not waste too much time if we already have a good match: */
            if (s.prev_length >= s.good_match) {
                chain_length >>= 2;
            }
            /* Do not look for matches beyond the end of the input. This is necessary
             * to make deflate deterministic.
             */
            if (nice_match > s.lookahead) {
                nice_match = s.lookahead;
            } // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
            do {
                // Assert(cur_match < s->strstart, "no future");
                match = cur_match;
                /* Skip to next match if the match length cannot increase
                 * or if the match length is less than 2.  Note that the checks below
                 * for insufficient lookahead only occur occasionally for performance
                 * reasons.  Therefore uninitialized memory will be accessed, and
                 * conditional jumps will be made that depend on those values.
                 * However the length of the match is limited to the lookahead, so
                 * the output of deflate is not affected by the uninitialized values.
                 */
                if (_win[match + best_len] !== scan_end ||
                    _win[match + best_len - 1] !== scan_end1 ||
                    _win[match] !== _win[scan] ||
                    _win[++match] !== _win[scan + 1]) {
                    continue;
                }
                /* The check at best_len-1 can be removed because it will be made
                 * again later. (This heuristic is not always a win.)
                 * It is not necessary to compare scan[2] and match[2] since they
                 * are always equal when the other bytes match, given that
                 * the hash keys are equal and that HASH_BITS >= 8.
                 */
                scan += 2;
                match++; // Assert(*scan == *match, "match[2]?");
                /* We check for insufficient lookahead only every 8th comparison;
                 * the 256th check will be made at strstart+258.
                 */
                do {
                    /* jshint noempty:false */
                } while (_win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    scan < strend); // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
                len = MAX_MATCH$1 - (strend - scan);
                scan = strend - MAX_MATCH$1;
                if (len > best_len) {
                    s.match_start = cur_match;
                    best_len = len;
                    if (len >= nice_match) {
                        break;
                    }
                    scan_end1 = _win[scan + best_len - 1];
                    scan_end = _win[scan + best_len];
                }
            } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
            if (best_len <= s.lookahead) {
                return best_len;
            }
            return s.lookahead;
        };
        /* ===========================================================================
         * Fill the window when the lookahead becomes insufficient.
         * Updates strstart and lookahead.
         *
         * IN assertion: lookahead < MIN_LOOKAHEAD
         * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
         *    At least one byte has been read, or avail_in == 0; reads are
         *    performed for at least two bytes (required for the zip translate_eol
         *    option -- not supported here).
         */
        var fill_window = function fill_window(s) {
            var _w_size = s.w_size;
            var p;
            var n;
            var m;
            var more;
            var str; // Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
            do {
                more = s.window_size - s.lookahead - s.strstart; // JS ints have 32 bit, block below not needed
                /* Deal with !@#$% 64K limit: */
                // if (sizeof(int) <= 2) {
                //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
                //        more = wsize;
                //
                //  } else if (more == (unsigned)(-1)) {
                //        /* Very unlikely, but possible on 16 bit machine if
                //         * strstart == 0 && lookahead == 1 (input done a byte at time)
                //         */
                //        more--;
                //    }
                // }
                /* If the window is almost full and there is insufficient lookahead,
                 * move the upper half to the lower one to make room in the upper half.
                 */
                if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
                    s.window.set(s.window.subarray(_w_size, _w_size + _w_size), 0);
                    s.match_start -= _w_size;
                    s.strstart -= _w_size;
                    /* we now have strstart >= MAX_DIST */
                    s.block_start -= _w_size;
                    /* Slide the hash table (could be avoided with 32 bit values
                   at the expense of memory usage). We slide even when level == 0
                   to keep the hash table consistent if we switch back to level > 0
                   later. (Using level 0 permanently is not an optimal usage of
                   zlib, so we don't care about this pathological case.)
                   */
                    n = s.hash_size;
                    p = n;
                    do {
                        m = s.head[--p];
                        s.head[p] = m >= _w_size ? m - _w_size : 0;
                    } while (--n);
                    n = _w_size;
                    p = n;
                    do {
                        m = s.prev[--p];
                        s.prev[p] = m >= _w_size ? m - _w_size : 0;
                        /* If n is not on any hash chain, prev[n] is garbage but
                         * its value will never be used.
                         */
                    } while (--n);
                    more += _w_size;
                }
                if (s.strm.avail_in === 0) {
                    break;
                }
                /* If there was no sliding:
                 *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
                 *    more == window_size - lookahead - strstart
                 * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
                 * => more >= window_size - 2*WSIZE + 2
                 * In the BIG_MEM or MMAP case (not yet supported),
                 *   window_size == input_size + MIN_LOOKAHEAD  &&
                 *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
                 * Otherwise, window_size == 2*WSIZE so more >= 2.
                 * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
                 */
                // Assert(more >= 2, "more < 2");
                n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
                s.lookahead += n;
                /* Initialize the hash value now that we have some input: */
                if (s.lookahead + s.insert >= MIN_MATCH$1) {
                    str = s.strstart - s.insert;
                    s.ins_h = s.window[str];
                    /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
                    s.ins_h = HASH(s, s.ins_h, s.window[str + 1]); // #if MIN_MATCH != 3
                    //        Call update_hash() MIN_MATCH-3 more times
                    // #endif
                    while (s.insert) {
                        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                        s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH$1 - 1]);
                        s.prev[str & s.w_mask] = s.head[s.ins_h];
                        s.head[s.ins_h] = str;
                        str++;
                        s.insert--;
                        if (s.lookahead + s.insert < MIN_MATCH$1) {
                            break;
                        }
                    }
                }
                /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
                 * but this is not important since only literal bytes will be emitted.
                 */
            } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
            /* If the WIN_INIT bytes after the end of the current data have never been
             * written, then zero those bytes in order to avoid memory check reports of
             * the use of uninitialized (or uninitialised as Julian writes) bytes by
             * the longest match routines.  Update the high water mark for the next
             * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
             * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
             */
            //  if (s.high_water < s.window_size) {
            //    const curr = s.strstart + s.lookahead;
            //    let init = 0;
            //
            //    if (s.high_water < curr) {
            //      /* Previous high water mark below current data -- zero WIN_INIT
            //       * bytes or up to end of window, whichever is less.
            //       */
            //      init = s.window_size - curr;
            //      if (init > WIN_INIT)
            //        init = WIN_INIT;
            //      zmemzero(s->window + curr, (unsigned)init);
            //      s->high_water = curr + init;
            //    }
            //    else if (s->high_water < (ulg)curr + WIN_INIT) {
            //      /* High water mark at or above current data, but below current data
            //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
            //       * to end of window, whichever is less.
            //       */
            //      init = (ulg)curr + WIN_INIT - s->high_water;
            //      if (init > s->window_size - s->high_water)
            //        init = s->window_size - s->high_water;
            //      zmemzero(s->window + s->high_water, (unsigned)init);
            //      s->high_water += init;
            //    }
            //  }
            //
            //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
            //    "not enough room for search");
        };
        /* ===========================================================================
         * Copy without compression as much as possible from the input stream, return
         * the current block state.
         * This function does not insert new strings in the dictionary since
         * uncompressible data is probably not useful. This function is used
         * only for the level=0 compression option.
         * NOTE: this function should be optimized to avoid extra copying from
         * window to pending_buf.
         */
        var deflate_stored = function deflate_stored(s, flush) {
            /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
             * to pending_buf_size, and each stored block has a 5 byte header:
             */
            var max_block_size = 0xffff;
            if (max_block_size > s.pending_buf_size - 5) {
                max_block_size = s.pending_buf_size - 5;
            }
            /* Copy as much as possible from input to output: */
            for (;;) {
                /* Fill the window as much as possible: */
                if (s.lookahead <= 1) {
                    // Assert(s->strstart < s->w_size+MAX_DIST(s) ||
                    //  s->block_start >= (long)s->w_size, "slide too late");
                    //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
                    //        s.block_start >= s.w_size)) {
                    //        throw  new Error("slide too late");
                    //      }
                    fill_window(s);
                    if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                } // Assert(s->block_start >= 0L, "block gone");
                //    if (s.block_start < 0) throw new Error("block gone");
                s.strstart += s.lookahead;
                s.lookahead = 0;
                /* Emit a stored block if pending_buf will be full: */
                var max_start = s.block_start + max_block_size;
                if (s.strstart === 0 || s.strstart >= max_start) {
                    /* strstart == 0 is possible when wraparound on 16-bit machine */
                    s.lookahead = s.strstart - max_start;
                    s.strstart = max_start;
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
                /* Flush if we may have to slide, otherwise block_start may become
                 * negative and the data will be gone:
                 */
                if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.strstart > s.block_start) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_NEED_MORE;
        };
        /* ===========================================================================
         * Compress as much as possible from the input stream, return the current
         * block state.
         * This function does not perform lazy evaluation of matches and inserts
         * new strings in the dictionary only for unmatched strings or for short
         * matches. It is used only for the fast compression options.
         */
        var deflate_fast = function deflate_fast(s, flush) {
            var hash_head;
            /* head of the hash chain */
            var bflush;
            /* set if current block must be flushed */
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the next match, plus MIN_MATCH bytes to insert the
                 * string following the next match.
                 */
                if (s.lookahead < MIN_LOOKAHEAD) {
                    fill_window(s);
                    if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                        /* flush the current block */
                    }
                }
                /* Insert the string window[strstart .. strstart+2] in the
                 * dictionary, and set hash_head to the head of the hash chain:
                 */
                hash_head = 0;
                /* NIL */
                if (s.lookahead >= MIN_MATCH$1) {
                    /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                    s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                    /***/
                }
                /* Find the longest match, discarding those <= prev_length.
                 * At this point we have always match_length < MIN_MATCH
                 */
                if (hash_head !== 0 &&
                    /* NIL */
                    s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
                    /* To simplify the code, we prevent matches with the string
                     * of window index 0 (in particular we have to avoid a match
                     * of the string with itself at the start of the input file).
                     */
                    s.match_length = longest_match(s, hash_head);
                    /* longest_match() sets match_start */
                }
                if (s.match_length >= MIN_MATCH$1) {
                    // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
                    /** * _tr_tally_dist(s, s.strstart - s.match_start,
                                 s.match_length - MIN_MATCH, bflush); ** */
                    bflush = _tr_tally$1(s, s.strstart - s.match_start, s.match_length - MIN_MATCH$1);
                    s.lookahead -= s.match_length;
                    /* Insert new strings in the hash table only if the match length
                     * is not too large. This saves time but degrades compression.
                     */
                    if (s.match_length <= s.max_lazy_match &&
                        /* max_insert_length */
                        s.lookahead >= MIN_MATCH$1) {
                        s.match_length--;
                        /* string at strstart already in table */
                        do {
                            s.strstart++;
                            /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                            s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                            /***/
                            /* strstart never exceeds WSIZE-MAX_MATCH, so there are
                             * always MIN_MATCH bytes ahead.
                             */
                        } while (--s.match_length !== 0);
                        s.strstart++;
                    }
                    else {
                        s.strstart += s.match_length;
                        s.match_length = 0;
                        s.ins_h = s.window[s.strstart];
                        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
                        s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]); // #if MIN_MATCH != 3
                        //                Call UPDATE_HASH() MIN_MATCH-3 more times
                        // #endif
                        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
                         * matter since it will be recomputed at next deflate call.
                         */
                    }
                }
                else {
                    /* No match, output a literal byte */
                    // Tracevv((stderr,"%c", s.window[s.strstart]));
                    /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                    s.lookahead--;
                    s.strstart++;
                }
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * Same as above, but achieves better compression. We use a lazy
         * evaluation for matches: a match is finally adopted only if there is
         * no better match at the next window position.
         */
        var deflate_slow = function deflate_slow(s, flush) {
            var hash_head;
            /* head of hash chain */
            var bflush;
            /* set if current block must be flushed */
            var max_insert;
            /* Process the input block. */
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the next match, plus MIN_MATCH bytes to insert the
                 * string following the next match.
                 */
                if (s.lookahead < MIN_LOOKAHEAD) {
                    fill_window(s);
                    if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                }
                /* Insert the string window[strstart .. strstart+2] in the
                 * dictionary, and set hash_head to the head of the hash chain:
                 */
                hash_head = 0;
                /* NIL */
                if (s.lookahead >= MIN_MATCH$1) {
                    /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                    s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                    /***/
                }
                /* Find the longest match, discarding those <= prev_length.
                 */
                s.prev_length = s.match_length;
                s.prev_match = s.match_start;
                s.match_length = MIN_MATCH$1 - 1;
                if (hash_head !== 0 &&
                    /* NIL */
                    s.prev_length < s.max_lazy_match &&
                    s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD
                /* MAX_DIST(s) */
                ) {
                    /* To simplify the code, we prevent matches with the string
                     * of window index 0 (in particular we have to avoid a match
                     * of the string with itself at the start of the input file).
                     */
                    s.match_length = longest_match(s, hash_head);
                    /* longest_match() sets match_start */
                    if (s.match_length <= 5 &&
                        (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH$1 && s.strstart - s.match_start > 4096))
                    /* TOO_FAR */
                    ) {
                        /* If prev_match is also MIN_MATCH, match_start is garbage
                         * but we will ignore the current match anyway.
                         */
                        s.match_length = MIN_MATCH$1 - 1;
                    }
                }
                /* If there was a match at the previous step and the current
                 * match is not better, output the previous match:
                 */
                if (s.prev_length >= MIN_MATCH$1 && s.match_length <= s.prev_length) {
                    max_insert = s.strstart + s.lookahead - MIN_MATCH$1;
                    /* Do not insert strings in hash table beyond this. */
                    // check_match(s, s.strstart-1, s.prev_match, s.prev_length);
                    /** *_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                                 s.prev_length - MIN_MATCH, bflush);** */
                    bflush = _tr_tally$1(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH$1);
                    /* Insert in hash table all strings up to the end of the match.
                     * strstart-1 and strstart are already inserted. If there is not
                     * enough lookahead, the last two strings are not inserted in
                     * the hash table.
                     */
                    s.lookahead -= s.prev_length - 1;
                    s.prev_length -= 2;
                    do {
                        if (++s.strstart <= max_insert) {
                            /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                            s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                            /***/
                        }
                    } while (--s.prev_length !== 0);
                    s.match_available = 0;
                    s.match_length = MIN_MATCH$1 - 1;
                    s.strstart++;
                    if (bflush) {
                        /** * FLUSH_BLOCK(s, 0); ** */
                        flush_block_only(s, false);
                        if (s.strm.avail_out === 0) {
                            return BS_NEED_MORE;
                        }
                        /***/
                    }
                }
                else if (s.match_available) {
                    /* If there was no match at the previous position, output a
                     * single literal. If there was a match but the current match
                     * is longer, truncate the previous match to a single literal.
                     */
                    // Tracevv((stderr,"%c", s->window[s->strstart-1]));
                    /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart - 1]);
                    if (bflush) {
                        /** * FLUSH_BLOCK_ONLY(s, 0) ** */
                        flush_block_only(s, false);
                        /***/
                    }
                    s.strstart++;
                    s.lookahead--;
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                }
                else {
                    /* There is no previous match to compare with, wait for
                     * the next step to decide.
                     */
                    s.match_available = 1;
                    s.strstart++;
                    s.lookahead--;
                }
            } // Assert (flush != Z_NO_FLUSH, "no flush?");
            if (s.match_available) {
                // Tracevv((stderr,"%c", s->window[s->strstart-1]));
                /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
                bflush = _tr_tally$1(s, 0, s.window[s.strstart - 1]);
                s.match_available = 0;
            }
            s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * For Z_RLE, simply look for runs of bytes, generate matches only of distance
         * one.  Do not maintain a hash table.  (It will be regenerated if this run of
         * deflate switches away from Z_RLE.)
         */
        var deflate_rle = function deflate_rle(s, flush) {
            var bflush;
            /* set if current block must be flushed */
            var prev;
            /* byte at distance one to match */
            var scan;
            var strend;
            /* scan goes up to strend for length of run */
            var _win = s.window;
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the longest run, plus one for the unrolled loop.
                 */
                if (s.lookahead <= MAX_MATCH$1) {
                    fill_window(s);
                    if (s.lookahead <= MAX_MATCH$1 && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                }
                /* See how many times the previous byte repeats */
                s.match_length = 0;
                if (s.lookahead >= MIN_MATCH$1 && s.strstart > 0) {
                    scan = s.strstart - 1;
                    prev = _win[scan];
                    if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                        strend = s.strstart + MAX_MATCH$1;
                        do {
                            /* jshint noempty:false */
                        } while (prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            scan < strend);
                        s.match_length = MAX_MATCH$1 - (strend - scan);
                        if (s.match_length > s.lookahead) {
                            s.match_length = s.lookahead;
                        }
                    } // Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
                }
                /* Emit match if have run of MIN_MATCH or longer, else emit literal */
                if (s.match_length >= MIN_MATCH$1) {
                    // check_match(s, s.strstart, s.strstart - 1, s.match_length);
                    /** * _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ** */
                    bflush = _tr_tally$1(s, 1, s.match_length - MIN_MATCH$1);
                    s.lookahead -= s.match_length;
                    s.strstart += s.match_length;
                    s.match_length = 0;
                }
                else {
                    /* No match, output a literal byte */
                    // Tracevv((stderr,"%c", s->window[s->strstart]));
                    /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                    s.lookahead--;
                    s.strstart++;
                }
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
         * (It will be regenerated if this run of deflate switches away from Huffman.)
         */
        var deflate_huff = function deflate_huff(s, flush) {
            var bflush;
            /* set if current block must be flushed */
            for (;;) {
                /* Make sure that we have a literal to write. */
                if (s.lookahead === 0) {
                    fill_window(s);
                    if (s.lookahead === 0) {
                        if (flush === Z_NO_FLUSH) {
                            return BS_NEED_MORE;
                        }
                        break;
                        /* flush the current block */
                    }
                }
                /* Output a literal byte */
                s.match_length = 0; // Tracevv((stderr,"%c", s->window[s->strstart]));
                /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                s.lookahead--;
                s.strstart++;
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* Values for max_lazy_match, good_match and max_chain_length, depending on
         * the desired pack level (0..9). The values given below have been tuned to
         * exclude worst case performance for pathological files. Better values may be
         * found for specific files.
         */
        function Config(good_length, max_lazy, nice_length, max_chain, func) {
            this.good_length = good_length;
            this.max_lazy = max_lazy;
            this.nice_length = nice_length;
            this.max_chain = max_chain;
            this.func = func;
        }
        var configuration_table = [
            /*      good lazy nice chain */
            new Config(0, 0, 0, 0, deflate_stored),
            /* 0 store only */
            new Config(4, 4, 8, 4, deflate_fast),
            /* 1 max speed, no lazy matches */
            new Config(4, 5, 16, 8, deflate_fast),
            /* 2 */
            new Config(4, 6, 32, 32, deflate_fast),
            /* 3 */
            new Config(4, 4, 16, 16, deflate_slow),
            /* 4 lazy matches */
            new Config(8, 16, 32, 32, deflate_slow),
            /* 5 */
            new Config(8, 16, 128, 128, deflate_slow),
            /* 6 */
            new Config(8, 32, 128, 256, deflate_slow),
            /* 7 */
            new Config(32, 128, 258, 1024, deflate_slow),
            /* 8 */
            new Config(32, 258, 258, 4096, deflate_slow),
            /* 9 max compression */
        ];
        /* ===========================================================================
         * Initialize the "longest match" routines for a new zlib stream
         */
        var lm_init = function lm_init(s) {
            s.window_size = 2 * s.w_size;
            /** * CLEAR_HASH(s); ** */
            zero$1(s.head); // Fill with NIL (= 0);
            /* Set the default configuration parameters:
             */
            s.max_lazy_match = configuration_table[s.level].max_lazy;
            s.good_match = configuration_table[s.level].good_length;
            s.nice_match = configuration_table[s.level].nice_length;
            s.max_chain_length = configuration_table[s.level].max_chain;
            s.strstart = 0;
            s.block_start = 0;
            s.lookahead = 0;
            s.insert = 0;
            s.match_length = s.prev_length = MIN_MATCH$1 - 1;
            s.match_available = 0;
            s.ins_h = 0;
        };
        function DeflateState() {
            this.strm = null;
            /* pointer back to this zlib stream */
            this.status = 0;
            /* as the name implies */
            this.pending_buf = null;
            /* output still pending */
            this.pending_buf_size = 0;
            /* size of pending_buf */
            this.pending_out = 0;
            /* next pending byte to output to the stream */
            this.pending = 0;
            /* nb of bytes in the pending buffer */
            this.wrap = 0;
            /* bit 0 true for zlib, bit 1 true for gzip */
            this.gzhead = null;
            /* gzip header information to write */
            this.gzindex = 0;
            /* where in extra, name, or comment */
            this.method = Z_DEFLATED;
            /* can only be DEFLATED */
            this.last_flush = -1;
            /* value of flush param for previous deflate call */
            this.w_size = 0;
            /* LZ77 window size (32K by default) */
            this.w_bits = 0;
            /* log2(w_size)  (8..16) */
            this.w_mask = 0;
            /* w_size - 1 */
            this.window = null;
            /* Sliding window. Input bytes are read into the second half of the window,
             * and move to the first half later to keep a dictionary of at least wSize
             * bytes. With this organization, matches are limited to a distance of
             * wSize-MAX_MATCH bytes, but this ensures that IO is always
             * performed with a length multiple of the block size.
             */
            this.window_size = 0;
            /* Actual size of window: 2*wSize, except when the user input buffer
             * is directly used as sliding window.
             */
            this.prev = null;
            /* Link to older string with same hash index. To limit the size of this
             * array to 64K, this link is maintained only for the last 32K strings.
             * An index in this array is thus a window index modulo 32K.
             */
            this.head = null;
            /* Heads of the hash chains or NIL. */
            this.ins_h = 0;
            /* hash index of string to be inserted */
            this.hash_size = 0;
            /* number of elements in hash table */
            this.hash_bits = 0;
            /* log2(hash_size) */
            this.hash_mask = 0;
            /* hash_size-1 */
            this.hash_shift = 0;
            /* Number of bits by which ins_h must be shifted at each input
             * step. It must be such that after MIN_MATCH steps, the oldest
             * byte no longer takes part in the hash key, that is:
             *   hash_shift * MIN_MATCH >= hash_bits
             */
            this.block_start = 0;
            /* Window position at the beginning of the current output block. Gets
             * negative when the window is moved backwards.
             */
            this.match_length = 0;
            /* length of best match */
            this.prev_match = 0;
            /* previous match */
            this.match_available = 0;
            /* set if previous match exists */
            this.strstart = 0;
            /* start of string to insert */
            this.match_start = 0;
            /* start of matching string */
            this.lookahead = 0;
            /* number of valid bytes ahead in window */
            this.prev_length = 0;
            /* Length of the best match at previous step. Matches not greater than this
             * are discarded. This is used in the lazy match evaluation.
             */
            this.max_chain_length = 0;
            /* To speed up deflation, hash chains are never searched beyond this
             * length.  A higher limit improves compression ratio but degrades the
             * speed.
             */
            this.max_lazy_match = 0;
            /* Attempt to find a better match only when the current match is strictly
             * smaller than this value. This mechanism is used only for compression
             * levels >= 4.
             */
            // That's alias to max_lazy_match, don't use directly
            // this.max_insert_length = 0;
            /* Insert new strings in the hash table only if the match length is not
             * greater than this length. This saves time but degrades compression.
             * max_insert_length is used only for compression levels <= 3.
             */
            this.level = 0;
            /* compression level (1..9) */
            this.strategy = 0;
            /* favor or force Huffman coding */
            this.good_match = 0;
            /* Use a faster search when the previous match is longer than this */
            this.nice_match = 0;
            /* Stop searching when current match exceeds this */
            /* used by trees.c: */
            /* Didn't use ct_data typedef below to suppress compiler warning */
            // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
            // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
            // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
            // Use flat array of DOUBLE size, with interleaved fata,
            // because JS does not support effective
            this.dyn_ltree = new Uint16Array(HEAP_SIZE$1 * 2);
            this.dyn_dtree = new Uint16Array((2 * D_CODES$1 + 1) * 2);
            this.bl_tree = new Uint16Array((2 * BL_CODES$1 + 1) * 2);
            zero$1(this.dyn_ltree);
            zero$1(this.dyn_dtree);
            zero$1(this.bl_tree);
            this.l_desc = null;
            /* desc. for literal tree */
            this.d_desc = null;
            /* desc. for distance tree */
            this.bl_desc = null;
            /* desc. for bit length tree */
            // ush bl_count[MAX_BITS+1];
            this.bl_count = new Uint16Array(MAX_BITS$1 + 1);
            /* number of codes at each bit length for an optimal tree */
            // int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
            this.heap = new Uint16Array(2 * L_CODES$1 + 1);
            /* heap used to build the Huffman trees */
            zero$1(this.heap);
            this.heap_len = 0;
            /* number of elements in the heap */
            this.heap_max = 0;
            /* element of largest frequency */
            /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
             * The same heap array is used to build all trees.
             */
            this.depth = new Uint16Array(2 * L_CODES$1 + 1); // uch depth[2*L_CODES+1];
            zero$1(this.depth);
            /* Depth of each subtree used as tie breaker for trees of equal frequency
             */
            this.l_buf = 0;
            /* buffer index for literals or lengths */
            this.lit_bufsize = 0;
            /* Size of match buffer for literals/lengths.  There are 4 reasons for
             * limiting lit_bufsize to 64K:
             *   - frequencies can be kept in 16 bit counters
             *   - if compression is not successful for the first block, all input
             *     data is still in the window so we can still emit a stored block even
             *     when input comes from standard input.  (This can also be done for
             *     all blocks if lit_bufsize is not greater than 32K.)
             *   - if compression is not successful for a file smaller than 64K, we can
             *     even emit a stored file instead of a stored block (saving 5 bytes).
             *     This is applicable only for zip (not gzip or zlib).
             *   - creating new Huffman trees less frequently may not provide fast
             *     adaptation to changes in the input data statistics. (Take for
             *     example a binary file with poorly compressible code followed by
             *     a highly compressible string table.) Smaller buffer sizes give
             *     fast adaptation but have of course the overhead of transmitting
             *     trees more frequently.
             *   - I can't count above 4
             */
            this.last_lit = 0;
            /* running index in l_buf */
            this.d_buf = 0;
            /* Buffer index for distances. To simplify the code, d_buf and l_buf have
             * the same number of elements. To use different lengths, an extra flag
             * array would be necessary.
             */
            this.opt_len = 0;
            /* bit length of current block with optimal trees */
            this.static_len = 0;
            /* bit length of current block with static trees */
            this.matches = 0;
            /* number of string matches in current block */
            this.insert = 0;
            /* bytes at end of window left to insert */
            this.bi_buf = 0;
            /* Output buffer. bits are inserted starting at the bottom (least
             * significant bits).
             */
            this.bi_valid = 0;
            /* Number of valid bits in bi_buf.  All bits above the last valid bit
             * are always zero.
             */
            // Used for window memory init. We safely ignore it for JS. That makes
            // sense only for pointers and memory check tools.
            // this.high_water = 0;
            /* High water mark offset in window for initialized bytes -- bytes above
             * this are set to zero in order to avoid memory check warnings when
             * longest match routines access bytes past the input.  This is then
             * updated to the new high water mark.
             */
        }
        var deflateResetKeep = function deflateResetKeep(strm) {
            if (!strm || !strm.state) {
                return err(strm, Z_STREAM_ERROR);
            }
            strm.total_in = strm.total_out = 0;
            strm.data_type = Z_UNKNOWN$1;
            var s = strm.state;
            s.pending = 0;
            s.pending_out = 0;
            if (s.wrap < 0) {
                s.wrap = -s.wrap;
                /* was made negative by deflate(..., Z_FINISH); */
            }
            s.status = s.wrap ? INIT_STATE : BUSY_STATE;
            strm.adler =
                s.wrap === 2
                    ? 0 // crc32(0, Z_NULL, 0)
                    : 1; // adler32(0, Z_NULL, 0)
            s.last_flush = Z_NO_FLUSH;
            _tr_init$1(s);
            return Z_OK;
        };
        var deflateReset = function deflateReset(strm) {
            var ret = deflateResetKeep(strm);
            if (ret === Z_OK) {
                lm_init(strm.state);
            }
            return ret;
        };
        var deflateSetHeader = function deflateSetHeader(strm, head) {
            if (!strm || !strm.state) {
                return Z_STREAM_ERROR;
            }
            if (strm.state.wrap !== 2) {
                return Z_STREAM_ERROR;
            }
            strm.state.gzhead = head;
            return Z_OK;
        };
        var deflateInit2 = function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
            if (!strm) {
                // === Z_NULL
                return Z_STREAM_ERROR;
            }
            var wrap = 1;
            if (level === Z_DEFAULT_COMPRESSION) {
                level = 6;
            }
            if (windowBits < 0) {
                /* suppress zlib wrapper */
                wrap = 0;
                windowBits = -windowBits;
            }
            else if (windowBits > 15) {
                wrap = 2;
                /* write gzip wrapper instead */
                windowBits -= 16;
            }
            if (memLevel < 1 ||
                memLevel > MAX_MEM_LEVEL ||
                method !== Z_DEFLATED ||
                windowBits < 8 ||
                windowBits > 15 ||
                level < 0 ||
                level > 9 ||
                strategy < 0 ||
                strategy > Z_FIXED$1) {
                return err(strm, Z_STREAM_ERROR);
            }
            if (windowBits === 8) {
                windowBits = 9;
            }
            /* until 256-byte window bug fixed */
            var s = new DeflateState();
            strm.state = s;
            s.strm = strm;
            s.wrap = wrap;
            s.gzhead = null;
            s.w_bits = windowBits;
            s.w_size = 1 << s.w_bits;
            s.w_mask = s.w_size - 1;
            s.hash_bits = memLevel + 7;
            s.hash_size = 1 << s.hash_bits;
            s.hash_mask = s.hash_size - 1;
            s.hash_shift = ~~((s.hash_bits + MIN_MATCH$1 - 1) / MIN_MATCH$1);
            s.window = new Uint8Array(s.w_size * 2);
            s.head = new Uint16Array(s.hash_size);
            s.prev = new Uint16Array(s.w_size); // Don't need mem init magic for JS.
            // s.high_water = 0;  /* nothing written to s->window yet */
            s.lit_bufsize = 1 << (memLevel + 6);
            /* 16K elements by default */
            s.pending_buf_size = s.lit_bufsize * 4;
            // overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
            // s->pending_buf = (uchf *) overlay;
            // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
            s.pending_buf = new Uint8Array(s.pending_buf_size);
            // s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
            s.d_buf = 1 * s.lit_bufsize; // s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
            s.l_buf = (1 + 2) * s.lit_bufsize;
            s.level = level;
            s.strategy = strategy;
            s.method = method;
            return deflateReset(strm);
        };
        var deflateInit = function deflateInit(strm, level) {
            return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
        };
        var deflate = function deflate(strm, flush) {
            var beg;
            var val; // for gzip header write only
            if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) {
                return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
            }
            var s = strm.state;
            if (!strm.output || (!strm.input && strm.avail_in !== 0) || (s.status === FINISH_STATE && flush !== Z_FINISH)) {
                return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
            }
            s.strm = strm;
            /* just in case */
            var old_flush = s.last_flush;
            s.last_flush = flush;
            /* Write the header */
            if (s.status === INIT_STATE) {
                if (s.wrap === 2) {
                    // GZIP header
                    strm.adler = 0; // crc32(0L, Z_NULL, 0);
                    put_byte(s, 31);
                    put_byte(s, 139);
                    put_byte(s, 8);
                    if (!s.gzhead) {
                        // s->gzhead == Z_NULL
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                        put_byte(s, OS_CODE);
                        s.status = BUSY_STATE;
                    }
                    else {
                        put_byte(s, (s.gzhead.text ? 1 : 0) +
                            (s.gzhead.hcrc ? 2 : 0) +
                            (!s.gzhead.extra ? 0 : 4) +
                            (!s.gzhead.name ? 0 : 8) +
                            (!s.gzhead.comment ? 0 : 16));
                        put_byte(s, s.gzhead.time & 0xff);
                        put_byte(s, (s.gzhead.time >> 8) & 0xff);
                        put_byte(s, (s.gzhead.time >> 16) & 0xff);
                        put_byte(s, (s.gzhead.time >> 24) & 0xff);
                        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                        put_byte(s, s.gzhead.os & 0xff);
                        if (s.gzhead.extra && s.gzhead.extra.length) {
                            put_byte(s, s.gzhead.extra.length & 0xff);
                            put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
                        }
                        if (s.gzhead.hcrc) {
                            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending, 0);
                        }
                        s.gzindex = 0;
                        s.status = EXTRA_STATE;
                    }
                } // DEFLATE header
                else {
                    var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
                    var level_flags = -1;
                    if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
                        level_flags = 0;
                    }
                    else if (s.level < 6) {
                        level_flags = 1;
                    }
                    else if (s.level === 6) {
                        level_flags = 2;
                    }
                    else {
                        level_flags = 3;
                    }
                    header |= level_flags << 6;
                    if (s.strstart !== 0) {
                        header |= PRESET_DICT;
                    }
                    header += 31 - (header % 31);
                    s.status = BUSY_STATE;
                    putShortMSB(s, header);
                    /* Save the adler32 of the preset dictionary: */
                    if (s.strstart !== 0) {
                        putShortMSB(s, strm.adler >>> 16);
                        putShortMSB(s, strm.adler & 0xffff);
                    }
                    strm.adler = 1; // adler32(0L, Z_NULL, 0);
                }
            } // #ifdef GZIP
            if (s.status === EXTRA_STATE) {
                if (s.gzhead.extra
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                break;
                            }
                        }
                        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                        s.gzindex++;
                    }
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (s.gzindex === s.gzhead.extra.length) {
                        s.gzindex = 0;
                        s.status = NAME_STATE;
                    }
                }
                else {
                    s.status = NAME_STATE;
                }
            }
            if (s.status === NAME_STATE) {
                if (s.gzhead.name
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    // int val;
                    do {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                val = 1;
                                break;
                            }
                        } // JS specific: little magic to add zero terminator to end of string
                        if (s.gzindex < s.gzhead.name.length) {
                            val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                        }
                        else {
                            val = 0;
                        }
                        put_byte(s, val);
                    } while (val !== 0);
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (val === 0) {
                        s.gzindex = 0;
                        s.status = COMMENT_STATE;
                    }
                }
                else {
                    s.status = COMMENT_STATE;
                }
            }
            if (s.status === COMMENT_STATE) {
                if (s.gzhead.comment
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    // int val;
                    do {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                val = 1;
                                break;
                            }
                        } // JS specific: little magic to add zero terminator to end of string
                        if (s.gzindex < s.gzhead.comment.length) {
                            val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                        }
                        else {
                            val = 0;
                        }
                        put_byte(s, val);
                    } while (val !== 0);
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (val === 0) {
                        s.status = HCRC_STATE;
                    }
                }
                else {
                    s.status = HCRC_STATE;
                }
            }
            if (s.status === HCRC_STATE) {
                if (s.gzhead.hcrc) {
                    if (s.pending + 2 > s.pending_buf_size) {
                        flush_pending(strm);
                    }
                    if (s.pending + 2 <= s.pending_buf_size) {
                        put_byte(s, strm.adler & 0xff);
                        put_byte(s, (strm.adler >> 8) & 0xff);
                        strm.adler = 0; // crc32(0L, Z_NULL, 0);
                        s.status = BUSY_STATE;
                    }
                }
                else {
                    s.status = BUSY_STATE;
                }
            } // #endif
            /* Flush as much pending output as possible */
            if (s.pending !== 0) {
                flush_pending(strm);
                if (strm.avail_out === 0) {
                    /* Since avail_out is 0, deflate will be called again with
                     * more output space, but possibly with both pending and
                     * avail_in equal to zero. There won't be anything to do,
                     * but this is not an error situation so make sure we
                     * return OK instead of BUF_ERROR at next call of deflate:
                     */
                    s.last_flush = -1;
                    return Z_OK;
                }
                /* Make sure there is something to do and avoid duplicate consecutive
                 * flushes. For repeated and useless calls with Z_FINISH, we keep
                 * returning Z_STREAM_END instead of Z_BUF_ERROR.
                 */
            }
            else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) {
                return err(strm, Z_BUF_ERROR);
            }
            /* User must not provide more input after the first FINISH: */
            if (s.status === FINISH_STATE && strm.avail_in !== 0) {
                return err(strm, Z_BUF_ERROR);
            }
            /* Start a new block or continue the current one.
             */
            if (strm.avail_in !== 0 || s.lookahead !== 0 || (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
                var bstate = s.strategy === Z_HUFFMAN_ONLY
                    ? deflate_huff(s, flush)
                    : s.strategy === Z_RLE
                        ? deflate_rle(s, flush)
                        : configuration_table[s.level].func(s, flush);
                if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
                    s.status = FINISH_STATE;
                }
                if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
                    if (strm.avail_out === 0) {
                        s.last_flush = -1;
                        /* avoid BUF_ERROR next call, see above */
                    }
                    return Z_OK;
                    /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
                     * of deflate should use the same flush parameter to make sure
                     * that the flush is complete. So we don't have to output an
                     * empty block here, this will be done at next call. This also
                     * ensures that for a very small output buffer, we emit at most
                     * one empty block.
                     */
                }
                if (bstate === BS_BLOCK_DONE) {
                    if (flush === Z_PARTIAL_FLUSH) {
                        _tr_align$1(s);
                    }
                    else if (flush !== Z_BLOCK) {
                        /* FULL_FLUSH or SYNC_FLUSH */
                        _tr_stored_block$1(s, 0, 0, false);
                        /* For a full flush, this empty block will be recognized
                         * as a special marker by inflate_sync().
                         */
                        if (flush === Z_FULL_FLUSH) {
                            /** * CLEAR_HASH(s); ** */
                            /* forget history */
                            zero$1(s.head); // Fill with NIL (= 0);
                            if (s.lookahead === 0) {
                                s.strstart = 0;
                                s.block_start = 0;
                                s.insert = 0;
                            }
                        }
                    }
                    flush_pending(strm);
                    if (strm.avail_out === 0) {
                        s.last_flush = -1;
                        /* avoid BUF_ERROR at next call, see above */
                        return Z_OK;
                    }
                }
            } // Assert(strm->avail_out > 0, "bug2");
            // if (strm.avail_out <= 0) { throw new Error("bug2");}
            if (flush !== Z_FINISH) {
                return Z_OK;
            }
            if (s.wrap <= 0) {
                return Z_STREAM_END;
            }
            /* Write the trailer */
            if (s.wrap === 2) {
                put_byte(s, strm.adler & 0xff);
                put_byte(s, (strm.adler >> 8) & 0xff);
                put_byte(s, (strm.adler >> 16) & 0xff);
                put_byte(s, (strm.adler >> 24) & 0xff);
                put_byte(s, strm.total_in & 0xff);
                put_byte(s, (strm.total_in >> 8) & 0xff);
                put_byte(s, (strm.total_in >> 16) & 0xff);
                put_byte(s, (strm.total_in >> 24) & 0xff);
            }
            else {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
            }
            flush_pending(strm);
            /* If avail_out is zero, the application will call deflate again
             * to flush the rest.
             */
            if (s.wrap > 0) {
                s.wrap = -s.wrap;
            }
            /* write the trailer only once! */
            return s.pending !== 0 ? Z_OK : Z_STREAM_END;
        };
        var deflateEnd = function deflateEnd(strm) {
            if (!strm ||
                /* == Z_NULL */
                !strm.state
            /* == Z_NULL */
            ) {
                return Z_STREAM_ERROR;
            }
            var status = strm.state.status;
            if (status !== INIT_STATE &&
                status !== EXTRA_STATE &&
                status !== NAME_STATE &&
                status !== COMMENT_STATE &&
                status !== HCRC_STATE &&
                status !== BUSY_STATE &&
                status !== FINISH_STATE) {
                return err(strm, Z_STREAM_ERROR);
            }
            strm.state = null;
            return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
        };
        /* =========================================================================
         * Initializes the compression dictionary from the given byte
         * sequence without producing any compressed output.
         */
        var deflateSetDictionary = function deflateSetDictionary(strm, dictionary) {
            var dictLength = dictionary.length;
            if (!strm ||
                /* == Z_NULL */
                !strm.state
            /* == Z_NULL */
            ) {
                return Z_STREAM_ERROR;
            }
            var s = strm.state;
            var wrap = s.wrap;
            if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
                return Z_STREAM_ERROR;
            }
            /* when using zlib wrappers, compute Adler-32 for provided dictionary */
            if (wrap === 1) {
                /* adler32(strm->adler, dictionary, dictLength); */
                strm.adler = adler32_1(strm.adler, dictionary, dictLength, 0);
            }
            s.wrap = 0;
            /* avoid computing Adler-32 in read_buf */
            /* if dictionary would fill window, just replace the history */
            if (dictLength >= s.w_size) {
                if (wrap === 0) {
                    /* already empty otherwise */
                    /** * CLEAR_HASH(s); ** */
                    zero$1(s.head); // Fill with NIL (= 0);
                    s.strstart = 0;
                    s.block_start = 0;
                    s.insert = 0;
                }
                /* use the tail */
                // dictionary = dictionary.slice(dictLength - s.w_size);
                var tmpDict = new Uint8Array(s.w_size);
                tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
                dictionary = tmpDict;
                dictLength = s.w_size;
            }
            /* insert dictionary into window and hash */
            var avail = strm.avail_in;
            var next = strm.next_in;
            var input = strm.input;
            strm.avail_in = dictLength;
            strm.next_in = 0;
            strm.input = dictionary;
            fill_window(s);
            while (s.lookahead >= MIN_MATCH$1) {
                var str = s.strstart;
                var n = s.lookahead - (MIN_MATCH$1 - 1);
                do {
                    /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                    s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH$1 - 1]);
                    s.prev[str & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = str;
                    str++;
                } while (--n);
                s.strstart = str;
                s.lookahead = MIN_MATCH$1 - 1;
                fill_window(s);
            }
            s.strstart += s.lookahead;
            s.block_start = s.strstart;
            s.insert = s.lookahead;
            s.lookahead = 0;
            s.match_length = s.prev_length = MIN_MATCH$1 - 1;
            s.match_available = 0;
            strm.next_in = next;
            strm.input = input;
            strm.avail_in = avail;
            s.wrap = wrap;
            return Z_OK;
        };
        var deflateInit_1 = deflateInit;
        var deflateInit2_1 = deflateInit2;
        var deflateReset_1 = deflateReset;
        var deflateResetKeep_1 = deflateResetKeep;
        var deflateSetHeader_1 = deflateSetHeader;
        var deflate_2 = deflate;
        var deflateEnd_1 = deflateEnd;
        var deflateSetDictionary_1 = deflateSetDictionary;
        var deflateInfo = 'pako deflate (from Nodeca project)';
        /* Not implemented
      module.exports.deflateBound = deflateBound;
      module.exports.deflateCopy = deflateCopy;
      module.exports.deflateParams = deflateParams;
      module.exports.deflatePending = deflatePending;
      module.exports.deflatePrime = deflatePrime;
      module.exports.deflateTune = deflateTune;
      */
        var deflate_1 = {
            deflateInit: deflateInit_1,
            deflateInit2: deflateInit2_1,
            deflateReset: deflateReset_1,
            deflateResetKeep: deflateResetKeep_1,
            deflateSetHeader: deflateSetHeader_1,
            deflate: deflate_2,
            deflateEnd: deflateEnd_1,
            deflateSetDictionary: deflateSetDictionary_1,
            deflateInfo: deflateInfo,
        };
        // Join array of chunks to single array.
        function flattenChunks(chunks) {
            // calculate data length
            var len = 0;
            for (var i = 0, l = chunks.length; i < l; i++) {
                len += chunks[i].length;
            } // join chunks
            var result = new Uint8Array(len);
            for (var _i = 0, pos = 0, _l = chunks.length; _i < _l; _i++) {
                var chunk = chunks[_i];
                result.set(chunk, pos);
                pos += chunk.length;
            }
            return result;
        }
        // String encode/decode helpers
        //
        // - apply(Array) can fail on Android 2.2
        // - apply(Uint8Array) can fail on iOS 5.1 Safari
        //
        // Table with utf8 lengths (calculated by first byte of sequence)
        // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
        // because max possible codepoint is 0x10ffff
        var _utf8len = new Uint8Array(256);
        for (var q = 0; q < 256; q++) {
            _utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
        }
        _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
        // convert string to array (typed, when possible)
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        function ZStream() {
            /* next input byte */
            this.input = null; // JS specific, because we have no pointers
            this.next_in = 0;
            /* number of bytes available at input */
            this.avail_in = 0;
            /* total number of input bytes read so far */
            this.total_in = 0;
            /* next output byte should be put there */
            this.output = null; // JS specific, because we have no pointers
            this.next_out = 0;
            /* remaining free space at output */
            this.avail_out = 0;
            /* total number of bytes output so far */
            this.total_out = 0;
            /* last error message, NULL if no error */
            this.msg = '';
            /* Z_NULL */
            /* not visible by applications */
            this.state = null;
            /* best guess about the data type: binary or text */
            this.data_type = 2;
            /* Z_UNKNOWN */
            /* adler32 value of the uncompressed data */
            this.adler = 0;
        }
        var zstream = ZStream;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var toString = Object.prototype.toString;
        /* Public constants ========================================================== */
        /* =========================================================================== */
        var Z_NO_FLUSH$1 = constants.Z_NO_FLUSH;
        var Z_SYNC_FLUSH = constants.Z_SYNC_FLUSH;
        var Z_FULL_FLUSH$1 = constants.Z_FULL_FLUSH;
        var Z_FINISH$1 = constants.Z_FINISH;
        var Z_OK$1 = constants.Z_OK;
        var Z_STREAM_END$1 = constants.Z_STREAM_END;
        var Z_DEFAULT_COMPRESSION$1 = constants.Z_DEFAULT_COMPRESSION;
        var Z_DEFAULT_STRATEGY$1 = constants.Z_DEFAULT_STRATEGY;
        var Z_DEFLATED$1 = constants.Z_DEFLATED;
        /* =========================================================================== */
        /**
         * class Deflate
         *
         * Generic JS-style wrapper for zlib calls. If you don't need
         * streaming behaviour - use more simple functions: [[deflate]],
         * [[deflateRaw]] and [[gzip]].
         * */
        /* internal
         * Deflate.chunks -> Array
         *
         * Chunks of output data, if [[Deflate#onData]] not overridden.
         * */
        /**
         * Deflate.result -> Uint8Array
         *
         * Compressed result, generated by default [[Deflate#onData]]
         * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
         * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
         * */
        /**
         * Deflate.err -> Number
         *
         * Error code after deflate finished. 0 (Z_OK) on success.
         * You will not need it in real life, because deflate errors
         * are possible only on wrong options or bad `onData` / `onEnd`
         * custom handlers.
         * */
        /**
         * Deflate.msg -> String
         *
         * Error message, if [[Deflate.err]] != 0
         * */
        /**
         * new Deflate(options)
         * - options (Object): zlib deflate options.
         *
         * Creates new deflator instance with specified params. Throws exception
         * on bad params. Supported options:
         *
         * - `level`
         * - `windowBits`
         * - `memLevel`
         * - `strategy`
         * - `dictionary`
         *
         * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
         * for more information on these.
         *
         * Additional options, for internal needs:
         *
         * * `chunkSize` - size of generated data chunks (16K by default)
         * * `raw` (Boolean) - do raw deflate
         * * `gzip` (Boolean) - create gzip wrapper
         * * `header` (Object) - custom header for gzip
         * ** `text` (Boolean) - true if compressed data believed to be text
         * ** `time` (Number) - modification time, unix timestamp
         * ** `os` (Number) - operation system code
         * ** `extra` (Array) - array of bytes with extra data (max 65536)
         * ** `name` (String) - file name (binary string)
         * ** `comment` (String) - comment (binary string)
         * ** `hcrc` (Boolean) - true if header crc should be added
         *
         * ##### Example:
         *
         * ```javascript
         * const pako = require('pako')
         *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
         *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
         *
         * const deflate = new pako.Deflate({ level: 3});
         *
         * deflate.push(chunk1, false);
         * deflate.push(chunk2, true);  // true -> last chunk
         *
         * if (deflate.err) { throw new Error(deflate.err); }
         *
         * console.log(deflate.result);
         * ```
         * */
        function Deflate() {
            this.options = {
                level: Z_DEFAULT_COMPRESSION$1,
                method: Z_DEFLATED$1,
                chunkSize: 16384,
                windowBits: 15,
                memLevel: 8,
                strategy: Z_DEFAULT_STRATEGY$1,
            };
            var opt = this.options;
            if (opt.raw && opt.windowBits > 0) {
                opt.windowBits = -opt.windowBits;
            }
            else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) {
                opt.windowBits += 16;
            }
            this.err = 0; // error code, if happens (0 = Z_OK)
            this.msg = ''; // error message
            this.ended = false; // used to avoid multiple onEnd() calls
            this.chunks = []; // chunks of compressed data
            this.strm = new zstream();
            this.strm.avail_out = 0;
            var status = deflate_1.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
            if (status !== Z_OK$1) {
                throw new Error(messages[status]);
            }
            if (opt.header) {
                deflate_1.deflateSetHeader(this.strm, opt.header);
            }
            if (opt.dictionary) {
                var dict; // Convert data if needed
                if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
                    dict = new Uint8Array(opt.dictionary);
                }
                else {
                    dict = opt.dictionary;
                }
                status = deflate_1.deflateSetDictionary(this.strm, dict);
                if (status !== Z_OK$1) {
                    throw new Error(messages[status]);
                }
                this._dict_set = true;
            }
        }
        /**
         * Deflate#push(data[, flush_mode]) -> Boolean
         * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
         * converted to utf8 byte sequence.
         * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
         * See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
         *
         * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
         * new compressed chunks. Returns `true` on success. The last data block must
         * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
         * buffers and call [[Deflate#onEnd]].
         *
         * On fail call [[Deflate#onEnd]] with error code and return false.
         *
         * ##### Example
         *
         * ```javascript
         * push(chunk, false); // push one of data chunks
         * ...
         * push(chunk, true);  // push last chunk
         * ```
         * */
        Deflate.prototype.push = function (data, flush_mode) {
            var strm = this.strm;
            var chunkSize = this.options.chunkSize;
            var status;
            var _flush_mode;
            if (this.ended) {
                return false;
            }
            if (flush_mode === ~~flush_mode) {
                _flush_mode = flush_mode;
            }
            else {
                _flush_mode = flush_mode === true ? Z_FINISH$1 : Z_NO_FLUSH$1;
            } // Convert data if needed
            if (toString.call(data) === '[object ArrayBuffer]') {
                strm.input = new Uint8Array(data);
            }
            else {
                strm.input = data;
            }
            strm.next_in = 0;
            strm.avail_in = strm.input.length;
            for (;;) {
                if (strm.avail_out === 0) {
                    strm.output = new Uint8Array(chunkSize);
                    strm.next_out = 0;
                    strm.avail_out = chunkSize;
                } // Make sure avail_out > 6 to avoid repeating markers
                if ((_flush_mode === Z_SYNC_FLUSH || _flush_mode === Z_FULL_FLUSH$1) && strm.avail_out <= 6) {
                    this.onData(strm.output.subarray(0, strm.next_out));
                    strm.avail_out = 0;
                    continue;
                }
                status = deflate_1.deflate(strm, _flush_mode); // Ended => flush and finish
                if (status === Z_STREAM_END$1) {
                    if (strm.next_out > 0) {
                        this.onData(strm.output.subarray(0, strm.next_out));
                    }
                    status = deflate_1.deflateEnd(this.strm);
                    this.onEnd(status);
                    this.ended = true;
                    return status === Z_OK$1;
                } // Flush if out buffer full
                if (strm.avail_out === 0) {
                    this.onData(strm.output);
                    continue;
                } // Flush if requested and has data
                if (_flush_mode > 0 && strm.next_out > 0) {
                    this.onData(strm.output.subarray(0, strm.next_out));
                    strm.avail_out = 0;
                    continue;
                }
                if (strm.avail_in === 0) {
                    break;
                }
            }
            return true;
        };
        /**
         * Deflate#onData(chunk) -> Void
         * - chunk (Uint8Array): output data.
         *
         * By default, stores data blocks in `chunks[]` property and glue
         * those in `onEnd`. Override this handler, if you need another behaviour.
         * */
        Deflate.prototype.onData = function (chunk) {
            this.chunks.push(chunk);
        };
        /**
         * Deflate#onEnd(status) -> Void
         * - status (Number): deflate status. 0 (Z_OK) on success,
         * other if not.
         *
         * Called once after you tell deflate that the input stream is
         * complete (Z_FINISH). By default - join collected chunks,
         * free memory and fill `results` / `err` properties.
         * */
        Deflate.prototype.onEnd = function (status) {
            // On success - join
            if (status === Z_OK$1) {
                this.result = flattenChunks(this.chunks);
            }
            this.chunks = [];
            this.err = status;
            this.msg = this.strm.msg;
        };
        // https://github.com/nodeca/pako/blob/26dff4fb3472c5532b3bd8856421146d35ab7592/lib/utils/strings.js#L26
        function string2buf(str) {
            if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) {
                return new TextEncoder().encode(str);
            }
            var buf;
            var c;
            var c2;
            var m_pos;
            var i;
            var str_len = str.length;
            var buf_len = 0;
            // count binary size
            for (m_pos = 0; m_pos < str_len; m_pos++) {
                c = str.charCodeAt(m_pos);
                if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                    c2 = str.charCodeAt(m_pos + 1);
                    if ((c2 & 0xfc00) === 0xdc00) {
                        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                        m_pos++;
                    }
                }
                buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
            }
            // allocate buffer
            buf = new Uint8Array(buf_len);
            // convert
            for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
                c = str.charCodeAt(m_pos);
                if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                    c2 = str.charCodeAt(m_pos + 1);
                    if ((c2 & 0xfc00) === 0xdc00) {
                        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                        m_pos++;
                    }
                }
                if (c < 0x80) {
                    /* one byte */
                    buf[i++] = c;
                }
                else if (c < 0x800) {
                    /* two bytes */
                    buf[i++] = 0xc0 | (c >>> 6);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
                else if (c < 0x10000) {
                    /* three bytes */
                    buf[i++] = 0xe0 | (c >>> 12);
                    buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
                else {
                    /* four bytes */
                    buf[i++] = 0xf0 | (c >>> 18);
                    buf[i++] = 0x80 | ((c >>> 12) & 0x3f);
                    buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
            }
            return buf;
        }
        return { Deflate: Deflate, constants: constants, string2buf: string2buf };
    }
}
//# sourceMappingURL=deflateWorker.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/startDeflateWorker.js


var state = { status: 0 /* Nil */ };
function startDeflateWorker(callback, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    switch (state.status) {
        case 0 /* Nil */:
            state = { status: 1 /* Loading */, callbacks: [callback] };
            doStartDeflateWorker(createDeflateWorkerImpl);
            break;
        case 1 /* Loading */:
            state.callbacks.push(callback);
            break;
        case 2 /* Error */:
            callback();
            break;
        case 3 /* Initialized */:
            callback(state.worker);
            break;
    }
}
function resetDeflateWorkerState() {
    state = { status: 0 /* Nil */ };
}
/**
 * Starts the deflate worker and handle messages and errors
 *
 * The spec allow browsers to handle worker errors differently:
 * - Chromium throws an exception
 * - Firefox fires an error event
 *
 * more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
 */
function doStartDeflateWorker(createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    try {
        var worker_1 = createDeflateWorkerImpl();
        worker_1.addEventListener('error', monitor(onError));
        worker_1.addEventListener('message', monitor(function (_a) {
            var data = _a.data;
            if (data.type === 'errored') {
                onError(data.error);
            }
            else if (data.type === 'initialized') {
                onInitialized(worker_1);
            }
        }));
        worker_1.postMessage({ action: 'init' });
        return worker_1;
    }
    catch (error) {
        onError(error);
    }
}
function onInitialized(worker) {
    if (state.status === 1 /* Loading */) {
        state.callbacks.forEach(function (callback) { return callback(worker); });
        state = { status: 3 /* Initialized */, worker: worker };
    }
}
function onError(error) {
    if (state.status === 1 /* Loading */) {
        display.error('Session Replay recording failed to start: an error occurred while creating the Worker:', error);
        if (error instanceof Event || (error instanceof Error && includes(error.message, 'Content Security Policy'))) {
            display.error('Please make sure CSP is correctly configured ' +
                'https://docs.datadoghq.com/real_user_monitoring/faq/content_security_policy');
        }
        else {
            addTelemetryError(error);
        }
        state.callbacks.forEach(function (callback) { return callback(); });
        state = { status: 2 /* Error */ };
    }
    else {
        addTelemetryError(error);
    }
}
//# sourceMappingURL=startDeflateWorker.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/transport/send.js


function send(endpointBuilder, data, metadata, rawSegmentBytesCount, reason) {
    var formData = new FormData();
    formData.append('segment', new Blob([data], {
        type: 'application/octet-stream',
    }), "".concat(metadata.session.id, "-").concat(metadata.start));
    toFormEntries(metadata, function (key, value) { return formData.append(key, value); });
    formData.append('raw_segment_size', rawSegmentBytesCount.toString());
    var request = new HttpRequest(endpointBuilder, SEGMENT_BYTES_LIMIT);
    request.send(formData, data.byteLength, reason);
}
function toFormEntries(input, onEntry, prefix) {
    if (prefix === void 0) { prefix = ''; }
    objectEntries(input).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (typeof value === 'object' && value !== null) {
            toFormEntries(value, onEntry, "".concat(prefix).concat(key, "."));
        }
        else {
            onEntry("".concat(prefix).concat(key), String(value));
        }
    });
}
//# sourceMappingURL=send.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/startRecording.js





function startRecording(lifeCycle, configuration, sessionManager, viewContexts, worker) {
    if (isExperimentalFeatureEnabled('lower-batch-size')) {
        setSegmentBytesLimit(22 * ONE_KILO_BYTE);
    }
    var _a = startSegmentCollection(lifeCycle, configuration.applicationId, sessionManager, viewContexts, function (data, metadata, rawSegmentBytesCount) {
        return send(configuration.sessionReplayEndpointBuilder, data, metadata, rawSegmentBytesCount);
    }, worker), addRecord = _a.addRecord, stopSegmentCollection = _a.stop;
    var _b = record({
        emit: addRecord,
        defaultPrivacyLevel: configuration.defaultPrivacyLevel,
    }), stopRecording = _b.stop, takeFullSnapshot = _b.takeFullSnapshot, flushMutations = _b.flushMutations;
    var unsubscribeViewEnded = lifeCycle.subscribe(4 /* VIEW_ENDED */, function () {
        flushMutations();
        addRecord({
            timestamp: timeStampNow(),
            type: RecordType.ViewEnd,
        });
    }).unsubscribe;
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* VIEW_CREATED */, function (view) {
        takeFullSnapshot(view.startClocks.timeStamp);
    }).unsubscribe;
    return {
        stop: function () {
            unsubscribeViewEnded();
            unsubscribeViewCreated();
            stopRecording();
            stopSegmentCollection();
        },
    };
}
//# sourceMappingURL=startRecording.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/recorderApi.js



function makeRecorderApi(startRecordingImpl, startDeflateWorkerImpl) {
    if (startDeflateWorkerImpl === void 0) { startDeflateWorkerImpl = startDeflateWorker; }
    if (canUseEventBridge()) {
        return {
            start: noop,
            stop: noop,
            getReplayStats: function () { return undefined; },
            onRumStart: noop,
            isRecording: function () { return false; },
        };
    }
    var state = {
        status: 0 /* Stopped */,
    };
    var startStrategy = function () {
        state = { status: 1 /* IntentToStart */ };
    };
    var stopStrategy = function () {
        state = { status: 0 /* Stopped */ };
    };
    return {
        start: function () { return startStrategy(); },
        stop: function () { return stopStrategy(); },
        getReplayStats: getReplayStats,
        onRumStart: function (lifeCycle, configuration, sessionManager, viewContexts) {
            lifeCycle.subscribe(7 /* SESSION_EXPIRED */, function () {
                if (state.status === 2 /* Starting */ || state.status === 3 /* Started */) {
                    stopStrategy();
                    state = { status: 1 /* IntentToStart */ };
                }
            });
            lifeCycle.subscribe(8 /* SESSION_RENEWED */, function () {
                if (state.status === 1 /* IntentToStart */) {
                    startStrategy();
                }
            });
            startStrategy = function () {
                var session = sessionManager.findTrackedSession();
                if (!session || !session.hasPremiumPlan) {
                    state = { status: 1 /* IntentToStart */ };
                    return;
                }
                if (state.status === 2 /* Starting */ || state.status === 3 /* Started */) {
                    return;
                }
                state = { status: 2 /* Starting */ };
                runOnReadyState('interactive', function () {
                    if (state.status !== 2 /* Starting */) {
                        return;
                    }
                    startDeflateWorkerImpl(function (worker) {
                        if (state.status !== 2 /* Starting */) {
                            return;
                        }
                        if (!worker) {
                            state = {
                                status: 0 /* Stopped */,
                            };
                            return;
                        }
                        var stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, viewContexts, worker).stop;
                        state = {
                            status: 3 /* Started */,
                            stopRecording: stopRecording,
                        };
                    });
                });
            };
            stopStrategy = function () {
                if (state.status === 0 /* Stopped */) {
                    return;
                }
                if (state.status === 3 /* Started */) {
                    state.stopRecording();
                }
                state = {
                    status: 0 /* Stopped */,
                };
            };
            if (state.status === 1 /* IntentToStart */) {
                startStrategy();
            }
        },
        isRecording: function () { return state.status === 3 /* Started */; },
    };
}
//# sourceMappingURL=recorderApi.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/entries/main.js
// Keep the following in sync with packages/rum-slim/src/entries/main.ts





var recorderApi = makeRecorderApi(startRecording);
var datadogRum = makeRumPublicApi(startRum, recorderApi);
defineGlobal(getGlobalObject(), 'DD_RUM', datadogRum);
//# sourceMappingURL=main.js.map

/***/ }),

/***/ 6489:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.Q = parse;
exports.q = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(9864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 3454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) === null || ref === void 0 ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) === null || ref1 === void 0 ? void 0 : ref1.env) === 'object' ? __webpack_require__.g.process : __webpack_require__(7663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 2136:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(8751);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7379);
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2317);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1407);
/* harmony import */ var context_state_reducer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2807);
/* harmony import */ var context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1387);
/* harmony import */ var _Icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8736);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6754);









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  z-index: 10;\n  display: flex;\n  width: 100%;\n  height: 80px;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  margin: 0;\n  background: ",
        ";\n  .logo {\n    display: block;\n    svg {\n      fill: ",
        ";\n      width: 100%;\n      max-width: 80px;\n      max-height: 80px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var BrandLogo = _defineProperty({}, constants_index__WEBPACK_IMPORTED_MODULE_3__/* .Brand.SPORTS */ .H2.SPORTS, _Icons__WEBPACK_IMPORTED_MODULE_6__/* .FoxSportsLogo */ .GB);
var Logo = BrandLogo[constants_index__WEBPACK_IMPORTED_MODULE_3__/* .Brand.SPORTS */ .H2.SPORTS];
var Header = function() {
    var dispatch = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_5__/* .AppContext */ .I).dispatch;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledHeader, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            className: "logo",
            href: constants_index__WEBPACK_IMPORTED_MODULE_3__/* .ROUTE_HOME */ .XX,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Logo, {
                onClick: function() {
                    return dispatch((0,context_state_reducer__WEBPACK_IMPORTED_MODULE_4__/* .setLoading */ .K4)(false));
                }
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Header);
var StyledHeader = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].header.withConfig */ .ZP.header.withConfig({
    componentId: "sc-cfc6a187-0"
})(_templateObject(), styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].header */ .Z.header, styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].white */ .Z.white);


/***/ }),

/***/ 2950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


var CheckMark = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
            width: "24",
            height: "24",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm5.336 6.99L10.39 14.18l-3.002-2.898L6 12.72l3.001 2.899-.001.001 1.439 1.39 8.336-8.632-1.44-1.39Z",
                fill: "#FFF",
                fillRule: "evenodd"
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CheckMark);


/***/ }),

/***/ 8736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yg": function() { return /* reexport */ Icons_AppStoreBadge; },
  "I8": function() { return /* reexport */ Icons_Edit; },
  "GB": function() { return /* reexport */ Icons_FoxSportsLogo; },
  "Gz": function() { return /* reexport */ Icons_GoogleBadge; },
  "W1": function() { return /* reexport */ Icons_SearchIcon; }
});

// UNUSED EXPORTS: Apple, CheckMark, Facebook

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/common/Icons/AppStoreBadge.tsx


var AppStoreBadge = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 135 40",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#A6A6A6",
                    d: "M130.197,40H4.729C2.122,40,0,37.872,0,35.267V4.726C0,2.12,2.122,0,4.729,0h125.468 C132.803,0,135,2.12,135,4.726v30.541C135,37.872,132.803,40,130.197,40L130.197,40z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M134.032,35.268c0,2.116-1.714,3.83-3.834,3.83H4.729c-2.119,0-3.839-1.714-3.839-3.83V4.725 c0-2.115,1.72-3.835,3.839-3.835h125.468c2.121,0,3.834,1.72,3.834,3.835L134.032,35.268L134.032,35.268z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#FFFFFF",
                                d: "M30.128,19.784c-0.029-3.223,2.639-4.791,2.761-4.864c-1.511-2.203-3.853-2.504-4.676-2.528 c-1.967-0.207-3.875,1.177-4.877,1.177c-1.022,0-2.565-1.157-4.228-1.123c-2.14,0.033-4.142,1.272-5.24,3.196 c-2.266,3.923-0.576,9.688,1.595,12.859c1.086,1.553,2.355,3.287,4.016,3.226c1.625-0.067,2.232-1.036,4.193-1.036 c1.943,0,2.513,1.036,4.207,0.997c1.744-0.028,2.842-1.56,3.89-3.127c1.255-1.78,1.759-3.533,1.779-3.623 C33.507,24.924,30.161,23.647,30.128,19.784z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#FFFFFF",
                                d: "M26.928,10.306c0.874-1.093,1.472-2.58,1.306-4.089c-1.265,0.056-2.847,0.875-3.758,1.944 c-0.806,0.942-1.526,2.486-1.34,3.938C24.557,12.205,26.016,11.382,26.928,10.306z"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FFFFFF",
                            d: "M53.645,31.504h-2.271l-1.244-3.909h-4.324l-1.185,3.909h-2.211l4.284-13.308h2.646L53.645,31.504z M49.755,25.955L48.63,22.48c-0.119-0.355-0.342-1.191-0.671-2.507h-0.04c-0.131,0.566-0.342,1.402-0.632,2.507l-1.105,3.475 H49.755z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FFFFFF",
                            d: "M64.662,26.588c0,1.632-0.441,2.922-1.323,3.869c-0.79,0.843-1.771,1.264-2.942,1.264 c-1.264,0-2.172-0.454-2.725-1.362h-0.04v5.055h-2.132V25.067c0-1.026-0.027-2.079-0.079-3.159h1.875l0.119,1.521h0.04 c0.711-1.146,1.79-1.718,3.238-1.718c1.132,0,2.077,0.447,2.833,1.342C64.284,23.949,64.662,25.127,64.662,26.588z M62.49,26.666 c0-0.934-0.21-1.704-0.632-2.31c-0.461-0.632-1.08-0.948-1.856-0.948c-0.526,0-1.004,0.176-1.431,0.523 c-0.428,0.35-0.708,0.807-0.839,1.373c-0.066,0.264-0.099,0.48-0.099,0.65v1.6c0,0.698,0.214,1.287,0.642,1.768 s0.984,0.721,1.668,0.721c0.803,0,1.428-0.31,1.875-0.928C62.266,28.496,62.49,27.68,62.49,26.666z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FFFFFF",
                            d: "M75.699,26.588c0,1.632-0.441,2.922-1.324,3.869c-0.789,0.843-1.77,1.264-2.941,1.264 c-1.264,0-2.172-0.454-2.724-1.362H68.67v5.055h-2.132V25.067c0-1.026-0.027-2.079-0.079-3.159h1.875l0.119,1.521h0.04 c0.71-1.146,1.789-1.718,3.238-1.718c1.131,0,2.076,0.447,2.834,1.342C75.32,23.949,75.699,25.127,75.699,26.588z M73.527,26.666 c0-0.934-0.211-1.704-0.633-2.31c-0.461-0.632-1.078-0.948-1.855-0.948c-0.527,0-1.004,0.176-1.432,0.523 c-0.428,0.35-0.707,0.807-0.838,1.373c-0.065,0.264-0.099,0.48-0.099,0.65v1.6c0,0.698,0.214,1.287,0.64,1.768 c0.428,0.48,0.984,0.721,1.67,0.721c0.803,0,1.428-0.31,1.875-0.928C73.303,28.496,73.527,27.68,73.527,26.666z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FFFFFF",
                            d: "M88.039,27.772c0,1.132-0.393,2.053-1.182,2.764c-0.867,0.777-2.074,1.165-3.625,1.165 c-1.432,0-2.58-0.276-3.449-0.829l0.494-1.777c0.936,0.566,1.963,0.85,3.082,0.85c0.803,0,1.428-0.182,1.877-0.544 c0.447-0.362,0.67-0.848,0.67-1.454c0-0.54-0.184-0.995-0.553-1.364c-0.367-0.369-0.98-0.712-1.836-1.029 c-2.33-0.869-3.494-2.142-3.494-3.816c0-1.094,0.408-1.991,1.225-2.689c0.814-0.699,1.9-1.048,3.258-1.048 c1.211,0,2.217,0.211,3.02,0.632l-0.533,1.738c-0.75-0.408-1.598-0.612-2.547-0.612c-0.75,0-1.336,0.185-1.756,0.553 c-0.355,0.329-0.533,0.73-0.533,1.205c0,0.526,0.203,0.961,0.611,1.303c0.355,0.316,1,0.658,1.936,1.027 c1.145,0.461,1.986,1,2.527,1.618C87.77,26.081,88.039,26.852,88.039,27.772z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FFFFFF",
                            d: "M95.088,23.508h-2.35v4.659c0,1.185,0.414,1.777,1.244,1.777c0.381,0,0.697-0.033,0.947-0.099l0.059,1.619 c-0.42,0.157-0.973,0.236-1.658,0.236c-0.842,0-1.5-0.257-1.975-0.77c-0.473-0.514-0.711-1.376-0.711-2.587v-4.837h-1.4v-1.6h1.4 v-1.757l2.094-0.632v2.389h2.35V23.508z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FFFFFF",
                            d: "M105.691,26.627c0,1.475-0.422,2.686-1.264,3.633c-0.883,0.975-2.055,1.461-3.516,1.461 c-1.408,0-2.529-0.467-3.365-1.401s-1.254-2.113-1.254-3.534c0-1.487,0.43-2.705,1.293-3.652c0.861-0.948,2.023-1.422,3.484-1.422 c1.408,0,2.541,0.467,3.396,1.402C105.283,24.021,105.691,25.192,105.691,26.627z M103.479,26.696 c0-0.885-0.189-1.644-0.572-2.277c-0.447-0.766-1.086-1.148-1.914-1.148c-0.857,0-1.508,0.383-1.955,1.148 c-0.383,0.634-0.572,1.405-0.572,2.317c0,0.885,0.189,1.644,0.572,2.276c0.461,0.766,1.105,1.148,1.936,1.148 c0.814,0,1.453-0.39,1.914-1.168C103.281,28.347,103.479,27.58,103.479,26.696z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FFFFFF",
                            d: "M112.621,23.783c-0.211-0.039-0.436-0.059-0.672-0.059c-0.75,0-1.33,0.283-1.738,0.85 c-0.355,0.5-0.533,1.132-0.533,1.895v5.035h-2.131l0.02-6.574c0-1.106-0.027-2.113-0.08-3.021h1.857l0.078,1.836h0.059 c0.225-0.631,0.58-1.139,1.066-1.52c0.475-0.343,0.988-0.514,1.541-0.514c0.197,0,0.375,0.014,0.533,0.039V23.783z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FFFFFF",
                            d: "M122.156,26.252c0,0.382-0.025,0.704-0.078,0.967h-6.396c0.025,0.948,0.334,1.673,0.928,2.173 c0.539,0.447,1.236,0.671,2.092,0.671c0.947,0,1.811-0.151,2.588-0.454l0.334,1.48c-0.908,0.396-1.98,0.593-3.217,0.593 c-1.488,0-2.656-0.438-3.506-1.313c-0.848-0.875-1.273-2.05-1.273-3.524c0-1.447,0.395-2.652,1.186-3.613 c0.828-1.026,1.947-1.539,3.355-1.539c1.383,0,2.43,0.513,3.141,1.539C121.873,24.047,122.156,25.055,122.156,26.252z M120.123,25.699c0.014-0.632-0.125-1.178-0.414-1.639c-0.369-0.593-0.936-0.889-1.699-0.889c-0.697,0-1.264,0.289-1.697,0.869 c-0.355,0.461-0.566,1.014-0.631,1.658H120.123z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#FFFFFF",
                                d: "M49.05,10.009c0,1.177-0.353,2.063-1.058,2.658c-0.653,0.549-1.581,0.824-2.783,0.824 c-0.596,0-1.106-0.026-1.533-0.078V6.982c0.557-0.09,1.157-0.136,1.805-0.136c1.145,0,2.008,0.249,2.59,0.747 C48.723,8.156,49.05,8.961,49.05,10.009z M47.945,10.038c0-0.763-0.202-1.348-0.606-1.756c-0.404-0.407-0.994-0.611-1.771-0.611 c-0.33,0-0.611,0.022-0.844,0.068v4.889c0.129,0.02,0.365,0.029,0.708,0.029c0.802,0,1.421-0.223,1.857-0.669 S47.945,10.892,47.945,10.038z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#FFFFFF",
                                d: "M54.909,11.037c0,0.725-0.207,1.319-0.621,1.785c-0.434,0.479-1.009,0.718-1.727,0.718 c-0.692,0-1.243-0.229-1.654-0.689c-0.41-0.459-0.615-1.038-0.615-1.736c0-0.73,0.211-1.329,0.635-1.794s0.994-0.698,1.712-0.698 c0.692,0,1.248,0.229,1.669,0.688C54.708,9.757,54.909,10.333,54.909,11.037z M53.822,11.071c0-0.435-0.094-0.808-0.281-1.119 c-0.22-0.376-0.533-0.564-0.94-0.564c-0.421,0-0.741,0.188-0.961,0.564c-0.188,0.311-0.281,0.69-0.281,1.138 c0,0.435,0.094,0.808,0.281,1.119c0.227,0.376,0.543,0.564,0.951,0.564c0.4,0,0.714-0.191,0.94-0.574 C53.725,11.882,53.822,11.506,53.822,11.071z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#FFFFFF",
                                d: "M62.765,8.719l-1.475,4.714h-0.96l-0.611-2.047c-0.155-0.511-0.281-1.019-0.379-1.523h-0.019 c-0.091,0.518-0.217,1.025-0.379,1.523l-0.649,2.047h-0.971l-1.387-4.714h1.077l0.533,2.241c0.129,0.53,0.235,1.035,0.32,1.513 h0.019c0.078-0.394,0.207-0.896,0.389-1.503l0.669-2.25h0.854l0.641,2.202c0.155,0.537,0.281,1.054,0.378,1.552h0.029 c0.071-0.485,0.178-1.002,0.32-1.552l0.572-2.202H62.765z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#FFFFFF",
                                d: "M68.198,13.433H67.15v-2.7c0-0.832-0.316-1.248-0.95-1.248c-0.311,0-0.562,0.114-0.757,0.343 c-0.193,0.229-0.291,0.499-0.291,0.808v2.796h-1.048v-3.366c0-0.414-0.013-0.863-0.038-1.349h0.921l0.049,0.737h0.029 c0.122-0.229,0.304-0.418,0.543-0.569c0.284-0.176,0.602-0.265,0.95-0.265c0.44,0,0.806,0.142,1.097,0.427 c0.362,0.349,0.543,0.87,0.543,1.562V13.433z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#FFFFFF",
                                d: "M71.088,13.433h-1.047V6.556h1.047V13.433z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#FFFFFF",
                                d: "M77.258,11.037c0,0.725-0.207,1.319-0.621,1.785c-0.434,0.479-1.01,0.718-1.727,0.718 c-0.693,0-1.244-0.229-1.654-0.689c-0.41-0.459-0.615-1.038-0.615-1.736c0-0.73,0.211-1.329,0.635-1.794s0.994-0.698,1.711-0.698 c0.693,0,1.248,0.229,1.67,0.688C77.057,9.757,77.258,10.333,77.258,11.037z M76.17,11.071c0-0.435-0.094-0.808-0.281-1.119 c-0.219-0.376-0.533-0.564-0.939-0.564c-0.422,0-0.742,0.188-0.961,0.564c-0.188,0.311-0.281,0.69-0.281,1.138 c0,0.435,0.094,0.808,0.281,1.119c0.227,0.376,0.543,0.564,0.951,0.564c0.4,0,0.713-0.191,0.939-0.574 C76.074,11.882,76.17,11.506,76.17,11.071z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#FFFFFF",
                                d: "M82.33,13.433h-0.941l-0.078-0.543h-0.029c-0.322,0.433-0.781,0.65-1.377,0.65 c-0.445,0-0.805-0.143-1.076-0.427c-0.246-0.258-0.369-0.579-0.369-0.96c0-0.576,0.24-1.015,0.723-1.319 c0.482-0.304,1.16-0.453,2.033-0.446V10.3c0-0.621-0.326-0.931-0.979-0.931c-0.465,0-0.875,0.117-1.229,0.349l-0.213-0.688 c0.438-0.271,0.979-0.407,1.617-0.407c1.232,0,1.85,0.65,1.85,1.95v1.736C82.262,12.78,82.285,13.155,82.33,13.433z M81.242,11.813v-0.727c-1.156-0.02-1.734,0.297-1.734,0.95c0,0.246,0.066,0.43,0.201,0.553c0.135,0.123,0.307,0.184,0.512,0.184 c0.23,0,0.445-0.073,0.641-0.218c0.197-0.146,0.318-0.331,0.363-0.558C81.236,11.946,81.242,11.884,81.242,11.813z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#FFFFFF",
                                d: "M88.285,13.433h-0.93l-0.049-0.757h-0.029c-0.297,0.576-0.803,0.864-1.514,0.864 c-0.568,0-1.041-0.223-1.416-0.669s-0.562-1.025-0.562-1.736c0-0.763,0.203-1.381,0.611-1.853c0.395-0.44,0.879-0.66,1.455-0.66 c0.633,0,1.076,0.213,1.328,0.64h0.02V6.556h1.049v5.607C88.248,12.622,88.26,13.045,88.285,13.433z M87.199,11.445v-0.786 c0-0.136-0.01-0.246-0.029-0.33c-0.059-0.252-0.186-0.464-0.379-0.635c-0.195-0.171-0.43-0.257-0.701-0.257 c-0.391,0-0.697,0.155-0.922,0.466c-0.223,0.311-0.336,0.708-0.336,1.193c0,0.466,0.107,0.844,0.322,1.135 c0.227,0.31,0.533,0.465,0.916,0.465c0.344,0,0.619-0.129,0.828-0.388C87.1,12.069,87.199,11.781,87.199,11.445z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#FFFFFF",
                                d: "M97.248,11.037c0,0.725-0.207,1.319-0.621,1.785c-0.434,0.479-1.008,0.718-1.727,0.718 c-0.691,0-1.242-0.229-1.654-0.689c-0.41-0.459-0.615-1.038-0.615-1.736c0-0.73,0.211-1.329,0.635-1.794s0.994-0.698,1.713-0.698 c0.691,0,1.248,0.229,1.668,0.688C97.047,9.757,97.248,10.333,97.248,11.037z M96.162,11.071c0-0.435-0.094-0.808-0.281-1.119 c-0.221-0.376-0.533-0.564-0.941-0.564c-0.42,0-0.74,0.188-0.961,0.564c-0.188,0.311-0.281,0.69-0.281,1.138 c0,0.435,0.094,0.808,0.281,1.119c0.227,0.376,0.543,0.564,0.951,0.564c0.4,0,0.715-0.191,0.941-0.574 C96.064,11.882,96.162,11.506,96.162,11.071z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#FFFFFF",
                                d: "M102.883,13.433h-1.047v-2.7c0-0.832-0.316-1.248-0.951-1.248c-0.311,0-0.562,0.114-0.756,0.343 s-0.291,0.499-0.291,0.808v2.796h-1.049v-3.366c0-0.414-0.012-0.863-0.037-1.349h0.92l0.049,0.737h0.029 c0.123-0.229,0.305-0.418,0.543-0.569c0.285-0.176,0.602-0.265,0.951-0.265c0.439,0,0.805,0.142,1.096,0.427 c0.363,0.349,0.543,0.87,0.543,1.562V13.433z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#FFFFFF",
                                d: "M109.936,9.504h-1.154v2.29c0,0.582,0.205,0.873,0.611,0.873c0.188,0,0.344-0.016,0.467-0.049 l0.027,0.795c-0.207,0.078-0.479,0.117-0.814,0.117c-0.414,0-0.736-0.126-0.969-0.378c-0.234-0.252-0.35-0.676-0.35-1.271V9.504 h-0.689V8.719h0.689V7.855l1.027-0.31v1.173h1.154V9.504z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#FFFFFF",
                                d: "M115.484,13.433h-1.049v-2.68c0-0.845-0.316-1.268-0.949-1.268c-0.486,0-0.818,0.245-1,0.735 c-0.031,0.103-0.049,0.229-0.049,0.377v2.835h-1.047V6.556h1.047v2.841h0.02c0.33-0.517,0.803-0.775,1.416-0.775 c0.434,0,0.793,0.142,1.078,0.427c0.355,0.355,0.533,0.883,0.533,1.581V13.433z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#FFFFFF",
                                d: "M121.207,10.853c0,0.188-0.014,0.346-0.039,0.475h-3.143c0.014,0.466,0.164,0.821,0.455,1.067 c0.266,0.22,0.609,0.33,1.029,0.33c0.465,0,0.889-0.074,1.271-0.223l0.164,0.728c-0.447,0.194-0.973,0.291-1.582,0.291 c-0.73,0-1.305-0.215-1.721-0.645c-0.418-0.43-0.625-1.007-0.625-1.731c0-0.711,0.193-1.303,0.582-1.775 c0.406-0.504,0.955-0.756,1.648-0.756c0.678,0,1.193,0.252,1.541,0.756C121.068,9.77,121.207,10.265,121.207,10.853z M120.207,10.582c0.008-0.311-0.061-0.579-0.203-0.805c-0.182-0.291-0.459-0.437-0.834-0.437c-0.342,0-0.621,0.142-0.834,0.427 c-0.174,0.227-0.277,0.498-0.311,0.815H120.207z"
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var Icons_AppStoreBadge = (AppStoreBadge);

// EXTERNAL MODULE: ./components/common/Icons/CheckMark.tsx
var CheckMark = __webpack_require__(2950);
;// CONCATENATED MODULE: ./components/common/Icons/FoxSportsLogo.tsx


var FoxSportsLogo = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "80",
        height: "49",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.494 36.078v1.894l-.7.718H3.701l-.272.274v1.818l.196.196h6.726l1.495 1.499v4.336l-1.723 1.723H0v-1.757l.899-.87h7.258l.274-.272v-1.863l-.198-.2H1.495L0 42.079V37.8l1.724-1.721h9.77Zm12.63 0 1.922 1.919v4.617l-1.921 1.923h-6.707v3.998h-3.433V36.078h10.14Zm14.041 0 1.922 1.92v8.622l-1.922 1.915h-8.417l-1.904-1.915v-8.623l1.904-1.92h8.417Zm14.406 0 1.724 1.721v3.978l-1.646 1.646 2.167 5.112h-3.817l-1.612-4.518h-3.632v4.518h-3.43V36.078h10.246Zm14.243 0v2.886H62.85v9.572h-3.431v-9.572h-3.966v-2.886h11.36Zm12.587 0v1.894l-.702.718h-7.086l-.274.274v1.818l.196.196h6.727l1.494 1.499v4.336l-1.726 1.723H67.904v-1.757l.9-.87h7.26l.274-.272v-1.863l-.198-.2h-6.738l-1.498-1.495V37.8l1.726-1.721H79.4ZM35.95 38.78h-3.99l-.701.703v5.438l.7.697h3.99l.71-.697v-5.438l-.71-.703Zm-13.855-.061h-4.677v3.39h4.677l.504-.501v-2.386l-.504-.503Zm28.28-.09h-4.62v2.792h4.62l.489-.489v-1.815l-.488-.488ZM21.132 0l.625 9.242H10.362v4.407h9.286v9.224h-9.352v10.924H.78V0h20.35Zm38.842.05 4.155 7.276L68.355.05h10.19l-9.253 16.162 10.184 17.534H68.941l-4.94-8.525-4.89 8.54-10.24.006 9.984-17.442L49.43.05h10.543ZM37.598.51c8.898 0 16.109 7.36 16.109 16.43 0 9.08-7.21 16.436-16.11 16.436-8.891 0-16.098-7.356-16.098-16.436 0-9.07 7.207-16.43 16.099-16.43Zm.047 6.758c-1.506 0-2.726 1.383-2.726 2.92l-.005 13.46c0 1.54 1.225 2.789 2.731 2.789 1.51 0 2.85-1.204 2.85-2.748V10.188c0-1.537-1.34-2.92-2.85-2.92Z",
            fill: "#FFF",
            fillRule: "evenodd"
        })
    }));
};
/* harmony default export */ var Icons_FoxSportsLogo = (FoxSportsLogo);

;// CONCATENATED MODULE: ./components/common/Icons/GoogleBadge.tsx


var GoogleBadge = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 122 36",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "60.376%",
                        y1: "4.959%",
                        x2: "27.932%",
                        y2: "71.805%",
                        id: "c",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#00A0FF",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#00A1FF",
                                offset: "1%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#00BEFF",
                                offset: "26%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#00D2FF",
                                offset: "51%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#00DFFF",
                                offset: "76%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#00E3FF",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "107.567%",
                        y1: "50%",
                        x2: "-130.487%",
                        y2: "50%",
                        id: "d",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FFE000",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FFBD00",
                                offset: "41%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "orange",
                                offset: "78%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF9C00",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "86.147%",
                        y1: "29.982%",
                        x2: "-50.234%",
                        y2: "140.366%",
                        id: "e",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF3A44",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#C31162",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        x1: "-18.798%",
                        y1: "-14.959%",
                        x2: "42.093%",
                        y2: "34.362%",
                        id: "f",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#32A071",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#2DA771",
                                offset: "7%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#15CF74",
                                offset: "48%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#06E775",
                                offset: "80%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#00F076",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "a",
                        d: "M0 0h121.6v36H0z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "b",
                        fill: "#fff",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#a"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M117.458 36H4.334C1.984 36 0 34.055 0 31.708V4.195C0 1.847 1.984 0 4.334 0h113.124c2.35 0 4.142 1.847 4.142 4.195v27.513c0 2.347-1.852 4.292-4.2 4.292h.058Z",
                        fill: "#B5B5B5",
                        mask: "url(#b)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M120.916 31.709a3.452 3.452 0 0 1-3.457 3.45H4.334a3.456 3.456 0 0 1-3.46-3.45V4.194A3.46 3.46 0 0 1 4.334.74h113.124a3.456 3.456 0 0 1 3.458 3.455V31.71Z",
                        fill: "#000"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M42.397 8.618a2.378 2.378 0 0 1-.687 1.789 2.717 2.717 0 0 1-2.026.791c-1.593 0-2.884-1.253-2.884-2.799S38.091 5.6 39.684 5.6c.389 0 .774.076 1.132.226.332.13.628.335.864.597l-.487.473a1.878 1.878 0 0 0-1.51-.635c-.99.01-1.852.66-2.108 1.589-.255.93.159 1.91 1.012 2.397a2.257 2.257 0 0 0 2.651-.304 1.68 1.68 0 0 0 .462-1.086h-2.003V8.22h2.674c.02.132.03.264.026.397Zm4.803-1.53h-2.498v1.779h2.251v.666h-2.251v1.779H47.2V12H44V6.4h3.2zM49.9 12h-.6V7.087H48V6.4h3.2v.687h-1.3zm3.7 0V6.4h.8V12zm4.3 0h-.6V7.087H56V6.4h3.2v.687h-1.3zm8.5-1.61a2.87 2.87 0 0 1-3.996 0 2.858 2.858 0 0 1 0-3.975 2.844 2.844 0 0 1 1.997-.815c.749 0 1.467.293 1.996.815a2.858 2.858 0 0 1 0 3.972l.003.003Zm-3.479-.448a2.122 2.122 0 0 0 2.96 0c.81-.872.81-2.207 0-3.08a2.121 2.121 0 0 0-2.96 0 2.264 2.264 0 0 0 0 3.08ZM68 12V6.4h.812l2.521 4.355h.031l-.031-1.079V6.4H72V12h-.695l-2.638-4.568h-.027l.027 1.079V12z",
                        stroke: "#FFF",
                        strokeWidth: ".5",
                        fill: "#FFF",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M61.283 19.4c-2.138 0-3.87 1.705-3.87 3.81s1.732 3.81 3.87 3.81c2.137 0 3.87-1.705 3.87-3.81a3.714 3.714 0 0 0-1.113-2.715 3.834 3.834 0 0 0-2.757-1.096Zm0 6.1a2.347 2.347 0 0 1-2.277-1.306 2.279 2.279 0 0 1 .399-2.565 2.367 2.367 0 0 1 2.57-.575 2.306 2.306 0 0 1 1.485 2.143 2.178 2.178 0 0 1-.596 1.603c-.41.434-.98.686-1.581.7Zm-8.447-6.1c-2.138 0-3.87 1.705-3.87 3.81s1.732 3.81 3.87 3.81 3.87-1.705 3.87-3.81a3.714 3.714 0 0 0-1.113-2.715 3.834 3.834 0 0 0-2.757-1.096Zm0 6.1a2.347 2.347 0 0 1-2.277-1.306 2.279 2.279 0 0 1 .399-2.565 2.367 2.367 0 0 1 2.57-.575 2.306 2.306 0 0 1 1.485 2.143 2.178 2.178 0 0 1-.596 1.603c-.41.434-.98.686-1.581.7Zm-10.047-4.935v1.613h3.916a3.329 3.329 0 0 1-.89 2.026 4.042 4.042 0 0 1-3.026 1.181c-2.404 0-4.354-1.92-4.354-4.287 0-2.368 1.95-4.287 4.354-4.287 1.1-.014 2.16.4 2.951 1.153l1.155-1.137A5.753 5.753 0 0 0 42.79 15.2c-3.307 0-5.989 2.64-5.989 5.897s2.682 5.898 5.99 5.898c1.783 0 3.128-.575 4.192-1.655s1.416-2.56 1.416-3.77a5.234 5.234 0 0 0-.087-1.006H42.79Zm41.087 1.25c-.323-.847-1.29-2.416-3.3-2.416-2.009 0-3.638 1.54-3.638 3.811a3.685 3.685 0 0 0 1.09 2.709 3.804 3.804 0 0 0 2.739 1.102 3.845 3.845 0 0 0 3.225-1.683l-1.316-.864a2.204 2.204 0 0 1-1.896 1.051 1.96 1.96 0 0 1-1.871-1.15l5.16-2.102-.193-.457Zm-5.257 1.271a2.06 2.06 0 0 1 .531-1.53c.38-.419.915-.669 1.485-.693a1.5 1.5 0 0 1 1.432.804l-3.448 1.42Zm-4.193 3.684h1.693V15.614h-1.693V26.77Zm-2.777-6.517h-.058a2.687 2.687 0 0 0-2.032-.85c-1.935 0-3.696 1.67-3.696 3.81-.013 2.04 1.626 3.717 3.696 3.783a2.648 2.648 0 0 0 2.032-.864h.058v.55c0 1.45-.79 2.222-2.061 2.222a2.13 2.13 0 0 1-1.935-1.353l-1.477.604a3.681 3.681 0 0 0 3.418 2.245c1.987 0 3.668-1.153 3.668-3.957V19.63h-1.613v.622Zm-1.935 5.25c-1.171 0-2.148-.953-2.148-2.287 0-1.333.967-2.315 2.148-2.315 1.18 0 2.058.978 2.058 2.315s-.913 2.284-2.065 2.284l.007.003Zm22.103-9.89h-4.058v11.163h1.693v-4.24h2.365c1.873 0 3.718-1.336 3.718-3.467 0-2.131-1.845-3.455-3.718-3.455Zm.041 5.38h-2.406v-3.836h2.406c1.074 0 1.944.857 1.944 1.913 0 1.057-.87 1.914-1.944 1.914v.01Zm10.454-1.613c-1.223 0-2.494.53-3.02 1.709l1.504.619a1.62 1.62 0 0 1 1.548-.82c.874 0 1.764.518 1.777 1.436v.114a3.798 3.798 0 0 0-1.764-.428c-1.613 0-3.267.873-3.267 2.512 0 1.492 1.328 2.454 2.815 2.454a2.398 2.398 0 0 0 2.158-1.089h.058v.86h1.635v-4.28c.003-1.982-1.51-3.087-3.444-3.087Zm-.204 6.117c-.554 0-1.325-.27-1.325-.953 0-.86.967-1.191 1.793-1.191a3.037 3.037 0 0 1 1.545.371 2.037 2.037 0 0 1-2.01 1.773h-.003Zm9.599-5.872-1.935 4.84h-.058l-2.013-4.84h-1.822l3.019 6.764-1.723 3.763h1.764l4.661-10.527h-1.893Zm-15.243 7.142h1.693V15.614h-1.693v11.153Z",
                        fill: "#FFF",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.004 6.476c-.282.35-.425.799-.4 1.254v19.734c-.03.46.113.915.4 1.27l.065.066L20.8 17.743v-.26L10.07 6.4l-.066.076Z",
                        fill: "url(#c)",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.9 21.6 20 18.123v-.246l3.9-3.477.087.045 4.623 2.343c1.32.672 1.32 1.767 0 2.436l-4.623 2.346-.087.03Z",
                        fill: "url(#d)",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.984 21.546 20.138 17.6 8.8 29.226c.421.459 1.114.515 1.895.06L24 21.533",
                        fill: "url(#e)",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M24 14.47 10.695 6.713c-.78-.455-1.474-.398-1.895.057L20.155 18.4 24 14.47Z",
                        fill: "url(#f)",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "m23.916 21.6-13.22 7.566c-.743.421-1.404.395-1.828 0l-.068.069.068.065c.424.385 1.085.414 1.827 0L24 21.685l-.084-.085Z",
                        fill: "#000",
                        fillRule: "nonzero",
                        opacity: ".2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.49 28.723c-.485-.202-.73-.46-.685-.723v.077c-.043.262.202.52.684.723l.111-.038-.11-.039Zm19.116-9.904L24 21.512l.086.088 4.527-2.633c.658-.374.987-.872.987-1.367a1.761 1.761 0 0 1-.994 1.219Z",
                        fill: "#000",
                        fillRule: "nonzero",
                        opacity: ".12"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "m11.089 6.85 17.55 10.339c.487.224.843.673.961 1.211 0-.488-.32-.976-.96-1.348L11.089 6.714C9.83 5.974 8.8 6.588 8.8 8.08v.136c0-1.493 1.03-2.097 2.289-1.367Z",
                        fill: "#FFF",
                        fillRule: "nonzero",
                        opacity: ".25"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Icons_GoogleBadge = (GoogleBadge);

;// CONCATENATED MODULE: ./components/common/Icons/SearchIcon.tsx


var SearchIcon = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            fill: "#fff",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.832 19.641l-6.821-6.821c2.834-5.878-1.45-12.82-8.065-12.82-4.932 0-8.946 4.014-8.946 8.947 0 6.508 6.739 10.798 12.601 8.166l6.879 6.879c1.957.164 4.52-2.326 4.352-4.351zm-14.886-4.721c-3.293 0-5.973-2.68-5.973-5.973s2.68-5.973 5.973-5.973c3.294 0 5.974 2.68 5.974 5.973s-2.68 5.973-5.974 5.973z"
            })
        })
    }));
};
/* harmony default export */ var Icons_SearchIcon = (SearchIcon);

;// CONCATENATED MODULE: ./components/common/Icons/Apple.tsx


var Apple = function() {
    return(/*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsxs("g", {
            children: [
                /*#__PURE__*/ _jsx("path", {
                    d: "M18.685,12.678c-0.027,-2.949 2.408,-4.364 2.519,-4.433c-1.371,-2.005 -3.503,-2.28 -4.264,-2.312c-1.814,-0.183 -3.541,1.068 -4.46,1.068c-0.919,0 -2.341,-1.041 -3.845,-1.012c-1.979,0.029 -3.802,1.15 -4.821,2.921c-2.055,3.564 -0.524,8.847 1.476,11.74c0.979,1.414 2.145,3.008 3.679,2.949c1.477,-0.059 2.035,-0.955 3.818,-0.955c1.783,0 2.285,0.955 3.846,0.927c1.588,-0.031 2.595,-1.445 3.567,-2.864c1.122,-1.642 1.587,-3.231 1.613,-3.314c-0.035,-0.015 -3.096,-1.188 -3.128,-4.715"
                }),
                /*#__PURE__*/ _jsx("path", {
                    id: "path190",
                    d: "M15.752,4.02c0.813,-0.985 1.362,-2.356 1.211,-3.721c-1.172,0.047 -2.59,0.781 -3.432,1.766c-0.753,0.871 -1.414,2.266 -1.235,3.604c1.307,0.102 2.642,-0.665 3.456,-1.649"
                })
            ]
        })
    }));
};
/* harmony default export */ var Icons_Apple = ((/* unused pure expression or super */ null && (Apple)));

;// CONCATENATED MODULE: ./components/common/Icons/Edit.tsx


var Edit = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.456058,5.91891193 L19.267767,4.10710678 C20.2104357,3.16061199 20.2409263,2.17220389 19.3855417,1.29581982 L18.7047254,0.594712568 C17.8493408,-0.264143816 16.8118716,-0.15537726 15.8692029,0.773589849 L14.0951402,2.54613078 L17.456058,5.91891193 Z M5.44370412,17.9355005 L16.7490401,6.62724495 L16.7490401,6.62724495 L13.3743541,3.25561154 L2.06525646,14.5668948 C1.85756188,14.7746295 1.69817751,15.0255655 1.59843283,15.3018656 L0.0278603893,19.6524669 C-0.0190221021,19.7823348 0.0482509052,19.9256194 0.178118857,19.9725018 C0.23290799,19.9922808 0.292884023,19.9923069 0.347690376,19.9725757 L4.70677405,18.4032346 C4.98385771,18.30348 5.23549275,18.1437657 5.44370412,17.9355005 Z",
                id: "Edit"
            })
        })
    }));
};
/* harmony default export */ var Icons_Edit = (Edit);

;// CONCATENATED MODULE: ./components/common/Icons/Facebook.tsx


var Facebook = function() {
    return(/*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("g", {
            children: /*#__PURE__*/ _jsx("path", {
                id: "icon-fb",
                d: "M30.1834292,15.0917146 C30.1834292,6.75678464 23.4266445,0 15.0917146,0 C6.75678464,0 0,6.75678464 0,15.0917146 C0,22.6244256 5.5188219,28.8679151 12.7336342,30 L12.7336342,19.4541633 L8.90175353,19.4541633 L8.90175353,15.0917146 L12.7336342,15.0917146 L12.7336342,11.7668212 C12.7336342,7.98446025 14.9867211,5.89520101 18.4339988,5.89520101 C20.0851562,5.89520101 21.8122437,6.18996106 21.8122437,6.18996106 L21.8122437,9.9039377 L19.9092139,9.9039377 C18.0344516,9.9039377 17.449795,11.0672672 17.449795,12.2607506 L17.449795,15.0917146 L21.6353877,15.0917146 L20.9662824,19.4541633 L17.449795,19.4541633 L17.449795,30 C24.6646073,28.8679151 30.1834292,22.6244256 30.1834292,15.0917146"
            })
        })
    }));
};
/* harmony default export */ var Icons_Facebook = ((/* unused pure expression or super */ null && (Facebook)));

;// CONCATENATED MODULE: ./components/common/Icons/index.ts











/***/ }),

/***/ 4367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2115);




var Layout = function(param) {
    var children = param.children;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_2__["default"], {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Second Screen Activation | FOX Broadcasting Company"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "/favicons/apple-icon-180x180.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: "/favicons/favicon-32x32.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: "/favicons/favicon-16x16.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                children: children
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 6754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);



var Link = function(param) {
    var _href = param.href, href = _href === void 0 ? '' : _href, _target = param.target, target = _target === void 0 ? '' : _target, external = param.external, passHref = param.passHref, children = param.children, className = param.className;
    if (external) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: className,
            href: href,
            target: target,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: children
            })
        }));
    } else return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
        href: href,
        passHref: passHref,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: className,
            children: children
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(Link));


/***/ }),

/***/ 1407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EO": function() { return /* binding */ ACCOUNT_COOKIE_NAME_FOX; },
/* harmony export */   "r5": function() { return /* binding */ COOKIE_CODE_INFO; },
/* harmony export */   "h3": function() { return /* binding */ FLOW_STAGE_ENTER_REG_CODE; },
/* harmony export */   "Vr": function() { return /* binding */ FLOW_STAGE_MVPD_SELECT; },
/* harmony export */   "T7": function() { return /* binding */ FLOW_STAGE_PROFILE_AUTH; },
/* harmony export */   "xg": function() { return /* binding */ FLOW_STAGE_MVPD_AUTH; },
/* harmony export */   "o2": function() { return /* binding */ ANONYMOUS; },
/* harmony export */   "gV": function() { return /* binding */ COOKIE_CAMPAIGN_CODES; },
/* harmony export */   "vl": function() { return /* binding */ INT_CMP; },
/* harmony export */   "Mp": function() { return /* binding */ CODE_TYPE_API; },
/* harmony export */   "XX": function() { return /* binding */ ROUTE_HOME; },
/* harmony export */   "W3": function() { return /* binding */ ROUTE_MVPD; },
/* harmony export */   "VU": function() { return /* binding */ ROUTE_SUCCESS; },
/* harmony export */   "I": function() { return /* binding */ ROUTE_ACCOUNT; },
/* harmony export */   "hd": function() { return /* binding */ ROUTE_ACCOUNT_NATION; },
/* harmony export */   "rr": function() { return /* binding */ PATH_ACTIVATE; },
/* harmony export */   "yk": function() { return /* binding */ REDIRECT_SECONDS; },
/* harmony export */   "St": function() { return /* binding */ ACTIVATE_CODE_EXPIRES_MINUTES; },
/* harmony export */   "Tr": function() { return /* binding */ GOOGLE; },
/* harmony export */   "vq": function() { return /* binding */ FACEBOOK; },
/* harmony export */   "uv": function() { return /* binding */ DEBUG_PANEL_API_INTEGRATION; },
/* harmony export */   "Hi": function() { return /* binding */ DEBUG_PANEL_API_BASEURL_INT; },
/* harmony export */   "ME": function() { return /* binding */ PREVIEW_PASS_5_MVPD; },
/* harmony export */   "hn": function() { return /* binding */ PREVIEW_PASS_60_MVPD; },
/* harmony export */   "VG": function() { return /* binding */ SECOND_SCREEN_VERSION; },
/* harmony export */   "H2": function() { return /* binding */ Brand; },
/* harmony export */   "CG": function() { return /* binding */ ENVS; },
/* harmony export */   "xD": function() { return /* binding */ DataDogService; },
/* harmony export */   "O3": function() { return /* binding */ ExternalBrand; },
/* harmony export */   "it": function() { return /* binding */ ExternalENVFile; },
/* harmony export */   "BA": function() { return /* binding */ LINKS; }
/* harmony export */ });
/* unused harmony exports FLOW_STAGE_GEN_REG_CODE, FLOW_STAGE_MVPD_LINK */
var ACCOUNT_COOKIE_NAME_FOX = 'ACTIVATE_ACCOUNT';
var COOKIE_CODE_INFO = 'code-info';
var FLOW_STAGE_ENTER_REG_CODE = 'ENTER_REG_CODE';
var FLOW_STAGE_GEN_REG_CODE = 'GEN_REG_CODE';
var FLOW_STAGE_MVPD_SELECT = 'MVPD_SELECT';
var FLOW_STAGE_PROFILE_AUTH = 'PROFILE_AUTH';
var FLOW_STAGE_MVPD_AUTH = 'MVPD_AUTH';
var FLOW_STAGE_MVPD_LINK = 'MVPD_LINK';
var ANONYMOUS = 'anonymous';
var COOKIE_CAMPAIGN_CODES = 'c_m';
var INT_CMP = 'int_cmp';
var CODE_TYPE_API = 'api';
var ROUTE_HOME = '/';
var ROUTE_MVPD = '/mvpd/';
var ROUTE_SUCCESS = '/success/';
var ROUTE_ACCOUNT = '/account/';
var ROUTE_ACCOUNT_NATION = '/account/signin/tv/';
var PATH_ACTIVATE = '/activate/';
var REDIRECT_SECONDS = 5;
var ACTIVATE_CODE_EXPIRES_MINUTES = 30;
var GOOGLE = 'google';
var FACEBOOK = 'facebook';
var DEBUG_PANEL_API_INTEGRATION = 'Integration';
var DEBUG_PANEL_API_BASEURL_INT = 'https://int1.api3.fox.com/v2.0';
var PREVIEW_PASS_5_MVPD = 'TempPass_fbcfox_5min';
var PREVIEW_PASS_60_MVPD = 'TempPass_fbcfox_60min';
var SECOND_SCREEN_VERSION = 'v2';
var Brand;
(function(Brand) {
    Brand["SPORTS"] = 'sports';
})(Brand || (Brand = {}));
var ENVS;
(function(ENVS) {
    ENVS["PRODUCTION"] = 'production';
    ENVS["STAGE"] = 'stage';
    ENVS["DEV"] = 'dev';
})(ENVS || (ENVS = {}));
var DataDogService;
(function(DataDogService) {
    DataDogService["SPORTS"] = 'fox-sports-ssa';
})(DataDogService || (DataDogService = {}));
var ExternalBrand;
(function(ExternalBrand) {
    ExternalBrand["SPORTS"] = 'foxsports';
})(ExternalBrand || (ExternalBrand = {}));
var ExternalENVFile;
(function(ExternalENVFile) {
    ExternalENVFile["PRODUCTION"] = 'info.json';
    ExternalENVFile["STAGE"] = 'info-qa.json';
    ExternalENVFile["DEV"] = 'info-qa.json';
})(ExternalENVFile || (ExternalENVFile = {}));
var LINKS = {
    HELP_LINK: 'https://help.fox.com/s/topic/0TO1H000000HHQVWA4/fox-sports',
    TERMS_LINK: 'https://www.foxsports.com/terms-of-use',
    DO_NOT_SELL_LINK: 'https://www.foxsports.com/do-not-sell',
    PRIVACY_POLICY: 'https://www.foxsports.com/privacy-policy',
    target: '_blank'
};


/***/ }),

/***/ 1387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ GlobalContextProvider; },
/* harmony export */   "I": function() { return /* binding */ AppContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _state_reducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2807);
/* harmony import */ var _state_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9717);




var AppContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    state: _state_state__WEBPACK_IMPORTED_MODULE_3__/* .initialState */ .E,
    dispatch: function() {
        return null;
    }
});
var GlobalContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(_state_reducer__WEBPACK_IMPORTED_MODULE_2__/* .reducer */ .I6, _state_state__WEBPACK_IMPORTED_MODULE_3__/* .initialState */ .E), state = ref[0], dispatch = ref[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AppContext.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    }));
};



/***/ }),

/***/ 2807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I6": function() { return /* binding */ reducer; },
  "ys": function() { return /* binding */ setCodeInfo; },
  "sT": function() { return /* binding */ setError; },
  "qs": function() { return /* binding */ setFirstScreenVersion; },
  "Kc": function() { return /* binding */ setFlowStage; },
  "ko": function() { return /* binding */ setIsRegister; },
  "v4": function() { return /* binding */ setIsSocialAuth; },
  "K4": function() { return /* binding */ setLoading; }
});

// UNUSED EXPORTS: setAccount, setQRCode

// EXTERNAL MODULE: ./lib/utils/logReportHelper.ts
var logReportHelper = __webpack_require__(1184);
;// CONCATENATED MODULE: ./context/state/actions.ts
var actions_ActionType;
(function(ActionType) {
    ActionType["SetLoading"] = 'SET_LOADING';
    ActionType["SetLanguageStrings"] = 'SET_LANGUAGE_STRINGS';
    ActionType["SetFlowStage"] = 'SET_FLOW_STAGE';
    ActionType["SetCodeInfo"] = 'SET_CODE_INFO';
    ActionType["SetQRCode"] = 'SET_QR_CODE';
    ActionType["SetAccount"] = 'SET_ACCOUNT';
    ActionType["SetError"] = 'SET_ERROR';
    ActionType["SetIsRegister"] = 'SET_IS_REGISTER';
    ActionType["SetIsSocialAuth"] = 'SET_IS_SOCIAL_AUTH';
    ActionType["SetFirstScreenVersion"] = 'SET_FIRST_SCREEN_VERSION';
})(actions_ActionType || (actions_ActionType = {}));

;// CONCATENATED MODULE: ./context/state/reducer.ts


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var reducer = function(state, action) {
    switch(action.type){
        case actions_ActionType.SetLoading:
            {
                return _objectSpread({}, state, {
                    isLoading: action.payload
                });
            }
        case actions_ActionType.SetIsSocialAuth:
            {
                return _objectSpread({}, state, {
                    isSocialAuth: {
                        data: action.payload,
                        value: action.value,
                        kind: action.kind
                    }
                });
            }
        case actions_ActionType.SetFlowStage:
            {
                return _objectSpread({}, state, {
                    flowStage: action.payload
                });
            }
        case actions_ActionType.SetCodeInfo:
            {
                var _payload;
                return _objectSpread({}, state, {
                    codeInfo: (_payload = action.payload) !== null && _payload !== void 0 ? _payload : {}
                });
            }
        case actions_ActionType.SetQRCode:
            {
                return _objectSpread({}, state, {
                    qrCode: action.payload.toUpperCase()
                });
            }
        case actions_ActionType.SetAccount:
            {
                return _objectSpread({}, state, {
                    account: action.payload
                });
            }
        case actions_ActionType.SetLanguageStrings:
            {
                return _objectSpread({}, state, {
                    languageStrings: action.payload
                });
            }
        case actions_ActionType.SetError:
            {
                return _objectSpread({}, state, {
                    error: action.payload
                });
            }
        case actions_ActionType.SetIsRegister:
            {
                return _objectSpread({}, state, {
                    isRegister: {
                        value: action.value,
                        account: action.payload
                    }
                });
            }
        case actions_ActionType.SetFirstScreenVersion:
            {
                return _objectSpread({}, state, {
                    firstScreenVersion: action.payload
                });
            }
        default:
            return state;
    }
};
var setLoading = function(isLoading) {
    return {
        type: actions_ActionType.SetLoading,
        payload: isLoading
    };
};
var setIsSocialAuth = function(isSocialAuth, data, kind) {
    return {
        type: actions_ActionType.SetIsSocialAuth,
        value: isSocialAuth,
        kind: kind,
        payload: data
    };
};
var setFlowStage = function(flowStage) {
    return {
        type: actions_ActionType.SetFlowStage,
        payload: flowStage
    };
};
var setAccount = function(account) {
    return {
        type: ActionType.SetAccount,
        payload: account
    };
};
var setQRCode = function(qrCode) {
    return {
        type: ActionType.SetQRCode,
        payload: qrCode
    };
};
var setCodeInfo = function(codeInfo) {
    return {
        type: actions_ActionType.SetCodeInfo,
        payload: codeInfo
    };
};
var setError = function(error) {
    var errorResponse = error;
    if (error === null || error === void 0 ? void 0 : error.info) {
        var responseError = 'Error Boundary Reached';
        (0,logReportHelper/* logError */.H)(error.error, {
            name: responseError
        });
    } else if (error && (error === null || error === void 0 ? void 0 : error.name)) {
        var responseError1 = (error === null || error === void 0 ? void 0 : error.message) || (error === null || error === void 0 ? void 0 : error.name);
        (0,logReportHelper/* logError */.H)(errorResponse, {
            name: responseError1
        });
    }
    return {
        type: actions_ActionType.SetError,
        payload: error
    };
};
var setIsRegister = function(value, account) {
    return {
        type: actions_ActionType.SetIsRegister,
        payload: account,
        value: value
    };
};
var setFirstScreenVersion = function(screenVersion) {
    return {
        type: actions_ActionType.SetFirstScreenVersion,
        payload: screenVersion
    };
};


/***/ }),

/***/ 9717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ FlowStage; },
/* harmony export */   "E": function() { return /* binding */ initialState; }
/* harmony export */ });
/* harmony import */ var lib_utils_getConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(889);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1407);


var FlowStage;
(function(FlowStage) {
    FlowStage["LANDING_PAGE"] = 'landingPage';
    FlowStage["EXISTING_USER"] = 'existingUser';
    FlowStage["NEW_USER"] = 'newUser';
    FlowStage["FORGOT_PASSWORD"] = 'forgotPassword';
    FlowStage["CREATE_PASSWORD"] = 'createPassword';
    FlowStage["SUCCESS"] = 'success';
    FlowStage["LINK"] = 'link';
})(FlowStage || (FlowStage = {}));
var initialState = {
    isLoading: false,
    isSocialAuth: {
        data: {},
        value: false,
        kind: ''
    },
    brand: constants_index__WEBPACK_IMPORTED_MODULE_1__/* .Brand.SPORTS */ .H2.SPORTS,
    account: {
        accessToken: '',
        isNew: undefined
    },
    config: (0,lib_utils_getConfig__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .i)(),
    codeInfo: {},
    qrCode: '',
    error: '',
    flowStage: '',
    languageStrings: {},
    isRegister: {
        value: undefined,
        account: {}
    },
    firstScreenVersion: '',
    secondScreenVersion: constants_index__WEBPACK_IMPORTED_MODULE_1__/* .SECOND_SCREEN_VERSION */ .VG
};


/***/ }),

/***/ 8113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kt": function() { return /* reexport */ hooks_useBoolean; },
  "ix": function() { return /* reexport */ useFlowManager/* default */.Z; },
  "Iw": function() { return /* reexport */ hooks_useGetProfileSdk; },
  "F2": function() { return /* reexport */ hooks_useLanguageStrings; }
});

// UNUSED EXPORTS: useExternalStrings, useIsMounted

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./context/state/reducer.ts + 1 modules
var reducer = __webpack_require__(2807);
// EXTERNAL MODULE: ./context/GlobalContextProvider.tsx
var GlobalContextProvider = __webpack_require__(1387);
;// CONCATENATED MODULE: ./lib/hooks/useGetProfileSdk.ts




function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var useGetProfileSdk = function(configs) {
    var ref1 = (0,react.useState)({}), profile1 = ref1[0], setProfile = ref1[1];
    var dispatch = (0,react.useContext)(GlobalContextProvider/* AppContext */.I).dispatch;
    (0,react.useEffect)(function() {
        var didCancel = false;
        var fetchProfile = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var ref, ProfileConfig, Profile, config, profile;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return __webpack_require__.e(/* import() */ 396).then(__webpack_require__.t.bind(__webpack_require__, 396, 23));
                        case 3:
                            ref = _ctx.sent;
                            ProfileConfig = ref.ProfileConfig;
                            Profile = ref.Profile;
                            if (didCancel) {
                                _ctx.next = 14;
                                break;
                            }
                            _ctx.next = 9;
                            return new ProfileConfig(configs);
                        case 9:
                            config = _ctx.sent;
                            _ctx.next = 12;
                            return new Profile(config);
                        case 12:
                            profile = _ctx.sent;
                            setProfile(profile);
                        case 14:
                            _ctx.next = 19;
                            break;
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](0);
                            dispatch((0,reducer/* setError */.sT)(_ctx.t0));
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        16
                    ]
                ]);
            }));
            return function fetchProfile() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchProfile().then().catch(function(e) {
            dispatch((0,reducer/* setError */.sT)(e));
        });
        return function() {
            didCancel = true;
        };
    }, [
        configs,
        dispatch
    ]);
    return profile1;
};
/* harmony default export */ var hooks_useGetProfileSdk = (useGetProfileSdk);

;// CONCATENATED MODULE: ./lib/hooks/useBoolean.ts

function useBoolean(defaultValue) {
    var ref = (0,react.useState)(!!defaultValue), value = ref[0], setValue = ref[1];
    var setTrue = function() {
        return setValue(true);
    };
    var setFalse = function() {
        return setValue(false);
    };
    var toggle = function() {
        return setValue(function(x) {
            return !x;
        });
    };
    return {
        value: value,
        setValue: setValue,
        setTrue: setTrue,
        setFalse: setFalse,
        toggle: toggle
    };
}
/* harmony default export */ var hooks_useBoolean = (useBoolean);

;// CONCATENATED MODULE: ./lib/hooks/useIsMounted.ts

function useIsMounted() {
    var isMounted = useRef(false);
    useEffect(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    return function() {
        return isMounted.current;
    };
}
/* harmony default export */ var hooks_useIsMounted = ((/* unused pure expression or super */ null && (useIsMounted)));

// EXTERNAL MODULE: ./lib/hooks/useFlowManager.ts
var useFlowManager = __webpack_require__(9697);
;// CONCATENATED MODULE: ./node_modules/swr/dist/index.mjs


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var noop = function () { };
// Using noop() as the undefined value as undefined can possibly be replaced
// by something else.  Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
var UNDEFINED = ( /*#__NOINLINE__*/noop());
var OBJECT = Object;
var isUndefined = function (v) { return v === UNDEFINED; };
var isFunction = function (v) { return typeof v == 'function'; };
var mergeObjects = function (a, b) { return OBJECT.assign({}, a, b); };
var STR_UNDEFINED = 'undefined';
// NOTE: Use function to guarantee it's re-evaluated between jsdom and node runtime for tests.
var hasWindow = function () { return typeof window != STR_UNDEFINED; };
var hasDocument = function () { return typeof document != STR_UNDEFINED; };
var hasRequestAnimationFrame = function () {
    return hasWindow() && typeof window['requestAnimationFrame'] != STR_UNDEFINED;
};

// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var table = new WeakMap();
// counter of the key
var counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsible.
var stableHash = function (arg) {
    var type = typeof arg;
    var constructor = arg && arg.constructor;
    var isDate = constructor == Date;
    var result;
    var index;
    if (OBJECT(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = table.get(arg);
        if (result)
            return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++counter + '~';
        table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = '@';
            for (index = 0; index < arg.length; index++) {
                result += stableHash(arg[index]) + ',';
            }
            table.set(arg, result);
        }
        if (constructor == OBJECT) {
            // Object, sort keys.
            result = '#';
            var keys = OBJECT.keys(arg).sort();
            while (!isUndefined((index = keys.pop()))) {
                if (!isUndefined(arg[index])) {
                    result += index + ':' + stableHash(arg[index]) + ',';
                }
            }
            table.set(arg, result);
        }
    }
    else {
        result = isDate
            ? arg.toJSON()
            : type == 'symbol'
                ? arg.toString()
                : type == 'string'
                    ? JSON.stringify(arg)
                    : '' + arg;
    }
    return result;
};

/**
 * Due to bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a work around, we always assume it's online on first load, and change
 * the status upon `online` or `offline` events.
 */
var online = true;
var isOnline = function () { return online; };
var hasWin = hasWindow();
var hasDoc = hasDocument();
// For node and React Native, `add/removeEventListener` doesn't exist on window.
var onWindowEvent = hasWin && window.addEventListener
    ? window.addEventListener.bind(window)
    : noop;
var onDocumentEvent = hasDoc ? document.addEventListener.bind(document) : noop;
var offWindowEvent = hasWin && window.removeEventListener
    ? window.removeEventListener.bind(window)
    : noop;
var offDocumentEvent = hasDoc
    ? document.removeEventListener.bind(document)
    : noop;
var isVisible = function () {
    var visibilityState = hasDoc && document.visibilityState;
    return isUndefined(visibilityState) || visibilityState !== 'hidden';
};
var initFocus = function (callback) {
    // focus revalidate
    onDocumentEvent('visibilitychange', callback);
    onWindowEvent('focus', callback);
    return function () {
        offDocumentEvent('visibilitychange', callback);
        offWindowEvent('focus', callback);
    };
};
var initReconnect = function (callback) {
    // revalidate on reconnected
    var onOnline = function () {
        online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    var onOffline = function () {
        online = false;
    };
    onWindowEvent('online', onOnline);
    onWindowEvent('offline', onOffline);
    return function () {
        offWindowEvent('online', onOnline);
        offWindowEvent('offline', onOffline);
    };
};
var preset = {
    isOnline: isOnline,
    isVisible: isVisible
};
var defaultConfigOptions = {
    initFocus: initFocus,
    initReconnect: initReconnect
};

var IS_SERVER = !hasWindow() || 'Deno' in window;
// Polyfill requestAnimationFrame
var rAF = function (f) {
    return hasRequestAnimationFrame() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
};
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
var useIsomorphicLayoutEffect = IS_SERVER ? react.useEffect : react.useLayoutEffect;
// This assignment is to extend the Navigator type to use effectiveType.
var navigatorConnection = typeof navigator !== 'undefined' &&
    navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
var slowConnection = !IS_SERVER &&
    navigatorConnection &&
    (['slow-2g', '2g'].includes(navigatorConnection.effectiveType) ||
        navigatorConnection.saveData);

var serialize = function (key) {
    if (isFunction(key)) {
        try {
            key = key();
        }
        catch (err) {
            // dependencies not ready
            key = '';
        }
    }
    var args = [].concat(key);
    // If key is not falsy, or not an empty array, hash it.
    key =
        typeof key == 'string'
            ? key
            : (Array.isArray(key) ? key.length : key)
                ? stableHash(key)
                : '';
    var infoKey = key ? '$swr$' + key : '';
    return [key, args, infoKey];
};

// Global state used to deduplicate requests and store listeners
var SWRGlobalState = new WeakMap();

var FOCUS_EVENT = 0;
var RECONNECT_EVENT = 1;
var MUTATE_EVENT = 2;

var broadcastState = function (cache, key, data, error, isValidating, revalidate, broadcast) {
    if (broadcast === void 0) { broadcast = true; }
    var _a = SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], FETCH = _a[3];
    var revalidators = EVENT_REVALIDATORS[key];
    var updaters = STATE_UPDATERS[key];
    // Cache was populated, update states of all hooks.
    if (broadcast && updaters) {
        for (var i = 0; i < updaters.length; ++i) {
            updaters[i](data, error, isValidating);
        }
    }
    // If we also need to revalidate, only do it for the first hook.
    if (revalidate) {
        // Invalidate the key by deleting the concurrent request markers so new
        // requests will not be deduped.
        delete FETCH[key];
        if (revalidators && revalidators[0]) {
            return revalidators[0](MUTATE_EVENT).then(function () {
                return cache.get(key);
            });
        }
    }
    return cache.get(key);
};

// Global timestamp.
var __timestamp = 0;
var getTimestamp = function () { return ++__timestamp; };

var internalMutate = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        var cache, _key, _data, _opts, options, populateCache, revalidate, rollbackOnError, optimisticData, _a, key, keyInfo, _b, MUTATION, data, error, beforeMutationTs, hasOptimisticData, rollbackData, res;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    cache = args[0], _key = args[1], _data = args[2], _opts = args[3];
                    options = typeof _opts === 'boolean' ? { revalidate: _opts } : _opts || {};
                    populateCache = isUndefined(options.populateCache)
                        ? true
                        : options.populateCache;
                    revalidate = options.revalidate !== false;
                    rollbackOnError = options.rollbackOnError !== false;
                    optimisticData = options.optimisticData;
                    _a = serialize(_key), key = _a[0], keyInfo = _a[2];
                    if (!key)
                        return [2 /*return*/];
                    _b = SWRGlobalState.get(cache), MUTATION = _b[2];
                    // If there is no new data provided, revalidate the key with current state.
                    if (args.length < 3) {
                        // Revalidate and broadcast state.
                        return [2 /*return*/, broadcastState(cache, key, cache.get(key), UNDEFINED, UNDEFINED, revalidate, true)];
                    }
                    data = _data;
                    beforeMutationTs = getTimestamp();
                    MUTATION[key] = [beforeMutationTs, 0];
                    hasOptimisticData = !isUndefined(optimisticData);
                    rollbackData = cache.get(key);
                    // Do optimistic data update.
                    if (hasOptimisticData) {
                        cache.set(key, optimisticData);
                        broadcastState(cache, key, optimisticData);
                    }
                    if (isFunction(data)) {
                        // `data` is a function, call it passing current cache value.
                        try {
                            data = data(cache.get(key));
                        }
                        catch (err) {
                            // If it throws an error synchronously, we shouldn't update the cache.
                            error = err;
                        }
                    }
                    if (!(data && isFunction(data.then))) return [3 /*break*/, 2];
                    return [4 /*yield*/, data.catch(function (err) {
                            error = err;
                        })
                        // Check if other mutations have occurred since we've started this mutation.
                        // If there's a race we don't update cache or broadcast the change,
                        // just return the data.
                    ];
                case 1:
                    // This means that the mutation is async, we need to check timestamps to
                    // avoid race conditions.
                    data = _c.sent();
                    // Check if other mutations have occurred since we've started this mutation.
                    // If there's a race we don't update cache or broadcast the change,
                    // just return the data.
                    if (beforeMutationTs !== MUTATION[key][0]) {
                        if (error)
                            throw error;
                        return [2 /*return*/, data];
                    }
                    else if (error && hasOptimisticData && rollbackOnError) {
                        // Rollback. Always populate the cache in this case but without
                        // transforming the data.
                        populateCache = true;
                        data = rollbackData;
                        cache.set(key, rollbackData);
                    }
                    _c.label = 2;
                case 2:
                    // If we should write back the cache after request.
                    if (populateCache) {
                        if (!error) {
                            // Transform the result into data.
                            if (isFunction(populateCache)) {
                                data = populateCache(data, rollbackData);
                            }
                            // Only update cached data if there's no error. Data can be `undefined` here.
                            cache.set(key, data);
                        }
                        // Always update or reset the error.
                        cache.set(keyInfo, mergeObjects(cache.get(keyInfo), { error: error }));
                    }
                    // Reset the timestamp to mark the mutation has ended.
                    MUTATION[key][1] = getTimestamp();
                    return [4 /*yield*/, broadcastState(cache, key, data, error, UNDEFINED, revalidate, !!populateCache)
                        // Throw error or return data
                    ];
                case 3:
                    res = _c.sent();
                    // Throw error or return data
                    if (error)
                        throw error;
                    return [2 /*return*/, populateCache ? res : data];
            }
        });
    });
};

var revalidateAllKeys = function (revalidators, type) {
    for (var key in revalidators) {
        if (revalidators[key][0])
            revalidators[key][0](type);
    }
};
var initCache = function (provider, options) {
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that bound to
    // the cache.
    // Provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!SWRGlobalState.has(provider)) {
        var opts = mergeObjects(defaultConfigOptions, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        var EVENT_REVALIDATORS = {};
        var mutate = internalMutate.bind(UNDEFINED, provider);
        var unmount = noop;
        // Update the state if it's new, or the provider has been extended.
        SWRGlobalState.set(provider, [EVENT_REVALIDATORS, {}, {}, {}, mutate]);
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        if (!IS_SERVER) {
            // When listening to the native events for auto revalidations,
            // we intentionally put a delay (setTimeout) here to make sure they are
            // fired after immediate JavaScript executions, which can possibly be
            // React's state updates.
            // This avoids some unnecessary revalidations such as
            // https://github.com/vercel/swr/issues/1680.
            var releaseFocus_1 = opts.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, FOCUS_EVENT)));
            var releaseReconnect_1 = opts.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, RECONNECT_EVENT)));
            unmount = function () {
                releaseFocus_1 && releaseFocus_1();
                releaseReconnect_1 && releaseReconnect_1();
                // When un-mounting, we need to remove the cache provider from the state
                // storage too because it's a side-effect. Otherwise when re-mounting we
                // will not re-register those event listeners.
                SWRGlobalState.delete(provider);
            };
        }
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [provider, mutate, unmount];
    }
    return [provider, SWRGlobalState.get(provider)[4]];
};

// error retry
var onErrorRetry = function (_, __, config, revalidate, opts) {
    var maxRetryCount = config.errorRetryCount;
    var currentRetryCount = opts.retryCount;
    // Exponential backoff
    var timeout = ~~((Math.random() + 0.5) *
        (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount) {
        return;
    }
    setTimeout(revalidate, timeout, opts);
};
// Default cache provider
var _a = initCache(new Map()), cache = _a[0], mutate = _a[1];
// Default config
var defaultConfig = mergeObjects({
    // events
    onLoadingSlow: noop,
    onSuccess: noop,
    onError: noop,
    onErrorRetry: onErrorRetry,
    onDiscarded: noop,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: slowConnection ? 10000 : 5000,
    focusThrottleInterval: 5 * 1000,
    dedupingInterval: 2 * 1000,
    loadingTimeout: slowConnection ? 5000 : 3000,
    // providers
    compare: function (currentData, newData) {
        return stableHash(currentData) == stableHash(newData);
    },
    isPaused: function () { return false; },
    cache: cache,
    mutate: mutate,
    fallback: {}
}, 
// use web preset by default
preset);

var mergeConfigs = function (a, b) {
    // Need to create a new object to avoid mutating the original here.
    var v = mergeObjects(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        var u1 = a.use, f1 = a.fallback;
        var u2 = b.use, f2 = b.fallback;
        if (u1 && u2) {
            v.use = u1.concat(u2);
        }
        if (f1 && f2) {
            v.fallback = mergeObjects(f1, f2);
        }
    }
    return v;
};

var SWRConfigContext = (0,react.createContext)({});
var SWRConfig$1 = function (props) {
    var value = props.value;
    // Extend parent context values and middleware.
    var extendedConfig = mergeConfigs((0,react.useContext)(SWRConfigContext), value);
    // Should not use the inherited provider.
    var provider = value && value.provider;
    // Use a lazy initialized state to create the cache on first access.
    var cacheContext = (0,react.useState)(function () {
        return provider
            ? initCache(provider(extendedConfig.cache || cache), value)
            : UNDEFINED;
    })[0];
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    useIsomorphicLayoutEffect(function () { return (cacheContext ? cacheContext[2] : UNDEFINED); }, []);
    return (0,react.createElement)(SWRConfigContext.Provider, mergeObjects(props, {
        value: extendedConfig
    }));
};

/**
 * An implementation of state with dependency-tracking.
 */
var useStateWithDeps = function (state, unmountedRef) {
    var rerender = (0,react.useState)({})[1];
    var stateRef = (0,react.useRef)(state);
    // If a state property (data, error or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    var stateDependenciesRef = (0,react.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    /**
     * @param payload To change stateRef, pass the values explicitly to setState:
     * @example
     * ```js
     * setState({
     *   isValidating: false
     *   data: newData // set data to newData
     *   error: undefined // set error to undefined
     * })
     *
     * setState({
     *   isValidating: false
     *   data: undefined // set data to undefined
     *   error: err // set error to err
     * })
     * ```
     */
    var setState = (0,react.useCallback)(function (payload) {
        var shouldRerender = false;
        var currentState = stateRef.current;
        for (var _ in payload) {
            var k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) {
                    shouldRerender = true;
                }
            }
        }
        if (shouldRerender && !unmountedRef.current) {
            rerender({});
        }
    }, 
    // config.suspense isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update the state reference.
    useIsomorphicLayoutEffect(function () {
        stateRef.current = state;
    });
    return [stateRef, stateDependenciesRef.current, setState];
};

var normalize = function (args) {
    return isFunction(args[1])
        ? [args[0], args[1], args[2] || {}]
        : [args[0], null, (args[1] === null ? args[2] : args[1]) || {}];
};

var useSWRConfig = function () {
    return mergeObjects(defaultConfig, (0,react.useContext)(SWRConfigContext));
};

// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
var withArgs = function (hook) {
    return function useSWRArgs() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // Get the default and inherited configuration.
        var fallbackConfig = useSWRConfig();
        // Normalize arguments.
        var _a = normalize(args), key = _a[0], fn = _a[1], _config = _a[2];
        // Merge configurations.
        var config = mergeConfigs(fallbackConfig, _config);
        // Apply middleware
        var next = hook;
        var use = config.use;
        if (use) {
            for (var i = use.length; i-- > 0;) {
                next = use[i](next);
            }
        }
        return next(key, fn || config.fetcher, config);
    };
};

// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
var subscribeCallback = function (key, callbacks, callback) {
    var keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return function () {
        var index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};

var WITH_DEDUPE = { dedupe: true };
var useSWRHandler = function (_key, fetcher, config) {
    var cache = config.cache, compare = config.compare, fallbackData = config.fallbackData, suspense = config.suspense, revalidateOnMount = config.revalidateOnMount, refreshInterval = config.refreshInterval, refreshWhenHidden = config.refreshWhenHidden, refreshWhenOffline = config.refreshWhenOffline;
    var _a = SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], MUTATION = _a[2], FETCH = _a[3];
    // `key` is the identifier of the SWR `data` state, `keyInfo` holds extra
    // states such as `error` and `isValidating` inside,
    // all of them are derived from `_key`.
    // `fnArgs` is an array of arguments parsed from the key, which will be passed
    // to the fetcher.
    var _b = serialize(_key), key = _b[0], fnArgs = _b[1], keyInfo = _b[2];
    // If it's the initial render of this hook.
    var initialMountedRef = (0,react.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    var unmountedRef = (0,react.useRef)(false);
    // Refs to keep the key and config.
    var keyRef = (0,react.useRef)(key);
    var fetcherRef = (0,react.useRef)(fetcher);
    var configRef = (0,react.useRef)(config);
    var getConfig = function () { return configRef.current; };
    var isActive = function () { return getConfig().isVisible() && getConfig().isOnline(); };
    var patchFetchInfo = function (info) {
        return cache.set(keyInfo, mergeObjects(cache.get(keyInfo), info));
    };
    // Get the current state that SWR should return.
    var cached = cache.get(key);
    var fallback = isUndefined(fallbackData)
        ? config.fallback[key]
        : fallbackData;
    var data = isUndefined(cached) ? fallback : cached;
    var info = cache.get(keyInfo) || {};
    var error = info.error;
    var isInitialMount = !initialMountedRef.current;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    var shouldRevalidate = function () {
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !isUndefined(revalidateOnMount))
            return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused())
            return false;
        return suspense
            ? // Under suspense mode, it will always fetch on render if there is no
                // stale data so no need to revalidate immediately on mount again.
                !isUndefined(data)
            : // If there is no stale data, we need to revalidate on mount;
                // If `revalidateIfStale` is set to true, we will always revalidate.
                isUndefined(data) || config.revalidateIfStale;
    };
    // Resolve the current validating state.
    var resolveValidating = function () {
        if (!key || !fetcher)
            return false;
        if (info.isValidating)
            return true;
        // If it's not mounted yet and it should revalidate on mount, revalidate.
        return isInitialMount && shouldRevalidate();
    };
    var isValidating = resolveValidating();
    var _c = useStateWithDeps({
        data: data,
        error: error,
        isValidating: isValidating
    }, unmountedRef), stateRef = _c[0], stateDependencies = _c[1], setState = _c[2];
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    var revalidate = (0,react.useCallback)(function (revalidateOpts) { return __awaiter(void 0, void 0, void 0, function () {
        var currentFetcher, newData, startAt, loading, opts, shouldStartNewRequest, isCurrentKeyMounted, cleanupState, newState, finishRequestAndUpdateState, mutationInfo, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    currentFetcher = fetcherRef.current;
                    if (!key ||
                        !currentFetcher ||
                        unmountedRef.current ||
                        getConfig().isPaused()) {
                        return [2 /*return*/, false];
                    }
                    loading = true;
                    opts = revalidateOpts || {};
                    shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
                    isCurrentKeyMounted = function () {
                        return !unmountedRef.current &&
                            key === keyRef.current &&
                            initialMountedRef.current;
                    };
                    cleanupState = function () {
                        // Check if it's still the same request before deleting.
                        var requestInfo = FETCH[key];
                        if (requestInfo && requestInfo[1] === startAt) {
                            delete FETCH[key];
                        }
                    };
                    newState = { isValidating: false };
                    finishRequestAndUpdateState = function () {
                        patchFetchInfo({ isValidating: false });
                        // We can only set state if it's safe (still mounted with the same key).
                        if (isCurrentKeyMounted()) {
                            setState(newState);
                        }
                    };
                    // Start fetching. Change the `isValidating` state, update the cache.
                    patchFetchInfo({
                        isValidating: true
                    });
                    setState({ isValidating: true });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    if (shouldStartNewRequest) {
                        // Tell all other hooks to change the `isValidating` state.
                        broadcastState(cache, key, stateRef.current.data, stateRef.current.error, true);
                        // If no cache being rendered currently (it shows a blank page),
                        // we trigger the loading slow event.
                        if (config.loadingTimeout && !cache.get(key)) {
                            setTimeout(function () {
                                if (loading && isCurrentKeyMounted()) {
                                    getConfig().onLoadingSlow(key, config);
                                }
                            }, config.loadingTimeout);
                        }
                        // Start the request and save the timestamp.
                        FETCH[key] = [currentFetcher.apply(void 0, fnArgs), getTimestamp()];
                    }
                    _a = FETCH[key], newData = _a[0], startAt = _a[1];
                    return [4 /*yield*/, newData];
                case 2:
                    newData = _b.sent();
                    if (shouldStartNewRequest) {
                        // If the request isn't interrupted, clean it up after the
                        // deduplication interval.
                        setTimeout(cleanupState, config.dedupingInterval);
                    }
                    // If there're other ongoing request(s), started after the current one,
                    // we need to ignore the current one to avoid possible race conditions:
                    //   req1------------------>res1        (current one)
                    //        req2---------------->res2
                    // the request that fired later will always be kept.
                    // The timestamp maybe be `undefined` or a number
                    if (!FETCH[key] || FETCH[key][1] !== startAt) {
                        if (shouldStartNewRequest) {
                            if (isCurrentKeyMounted()) {
                                getConfig().onDiscarded(key);
                            }
                        }
                        return [2 /*return*/, false];
                    }
                    // Clear error.
                    patchFetchInfo({
                        error: UNDEFINED
                    });
                    newState.error = UNDEFINED;
                    mutationInfo = MUTATION[key];
                    if (!isUndefined(mutationInfo) &&
                        // case 1
                        (startAt <= mutationInfo[0] ||
                            // case 2
                            startAt <= mutationInfo[1] ||
                            // case 3
                            mutationInfo[1] === 0)) {
                        finishRequestAndUpdateState();
                        if (shouldStartNewRequest) {
                            if (isCurrentKeyMounted()) {
                                getConfig().onDiscarded(key);
                            }
                        }
                        return [2 /*return*/, false];
                    }
                    // Deep compare with latest state to avoid extra re-renders.
                    // For local state, compare and assign.
                    if (!compare(stateRef.current.data, newData)) {
                        newState.data = newData;
                    }
                    else {
                        // data and newData are deeply equal
                        // it should be safe to broadcast the stale data
                        newState.data = stateRef.current.data;
                        // At the end of this function, `brocastState` invokes the `onStateUpdate` function,
                        // which takes care of avoiding the re-render
                    }
                    // For global state, it's possible that the key has changed.
                    // https://github.com/vercel/swr/pull/1058
                    if (!compare(cache.get(key), newData)) {
                        cache.set(key, newData);
                    }
                    // Trigger the successful callback if it's the original request.
                    if (shouldStartNewRequest) {
                        if (isCurrentKeyMounted()) {
                            getConfig().onSuccess(newData, key, config);
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    cleanupState();
                    // Not paused, we continue handling the error. Otherwise discard it.
                    if (!getConfig().isPaused()) {
                        // Get a new error, don't use deep comparison for errors.
                        patchFetchInfo({ error: err_1 });
                        newState.error = err_1;
                        // Error event and retry logic. Only for the actual request, not
                        // deduped ones.
                        if (shouldStartNewRequest && isCurrentKeyMounted()) {
                            getConfig().onError(err_1, key, config);
                            if ((typeof config.shouldRetryOnError === 'boolean' &&
                                config.shouldRetryOnError) ||
                                (isFunction(config.shouldRetryOnError) &&
                                    config.shouldRetryOnError(err_1))) {
                                // When retrying, dedupe is always enabled
                                if (isActive()) {
                                    // If it's active, stop. It will auto revalidate when refocusing
                                    // or reconnecting.
                                    getConfig().onErrorRetry(err_1, key, config, revalidate, {
                                        retryCount: (opts.retryCount || 0) + 1,
                                        dedupe: true
                                    });
                                }
                            }
                        }
                    }
                    return [3 /*break*/, 4];
                case 4:
                    // Mark loading as stopped.
                    loading = false;
                    // Update the current hook's state.
                    finishRequestAndUpdateState();
                    // Here is the source of the request, need to tell all other hooks to
                    // update their states.
                    if (isCurrentKeyMounted() && shouldStartNewRequest) {
                        broadcastState(cache, key, newState.data, newState.error, false);
                    }
                    return [2 /*return*/, true];
            }
        });
    }); }, 
    // `setState` is immutable, and `eventsCallback`, `fnArgs`, `keyInfo`,
    // and `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [key]);
    // Similar to the global mutate, but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var boundMutate = (0,react.useCallback)(
    // By using `bind` we don't need to modify the size of the rest arguments.
    // Due to https://github.com/microsoft/TypeScript/issues/37181, we have to
    // cast it to any for now.
    internalMutate.bind(UNDEFINED, cache, function () { return keyRef.current; }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update fetcher and config refs.
    useIsomorphicLayoutEffect(function () {
        fetcherRef.current = fetcher;
        configRef.current = config;
    });
    // After mounted or key changed.
    useIsomorphicLayoutEffect(function () {
        if (!key)
            return;
        var keyChanged = key !== keyRef.current;
        var softRevalidate = revalidate.bind(UNDEFINED, WITH_DEDUPE);
        // Expose state updater to global event listeners. So we can update hook's
        // internal state from the outside.
        var onStateUpdate = function (updatedData, updatedError, updatedIsValidating) {
            setState(mergeObjects({
                error: updatedError,
                isValidating: updatedIsValidating
            }, 
            // Since `setState` only shallowly compares states, we do a deep
            // comparison here.
            compare(stateRef.current.data, updatedData)
                ? UNDEFINED
                : {
                    data: updatedData
                }));
        };
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        var nextFocusRevalidatedAt = 0;
        var onRevalidate = function (type) {
            if (type == FOCUS_EVENT) {
                var now = Date.now();
                if (getConfig().revalidateOnFocus &&
                    now > nextFocusRevalidatedAt &&
                    isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            }
            else if (type == RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) {
                    softRevalidate();
                }
            }
            else if (type == MUTATE_EVENT) {
                return revalidate();
            }
            return;
        };
        var unsubUpdate = subscribeCallback(key, STATE_UPDATERS, onStateUpdate);
        var unsubEvents = subscribeCallback(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // When `key` updates, reset the state to the initial value
        // and trigger a rerender if necessary.
        if (keyChanged) {
            setState({
                data: data,
                error: error,
                isValidating: isValidating
            });
        }
        // Trigger a revalidation.
        if (shouldRevalidate()) {
            if (isUndefined(data) || IS_SERVER) {
                // Revalidate immediately.
                softRevalidate();
            }
            else {
                // Delay the revalidate if we have data to return so we won't block
                // rendering.
                rAF(softRevalidate);
            }
        }
        return function () {
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubUpdate();
            unsubEvents();
        };
    }, [key, revalidate]);
    // Polling
    useIsomorphicLayoutEffect(function () {
        var timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            var interval = isFunction(refreshInterval)
                ? refreshInterval(data)
                : refreshInterval;
            // We only start next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) {
                timer = setTimeout(execute, interval);
            }
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online and not errored.
            if (!stateRef.current.error &&
                (refreshWhenHidden || getConfig().isVisible()) &&
                (refreshWhenOffline || getConfig().isOnline())) {
                revalidate(WITH_DEDUPE).then(next);
            }
            else {
                // Schedule next interval to check again.
                next();
            }
        }
        next();
        return function () {
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [refreshInterval, refreshWhenHidden, refreshWhenOffline, revalidate]);
    // Display debug info in React DevTools.
    (0,react.useDebugValue)(data);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && isUndefined(data) && key) {
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        throw isUndefined(error) ? revalidate(WITH_DEDUPE) : error;
    }
    return {
        mutate: boundMutate,
        get data() {
            stateDependencies.data = true;
            return data;
        },
        get error() {
            stateDependencies.error = true;
            return error;
        },
        get isValidating() {
            stateDependencies.isValidating = true;
            return isValidating;
        }
    };
};
var SWRConfig = OBJECT.defineProperty(SWRConfig$1, 'default', {
    value: defaultConfig
});
var unstable_serialize = function (key) { return serialize(key)[0]; };
var dist_useSWR = withArgs(useSWRHandler);

// useSWR



;// CONCATENATED MODULE: ./lib/hooks/useLanguageStrings.ts

var fetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    });
};
var useLanguageStrings = function() {
    var url = 'https://config.foxdcg.com/foxnow/web/lang/strings-en_US.json';
    var ref = dist_useSWR(url, fetcher, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    }), data = ref.data, error = ref.error;
    return {
        language_strings_en_US: data,
        isLoading: !error && !data,
        isError: error
    };
};
/* harmony default export */ var hooks_useLanguageStrings = (useLanguageStrings);

// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(1407);
;// CONCATENATED MODULE: ./lib/hooks/useExternalStrings.ts
//TODO This should only be used on non-sesitive information


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useExternalStrings_fetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    });
};
var getBrandConst = _defineProperty({}, constants/* Brand.SPORTS */.H2.SPORTS, constants/* ExternalBrand.SPORTS */.O3.SPORTS);
var _obj;
var getENVConstFile = (_obj = {}, _defineProperty(_obj, constants/* ENVS.PRODUCTION */.CG.PRODUCTION, constants/* ExternalENVFile.PRODUCTION */.it.PRODUCTION), _defineProperty(_obj, constants/* ENVS.STAGE */.CG.STAGE, constants/* ExternalENVFile.STAGE */.it.STAGE), _defineProperty(_obj, constants/* ENVS.DEV */.CG.DEV, constants/* ExternalENVFile.DEV */.it.DEV), _obj);
var useExternalStrings = function() {
    var brandConst = getBrandConst[Brand.SPORTS];
    var envConstFile = getENVConstFile["production" || 0];
    // This URL should be changed to another nondetermental URL
    var url = "https://config.foxdcg.com/".concat(brandConst, "/ssa/").concat(envConstFile);
    var ref = useSWR(url, useExternalStrings_fetcher, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    }), data = ref.data, error = ref.error;
    return {
        externalConfig: data,
        isLoading: !error && !data,
        isError: error
    };
};
/* harmony default export */ var hooks_useExternalStrings = ((/* unused pure expression or super */ null && (useExternalStrings)));

;// CONCATENATED MODULE: ./lib/hooks/index.ts









/***/ }),

/***/ 9697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(708);
/* harmony import */ var context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1387);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1407);




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function useFlowManager() {
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''), code = ref12[0], setCode = ref12[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isNew = ref1[0], setIsNew = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isMVPD = ref2[0], setIsMVPD = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isAnonymous = ref3[0], setIsAnonymous = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''), accessToken = ref4[0], setAccessToken = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isNoCodeOrAccount = ref5[0], setIsNoCodeOrAccount = ref5[1];
    var ref6 = _slicedToArray((0,react_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)([
        constants_index__WEBPACK_IMPORTED_MODULE_2__/* .ACCOUNT_COOKIE_NAME_FOX */ .EO,
        constants_index__WEBPACK_IMPORTED_MODULE_2__/* .COOKIE_CODE_INFO */ .r5, 
    ]), 3), cookies = ref6[0], setCookie = ref6[1], removeCookie = ref6[2];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .I), _state = ref7.state, _isRegister = _state.isRegister, isRegister = _isRegister.value, flowStage = _state.flowStage;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var ref, ref8, ref9, ref10, ref11;
        setIsNoCodeOrAccount(!cookies[constants_index__WEBPACK_IMPORTED_MODULE_2__/* .COOKIE_CODE_INFO */ .r5] || !cookies[constants_index__WEBPACK_IMPORTED_MODULE_2__/* .ACCOUNT_COOKIE_NAME_FOX */ .EO]);
        setCode((ref = cookies[constants_index__WEBPACK_IMPORTED_MODULE_2__/* .COOKIE_CODE_INFO */ .r5]) === null || ref === void 0 ? void 0 : ref.code);
        setAccessToken((ref8 = cookies[constants_index__WEBPACK_IMPORTED_MODULE_2__/* .ACCOUNT_COOKIE_NAME_FOX */ .EO]) === null || ref8 === void 0 ? void 0 : ref8.accessToken);
        setIsMVPD((ref9 = cookies[constants_index__WEBPACK_IMPORTED_MODULE_2__/* .COOKIE_CODE_INFO */ .r5]) === null || ref9 === void 0 ? void 0 : ref9.isMvpd);
        setIsAnonymous((ref10 = cookies[constants_index__WEBPACK_IMPORTED_MODULE_2__/* .COOKIE_CODE_INFO */ .r5]) === null || ref10 === void 0 ? void 0 : ref10.isAnonymous);
        setIsNew((ref11 = cookies[constants_index__WEBPACK_IMPORTED_MODULE_2__/* .ACCOUNT_COOKIE_NAME_FOX */ .EO]) === null || ref11 === void 0 ? void 0 : ref11.isNew);
    }, [
        cookies,
        isRegister
    ]);
    return {
        accountType: '',
        isAnonymous: isAnonymous,
        accessToken: accessToken,
        code: code,
        cookies: cookies,
        isNew: isNew,
        isMVPD: isMVPD,
        isNoCodeOrAccount: isNoCodeOrAccount,
        setIsNoCodeOrAccount: setIsNoCodeOrAccount,
        removeCookie: removeCookie,
        setCookie: setCookie,
        flowStage: flowStage
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useFlowManager);


/***/ }),

/***/ 2670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vc": function() { return /* binding */ config; },
/* harmony export */   "Vc": function() { return /* binding */ profileConfig; },
/* harmony export */   "CL": function() { return /* binding */ setUpdatedProfile; },
/* harmony export */   "Aj": function() { return /* binding */ analyticsConfig; },
/* harmony export */   "se": function() { return /* binding */ isIntegrationApi; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5501);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1407);
/* harmony import */ var _getConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(889);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9981);
/* harmony import */ var _getProfileSdkResponse__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6357);
/* harmony import */ var _package_json__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4147);
/* provided dependency */ var process = __webpack_require__(3454);







function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var cookies = new react_cookie__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z();
var config = _objectSpread({}, (0,_getConfig__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)(), {
    API_KEY: 'cf289e299efdfa39fb6316f259d1de93',
    ENVIRONMENT: 'dev',
    BRAND: '',
    COOKIE_DEVICE_ID: 'sample_app_device_id',
    COOKIE_ACCESS_TOKEN: 'sample_app_cookie_access_token',
    COOKIE_PROFILE_ID: 'sample_app_cookie_profile_id',
    SECONDS_FOR_24_HOURS: 60 * 60 * 24,
    FACEBOOK_APP_ID: '441830202634558',
    APPLE_CLIENT_ID: 'com.fox.now.siwa',
    GOOGLE_CLIENT_ID: '408795325691-2ahbapehgrqg94i9h7un5e0mj0gl8c76.apps.googleusercontent.com'
});
var profileConfig = _objectSpread({}, config, {
    apiKey: process.env.NEXT_PUBLIC_API_KEY || config.API_KEY,
    environment: "production" || 0,
    profileId: process.env.NEXT_PUBLIC_COOKIE_PROFILE_ID || config.COOKIE_PROFILE_ID,
    appName: 'Fox',
    appVersion: _package_json__WEBPACK_IMPORTED_MODULE_5__/* .version */ .i8,
    baseUrl: cookies.getAll().DEBUG_PANEL_API_BASEURL === constants_index__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_PANEL_API_INTEGRATION */ .uv ? constants_index__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_PANEL_API_BASEURL_INT */ .Hi : process.env.NEXT_PUBLIC_API_BASE_URL || "https://api3.fox.com/v2.0" || 0
});
var setUpdatedProfile = function() {
    var _ref = _asyncToGenerator(_home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(accessToken) {
        var profile;
        return _home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    profile = (0,_getProfileSdkResponse__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(profileConfig);
                    _ctx.t0 = _helper__WEBPACK_IMPORTED_MODULE_3__.setConfigToProfile;
                    _ctx.next = 4;
                    return profile;
                case 4:
                    _ctx.t1 = _ctx.sent;
                    _ctx.t2 = {
                        appName: profileConfig.appName,
                        appVersion: profileConfig.appVersion,
                        accessToken: accessToken || ''
                    };
                    _ctx.next = 8;
                    return (0, _ctx.t0)(_ctx.t1, _ctx.t2);
                case 8:
                    return _ctx.abrupt("return", _ctx.sent);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function setUpdatedProfile(accessToken) {
        return _ref.apply(this, arguments);
    };
}();
var analyticsConfig = {
    segmentKey: false
};
var isIntegrationApi = function() {
    return cookies.getAll().DEBUG_PANEL_API_BASEURL === constants_index__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_PANEL_API_INTEGRATION */ .uv || process.env.NEXT_PUBLIC_API_BASE_URL === constants_index__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_PANEL_API_BASEURL_INT */ .Hi;
};


/***/ }),

/***/ 889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ getConfig; }
});

;// CONCATENATED MODULE: ./config/json/remoteConfig.json
var remoteConfig_namespaceObject = JSON.parse('{"apiUrl":"https://api3.fox.com/v2.0","siteUrl":"https://www.foxsports.com","registrationUrl":"http://go.foxsports.com","loginHelpUrl":"https://help.fox.com/fox/s/topic/0TO1H000000HHcIWAW/fox-sports-tv-provider","topProvidersUrl":"https://api3.fox.com/v2.0/mvpds?itemsPerPage=9","allProvidersUrl":"https://api3.fox.com/v2.0/mvpds?itemsPerPage=2000&_fields=id,adobePassId,name,logos,code","adobeId":"fbc-fox","additionalDevices":{"web":{"providers-key":"xKVbwnZ794xXP6nTbXFz0HcbSfxQDo20","display-name":"Web"}},"devices":{"android-tv":{"private_key":"hbni91YAYqrdvpEC","public_key":"EP2yuzGJ0ocrkAGQ95z9KW5xtibgnHxO","display-name":"Android TV","providers-key":"wefzlsJHalzbAjkO37fnZ7aUkwiqT030"},"tvos":{"private_key":"sIdRm4jYEqpiyf4u","public_key":"QGLHodIjn8vqPHSGK7ybU9B0P5CBjyr0","display-name":"TVOS","providers-key":"11NNxmnTwya3ssk9PgwR61D231txrSMR"},"fire-tv":{"private_key":"qT9SvbkTYWxZ2f7g","public_key":"X15i9QYwOvMPRF86QgYpeGOkWtYPeGFB","display-name":"Fire TV","providers-key":"CHhbpefQXoi2lbM7sp86mZ3MmfZIFg51"},"roku":{"private_key":"khhSdpRmYIxLFAeP","public_key":"jCbU34T7RnfSG9Jy4GhVGB6arzaAQleM","display-name":"Roku","providers-key":"5YDBGT0Qm4hgdy6ygx3z5bf7DxgSFcgl"},"samsung-smart-tv":{"private_key":"7RPRwMTbPofVae57","public_key":"FAhOk9yhMAdKMz8r0yWTzbz8MZyojuWa","display-name":"Samsung Smart TV","providers-key":"b430ae43fa302f61eaf2e9acb165c922"},"vizio":{"private_key":"","public_key":"","display-name":"Vizio","providers-key":"vKawWsXbqOLfqG9Vhgx4FpfFTa3TLzzF"},"xbox-one":{"private_key":"YqGMpQa1nrU5EbXy","public_key":"GNRLhooSxqtrmhIGr9MWNbq30cjcOpHo","display-name":"XBOX One","providers-key":"sk9PgwR61D231txrSMReHtyEqLdvvnUQ"}},"dataDog":{"applicationId":"c227f459-aa27-4c70-aa46-cd43a42e627e","clientToken":"pubbb82e0321f70216114ac26061ff21b83","site":"datadoghq.com","env":"prod"}}');
var json_remoteConfig_namespaceObject = /*#__PURE__*/__webpack_require__.t(remoteConfig_namespaceObject, 2);
;// CONCATENATED MODULE: ./lib/utils/getConfig.ts

var getConfig = function() {
    return json_remoteConfig_namespaceObject;
};


/***/ }),

/***/ 6357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_utils_logReportHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1184);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var getProfileSdkResponse = function() {
    var _ref = _asyncToGenerator(_home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(configs) {
        var ref, ProfileConfig, Profile, config, responseError;
        return _home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return __webpack_require__.e(/* import() */ 396).then(__webpack_require__.t.bind(__webpack_require__, 396, 23));
                case 3:
                    ref = _ctx.sent;
                    ProfileConfig = ref.ProfileConfig;
                    Profile = ref.Profile;
                    config = new ProfileConfig(configs);
                    return _ctx.abrupt("return", new Profile(config));
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    responseError = 'Profile Mounting Error';
                    (0,lib_utils_logReportHelper__WEBPACK_IMPORTED_MODULE_1__/* .logError */ .H)(_ctx.t0, {
                        name: responseError
                    });
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }));
    return function getProfileSdkResponse(configs) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (getProfileSdkResponse);


/***/ }),

/***/ 9981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ts": function() { return /* binding */ ts; },
/* harmony export */   "uuidv4": function() { return /* binding */ uuidv4; },
/* harmony export */   "setConfigToProfile": function() { return /* binding */ setConfigToProfile; },
/* harmony export */   "tokenValid": function() { return /* binding */ tokenValid; },
/* harmony export */   "cleanObject": function() { return /* binding */ cleanObject; },
/* harmony export */   "setAccountCookie": function() { return /* binding */ setAccountCookie; },
/* harmony export */   "displayNationAccountEnvURL": function() { return /* binding */ displayNationAccountEnvURL; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5501);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1407);



function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// native Classnames or clsx
var ts = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var template = [];
    args.forEach(function(arg) {
        if (arg.join()) {
            template = _toConsumableArray(template).concat(_toConsumableArray(arg));
            return;
        }
        var entries = Object.entries(arg);
        if (entries.length) {
            entries.forEach(function(entry) {
                if (entry[1]) template.push(entry[0]);
            });
        }
    });
    return template.join(' ');
};
var uuidv4 = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 3 | 8;
        return v.toString(16);
    });
};
var setConfigToProfile = function() {
    var _ref = _asyncToGenerator(_home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(profile, newConfig) {
        var ref, ProfileConfig, Profile, config;
        return _home_runner_work_go_foxsports_com_go_foxsports_com_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return __webpack_require__.e(/* import() */ 396).then(__webpack_require__.t.bind(__webpack_require__, 396, 23));
                case 3:
                    ref = _ctx.sent;
                    ProfileConfig = ref.ProfileConfig;
                    Profile = ref.Profile;
                    _ctx.next = 8;
                    return new ProfileConfig(_objectSpread({}, profile === null || profile === void 0 ? void 0 : profile.config, newConfig));
                case 8:
                    config = _ctx.sent;
                    _ctx.next = 11;
                    return new Profile(config);
                case 11:
                    return _ctx.abrupt("return", _ctx.sent);
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                14
            ]
        ]);
    }));
    return function setConfigToProfile(profile, newConfig) {
        return _ref.apply(this, arguments);
    };
}();
var tokenValid = function() {
    var token = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var iat = token.iat, exp = token.exp;
    var now = Date.now() / 1000;
    if (iat && exp) {
        var expiry = iat + exp - 60;
        return now < expiry || iat !== exp;
    }
};
var cleanObject = function() {
    var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Object.entries(obj).reduce(function(newObj, param) {
        var _param = _slicedToArray(param, 2), key = _param[0], tmp = _param[1], value = tmp === void 0 ? null : tmp;
        var ref;
        if (typeof value !== 'string' && !Array.isArray(value) && Object.keys((ref = value) !== null && ref !== void 0 ? ref : {}).length) {
            return _objectSpread({}, newObj, _defineProperty({}, key, cleanObject(value)));
        }
        if ([
            0,
            false
        ].includes(value) || value) {
            return _objectSpread({}, newObj, _defineProperty({}, key, value));
        }
        return newObj;
    }, {});
};
var setAccountCookie = function(value) {
    var ref, ref1, ref2;
    var cookies = new react_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z();
    var now = new Date().getTime();
    var expires = new Date(now + constants_index__WEBPACK_IMPORTED_MODULE_1__/* .ACTIVATE_CODE_EXPIRES_MINUTES */ .St * 60000);
    var domainName = (ref2 = window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : (ref1 = ref.hostname) === null || ref1 === void 0 ? void 0 : ref1.match(/([a-z0-9-]*?)\.[a-z]{2,}$/)) === null || ref2 === void 0 ? void 0 : ref2[1];
    var updatedVal = _objectSpread({}, value);
    // can't set cookie with this field
    delete updatedVal.idToken;
    cookies.set(constants_index__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_COOKIE_NAME_FOX */ .EO, updatedVal, {
        path: constants_index__WEBPACK_IMPORTED_MODULE_1__/* .ROUTE_HOME */ .XX,
        domain: ".".concat(domainName, ".com"),
        expires: expires
    });
};
var displayNationAccountEnvURL = function() {
    if ("production" === constants_index__WEBPACK_IMPORTED_MODULE_1__/* .ENVS.PRODUCTION */ .CG.PRODUCTION) {
        return "https://nation.foxnews.com".concat(constants_index__WEBPACK_IMPORTED_MODULE_1__/* .ROUTE_ACCOUNT_NATION */ .hd);
    }
    return "https://".concat("production", "-nation.foxnews.com/account/signin/tv/");
};


/***/ }),

/***/ 1184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ logError; }
/* harmony export */ });
/* harmony import */ var _datadog_browser_rum__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6136);

var logError = function(error, errProps) {
    _datadog_browser_rum__WEBPACK_IMPORTED_MODULE_0__/* .datadogRum.addError */ .v.addError(error, errProps);
};


/***/ }),

/***/ 8418:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
__webpack_unused_export__ = ({
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(7294));
var _router = __webpack_require__(6273);
var _router1 = __webpack_require__(387);
var _useIntersection = __webpack_require__(7190);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === 'A';
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    // replace state instead of push if prop is present
    router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
    });
}
function Link(props) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var p = props.prefetch !== false;
    var router = (0, _router1).useRouter();
    var ref2 = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, props.href, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: props.as ? (0, _router).resolveHref(router, props.as) : resolvedAs || resolvedHref
        };
    }, [
        router,
        props.href,
        props.as
    ]), href = ref2.href, as = ref2.as;
    var children = props.children, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale;
    if (typeof children === 'string') {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (false) {} else {
        child = _react.default.Children.only(children);
    }
    var childRef = child && typeof child === 'object' && child.ref;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: '200px'
    }), 2), setIntersectionRef = ref1[0], isVisible = ref1[1];
    var setRef = _react.default.useCallback(function(el) {
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === 'function') childRef(el);
            else if (typeof childRef === 'object') {
                childRef.current = el;
            }
        }
    }, [
        childRef,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
        var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (child.props && typeof child.props.onClick === 'function') {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale);
            }
        }
    };
    childProps.onMouseEnter = function(e) {
        if (child.props && typeof child.props.onMouseEnter === 'function') {
            child.props.onMouseEnter(e);
        }
        if ((0, _router).isLocalURL(href)) {
            prefetch(router, href, as, {
                priority: true
            });
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (props.passHref || child.type === 'a' && !('href' in child.props)) {
        var curLocale1 = typeof locale !== 'undefined' ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _router).getDomainLocale(as, curLocale1, router && router.locales, router && router.domainLocales);
        childProps.href = localeDomain || (0, _router).addBasePath((0, _router).addLocale(as, curLocale1, router && router.defaultLocale));
    }
    return(/*#__PURE__*/ _react.default.cloneElement(child, childProps));
}
var _default = Link;
exports["default"] = _default; //# sourceMappingURL=link.js.map


/***/ }),

/***/ 7190:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(7294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver !== 'undefined';
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var unobserve = (0, _react).useRef();
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(rootRef ? rootRef.current : null), 2), root = ref1[0], setRoot = ref1[1];
    var setRef = (0, _react).useCallback(function(el) {
        if (unobserve.current) {
            unobserve.current();
            unobserve.current = undefined;
        }
        if (isDisabled || visible) return;
        if (el && el.tagName) {
            unobserve.current = observe(el, function(isVisible) {
                return isVisible && setVisible(isVisible);
            }, {
                root: root,
                rootMargin: rootMargin
            });
        }
    }, [
        isDisabled,
        root,
        rootMargin,
        visible
    ]);
    (0, _react).useEffect(function() {
        if (!hasIntersectionObserver) {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        visible
    ]);
    (0, _react).useEffect(function() {
        if (rootRef) setRoot(rootRef.current);
    }, [
        rootRef
    ]);
    return [
        setRef,
        visible
    ];
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ''
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
    } else {
        instance = observers.get(id);
        idList.push(id);
    }
    if (instance) {
        return instance;
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    observers.set(id, instance = {
        id: id,
        observer: observer,
        elements: elements
    });
    return instance;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 8751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(5885);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/CookiesContext.js
var CookiesContext = __webpack_require__(5163);
;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/CookiesProvider.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var CookiesProvider = /** @class */ (function (_super) {
    __extends(CookiesProvider, _super);
    function CookiesProvider(props) {
        var _this = _super.call(this, props) || this;
        if (props.cookies) {
            _this.cookies = props.cookies;
        }
        else {
            _this.cookies = new es6/* default */.Z();
        }
        return _this;
    }
    CookiesProvider.prototype.render = function () {
        return react.createElement(CookiesContext/* Provider */.zt, { value: this.cookies }, this.props.children);
    };
    return CookiesProvider;
}(react.Component));
/* harmony default export */ var es6_CookiesProvider = (CookiesProvider);

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(5666);
// EXTERNAL MODULE: ./context/GlobalContextProvider.tsx
var GlobalContextProvider = __webpack_require__(1387);
// EXTERNAL MODULE: ./lib/utils/configs.ts
var configs = __webpack_require__(2670);
// EXTERNAL MODULE: ./lib/utils/getConfig.ts + 1 modules
var getConfig = __webpack_require__(889);
// EXTERNAL MODULE: ./lib/hooks/index.ts + 6 modules
var hooks = __webpack_require__(8113);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-rum/esm/entries/main.js + 101 modules
var main = __webpack_require__(6136);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(1407);
// EXTERNAL MODULE: ./package.json
var package_0 = __webpack_require__(4147);
;// CONCATENATED MODULE: ./lib/utils/initializeDataDog.ts



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var getBrandService = _defineProperty({}, constants/* Brand.SPORTS */.H2.SPORTS, constants/* DataDogService.SPORTS */.xD.SPORTS);
function initializeDataDog() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (config) {
        var applicationId = config.applicationId, clientToken = config.clientToken, env = config.env, site = config.site;
        main/* datadogRum.init */.v.init({
            applicationId: applicationId,
            clientToken: clientToken,
            site: site,
            service: getBrandService[constants/* Brand.SPORTS */.H2.SPORTS],
            env: env,
            version: package_0/* version */.i8,
            sampleRate: 100,
            trackInteractions: true,
            defaultPrivacyLevel: 'mask-user-input'
        });
        main/* datadogRum.startSessionReplayRecording */.v.startSessionReplayRecording();
    }
};

// EXTERNAL MODULE: ./node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var react_error_boundary_umd = __webpack_require__(5800);
// EXTERNAL MODULE: ./context/state/reducer.ts + 1 modules
var reducer = __webpack_require__(2807);
;// CONCATENATED MODULE: ./components/common/ErrorBoundaryProvider/index.tsx





var ErrorFallback = function(param) {
    var error = param.error, resetErrorBoundary = param.resetErrorBoundary;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        role: "alert",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Something went wrong:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                children: error.message
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: resetErrorBoundary,
                children: "Try again"
            })
        ]
    });
};
var ErrorBoundaryProvider = function(param) {
    var children = param.children;
    var dispatch = (0,react.useContext)(GlobalContextProvider/* AppContext */.I).dispatch;
    var handleBoundaryError = function(error, info) {
        dispatch((0,reducer/* setError */.sT)({
            error: error,
            info: info
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react_error_boundary_umd.ErrorBoundary, {
        FallbackComponent: ErrorFallback,
        onError: handleBoundaryError,
        children: children
    }));
};
/* harmony default export */ var common_ErrorBoundaryProvider = (ErrorBoundaryProvider);

// EXTERNAL MODULE: ./components/common/Layout/index.tsx
var Layout = __webpack_require__(4367);
// EXTERNAL MODULE: ./node_modules/normalize.css/normalize.css
var normalize = __webpack_require__(5112);
// EXTERNAL MODULE: ./styles/colors.ts
var colors = __webpack_require__(2317);
// EXTERNAL MODULE: ./styles/helper.ts + 1 modules
var helper = __webpack_require__(9900);
;// CONCATENATED MODULE: ./styles/GlobalStyles.ts




function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "  \n      padding-top: 3.5rem;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  * {\n    box-sizing: border-box;\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    word-break: break-all;\n    word-break: break-word;\n    hyphens: auto;\n  }\n  html,\n  body {\n    padding: 0;\n    margin: 0;\n    color: ",
        ";\n    font-family: 'Graphik', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu,\n    Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n  }\n\n  body {\n    height: 100vh;\n    background: ",
        ";\n  }\n\n  a {\n    display: inherit;\n    color: inherit;\n    text-decoration: none;\n  }\n\n  main {\n    height: 80vh;\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    padding-top: 1.5rem;\n    margin: 0 1.5rem;\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var GlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject1(), colors/* default.white */.Z.white, colors/* default.body */.Z.body, helper/* respondTo.bp_767 */.s.bp_767(_templateObject()));
/* harmony default export */ var GlobalStyles = (GlobalStyle);

;// CONCATENATED MODULE: ./styles/fonts.ts

function fonts_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function fonts_templateObject() {
    var data = fonts_taggedTemplateLiteral([
        "\n\n  // graphik-400\n  @font-face {\n    font-family: 'Graphik';\n    src: url(data:application/font-woff;base64,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);\n    font-weight: 400;\n    font-style: normal;\n  }\n\n  // graphik-500\n  @font-face {\n    font-family: 'Graphik';\n    src: url(data:application/font-woff;base64,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);\n    font-weight: 500;\n    font-style: normal;\n  }\n\n  // graphik-700\n  @font-face {\n    font-family: 'Graphik';\n    src: url(data:application/font-woff;base64,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);\n    font-weight: 700;\n    font-style: normal;\n  }\n\n  @font-face {\n    font-family: 'Graphik-Black';\n    src: url('/static/fonts/Graphik-Black.woff2') format('woff2'),\n    url('/static/fonts/Graphik-Black.woff') format('woff');\n    font-weight: 800;\n    font-style: normal;\n    font-stretch: normal;\n  }\n\n  @font-face {\n    font-family: 'Graphik-Bold';\n    src: url('/static/fonts/Graphik-Bold.woff2') format('woff2'),\n    url('/static/fonts/Graphik-Bold.woff') format('woff');\n    font-weight: 700;\n    font-style: normal;\n    font-stretch: normal;\n  }\n\n  @font-face {\n    font-family: 'Graphik-Extralight';\n    src: url('/static/fonts/Graphik-Extralight.woff2') format('woff2'),\n    url('/static/fonts/Graphik-Extralight.woff') format('woff');\n    font-weight: 200;\n    font-style: normal;\n    font-stretch: normal;\n  }\n\n  @font-face {\n    font-family: 'Graphik-Light';\n    src: url('/static/fonts/Graphik-Light.woff2') format('woff2'),\n    url('/static/fonts/Graphik-Light.woff') format('woff');\n    font-weight: 300;\n    font-style: normal;\n    font-stretch: normal;\n  }\n\n  @font-face {\n    font-family: 'Graphik-Medium';\n    src: url('/static/fonts/Graphik-Medium.woff2') format('woff2'),\n    url('/static/fonts/Graphik-Medium.woff') format('woff');\n    font-weight: 500;\n    font-style: normal;\n    font-stretch: normal;\n  }\n\n  @font-face {\n    font-family: 'Graphik-Regular';\n    src: url('/static/fonts/Graphik-Regular.woff2') format('woff2'),\n    url('/static/fonts/Graphik-Regular.woff') format('woff');\n    font-weight: 400;\n    font-style: normal;\n    font-stretch: normal;\n  }\n\n  @font-face {\n    font-family: 'Graphik-Semibold';\n    src: url('/static/fonts/Graphik-Semibold.woff2') format('woff2'),\n    url('/static/fonts/Graphik-Semibold.woff') format('woff');\n    font-weight: 600;\n    font-style: normal;\n    font-stretch: normal;\n  }\n\n  @font-face {\n    font-family: 'Graphik-Super';\n    src: url('/static/fonts/Graphik-Super.woff2') format('woff2'),\n    url('/static/fonts/Graphik-Super.woff') format('woff');\n    font-weight: 900;\n    font-style: normal;\n    font-stretch: normal;\n  }\n\n  @font-face {\n    font-family: 'Graphik-Thin';\n    src: url('/static/fonts/Graphik-Thin.woff2') format('woff2'),\n    url('/static/fonts/Graphik-Thin.woff') format('woff');\n    font-weight: 100;\n    font-style: normal;\n    font-stretch: normal;\n  }\n\n"
    ]);
    fonts_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var FontStyles = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(fonts_templateObject());
/* harmony default export */ var fonts = (FontStyles);

;// CONCATENATED MODULE: ./pages/_app.page.tsx














function _app_page_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _app_page_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _app_page_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _app_page_templateObject() {
    var data = _app_page_taggedTemplateLiteral([
        "\n  position: fixed;\n  bottom: 20px;\n  right: 40px;\n  opacity: 0.4;\n"
    ]);
    _app_page_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var App = function(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var profile = (0,hooks/* useGetProfileSdk */.Iw)(configs/* profileConfig */.Vc);
    var config = (0,getConfig/* getConfig */.i)();
    (0,react.useEffect)(function() {
        config && initializeDataDog(config.dataDog);
    }, [
        config
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es6_CookiesProvider, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalContextProvider/* GlobalContextProvider */.n, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_ErrorBoundaryProvider, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _objectSpread({
                                    config: config,
                                    profile: profile
                                }, pageProps)),
                                (0,configs/* isIntegrationApi */.se)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(Integration, {
                                    children: "Integration API: https://int1.api3.fox.com/v2.0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyles, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fonts, {})
                    ]
                })
            })
        })
    }));
};
/* harmony default export */ var _app_page = (App);
var Integration = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-76e04ff9-0"
})(_app_page_templateObject());


/***/ }),

/***/ 2317:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var color = {
    altoLight: '#d8d8d8',
    azureRadiance: '#007ee4',
    black: '#000000',
    bluePrimary: '#0086bd',
    border: '1px solid #0059B5',
    endeavour: '#0059B5',
    error: '#d0021b',
    errorRed: '#d0021b',
    header: 'linear-gradient(to right top, #0b1219 0%, #1b222a) fixed',
    Monza: '#d0021b',
    sanMarino: '#4267b2',
    sportsGradientBodyBackground: 'linear-gradient(to right top, #000409,rgb(29 34 39 / 98%)) fixed',
    transparent: 'transparent',
    white: '#ffffff',
    white05: 'rgba(255, 255, 255, 0.05)',
    white10: 'rgba(255, 255, 255, 0.1)',
    white25: 'rgba(255, 255, 255, 0.25)',
    white50: 'rgba(255, 255, 255, 0.5)',
    body: 'linear-gradient(to right top, #000409,rgb(29 34 39 / 98%)) fixed',
    button: {
        background: '#0059B5',
        backgroundHover: '#FFFFFF',
        disabled: '#FFFFFF',
        hollowBg: 'transparent',
        hollowBorder: '1px solid white',
        text: '#FFFFFF',
        textHover: '#000000'
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (color);


/***/ }),

/***/ 9900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ respondTo; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
;// CONCATENATED MODULE: ./styles/breakpoints.ts
var breakpoints = {
    xs: '480px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
    bp_375: '375px',
    bp_767: '767px',
    bp_768: '768px',
    bp_1024: '1024px',
    bp_1099: '1099px',
    bp_1440: '1440px',
    bp_2560: '2560px'
};
/* harmony default export */ var styles_breakpoints = (breakpoints);

;// CONCATENATED MODULE: ./styles/helper.ts


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      @media (min-width: ",
        ") {\n        ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var keys = Object.keys(styles_breakpoints);
var respondTo = keys.reduce(function(accumulator, label) {
    accumulator[label] = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), styles_breakpoints[label], styled_components_browser_esm/* css.apply */.iv.apply(void 0, _toConsumableArray(args)));
    };
    return accumulator;
}, {});


/***/ }),

/***/ 5112:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={162:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(162);module.exports=r})();

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 1664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(8418)


/***/ }),

/***/ 5501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5885);

/* harmony default export */ __webpack_exports__["Z"] = (universal_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 5163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "zt": function() { return /* binding */ Provider; }
/* harmony export */ });
/* unused harmony export Consumer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _Cookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5501);


var CookiesContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(new _Cookies__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z());
var Provider = CookiesContext.Provider, Consumer = CookiesContext.Consumer;
/* harmony default export */ __webpack_exports__["ZP"] = (CookiesContext);


/***/ }),

/***/ 708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCookies; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/CookiesContext.js
var CookiesContext = __webpack_require__(5163);
;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/utils.js
function isInBrowser() {
    return (typeof window !== 'undefined' &&
        typeof window.document !== 'undefined' &&
        typeof window.document.createElement !== 'undefined');
}

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/useCookies.js



function useCookies(dependencies) {
    var cookies = (0,react.useContext)(CookiesContext/* default */.ZP);
    if (!cookies) {
        throw new Error('Missing <CookiesProvider>');
    }
    var initialCookies = cookies.getAll();
    var _a = (0,react.useState)(initialCookies), allCookies = _a[0], setCookies = _a[1];
    var previousCookiesRef = (0,react.useRef)(allCookies);
    if (isInBrowser()) {
        (0,react.useLayoutEffect)(function () {
            function onChange() {
                var newCookies = cookies.getAll();
                if (shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) {
                    setCookies(newCookies);
                }
                previousCookiesRef.current = newCookies;
            }
            cookies.addChangeListener(onChange);
            return function () {
                cookies.removeChangeListener(onChange);
            };
        }, [cookies]);
    }
    var setCookie = (0,react.useMemo)(function () { return cookies.set.bind(cookies); }, [cookies]);
    var removeCookie = (0,react.useMemo)(function () { return cookies.remove.bind(cookies); }, [cookies]);
    return [allCookies, setCookie, removeCookie];
}
function shouldUpdate(dependencies, newCookies, oldCookies) {
    if (!dependencies) {
        return true;
    }
    for (var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++) {
        var dependency = dependencies_1[_i];
        if (newCookies[dependency] !== oldCookies[dependency]) {
            return true;
        }
    }
    return false;
}


/***/ }),

/***/ 5800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(7294)) :
  0;
})(this, (function (exports, React) { 'use strict';

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
  }

  var changedArray = function changedArray(a, b) {
    if (a === void 0) {
      a = [];
    }

    if (b === void 0) {
      b = [];
    }

    return a.length !== b.length || a.some(function (item, index) {
      return !Object.is(item, b[index]);
    });
  };

  var initialState = {
    error: null
  };

  var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(ErrorBoundary, _React$Component);

    function ErrorBoundary() {
      var _this;

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
      _this.state = initialState;

      _this.resetErrorBoundary = function () {
        var _this$props;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);

        _this.reset();
      };

      return _this;
    }

    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
      return {
        error: error
      };
    };

    var _proto = ErrorBoundary.prototype;

    _proto.reset = function reset() {
      this.setState(initialState);
    };

    _proto.componentDidCatch = function componentDidCatch(error, info) {
      var _this$props$onError, _this$props2;

      (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      var error = this.state.error;
      var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
      // happens to *also* be in the resetKeys array, we'd end up resetting
      // the error boundary immediately. This would likely trigger a second
      // error to be thrown.
      // So we make sure that we don't check the resetKeys on the first call
      // of cDU after the error is set

      if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
        var _this$props$onResetKe, _this$props3;

        (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
        this.reset();
      }
    };

    _proto.render = function render() {
      var error = this.state.error;
      var _this$props4 = this.props,
          fallbackRender = _this$props4.fallbackRender,
          FallbackComponent = _this$props4.FallbackComponent,
          fallback = _this$props4.fallback;

      if (error !== null) {
        var _props = {
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        };

        if ( /*#__PURE__*/React__namespace.isValidElement(fallback)) {
          return fallback;
        } else if (typeof fallbackRender === 'function') {
          return fallbackRender(_props);
        } else if (FallbackComponent) {
          return /*#__PURE__*/React__namespace.createElement(FallbackComponent, _props);
        } else {
          throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
        }
      }

      return this.props.children;
    };

    return ErrorBoundary;
  }(React__namespace.Component);

  function withErrorBoundary(Component, errorBoundaryProps) {
    var Wrapped = function Wrapped(props) {
      return /*#__PURE__*/React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/React__namespace.createElement(Component, props));
    }; // Format for display in DevTools


    var name = Component.displayName || Component.name || 'Unknown';
    Wrapped.displayName = "withErrorBoundary(" + name + ")";
    return Wrapped;
  }

  function useErrorHandler(givenError) {
    var _React$useState = React__namespace.useState(null),
        error = _React$useState[0],
        setError = _React$useState[1];

    if (givenError != null) throw givenError;
    if (error != null) throw error;
    return setError;
  }
  /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */

  exports.ErrorBoundary = ErrorBoundary;
  exports.useErrorHandler = useErrorHandler;
  exports.withErrorBoundary = withErrorBoundary;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=react-error-boundary.umd.js.map


/***/ }),

/***/ 9921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 9864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(9921);
} else {}


/***/ }),

/***/ 5666:
/***/ (function(module) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : 0
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 6774:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 7379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vJ": function() { return /* binding */ We; },
  "iv": function() { return /* binding */ Ce; },
  "ZP": function() { return /* binding */ styled_components_browser_esm; },
  "F4": function() { return /* binding */ Ue; }
});

// UNUSED EXPORTS: ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, ThemeContext, ThemeProvider, __PRIVATE__, isStyledComponent, useTheme, version, withTheme

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(9864);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(6774);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ./node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

;// CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/memoize.browser.esm.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize_browser_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var is_prop_valid_browser_esm = (index);

// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(3454);
function v(){return(v=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var g=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},S=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is.typeOf)(t)},w=Object.freeze([]),E=Object.freeze({});function b(e){return"function"==typeof e}function _(e){return false||e.displayName||e.name||"Component"}function N(e){return e&&"string"==typeof e.styledComponentId}var A="undefined"!=typeof process&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",C="5.3.3",I="undefined"!=typeof window&&"HTMLElement"in window,P=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production"),O={},R= false?0:{};function D(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function j(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var T=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&j(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),x=new Map,k=new Map,V=1,B=function(e){if(x.has(e))return x.get(e);for(;k.has(V);)V++;var t=V++;return false&&0,x.set(e,t),k.set(t,e),t},z=function(e){return k.get(e)},M=function(e,t){t>=V&&(V=t+1),x.set(e,t),k.set(t,e)},G="style["+A+'][data-styled-version="5.3.3"]',L=new RegExp("^"+A+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),F=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},Y=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(L);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(M(u,c),F(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},q=function(){return"undefined"!=typeof window&&void 0!==window.__webpack_nonce__?window.__webpack_nonce__:null},H=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(A))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(A,"active"),r.setAttribute("data-styled-version","5.3.3");var i=q();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},$=function(){function e(e){var t=this.element=H(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}j(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),W=function(){function e(e){var t=this.element=H(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),U=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),J=I,X={isServer:!I,useCSSOMInjection:!P},Z=function(){function e(e,t,n){void 0===e&&(e=E),void 0===t&&(t={}),this.options=v({},X,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&I&&J&&(J=!1,function(e){for(var t=document.querySelectorAll(G),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(A)&&(Y(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return B(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(v({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new U(o):r?new $(o):new W(o),new T(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(B(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(B(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(B(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=z(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=A+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),K=/(a)(d)/gi,Q=function(e){return String.fromCharCode(e+(e>25?39:97))};function ee(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=Q(t%52)+n;return(Q(t%52)+n).replace(K,"$1-$2")}var te=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},ne=function(e){return te(5381,e)};function re(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(b(n)&&!N(n))return!1}return!0}var oe=ne("5.3.3"),se=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&re(e),this.componentId=t,this.baseHash=te(oe,t),this.baseStyle=n,Z.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=Ne(this.rules,e,t,n).join(""),i=ee(te(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=te(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=Ne(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=te(u,f+d),l+=f}}if(l){var m=ee(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),ie=/^\s*\/\/.*$/gm,ae=[":","[",".","#"];function ce(e){var t,n,r,o,s=void 0===e?E:e,i=s.options,a=void 0===i?E:i,c=s.plugins,u=void 0===c?w:c,l=new stylis_browser_esm(a),d=[],h=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ae.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(ie,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},h,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||j(15),te(e,t.name)}),5381).toString():"",m}var ue=react.createContext(),le=ue.Consumer,de=react.createContext(),he=(de.Consumer,new Z),pe=ce();function fe(){return (0,react.useContext)(ue)||he}function me(){return (0,react.useContext)(de)||pe}function ye(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=fe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ce({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ue.Provider,{value:u},react.createElement(de.Provider,{value:l}, false?0:e.children))}var ve=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=pe);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return j(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=pe),this.name+e.hash},e}(),ge=/([A-Z])/,Se=/([A-Z])/g,we=/^ms-/,Ee=function(e){return"-"+e.toLowerCase()};function be(e){return ge.test(e)?e.replace(Se,Ee).replace(we,"-ms-"):e}var _e=function(e){return null==e||!1===e||""===e};function Ne(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=Ne(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(_e(e))return"";if(N(e))return"."+e.styledComponentId;if(b(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,Ne(u,n,r,o)}var l;return e instanceof ve?r?(e.inject(r,o),e.getName(o)):e:S(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!_e(t[i])&&(Array.isArray(t[i])&&t[i].isCss||b(t[i])?s.push(be(i)+":",t[i],";"):S(t[i])?s.push.apply(s,e(t[i],i)):s.push(be(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ae=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ce(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return b(e)||S(e)?Ae(Ne(g(w,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ae(Ne(g(e,n)))}var Ie=/invalid hook call/i,Pe=new Set,Oe=function(e,t){if(false){ var o, n, r; }},Re=function(e,t,n){return void 0===n&&(n=E),e.theme!==n.theme&&e.theme||t||n.theme},De=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,je=/(^-|-$)/g;function Te(e){return e.replace(De,"-").replace(je,"")}var xe=function(e){return ee(ne(e)>>>0)};function ke(e){return"string"==typeof e&&( true||0)}var Ve=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Be=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function ze(e,t,n){var r=e[n];Ve(t)&&Ve(r)?Me(r,t):e[n]=t}function Me(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(Ve(i))for(var a in i)Be(a)&&ze(e,i[a],a)}return e}var Ge=react.createContext(),Le=Ge.Consumer;function Fe(e){var t=s(Ge),n=i((function(){return function(e,t){if(!e)return j(14);if(b(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?j(8):t?v({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?r.createElement(Ge.Provider,{value:n},e.children):null}var Ye={};function qe(e,t,n){var o=N(e),i=!ke(e),a=t.attrs,c=void 0===a?w:a,d=t.componentId,h=void 0===d?function(e,t){var n="string"!=typeof e?"sc":Te(e);Ye[n]=(Ye[n]||0)+1;var r=n+"-"+xe("5.3.3"+n+Ye[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):d,p=t.displayName,f=void 0===p?function(e){return ke(e)?"styled."+e:"Styled("+_(e)+")"}(e):p,g=t.displayName&&t.componentId?Te(t.displayName)+"-"+t.componentId:t.componentId||h,S=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,A=t.shouldForwardProp;o&&e.shouldForwardProp&&(A=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var C,I=new se(n,g,o?e.componentStyle:void 0),P=I.isStatic&&0===c.length,O=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,d=e.shouldForwardProp,h=e.styledComponentId,p=e.target; false&&0;var f=function(e,t,n){void 0===e&&(e=E);var r=v({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in b(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Re(t,(0,react.useContext)(Ge),a)||E,t,o),y=f[0],g=f[1],S=function(e,t,n,r){var o=fe(),s=me(),i=t?e.generateAndInjectStyles(E,o,s):e.generateAndInjectStyles(n,o,s);return false&&0, false&&0,i}(i,r,y, false?0:void 0),w=n,_=g.$as||t.$as||g.as||t.as||p,N=ke(_),A=g!==t?v({},t,{},g):t,C={};for(var I in A)"$"!==I[0]&&"as"!==I&&("forwardedAs"===I?C.as=A[I]:(d?d(I,is_prop_valid_browser_esm,_):!N||is_prop_valid_browser_esm(I))&&(C[I]=A[I]));return t.style&&g.style!==t.style&&(C.style=v({},t.style,{},g.style)),C.className=Array.prototype.concat(c,h,S!==h?S:null,t.className,g.className).filter(Boolean).join(" "),C.ref=w,(0,react.createElement)(_,C)}(C,e,t,P)};return O.displayName=f,(C=react.forwardRef(O)).attrs=S,C.componentStyle=I,C.displayName=f,C.shouldForwardProp=A,C.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):w,C.styledComponentId=g,C.target=o?e.target:e,C.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(ke(e)?e:Te(_(e)));return qe(e,v({},o,{attrs:S,componentId:s}),n)},Object.defineProperty(C,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?Me({},e.defaultProps,t):t}}), false&&(0),C.toString=function(){return"."+C.styledComponentId},i&&hoist_non_react_statics_cjs_default()(C,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),C}var He=function(e){return function e(t,r,o){if(void 0===o&&(o=E),!(0,react_is.isValidElementType)(r))return j(1,String(r));var s=function(){return t(r,o,Ce.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,v({},o,{},n))},s.attrs=function(n){return e(t,r,v({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(qe,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){He[e]=He(e)}));var $e=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=re(e),Z.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(Ne(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&Z.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function We(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ce.apply(void 0,[e].concat(n)),a="sc-global-"+xe(JSON.stringify(i)),u=new $e(i,a);function l(e){var t=fe(),n=me(),o=(0,react.useContext)(Ge),l=(0,react.useRef)(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(l,e,t,o,n),(0,react.useLayoutEffect)((function(){if(!t.server)return h(l,e,t,o,n),function(){return u.removeStyles(l,t)}}),[l,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,O,n,o);else{var s=v({},t,{theme:Re(t,r,l.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,react.memo(l)}function Ue(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ce.apply(void 0,[e].concat(n)).join(""),s=xe(o);return new ve(s,o)}var Je=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=q();return"<style "+[n&&'nonce="'+n+'"',A+'="true"','data-styled-version="5.3.3"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?j(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return j(2);var n=((t={})[A]="",t["data-styled-version"]="5.3.3",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=q();return o&&(n.nonce=o),[react.createElement("style",v({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new Z({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?j(2):react.createElement(ye,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return j(3)},e}(),Xe=function(e){var t=r.forwardRef((function(t,n){var o=s(Ge),i=e.defaultProps,a=Re(t,o,i);return false&&0,r.createElement(e,v({},t,{theme:a,ref:n}))}));return y(t,e),t.displayName="WithTheme("+_(e)+")",t},Ze=function(){return s(Ge)},Ke={StyleSheet:Z,masterSheet:he}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (He);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 5885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es6; }
});

// EXTERNAL MODULE: ./node_modules/cookie/index.js
var cookie = __webpack_require__(6489);
;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/utils.js

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return cookie/* parse */.Q(cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/Cookies.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = parseCookies(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = cookie/* parse */.Q(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return readCookie(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ var es6_Cookies = (Cookies);

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/index.js

/* harmony default export */ var es6 = (es6_Cookies);


/***/ }),

/***/ 4147:
/***/ (function(module) {

"use strict";
module.exports = {"i8":"4.6.0"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(2136), __webpack_exec__(387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);